import * as i0 from '@angular/core';
import { Injectable, Optional, Inject, InjectionToken, NgModule, Component, EventEmitter, ChangeDetectionStrategy, Input, Output, ViewChild, HostBinding, HostListener, Pipe, Directive, inject } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpUrlEncodingCodec, HttpErrorResponse, HttpResponse, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { throwError, BehaviorSubject, timer, of, forkJoin, combineLatest, Subject, fromEvent, from, take as take$1, map as map$1, interval, merge as merge$1 } from 'rxjs';
import * as i1$2 from '@ngrx/store';
import { createFeatureSelector, createSelector, StoreModule, select, createAction, props, createReducer, on } from '@ngrx/store';
import * as i2 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import { map, tap, exhaustMap, retryWhen, delay, take, switchMap, mergeMap, catchError, filter, distinctUntilChanged, merge, takeUntil, withLatestFrom, concatMap, pluck, startWith, takeWhile, debounceTime, throttleTime } from 'rxjs/operators';
import * as i2$2 from '@angular/common';
import { DOCUMENT, CommonModule, DatePipe, NgIfContext, registerLocaleData } from '@angular/common';
import * as i1$1 from '@angular/router';
import { Router, createUrlTreeFromSnapshot, RouterModule } from '@angular/router';
import * as i2$1 from '@arc/aureus';
import { PhoneNumberComponent, FileInputComponent, FileUploadModule, AureusModule, MessageService } from '@arc/aureus';
import * as i3 from '@ngx-translate/core';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import * as i3$1 from '@angular/forms';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SubSink } from 'subsink';
import * as i8 from 'primeng/dialog';
import { DialogModule } from 'primeng/dialog';
import * as i9 from 'primeng/api';
import * as i10 from 'primeng/messages';
import { MessagesModule } from 'primeng/messages';
import * as i2$3 from '@angular/platform-browser';
import * as i4 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import * as moment$1 from 'moment-timezone';
import moment__default from 'moment-timezone';
import * as i2$4 from 'primeng/card';
import { CardModule } from 'primeng/card';
import { getHours } from 'date-fns';
import * as i7 from 'ngx-captcha';
import { NgxCaptchaModule } from 'ngx-captcha';
import { interval as interval$1 } from 'rxjs/internal/observable/interval';
import * as _ from 'lodash-es';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import localeNo from '@angular/common/locales/nb';
import localeSv from '@angular/common/locales/sv';
import localePl from '@angular/common/locales/pl';
import { RouterTestingModule } from '@angular/router/testing';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { getManifest, loadRemoteModule } from '@angular-architects/module-federation';

class AppConfigSettings {
    constructor() {
        this.settings = new Map();
        try {
            this.browserStorageService = localStorage;
        }
        catch (e) { }
    }
    get routes() {
        return {
            loginRoute: this.getconfig('loginRoute') || '/login',
            forgotPasswordRoute: this.getconfig('forgotPasswordRoute') || '/forgotpassword',
            verificationCodeRoute: this.getconfig('verificationCodeRoute') || '/verificationcode',
            resetPasswordRoute: this.getconfig('resetPasswordRoute') || '/resetpassword',
            verifyPhoneNUmberRoute: this.getconfig('verifyPhoneNUmberRoute') || '/verifyphonenumber',
            dashboardRoute: this.getconfig('dashboardRoute') || '/dashboard',
            newPasswordRequiredRoute: this.getconfig('newPasswordRequiredRoute') || '/newpasswordrequired',
            profileRoute: this.getconfig('profileRoute') || '/profile',
            logoutRoute: this.getconfig('logoutRoute'),
        };
    }
    get appId() {
        return this.getrawconfig('appId') || 'pf';
    }
    get environment() {
        return this.getconfig('environment');
    }
    set environment(value) {
        this.setconfig('environment', value);
    }
    // 'showhide' | 'route'
    // mode for login widget,
    // 'route': use route for reset password, verification code,
    // 'showhide': all login flow is in one route, use a internal state to handle different view
    // default is using route
    get loginWidgetMode() {
        return this.getconfig('loginWidgetMode') || 'route';
    }
    set loginWidgetMode(value) {
        this.setconfig('loginWidgetMode', value);
    }
    getconfig(name) {
        if (!this.browserStorageService) {
            return '';
        }
        let configValue = '';
        try {
            configValue =
                this.browserStorageService.getItem(this.appId + '_appConfigSettings-' + name) ||
                    this.settings.get(name) ||
                    '';
        }
        catch (e) { }
        return configValue;
    }
    getrawconfig(name) {
        return this.settings.get(name) || '';
    }
    setconfig(key, value) {
        this.settings.set(key, value);
        if (!this.browserStorageService) {
            return;
        }
        try {
            this.browserStorageService.setItem(this.appId + '_appConfigSettings-' + key, value);
        }
        catch (e) { }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppConfigSettings, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppConfigSettings }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppConfigSettings, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

/**
 * Created with angular4-swagger-client-generator.
 */
class AuthService {
    constructor(http, domain, appConfigSetting) {
        this.http = http;
        this.appConfigSetting = appConfigSetting;
        // private get domain(): string {
        //   return this.appConfigSetting.getconfig("authenticationServiceUrl");;
        // } //
        this.domain = 'http://localhost';
        if (domain) {
            this.domain = domain;
        }
        if (appConfigSetting.getconfig('authenticationServiceUrl')) {
            this.domain = appConfigSetting.getconfig('authenticationServiceUrl');
        }
    }
    /**
     * Method V1LoginPost
     * @param loginRequest
     * @return Full HTTP response as Observable
     */
    V1LoginPost(loginRequest) {
        let uri = `/v1/login`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        return this.sendRequest('post', uri, headers, params, JSON.stringify(loginRequest), true);
    }
    V1SSOLoginGet(loginRequest) {
        let uri = `/v1/sso-login`;
        let headers = new HttpHeaders();
        let params = new HttpParams({ fromObject: loginRequest });
        return this.sendRequest('get', uri, headers, params, null);
    }
    /**
     * Method V1Force-resetPost
     * @param forcedForcePasswordRestRequest
     * @return Full HTTP response as Observable
     */
    V1ForceresetPost(forcedForcePasswordRestRequest) {
        let uri = `/v1/force-reset`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        return this.sendRequest('post', uri, headers, params, JSON.stringify(forcedForcePasswordRestRequest));
    }
    /**
     * Method V1Reset-passwordPost
     * @param resetPasswordRequest
     * @return Full HTTP response as Observable
     */
    V1ResetpasswordPost(resetPasswordRequest, tenantId) {
        let uri = `/v1/reset-password`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        params = params.append('tenantId', tenantId);
        return this.sendRequest('post', uri, headers, params, JSON.stringify(resetPasswordRequest));
    }
    /**
     * Method V1Reset-passwordVerifyPost
     * @param resetPasswordRequest
     * @return Full HTTP response as Observable
     */
    V1ResetpasswordVerifyPost(resetPasswordRequest) {
        let uri = `/v1/reset-password/verify`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        return this.sendRequest('post', uri, headers, params, JSON.stringify(resetPasswordRequest));
    }
    /**
     * Method V1Verify-sessionPost
     * @param verifySessionRequest
     * @return Full HTTP response as Observable
     */
    V1VerifysessionPost(verifySessionRequest) {
        let uri = `/v1/verify-session`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        return this.sendRequest('post', uri, headers, params, JSON.stringify(verifySessionRequest));
    }
    /**
     * Method V1SessionTtlGet
     * @param XBilltrustAuth
     * @return Full HTTP response as Observable
     */
    V1SessionTtlGet(XBilltrustAuth) {
        const uri = `/v1/session/ttl`;
        let headers = new HttpHeaders();
        const params = new HttpParams();
        if (XBilltrustAuth !== undefined && XBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', XBilltrustAuth + '');
        }
        return this.sendRequest('get', uri, headers, params, null);
    }
    V1ChangePasswordPost(changePasswordRequest) {
        let uri = `/v1/change-password`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        return this.sendRequest('post', uri, headers, params, JSON.stringify(changePasswordRequest));
    }
    /**
     * Method V1LogoutPost
     * @param logoutRequest
     * @return Full HTTP response as Observable
     */
    V1LogoutPost(logoutRequest) {
        let uri = `/v1/logout`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        return this.sendRequest('post', uri, headers, params, JSON.stringify(logoutRequest));
    }
    /**
     * Method V1TenantsByTenantIdUserPost
     * @param createRequest
     * @param tenantId
     * @param XBilltrustAuth
     * @return Full HTTP response as Observable
     */
    V1TenantsByTenantIdUserPost(createRequest, tenantId, XBilltrustAuth) {
        let uri = `/v1/tenants/${tenantId}/user`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        if (XBilltrustAuth !== undefined && XBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', XBilltrustAuth + '');
        }
        return this.sendRequest('post', uri, headers, params, JSON.stringify(createRequest));
    }
    /**
     * Method V1TenantsByTenantIdUserPost
     * @param createRequest
     * @param tenantId
     * @param XBilltrustAuth
     * @return Full HTTP response as Observable
     */
    v1TenantsByTenantIdUserServiceAccountPost(createRequest, tenantId, XBilltrustAuth) {
        let uri = `/v1/tenants/${tenantId}/user/service-account`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        if (XBilltrustAuth !== undefined && XBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', XBilltrustAuth + '');
        }
        return this.sendRequest('post', uri, headers, params, JSON.stringify(createRequest));
    }
    /**
     * Method V1TenantsByTenantIdUserExternalAnonymousApplicationByApplicationIdPersonaByPersonaIdPost
     * @param createAnonymousUserRequest
     * @param tenantId
     * @param applicationId
     * @param personaId
     * @param XBilltrustAuth
     * @return Full HTTP response as Observable
     */
    V1TenantsByTenantIdUserExternalAnonymousApplicationByApplicationIdPersonaByPersonaIdPost(createAnonymousUserRequest, tenantId, applicationId, personaId) {
        const uri = `/v1/tenants/${tenantId}/user/external/anonymous/application/${applicationId}/persona/${personaId}`;
        const headers = new HttpHeaders();
        const params = new HttpParams();
        return this.sendRequest('post', uri, headers, params, JSON.stringify(createAnonymousUserRequest));
    }
    /**
     * Method V1TenantsByTenantIdUserExternalAnonymousApplicationByApplicationIdPersonaByPersonaIdFeatureByFeatureIdPost
     * @param createAnonymousUserRequest
     * @param tenantId
     * @param applicationId
     * @param featureId
     * @param personaId
     * @param XBilltrustAuth
     * @return Full HTTP response as Observable
     */
    V1TenantsByTenantIdUserExternalAnonymousApplicationByApplicationIdPersonaByPersonaIdFeatureByFeatureIdPost(createAnonymousUserRequest, tenantId, applicationId, featureId, personaId) {
        const uri = `/v1/tenants/${tenantId}/user/external/anonymous/application/${applicationId}/feature/${featureId}/persona/${personaId}`;
        const headers = new HttpHeaders();
        const params = new HttpParams();
        return this.sendRequest('post', uri, headers, params, JSON.stringify(createAnonymousUserRequest));
    }
    /**
     * Lets make users in bulk. This endpoint asynchronously creates users in bulk
     *  UsersFileAsBase64 should be a base64 encoded string of a csv with the following line format.                email (required)|roleName (optional)|firstName (optional)|lastName (optional)
     *
     * @param tenantId
     * @param xBilltrustAuth
     * @param request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    v1TenantsByTenantIdUsersBulkPost(tenantId, request, xBilltrustAuth, observe, reportProgress) {
        const uri = `/v1/tenants/${encodeURIComponent(String(tenantId))}/users/bulk`;
        let headers = new HttpHeaders();
        const params = new HttpParams();
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', xBilltrustAuth + '');
        }
        return this.sendRequest('post', uri, headers, params, JSON.stringify(request));
    }
    /**
     * Method V1HelloGet
     * @param name the name to address the greeting to
     * @return Full HTTP response as Observable
     */
    V1HelloGet(name) {
        let uri = `/v1/hello`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        if (name !== undefined && name !== null) {
            params = params.set('name', name + '');
        }
        return this.sendRequest('get', uri, headers, params, null);
    }
    /**
     * Method V1HealthGet
     * @return Full HTTP response as Observable
     */
    V1HealthGet() {
        let uri = `/v1/health`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        return this.sendRequest('get', uri, headers, params, null);
    }
    /**
     * Method V1UpGet
     * @return Full HTTP response as Observable
     */
    V1UpGet() {
        let uri = `/v1/up`;
        let headers = new HttpHeaders();
        let params = new HttpParams();
        return this.sendRequest('get', uri, headers, params, null);
    }
    sendRequest(method, uri, headers, params, body, withCredentials) {
        if (method === 'get') {
            return this.http.get(this.domain + uri, {
                headers: headers.set('Accept', 'application/json'),
                params: params,
                observe: 'response',
                withCredentials: !!withCredentials,
            });
        }
        else if (method === 'put') {
            return this.http.put(this.domain + uri, body, {
                headers: headers.set('Content-Type', 'application/json'),
                params: params,
                observe: 'response',
                withCredentials: !!withCredentials,
            });
        }
        else if (method === 'post') {
            return this.http.post(this.domain + uri, body, {
                headers: headers.set('Content-Type', 'application/json'),
                params: params,
                observe: 'response',
                withCredentials: !!withCredentials,
            });
        }
        else if (method === 'delete') {
            return this.http.delete(this.domain + uri, {
                headers: headers,
                params: params,
                observe: 'response',
                withCredentials: !!withCredentials,
            });
        }
        else {
            console.error('Unsupported request: ' + method);
            return throwError('Unsupported request: ' + method);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthService, deps: [{ token: i1.HttpClient }, { token: 'domain', optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['domain']
                }] }, { type: AppConfigSettings }] });

const BASE_PATH = new InjectionToken('basePath');
const COLLECTION_FORMATS = {
    csv: ',',
    tsv: '   ',
    ssv: ' ',
    pipes: '|',
};

class Configuration {
    constructor(configurationParameters = {}) {
        this.apiKeys = configurationParameters.apiKeys;
        this.username = configurationParameters.username;
        this.password = configurationParameters.password;
        this.accessToken = configurationParameters.accessToken;
        this.basePath = configurationParameters.basePath;
        this.withCredentials = configurationParameters.withCredentials;
    }
    selectHeaderContentType(contentTypes) {
        if (contentTypes.length == 0) {
            return undefined;
        }
        let type = contentTypes.find((x) => this.isJsonMime(x));
        if (type === undefined) {
            return contentTypes[0];
        }
        return type;
    }
    selectHeaderAccept(accepts) {
        if (accepts.length == 0) {
            return undefined;
        }
        let type = accepts.find((x) => this.isJsonMime(x));
        if (type === undefined) {
            return accepts[0];
        }
        return type;
    }
    isJsonMime(mime) {
        const jsonMime = new RegExp('^(application/json|[^;/ \t]+/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return (mime != null &&
            (jsonMime.test(mime) ||
                mime.toLowerCase() === 'application/json-patch+json'));
    }
}

/**
 * User Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class UserService {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        this.isResellerJPM = new BehaviorSubject(false);
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
        if (appConfigSetting.getconfig('userServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('userServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    v1TenantsByTenantIdUsersByUserIdGet(tenantId, userId, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdUsersByUserIdGet.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling v1TenantsByTenantIdUsersByUserIdGet.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/users/${encodeURIComponent(String(userId))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdUsersByUserIdPut(tenantId, userId, updatedUser, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdUsersByUserIdPut.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling v1TenantsByTenantIdUsersByUserIdPut.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.put(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/users/${encodeURIComponent(String(userId))}`, updatedUser, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdUsersLoginPost(tenantId, request, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdUsersLoginPost.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/users/login`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdUsersGet(tenantId, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdUsersGet.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/users`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1UsersProfileGet(xBilltrustAuth, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/users/profile`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsTenantIdApplicationApplicationIdPersonaPersonaIdUsersProfileIsExternalUserGet(tenantId, applicationId, personaId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsTenantIdApplicationApplicationIdPersonaPersonaIdUsersProfileIsExternalUserGet.');
        }
        if (applicationId === null || applicationId === undefined) {
            throw new Error('Required parameter applicationId was null or undefined when calling v1TenantsTenantIdApplicationApplicationIdPersonaPersonaIdUsersProfileIsExternalUserGet.');
        }
        if (personaId === null || personaId === undefined) {
            throw new Error('Required parameter personaId was null or undefined when calling v1TenantsTenantIdApplicationApplicationIdPersonaPersonaIdUsersProfileIsExternalUserGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/application/${encodeURIComponent(String(applicationId))}/persona/${encodeURIComponent(String(personaId))}/users/profile/is-external-user`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1UsersProfilePut(profile, xBilltrustAuth, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.put(`${this.basePath}/v1/users/profile`, profile, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserService, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

/**
 * CustomHttpUrlEncodingCodec
 * Fix plus sign (+) not encoding, so sent as blank space
 * See: https://github.com/angular/angular/issues/11058#issuecomment-247367318
 */
class CustomHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
    encodeKey(k) {
        k = super.encodeKey(k);
        return k.replace(/\+/gi, '%2B');
    }
    encodeValue(v) {
        v = super.encodeValue(v);
        return v.replace(/\+/gi, '%2B');
    }
}

/**
 * Permission Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class PermissionV1Service {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
        if (appConfigSetting.getconfig('permissionServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('permissionServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    v1TenantsByTenantIdRolesByRoleIdDelete(tenantId, roleId, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdDelete.');
        }
        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdDelete.');
        }
        // if (xBilltrustAuth === null || xBilltrustAuth === undefined) {
        //     throw new Error('Required parameter xBilltrustAuth was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdDelete.');
        // }
        let headers = this.defaultHeaders;
        // if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
        //     headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        // }
        // to determine the Accept header
        let httpHeaderAccepts = [];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.delete(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles/${encodeURIComponent(String(roleId))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdAccessMappingPost(tenantId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdAccessMappingPost.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.post(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/access-mapping`, null, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdAccessMappingPut(tenantId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdAccessMappingPut.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.put(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/access-mapping`, null, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRoleProfileGet(tenantId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRoleProfileGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/role/profile`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesByRoleIdPut(tenantId, roleId, updateRole, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdPut.');
        }
        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdPut.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.put(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles/${encodeURIComponent(String(roleId))}`, updateRole, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesByRoleIdGet(tenantId, roleId, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdGet.');
        }
        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdGet.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles/${encodeURIComponent(String(roleId))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesByRoleIdGetUserCountGet(tenantId, roleId, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdGetUserCountGet.');
        }
        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdGetUserCountGet.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles/${encodeURIComponent(String(roleId))}/get-user-count`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesByRoleIdUsersPut(tenantId, roleId, user, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdUsersPut.');
        }
        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdUsersPut.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.put(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles/${encodeURIComponent(String(roleId))}/users`, user, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesGet(tenantId, ids, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesGet.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (ids !== undefined) {
            queryParameters = queryParameters.set('Ids', ids);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesGetByUseridByUserIdGet(tenantId, userId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesGetByUseridByUserIdGet.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling v1TenantsByTenantIdRolesGetByUseridByUserIdGet.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles/get-by-userid/${encodeURIComponent(String(userId))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesPost(tenantId, createRole, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesPost.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles`, createRole, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdUserRoleGet(tenantId, ids, hidrate, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdUserRoleGet.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (ids !== undefined) {
            queryParameters = queryParameters.set('Ids', ids);
        }
        if (hidrate !== undefined) {
            queryParameters = queryParameters.set('Hidrate', hidrate);
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/user-role`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesByRoleIdUsersBulkPut(tenantId, roleId, request, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdUsersBulkPut.');
        }
        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdUsersBulkPut.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        const httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.put(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles/${encodeURIComponent(String(roleId))}/users/bulk`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdRolesByRoleIdUsersGet(tenantId, roleId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdUsersGet.');
        }
        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling v1TenantsByTenantIdRolesByRoleIdUsersGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/roles/${encodeURIComponent(String(roleId))}/users`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdUsersPermissionsPost(tenantId, request, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdUsersPermissionsPost.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/users-permissions`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByTenantIdUsersSsoPut(tenantId, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsByTenantIdUsersSsoPut.');
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.put(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/users/sso`, null, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsTenantIdApplicationApplicationIdFeatureFeatureIdPersonaPersonaIdRoleProfileGet(tenantId, applicationId, featureId, personaId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsTenantIdApplicationApplicationIdFeatureFeatureIdPersonaPersonaIdRoleProfileGet.');
        }
        if (applicationId === null || applicationId === undefined) {
            throw new Error('Required parameter applicationId was null or undefined when calling v1TenantsTenantIdApplicationApplicationIdFeatureFeatureIdPersonaPersonaIdRoleProfileGet.');
        }
        if (featureId === null || featureId === undefined) {
            throw new Error('Required parameter featureId was null or undefined when calling v1TenantsTenantIdApplicationApplicationIdFeatureFeatureIdPersonaPersonaIdRoleProfileGet.');
        }
        if (personaId === null || personaId === undefined) {
            throw new Error('Required parameter personaId was null or undefined when calling v1TenantsTenantIdApplicationApplicationIdFeatureFeatureIdPersonaPersonaIdRoleProfileGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/application/${encodeURIComponent(String(applicationId))}/feature/${encodeURIComponent(String(featureId))}/persona/${encodeURIComponent(String(personaId))}/role/profile`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionV1Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionV1Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

/**
 * Tenant Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class TenantsV1Service {
    constructor(httpClient, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (appConfigSetting.getconfig('tenantServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('tenantServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    v1PartnersByPartnerIdTenantsByIdApplicationsByApplicationIdEnablePost(partnerId, id, applicationId, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdApplicationsByApplicationIdEnablePost.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1PartnersByPartnerIdTenantsByIdApplicationsByApplicationIdEnablePost.');
        }
        if (applicationId === null || applicationId === undefined) {
            throw new Error('Required parameter applicationId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdApplicationsByApplicationIdEnablePost.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.post(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants/${encodeURIComponent(String(id))}/applications/${encodeURIComponent(String(applicationId))}/enable`, null, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1PartnersByPartnerIdTenantsByIdApplicationsGet(partnerId, id, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdApplicationsGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1PartnersByPartnerIdTenantsByIdApplicationsGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants/${encodeURIComponent(String(id))}/applications`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1PartnersByPartnerIdTenantsByIdFeaturesByFeatureIdEnablePost(partnerId, id, featureId, request, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdFeaturesByFeatureIdEnablePost.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1PartnersByPartnerIdTenantsByIdFeaturesByFeatureIdEnablePost.');
        }
        if (featureId === null || featureId === undefined) {
            throw new Error('Required parameter featureId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdFeaturesByFeatureIdEnablePost.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants/${encodeURIComponent(String(id))}/features/${encodeURIComponent(String(featureId))}/enable`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1PartnersByPartnerIdTenantsByIdFeaturesByFeatureIdStatusGet(partnerId, id, featureId, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdFeaturesByFeatureIdStatusGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1PartnersByPartnerIdTenantsByIdFeaturesByFeatureIdStatusGet.');
        }
        if (featureId === null || featureId === undefined) {
            throw new Error('Required parameter featureId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdFeaturesByFeatureIdStatusGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants/${encodeURIComponent(String(id))}/features/${encodeURIComponent(String(featureId))}/status`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1PartnersByPartnerIdTenantsByIdFeaturesGet(partnerId, id, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdFeaturesGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1PartnersByPartnerIdTenantsByIdFeaturesGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants/${encodeURIComponent(String(id))}/features`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1PartnersByPartnerIdTenantsByIdGet(partnerId, id, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsByIdGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1PartnersByPartnerIdTenantsByIdGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1PartnersByPartnerIdTenantsGet(partnerId, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1PartnersByPartnerIdTenantsGetByUsernameByUsernameGet(partnerId, username, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsGetByUsernameByUsernameGet.');
        }
        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling v1PartnersByPartnerIdTenantsGetByUsernameByUsernameGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants/get-by-username/${encodeURIComponent(String(username))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1PartnersByPartnerIdTenantsPost(partnerId, request, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling v1PartnersByPartnerIdTenantsPost.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/partners/${encodeURIComponent(String(partnerId))}/tenants`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantsV1Service, deps: [{ token: i1.HttpClient }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantsV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantsV1Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: AppConfigSettings }] });

class TenantMgmtV1Service {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (appConfigSetting.getconfig('tenantMgmtServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('tenantMgmtServiceUrl');
        }
    }
    /**
     * Get an individual tenant's metadata
     *
     * @param tenantId
     * @param xBilltrustAuth
     * @param xAmznTraceId
     * @param xBTCorrId
     * @param xBTTestMode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    v1TenantsTenantIdMetaGet(tenantId, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsTenantIdMetaGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/meta`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantMgmtV1Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantMgmtV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantMgmtV1Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

/**
 * Tenant Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class TenantStandAloneV1Service {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (appConfigSetting.getconfig('tenantServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('tenantServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    v1TenantsByIdApplicationsGet(id, enabled, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1TenantsByIdApplicationsGet.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (enabled !== undefined) {
            queryParameters = queryParameters.set('Enabled', enabled);
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(id))}/applications`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByIdGet(id, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1TenantsByIdGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(id))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByIdVerifyAutomationTenantGet(id, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1TenantsByIdVerifyAutomationTenantGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(id))}/verify-automation-tenant`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsByIdVerifyTestTenantGet(id, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1TenantsByIdVerifyTestTenantGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(id))}/verify-test-tenant`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsGet(xBilltrustAuth, includeTestTenants, ids, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (ids !== undefined && ids !== null) {
            queryParameters = queryParameters.set('Ids', ids);
        }
        if (includeTestTenants !== undefined && includeTestTenants !== null) {
            queryParameters = queryParameters.set('includeTestTenants', includeTestTenants);
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v1/tenants`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsGetByUsernameByUsernameGet(username, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling v1TenantsGetByUsernameByUsernameGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/tenants/get-by-username/${encodeURIComponent(String(username))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsTenantIdMetaGet(tenantId, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantsTenantIdMetaGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/meta`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1TenantsIdFeaturesGet(id, enabled, xBilltrustAuth, xAmznTraceId, xBTCorrId, xBTTestMode, observe = 'body', reportProgress = false) {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling v1TenantsIdFeaturesGet.');
        }
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (enabled !== undefined && enabled !== null) {
            queryParameters = queryParameters.set('Enabled', enabled);
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        if (xAmznTraceId !== undefined && xAmznTraceId !== null) {
            headers = headers.set('X-Amzn-Trace-Id', String(xAmznTraceId));
        }
        if (xBTCorrId !== undefined && xBTCorrId !== null) {
            headers = headers.set('X-BT-Corr-Id', String(xBTCorrId));
        }
        if (xBTTestMode !== undefined && xBTTestMode !== null) {
            headers = headers.set('X-BT-Test-Mode', String(xBTTestMode));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'application/json'
        ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v1/tenants/${encodeURIComponent(String(id))}/features`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantStandAloneV1Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantStandAloneV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantStandAloneV1Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

/**
 * ARC Search Service
 * ARC Search Service
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class SearchV1Service {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (appConfigSetting.getconfig('searchServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('searchServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    searchV1AddTypeaheadEntry(tenantId, req, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling searchV1AddTypeaheadEntry.');
        }
        if (req === null || req === undefined) {
            throw new Error('Required parameter req was null or undefined when calling searchV1AddTypeaheadEntry.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = ['application/json'];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/typeahead/automation`, req, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    searchV1Typeahead(tenantId, q, types, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling searchV1Typeahead.');
        }
        if (q === null || q === undefined) {
            throw new Error('Required parameter q was null or undefined when calling searchV1Typeahead.');
        }
        if (types === null || types === undefined) {
            throw new Error('Required parameter types was null or undefined when calling searchV1Typeahead.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (q !== undefined) {
            queryParameters = queryParameters.set('q', q);
        }
        if (types) {
            queryParameters = queryParameters.set('types', types.join(COLLECTION_FORMATS['csv']));
        }
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = ['application/json'];
        return this.httpClient.get(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}/typeahead`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchV1Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchV1Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

/**
 * User Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class TimeZoneV1Service {
    constructor(httpClient, basePath, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (appConfigSetting.getconfig('userServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('userServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    v1TimezonesGet(xBilltrustAuth, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [];
        return this.httpClient.get(`${this.basePath}/v1/timezones`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TimeZoneV1Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TimeZoneV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TimeZoneV1Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: AppConfigSettings }] });

/**
 * ARC Demo Data Service
 * ARC Demo Data Service
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class DemoDataV1Service {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (appConfigSetting.getconfig('demoDataUrl')) {
            this.basePath = appConfigSetting.getconfig('demoDataUrl');
        }
    }
    v1DemoDataPut(tenantId, xBilltrustAuth, observe, reportProgress) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1DemoDataPut.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = [];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        return this.httpClient.put(`${this.basePath}/v1/tenants/${encodeURIComponent(String(tenantId))}`, null, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DemoDataV1Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DemoDataV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DemoDataV1Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

/**
 * ARC Search Service
 * ARC Search Service
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class SearchV2Service {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (appConfigSetting.getconfig('searchServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('searchServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    searchV2Typeahead(tenantId, q, types, page, pagesize, xBilltrustTags, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling searchV2Typeahead.');
        }
        if (q === null || q === undefined) {
            throw new Error('Required parameter q was null or undefined when calling searchV2Typeahead.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', q);
        }
        if (types) {
            queryParameters = queryParameters.set('types', types.join(COLLECTION_FORMATS['csv']));
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', page);
        }
        if (pagesize !== undefined && pagesize !== null) {
            queryParameters = queryParameters.set('pagesize', pagesize);
        }
        let headers = this.defaultHeaders;
        if (xBilltrustTags !== undefined && xBilltrustTags !== null) {
            headers = headers.set('x-billtrust-tags', String(xBilltrustTags));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v2/tenants/${encodeURIComponent(String(tenantId))}/typeahead`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchV2Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchV2Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchV2Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

class GeneralActionTypes {
    static { this.GeneralError = '[General] Error'; }
    static { this.GeneralSuccess = '[General] Success'; }
    static { this.GeneralErrorHandled = '[General] Error Handled'; }
    static { this.GeneralSuccessHandled = '[General] Success Handled'; }
    static { this.GeneralMessageDisplayed = '[General] '; }
    static { this.SystemNotification = '[General] System Notification'; }
    static { this.UserNotification = '[General] User Notification'; }
    static { this.UserNotificationDisplayed = '[General] User Notification Displayed'; }
    static { this.GeneralRedirect = '[General] Redirect'; }
    static { this.ExternalRedirect = '[General] External Redirect'; }
    static { this.SetTestTenantMode = '[General] Set Test Tenant'; }
    static { this.BackendNotification = '[General] Backend Notification'; }
    static { this.ClearAllStore = '[General] Clear All Store'; }
    static { this.DoNothing = '[General] Do Nothing Action Place Holder'; }
}
class DoNothingAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.DoNothing;
    }
}
class ExternalRedirectAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.ExternalRedirect;
    }
}
class BackendNotificationAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.BackendNotification;
    }
}
class ClearAllStoreAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.ClearAllStore;
    }
}
class GeneralErrorAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.GeneralError;
    }
}
class GeneralRedirectAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.GeneralRedirect;
    }
}
class ActionContext {
}
class GeneralSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.GeneralSuccess;
    }
}
class GeneralSuccessHandledAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.GeneralSuccessHandled;
    }
}
class GeneralErrorHandledAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.GeneralErrorHandled;
    }
}
class SystemNotificationAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.SystemNotification;
    }
}
class UserNotificationAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.UserNotification;
    }
}
class UserNotificationDisplayed {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.UserNotificationDisplayed;
    }
}
class SetTestTenantModeAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GeneralActionTypes.SetTestTenantMode;
    }
}

const initialSuccessState = {
    actionType: '',
};
const initialErrorState = {
    message: '',
    actionType: '',
    errorObj: '',
};
const initialSystemNotificationState = {
    type: '',
    message: '',
};
const initialUserNotificationState = {
    type: '',
    message: '',
};
const initialAppState = {};
function successReducer(state = initialSuccessState, action) {
    switch (action.type) {
        case GeneralActionTypes.GeneralSuccess: {
            if (action.payload) {
                const payload = action.payload;
                return { ...state, actionType: payload, handled: false };
            }
            if (action.payload instanceof ActionContext) {
                return {
                    ...state,
                    actionType: action.payload.actionType,
                    handled: false,
                };
            }
            return { ...state, actionType: action.payload, handled: false };
        }
        case GeneralActionTypes.GeneralSuccessHandled: {
            return { ...state, handled: true };
        }
        default: {
            return state;
        }
    }
}
function errorReducer(state = initialErrorState, action) {
    switch (action.type) {
        case GeneralActionTypes.GeneralError: {
            return {
                ...action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
function systemNotificationReducer(state = initialSystemNotificationState, action) {
    // if (action && action.payload && action.payload.type) { } else { return state; }
    switch (action.type) {
        case GeneralActionTypes.SystemNotification: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
function userNotificationReducer(state = initialUserNotificationState, action) {
    switch (action.type) {
        case GeneralActionTypes.UserNotification: {
            return {
                ...state,
                ...action.payload,
                displayed: false,
            };
        }
        case GeneralActionTypes.UserNotificationDisplayed: {
            return {
                ...state,
                ...action.payload,
                displayed: true,
            };
        }
        default: {
            return state;
        }
    }
}
function clearStateMetaReducer(reducer) {
    return function (state, action) {
        switch (action.type) {
            case GeneralActionTypes.ClearAllStore:
                state = undefined;
                break;
            default:
                break;
        }
        return reducer(state, action);
    };
}
function appStateReducer(state = initialAppState, action) {
    switch (action.type) {
        case GeneralActionTypes.SetTestTenantMode:
            return {
                ...state,
            };
        default: {
            return state;
        }
    }
}
const GeneralReducers = {
    error: errorReducer,
    success: successReducer,
    systemNotification: systemNotificationReducer,
    userNotification: userNotificationReducer,
    appState: appStateReducer,
};
const GeneralStore = createFeatureSelector('general');
const ErrorStore = createSelector(GeneralStore, (state) => {
    if (state) {
        return state.error;
    }
});
const SuccessStore = createSelector(GeneralStore, (state) => {
    if (state) {
        return state.success;
    }
});
const SysNotificationStore = createSelector(GeneralStore, (state) => state.systemNotification);
const UserNotificationStore = createSelector(GeneralStore, (state) => state.userNotification);
const AppStateStore = createSelector(GeneralStore, (state) => {
    if (state) {
        return state.appState;
    }
});

class StorageItem {
}
class BrowserStorageService {
    constructor(setting) {
        this.setting = setting;
        this.delimiter = '_';
    }
    setItem(key, value) {
        if (localStorage) {
            try {
                localStorage.setItem(this.setting.appId + this.delimiter + key, value);
            }
            catch (e) { }
        }
    }
    removeItem(key) {
        if (localStorage) {
            try {
                localStorage.removeItem(this.setting.appId + this.delimiter + key);
            }
            catch (e) { }
        }
    }
    getItem(key) {
        if (localStorage) {
            try {
                return localStorage.getItem(this.setting.appId + this.delimiter + key);
            }
            catch (e) { }
        }
        return '';
    }
    clear() {
        if (localStorage) {
            try {
                localStorage.clear();
            }
            catch (e) { }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrowserStorageService, deps: [{ token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrowserStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrowserStorageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AppConfigSettings }] });

class GeneralEffects {
    constructor(actions$, router, store$, storageService, messageService, ngZone, translateService, document) {
        this.actions$ = actions$;
        this.router = router;
        this.store$ = store$;
        this.storageService = storageService;
        this.messageService = messageService;
        this.ngZone = ngZone;
        this.translateService = translateService;
        this.document = document;
        this.generalRedirect$ = createEffect(() => this.actions$.pipe(ofType(GeneralActionTypes.GeneralRedirect), map((x) => x.payload), tap((url) => {
            if (url) {
                this.ngZone.run(() => {
                    this.router.navigateByUrl(url);
                });
            }
        })), { dispatch: false });
        // @Effect({ dispatch: false })
        // persistAppState$ = this.actions$.pipe(
        //   ofType(GeneralActionTypes.SetTestTenantMode),
        //   map((x: SetTestTenantModeAction) => x.payload),
        //   withLatestFrom(this.store$.select(AppStateStore)),
        //   tap(([x, y]) => {
        //     this.storageService.setItem('appState', JSON.stringify(y));
        //   })
        // );
        this.backendNotificationAction$ = createEffect(() => this.actions$.pipe(ofType(GeneralActionTypes.BackendNotification), map((x) => x.payload), map((x) => new UserNotificationAction({ message: x.payload, type: 'success' }))), { dispatch: true });
        this.externalRedirect$ = createEffect(() => this.actions$.pipe(ofType(GeneralActionTypes.ExternalRedirect), map((x) => x.payload), tap((url) => {
            this.document.location.href = url;
        })), { dispatch: false });
        this.userNotification$ = createEffect(() => this.actions$.pipe(ofType(GeneralActionTypes.UserNotification), map((x) => x.payload), tap((msg) => {
            let displayMessage = msg.message;
            let severity = msg.type;
            if (displayMessage) {
                displayMessage = this.translateService.instant(displayMessage, msg.messageData);
            }
            if (severity === 'error') {
                severity = 'danger';
            }
            if (msg.sticky) {
                this.messageService.open(displayMessage, '', {
                    severity,
                    duration: 0,
                });
            }
            else {
                if (severity === 'danger') {
                    this.messageService.open(displayMessage, '', {
                        severity,
                        dismissOnNavigate: true,
                    });
                }
                else {
                    this.messageService.open(displayMessage, '', {
                        severity,
                        duration: 10000,
                    });
                }
            }
        })), { dispatch: false });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GeneralEffects, deps: [{ token: i2.Actions }, { token: i1$1.Router }, { token: i1$2.Store }, { token: BrowserStorageService }, { token: i2$1.MessageService }, { token: i0.NgZone }, { token: i3.TranslateService }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GeneralEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GeneralEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.Actions }, { type: i1$1.Router }, { type: i1$2.Store }, { type: BrowserStorageService }, { type: i2$1.MessageService }, { type: i0.NgZone }, { type: i3.TranslateService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class GeneralStoreModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GeneralStoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: GeneralStoreModule, imports: [CommonModule, i1$2.StoreFeatureModule, i2.EffectsFeatureModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GeneralStoreModule, imports: [CommonModule,
            StoreModule.forFeature('general', GeneralReducers),
            EffectsModule.forFeature([GeneralEffects])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GeneralStoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        StoreModule.forFeature('general', GeneralReducers),
                        EffectsModule.forFeature([GeneralEffects]),
                    ],
                    exports: [],
                }]
        }] });

// export * from './auth.module';
// export * from './effects/auth.effects';

function TranslationServiceFactory(translateService) {
    return () => {
        return translateService.use('en').toPromise();
    };
}
function getAnnotations(typeOrFunc) {
    // Prefer the direct API.
    if (typeOrFunc.annotations) {
        let annotations = typeOrFunc.annotations;
        if (typeof annotations === 'function' && annotations.annotations) {
            annotations = annotations.annotations;
        }
        return annotations;
    }
    // API of tsickle for lowering decorators to properties on the class.
    if (typeOrFunc.decorators) {
        return convertTsickleDecoratorIntoMetadata(typeOrFunc.decorators);
    }
    // API for metadata created by invoking the decorators.
    if (Reflect && Reflect.getOwnMetadata) {
        return Reflect.getOwnMetadata('annotations', typeOrFunc);
    }
    return null;
}
function convertTsickleDecoratorIntoMetadata(decoratorInvocations) {
    if (!decoratorInvocations) {
        return [];
    }
    return decoratorInvocations.map((decoratorInvocation) => {
        const decoratorType = decoratorInvocation.type;
        const annotationCls = decoratorType.annotationCls;
        const annotationArgs = decoratorInvocation.args
            ? decoratorInvocation.args
            : [];
        return new annotationCls(...annotationArgs);
    });
}

function removeTrailingSlashes(url) {
    return url.replace(/\/+$/, '');
}

class Cookie {
}
class BrowserCookieService {
    constructor(setting) {
        this.setting = setting;
        this.cookieSameSitePolicy =
            setting.getconfig('cookieSameSitePolicy') || 'Strict';
    }
    removeCookie(key) {
        const cookieDomain = this.setting.getconfig('cookieDomain');
        document.cookie =
            key +
                '=;Domain=' +
                cookieDomain +
                '; expires=Thu, 01 Jan 1970 00:00:00 GMT;Path=/';
    }
    readCookie(name) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return '';
    }
    getCookie(key) {
        return this.readCookie(key);
    }
    writeCookie(cookie) {
        const secureFlagValue = this.setting.getconfig('isHttps') === 'true';
        const cookieString = this.serializeSingleCookie({
            secure: secureFlagValue,
            sameSite: this.cookieSameSitePolicy,
            ...cookie,
        });
        document.cookie = cookieString;
    }
    setSessionCookie(name, value) {
        if (name && value) {
            const secureFlagValue = this.setting.getconfig('isHttps') === 'true';
            const cookieString = this.serializeSingleCookie({
                name: name,
                value: value,
                domain: this.setting.getconfig('cookieDomain'),
                secure: secureFlagValue,
                sameSite: this.cookieSameSitePolicy,
            });
            document.cookie = cookieString;
        }
    }
    setSessionCookiePerEnv(name, value) {
        if (name && value) {
            name = name + this.getCookieSuffix();
            const secureFlagValue = this.setting.getconfig('isHttps') === 'true';
            const cookieString = this.serializeSingleCookie({
                name: name,
                value: value,
                domain: this.setting.getconfig('cookieDomain'),
                secure: secureFlagValue,
                sameSite: this.cookieSameSitePolicy,
            });
            document.cookie = cookieString;
        }
    }
    setSessionCookiePerEnvEncoded(name, value) {
        if (name && value) {
            name = name + this.getCookieSuffix();
            const secureFlagValue = this.setting.getconfig('isHttps') === 'true';
            const cookieString = this.serializeSingleCookie({
                name: name,
                value: encodeURIComponent(value),
                domain: this.setting.getconfig('cookieDomain'),
                secure: secureFlagValue,
                sameSite: this.cookieSameSitePolicy,
            });
            document.cookie = cookieString;
        }
    }
    readSessionCookiePerEnvDecoded(name) {
        if (!name) {
            return '';
        }
        name = name + this.getCookieSuffix();
        return decodeURIComponent(this.readCookie(name));
    }
    readSessionCookiePerEnv(name) {
        if (!name) {
            return '';
        }
        name = name + this.getCookieSuffix();
        return this.readCookie(name);
    }
    removeSessionCookiePerEnv(name) {
        if (!name) {
            return '';
        }
        name = name + this.getCookieSuffix();
        return this.removeCookie(name);
    }
    getCookieSuffix() {
        let suffix = '';
        const appId = this.setting.appId;
        const environment = this.setting.getconfig('environment');
        const useAppSpecificToken = this.setting.getconfig('useAppSpecificToken') === 'true';
        if (environment === 'prod') {
            suffix = useAppSpecificToken ? `_${appId}` : '';
        }
        else if (environment) {
            suffix = useAppSpecificToken ? `_${environment}_${appId}` : `_${environment}`;
        }
        return suffix;
    }
    removeDomainCookie(key) {
        document.cookie =
            key +
                '=;domain=' +
                this.setting.getconfig('cookieDomain') +
                '; expires=Thu, 01 Jan 1970 00:00:00 GMT;Path=/';
    }
    serializeSingleCookie(cookie) {
        let cookieString = '';
        cookieString += cookie.name + '=' + cookie.value;
        if (cookie.secure) {
            cookieString += ';Secure';
        }
        if (cookie.expires) {
            cookieString += ';Expires=' + cookie.expires;
        }
        if (cookie.sameSite) {
            cookieString += ';SameSite=' + cookie.sameSite;
        }
        if (cookie.domain) {
            cookieString += ';Domain=' + cookie.domain;
        }
        else {
            cookieString += ';Domain=';
        }
        cookieString += ';Path=/;';
        return cookieString;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrowserCookieService, deps: [{ token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrowserCookieService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrowserCookieService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AppConfigSettings }] });

class CoreService {
    constructor(ngZone, router, store, translateService, storageService, cookieService, authService, userService, permissionService, tenantMgmtService, tenantStandAloneService, searchServiceV2, settings) {
        this.ngZone = ngZone;
        this.router = router;
        this.store = store;
        this.translateService = translateService;
        this.storageService = storageService;
        this.cookieService = cookieService;
        this.authService = authService;
        this.userService = userService;
        this.permissionService = permissionService;
        this.tenantMgmtService = tenantMgmtService;
        this.tenantStandAloneService = tenantStandAloneService;
        this.searchServiceV2 = searchServiceV2;
        this.settings = settings;
        this.isLoading = false;
        this.showBackDrop = false;
    }
    setSessionTimeoutTimer(timeForReminder, expired) {
        this.cancelSessionTimeoutTimer();
        const url = this.router.url;
        if (!url.startsWith('/sso/')) {
            this.ngZone.runOutsideAngular(() => {
                this.sessionTimeoutTimerSub = timer(timeForReminder).subscribe((x) => {
                    this.ngZone.run(() => {
                        expired();
                    });
                    // this.store.dispatch(new DisplaySessionTimeoutWarningAction({ display: true, countDown: 30000 }));
                });
            });
        }
        else {
            this.ngZone.runOutsideAngular(() => {
                this.sessionTimeoutTimerSub = timer(14 * 1000 * 60).subscribe((x) => {
                    this.ngZone.run(() => {
                        this.store.dispatch(new UserNotificationAction({
                            type: 'error',
                            message: this.translateService.instant('ARC_SHARED_SESSION_ERROR_ACCESSTOKEN_EXPIRED'),
                            sticky: false,
                        }));
                        this.router.navigateByUrl('/accessdenied');
                    });
                });
            });
        }
    }
    cancelSessionTimeoutTimer() {
        if (this.sessionTimeoutTimerSub) {
            this.sessionTimeoutTimerSub.unsubscribe();
        }
    }
    getUserProfileWithTenantList(accessToken, fetchTenant = true) {
        let userProfile$;
        if (fetchTenant) {
            userProfile$ = this.userService.v1UsersProfileGet(accessToken).pipe(exhaustMap((profile) => this.tenantStandAloneService.v1TenantsGet(accessToken, true).pipe(map((tenantList) => {
                const tenants = Array.from(tenantList).sort((a, b) => {
                    a.tenantName = a.tenantName || '';
                    b.tenantName = b.tenantName || '';
                    return a.tenantName.localeCompare(b.tenantName);
                });
                return { ...profile, tenants: tenants };
            }))));
        }
        else {
            userProfile$ = this.userService.v1UsersProfileGet(accessToken);
        }
        return userProfile$;
    }
    CheckAndSetExternalUserProfileForTenant$(auth, accessToken) {
        const tenantId = auth.tenantId;
        const applicationId = auth.applicationId;
        const personaId = auth.personaId;
        const featureId = auth.featureId;
        if (!tenantId || !applicationId || !personaId) {
            throw new Error('empty payload');
        }
        const userProfile$ = this.userService.v1UsersProfileGet(accessToken);
        const checkExternalExistsForTenant$ = this.userService.v1TenantsTenantIdApplicationApplicationIdPersonaPersonaIdUsersProfileIsExternalUserGet(tenantId, applicationId, personaId, accessToken);
        const addExternalUserForTenant$ = this.authService.V1TenantsByTenantIdUserExternalAnonymousApplicationByApplicationIdPersonaByPersonaIdFeatureByFeatureIdPost({
            email: auth.email,
            firstName: '',
            lastName: '',
            templateId: '',
            redirectUrl: auth.redirectUrl,
            newUserWelcomeTemplateTypeId: auth.newUserWelcomeTemplateTypeId,
            existingUserWelcomeTemplateTypeId: auth.existingUserWelcomeTemplateTypeId,
        }, tenantId, applicationId, featureId, personaId);
        const pollExternalUserCreatedForTenant$ = this.permissionService
            .v1TenantsTenantIdApplicationApplicationIdFeatureFeatureIdPersonaPersonaIdRoleProfileGet(tenantId, applicationId, featureId, personaId, accessToken)
            .pipe(retryWhen((x) => x.pipe(delay(1000), take(25))));
        const getExternalRole$ = this.permissionService.v1TenantsTenantIdApplicationApplicationIdFeatureFeatureIdPersonaPersonaIdRoleProfileGet(tenantId, applicationId, featureId, personaId, accessToken);
        const addExternalUserToTenantPollToSucceed$ = addExternalUserForTenant$.pipe(switchMap((x) => {
            return pollExternalUserCreatedForTenant$;
        }));
        const checkAndSetExternalUser$ = checkExternalExistsForTenant$.pipe(mergeMap((x) => {
            if (featureId) {
                if (x.exists) {
                    return getExternalRole$;
                }
                else {
                    return addExternalUserToTenantPollToSucceed$;
                }
            }
            return of(true);
        }));
        const getTenantProfileById$ = this.tenantStandAloneService
            .v1TenantsByIdGet(tenantId, accessToken)
            .pipe();
        return forkJoin([userProfile$, checkAndSetExternalUser$]).pipe(switchMap(([x, y]) => getTenantProfileById$.pipe(map((t) => {
            return {
                user: { ...x, activeRole: y, accessToken: accessToken },
                activeTenant: { ...t, role: y },
                accessToken: accessToken,
                loginRedirectUrl: auth.loginRedirectUrl,
                authPayload: auth,
            };
        }))));
    }
    ReloadExternalUserProfileForTenant$(auth, accessToken) {
        const tenantId = auth.tenantId;
        const applicationId = auth.applicationId;
        const personaId = auth.personaId;
        const featureId = auth.featureId;
        if (!tenantId || !applicationId || !personaId) {
            throw new Error('empty payload');
        }
        const userProfile$ = this.userService
            .v1UsersProfileGet(accessToken)
            .pipe(catchError(() => of({})));
        const getExternalRole$ = !!featureId
            ? this.permissionService.v1TenantsTenantIdApplicationApplicationIdFeatureFeatureIdPersonaPersonaIdRoleProfileGet(tenantId, applicationId, featureId, personaId, accessToken)
            : of({});
        const getTenantProfileById$ = this.tenantStandAloneService
            .v1TenantsByIdGet(tenantId, accessToken)
            .pipe(catchError(() => of({})));
        return forkJoin([
            userProfile$,
            getExternalRole$,
            getTenantProfileById$,
        ]).pipe(map(([x, y, t]) => ({
            user: { ...x, activeRole: y },
            activeTenant: { ...t, role: y },
            accessToken: accessToken,
            loginRedirectUrl: auth.loginRedirectUrl,
            authPayload: auth,
        })));
    }
    defineActiveTenant() { }
    defineTenantForSession(defaultTenantId, tenantList) {
        tenantList = tenantList || [];
        let defaultTenant;
        if (defaultTenantId) {
            defaultTenant = (tenantList || []).find((x) => x.tenantId === defaultTenantId);
        }
        let activeTenant = defaultTenant;
        if (!activeTenant) {
            if (tenantList.length > 0) {
                activeTenant = {
                    ...tenantList[0],
                    regularTenantId: tenantList[0].tenantId,
                };
            }
        }
        else {
            activeTenant = {
                ...activeTenant,
                regularTenantId: activeTenant.tenantId,
            };
        }
        return activeTenant;
    }
    // get user role for the tenant, get applications enabled by tenant
    getTenantProfileByUser(tenantId, accessToken) {
        const getTenantProfileById$ = this.tenantStandAloneService
            .v1TenantsByIdGet(tenantId, accessToken)
            .pipe(map((x) => {
            if (!x.isTestTenant) {
                return { ...x, regularTenantId: x.tenantId };
            }
            else {
                return x;
            }
        }));
        const getTenantMetaById$ = this.tenantMgmtService.v1TenantsTenantIdMetaGet(tenantId, accessToken).pipe(catchError((err) => {
            console.error(err);
            return of({ 'externalClientConnectUrl': '' });
        })); // Don't stop login flow even if this fails
        const getTenantRole$ = this.permissionService
            .v1TenantsByTenantIdRoleProfileGet(tenantId, accessToken)
            .pipe(catchError(() => of(null)));
        const tenantApplications$ = this.tenantStandAloneService.v1TenantsByIdApplicationsGet(tenantId, 'true', accessToken);
        const getTenantProfileByUser$ = combineLatest([
            getTenantRole$,
            tenantApplications$,
            getTenantProfileById$,
            getTenantMetaById$,
        ]).pipe(map(([x, z, tenantProfile, tenantMeta]) => {
            tenantMeta.externalClientConnectUrl = removeTrailingSlashes(tenantMeta.externalClientConnectUrl);
            return ({
                ...tenantProfile,
                role: x,
                applications: z,
                clientConnectUrl: tenantMeta.externalClientConnectUrl, // tenant-mgmt service changed this key name, so we duplicate to the old name since other frontends rely on it
                ...tenantMeta,
            });
        }));
        return getTenantProfileByUser$;
    }
    getLandingRoute(user, tenant, role, loginRedirectUrl) {
        if (!user || !user.userId) {
            return this.settings.routes.loginRoute;
        }
        tenant = tenant || {};
        role = role || {};
        const roleId = role.roleId;
        const tenantId = tenant.tenantId;
        let routeUrl = this.storageService.getItem('latest_context') ||
            this.settings.routes.dashboardRoute;
        if (!tenantId || !roleId) {
            routeUrl = this.settings.routes.profileRoute;
            return routeUrl;
        }
        if (loginRedirectUrl) {
            routeUrl = loginRedirectUrl;
        }
        return routeUrl;
    }
    addGoogleAnalytics(useEnv = true) {
        const env = this.settings.environment;
        const scriptUrl = 'https://www.googletagmanager.com/gtag/js?id=UA-1432080-11';
        const initSCript = `
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', 'UA-1432080-11');
  `;
        if (env === 'prod' && useEnv) {
            this.loadScript(scriptUrl, '');
            this.loadScript('', initSCript);
        }
        else if (!useEnv) {
            this.loadScript(scriptUrl, '');
            this.loadScript('', initSCript);
        }
    }
    // Call get User profile, get tenant detail based tenant Ids,
    // defines active tenant aand cll get tenant profile for roles and permissions
    loadUserInfo(token, options = {}, loadTenantList) {
        const userOptions = { ...options };
        const tenantId = userOptions.tenantId;
        const redirectUrl = userOptions.returnUrl;
        let tenants = userOptions.tenants || [];
        userOptions.tenants = Array.from(tenants).sort((a, b) => {
            a.tenantName = a.tenantName || '';
            b.tenantName = b.tenantName || '';
            return a.tenantName.localeCompare(b.tenantName);
        });
        tenants = userOptions.tenants;
        const result = this.getUserProfileWithTenantList(token, loadTenantList).pipe(map((profile) => {
            const activeTenant = this.defineTenantForSession(tenantId || profile.defaultTenantId, loadTenantList ? profile.tenants : tenants);
            return {
                user: {
                    ...profile,
                    accessToken: token,
                    tenants: loadTenantList ? profile.tenants : tenants,
                },
                activeTenant: activeTenant,
                tenants: loadTenantList ? profile.tenants : tenants,
            };
        }), mergeMap((t) => {
            if (t.activeTenant) {
                return this.getTenantProfileByUser(t.activeTenant.tenantId, token).pipe(map((tenantProfile) => ({
                    ...t,
                    activeTenant: { ...t.activeTenant, ...tenantProfile },
                })));
            }
            else {
                return of(t);
            }
        }), map((result) => {
            const url = this.getLandingRoute(result.user, result.activeTenant, result.activeTenant ? result.activeTenant.role : null, redirectUrl || result.redirectUrl);
            result.loginRedirectUrl = url;
            result.accessToken = token;
            return result;
        }));
        return result;
    }
    setLocalStorageForLogin(token, activeTenant, appState) {
        this.clearLocalStorageForLogin();
        this.cookieService.setSessionCookiePerEnvEncoded('__bt_token', token);
        if (activeTenant && activeTenant.tenantId) {
            const liveTenantId = activeTenant.isTestTenant
                ? activeTenant.liveTenantId
                : activeTenant.tenantId;
            this.cookieService.setSessionCookiePerEnvEncoded('__bt_q_activetenant', JSON.stringify({
                tenantName: activeTenant.tenantName,
                tenantId: activeTenant.tenantId,
                tenantType: activeTenant.tenantType,
                isTestTenant: !!activeTenant.isTestTenant,
                // regularTenantId: activeTenant.regularTenantId,
                liveTenantId: liveTenantId,
            }));
        }
        this.storageService.setItem('appState', JSON.stringify(appState));
    }
    setTokenLocalStorage(token) {
        this.cookieService.setSessionCookiePerEnvEncoded('__bt_token', token);
    }
    setLocalStorageForExternalLogin(token, activeTenant, appId, featureId, personaId) {
        this.clearLocalStorageForExternalUserLogin();
        this.cookieService.setSessionCookiePerEnvEncoded('__bt_token', token);
        if (activeTenant && activeTenant.tenantId) {
            const liveTenantId = activeTenant.isTestTenant
                ? activeTenant.liveTenantId
                : activeTenant.tenantId;
            this.cookieService.setSessionCookiePerEnvEncoded('__bt_q_activetenant', JSON.stringify({
                tenantName: activeTenant.tenantName,
                tenantId: activeTenant.tenantId,
                tenantType: activeTenant.tenantType,
                isTestTenant: !!activeTenant.isTestTenant,
                liveTenantId: liveTenantId,
            }));
        }
        this.cookieService.setSessionCookiePerEnvEncoded('__bt_pf_appId', appId);
        this.cookieService.setSessionCookiePerEnvEncoded('__bt_pf_featureId', featureId);
        this.cookieService.setSessionCookiePerEnvEncoded('__bt_pf_personaId', personaId);
    }
    clearLocalStorageForLogin() {
        // Remove user lang preference from local storage
        this.storageService.removeItem('arc-userDefaultLang');
        this.storageService.removeItem('appState');
        this.cookieService.removeSessionCookiePerEnv('__bt_token');
        this.cookieService.removeSessionCookiePerEnv('__bt_q_activetenant');
        this.cookieService.removeSessionCookiePerEnv('__bt_logoutUrl');
        this.cookieService.removeSessionCookiePerEnv('__bt_pf_appId');
        this.cookieService.removeSessionCookiePerEnv('__bt_pf_featureId');
        this.cookieService.removeSessionCookiePerEnv('__bt_pf_personaId');
    }
    clearLocalStorageForExternalUserLogin() {
        this.storageService.removeItem('appState');
        this.cookieService.removeSessionCookiePerEnv('__bt_token');
        this.cookieService.removeSessionCookiePerEnv('__bt_q_activetenant');
        this.cookieService.removeSessionCookiePerEnv('__bt_logoutUrl');
        this.cookieService.removeSessionCookiePerEnv('__bt_pf_appId');
        this.cookieService.removeSessionCookiePerEnv('__bt_pf_featureId');
        this.cookieService.removeSessionCookiePerEnv('__bt_pf_personaId');
        this.cookieService.removeSessionCookiePerEnv('__bt_q_cc');
    }
    getAuthTokenFromLocalStorage() {
        return this.cookieService.readSessionCookiePerEnvDecoded('__bt_token');
    }
    getAppIdFromLocalStorage() {
        return this.cookieService.readSessionCookiePerEnvDecoded('__bt_pf_appId');
    }
    getFeatureIdFromLocalStorage() {
        return this.cookieService.readSessionCookiePerEnvDecoded('__bt_pf_featureId');
    }
    getPersonaIdFromLocalStorage() {
        return this.cookieService.readSessionCookiePerEnvDecoded('__bt_pf_personaId');
    }
    getClientConnectFromLocalStorage() {
        return this.cookieService.readSessionCookiePerEnvDecoded('__bt_q_cc');
    }
    setClientConnectLocalStorage(value) {
        this.cookieService.setSessionCookiePerEnvEncoded('__bt_q_cc', value);
    }
    clearClientConnectLocalStorage() {
        this.cookieService.removeSessionCookiePerEnv('__bt_q_cc');
    }
    getActiveTenantFromLocalStorage() {
        return this.cookieService.readSessionCookiePerEnvDecoded('__bt_q_activetenant');
    }
    getAppStateFromLocalStorage() {
        return this.storageService.getItem('appState');
    }
    writeLocalStorage(key, value) {
        this.storageService.setItem(key, value);
    }
    removeLocalStorage(key, value) {
        this.storageService.removeItem(key);
    }
    getLocalStorage(key) {
        return this.storageService.getItem(key);
    }
    isPageRefresh() {
        return !this.router.navigated;
    }
    loadScript(src, content, name) {
        if (src) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = src;
            document.getElementsByTagName('head')[0].appendChild(script);
        }
        else if (content) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.appendChild(document.createTextNode(content));
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }
    transformHighlights(text) {
        // return (text || '').replace('<em>', '<m>').replace('</em>', '</m>');
        return text;
    }
    removeHighlights(text) {
        return (text || '').replace('<em>', '').replace('</em>', '');
    }
    quickSearchAll(term, tenantId, types, pageNumber, pageSize) {
        return this.searchServiceV2
            .searchV2Typeahead(tenantId, term, types, pageNumber, pageSize, null, 'response')
            .pipe(map((response) => {
            const headers = response.headers;
            const pageMeta = {
                currentPageIndex: parseInt(headers.get('x-pagination-page'), 10),
                totalRecords: parseInt(headers.get('x-pagination-recordcount'), 10),
                pageSize: parseInt(headers.get('x-pagination-pagesize'), 10),
                term: term,
                types: types,
                results: [],
            };
            const x = response.body;
            const suggestions = (x || []).map((suggestion) => {
                const result = {};
                result.title = this.translateService.instant('ARC_TYPEAHEAD_TITLE_' + suggestion.type.toUpperCase());
                const t = suggestion;
                const searchType = t.type;
                if (searchType === 'accounts') {
                    const highlightArray = t.highlight;
                    const [accountName, accountNumber] = [
                        t.meta.accountName,
                        t.meta.accountNumber,
                    ].map((u) => {
                        return (highlightArray.find((item) => u
                            .toLowerCase()
                            .includes(this.removeHighlights(item).toLowerCase())) || u);
                    });
                    return {
                        type: searchType,
                        referenceId: t.referenceId,
                        accountName: this.transformHighlights(accountName),
                        accountNumber: this.transformHighlights(accountNumber),
                    };
                }
                if (searchType === 'invoices') {
                    const highlightArray = t.highlight;
                    const [billDate, invoiceNumber, billName] = [
                        t.meta.billDate,
                        t.meta.invoiceNumber,
                        t.meta.billName,
                    ].map((u) => {
                        if (!u)
                            return '';
                        return (highlightArray.find((item) => u
                            .toLowerCase()
                            .includes(this.removeHighlights(item).toLowerCase())) || u);
                    });
                    return {
                        type: searchType,
                        referenceId: t.referenceId,
                        accountId: t.meta.accountId,
                        billName: this.transformHighlights(billName),
                        accountName: this.transformHighlights(billName),
                        invoiceNumber: this.transformHighlights(invoiceNumber),
                        amount: billDate,
                    };
                }
                return result;
            });
            pageMeta.results = suggestions;
            return pageMeta;
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CoreService, deps: [{ token: i0.NgZone }, { token: i1$1.Router }, { token: i1$2.Store }, { token: i3.TranslateService }, { token: BrowserStorageService }, { token: BrowserCookieService }, { token: AuthService }, { token: UserService }, { token: PermissionV1Service }, { token: TenantMgmtV1Service }, { token: TenantStandAloneV1Service }, { token: SearchV2Service }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CoreService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CoreService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i0.NgZone }, { type: i1$1.Router }, { type: i1$2.Store }, { type: i3.TranslateService }, { type: BrowserStorageService }, { type: BrowserCookieService }, { type: AuthService }, { type: UserService }, { type: PermissionV1Service }, { type: TenantMgmtV1Service }, { type: TenantStandAloneV1Service }, { type: SearchV2Service }, { type: AppConfigSettings }] });

const AuthStore = createFeatureSelector('auth');
const AuthUserStore = createSelector(AuthStore, (state) => {
    if (state) {
        return state.user;
    }
});
const AuthUserProfileStore = createSelector(AuthStore, (state) => {
    if (state && state.user) {
        return state.user.user;
    }
});
const ResetPasswordStore = createSelector(AuthStore, (state) => {
    if (state) {
        return state.resetPassword;
    }
});
const ActiveTenantStore = createSelector(AuthStore, (state) => {
    if (state && state.user) {
        return state.user.activeTenant;
    }
});
const getActiveTenant$ = (store) => {
    const sStore = store;
    return sStore.pipe(select(ActiveTenantStore), filter((state) => state && !!state.tenantId), distinctUntilChanged((x, y) => x.tenantId === y.tenantId));
};
const userChanged$ = (store) => {
    const sStore = store;
    return sStore.pipe(select(AuthUserProfileStore), filter((state) => state && !!state.userId), distinctUntilChanged((x, y) => x.userId === y.userId));
};
const activeTenantSelector = (store) => {
    const sStore = store;
    return sStore.pipe(select(ActiveTenantStore), filter((state) => state && !!state.tenantId), distinctUntilChanged((x, y) => x.tenantId === y.tenantId));
};
const UserPermissionStore = createSelector(AuthStore, (state) => {
    if (state && state.user && state.user.activeRole) {
        const role = state.user.activeRole;
        return role.permissions;
    }
    else {
        return [];
    }
});
const UserPermissionSelector = createSelector(AuthStore, (state) => {
    return state?.permissions;
});
const selectTenantApplications = createSelector(ActiveTenantStore, (userTenant) => userTenant?.applications.map(applications => applications.applicationId));
const selectTenantResellerId = createSelector(ActiveTenantStore, (userTenant) => userTenant?.resellerId);
const userHasMultipleTenants = createSelector(AuthUserStore, (userState) => userState &&
    userState.user &&
    userState.user.tenants &&
    Array.isArray(userState.user.tenants) &&
    userState.user.tenants.length > 1);
const selectIsLoggedIn = createSelector(AuthUserStore, (userState) => userState &&
    userState.loggedIn);

var BackendMessageType;
(function (BackendMessageType) {
    BackendMessageType[BackendMessageType["BROADCAST"] = 0] = "BROADCAST";
    BackendMessageType[BackendMessageType["USER"] = 1] = "USER";
    BackendMessageType[BackendMessageType["TENANT"] = 2] = "TENANT";
    BackendMessageType[BackendMessageType["USERTENANT"] = 3] = "USERTENANT";
})(BackendMessageType || (BackendMessageType = {}));

class NotificationService {
    constructor(store, appConfigSetting, ngZone) {
        this.store = store;
        this.appConfigSetting = appConfigSetting;
        this.ngZone = ngZone;
        this.inBroadcast = false;
    }
    handleMessage(msg) {
        const message = {
            messageType: BackendMessageType.BROADCAST,
            payload: msg.message.body,
            action: msg.message.action,
        };
        if (msg.subscribedChannel.indexOf('user') !== -1 &&
            msg.subscribedChannel.indexOf('tenant') !== -1) {
            message.messageType = BackendMessageType.USERTENANT;
        }
        else if (msg.subscribedChannel.indexOf('user') !== -1) {
            message.messageType = BackendMessageType.USER;
        }
        else if (msg.subscribedChannel.indexOf('tenant') !== -1) {
            message.messageType = BackendMessageType.TENANT;
        }
        this.ngZone.runOutsideAngular(() => {
            this.store.dispatch(new BackendNotificationAction(message));
        });
    }
    handleTenantSwitch(activeTenant, userState) {
        if (this.previousTenant) {
            this.ngZone.runOutsideAngular(() => {
                this.pubnub.unsubscribe({
                    channels: [
                        `user-${userState.userId}-tenant-${this.previousTenant.tenantId}`,
                        `tenant-${this.previousTenant.tenantId}`,
                    ],
                });
            });
        }
        this.ngZone.runOutsideAngular(() => {
            this.pubnub.subscribe({
                channels: [
                    `user-${userState.userId}-tenant-${activeTenant.tenantId}`,
                    `tenant-${activeTenant.tenantId}`,
                ],
            });
        });
        this.previousTenant = activeTenant;
    }
    init() {
        this.pubnub = new PubNub({
            subscribeKey: this.appConfigSetting.getconfig('pubnubSubscriberKey'),
            ssl: true,
        });
        this.ngZone.runOutsideAngular(() => {
            this.pubnub.addListener({
                message: this.handleMessage.bind(this),
            });
        });
        this.store.select(AuthUserProfileStore).subscribe((user) => {
            if (!this.inBroadcast) {
                this.ngZone.runOutsideAngular(() => {
                    this.pubnub.subscribe({
                        channels: ['broadcast'],
                    });
                });
                this.inBroadcast = true;
            }
            if (user.userId) {
                this.previousUserId = user.userId;
                this.ngZone.runOutsideAngular(() => {
                    this.pubnub.subscribe({
                        channels: [`user-${user.userId}`],
                    });
                });
            }
            else {
                if (this.previousUserId) {
                    this.ngZone.runOutsideAngular(() => {
                        this.pubnub.unsubscribe({
                            channels: [`user-${this.previousUserId}`],
                        });
                    });
                }
            }
        });
        getActiveTenant$(this.store).subscribe((activeTenant) => {
            let storeUser;
            this.store
                .pipe(select(AuthUserProfileStore), take(1))
                .subscribe((user) => {
                storeUser = user;
            });
            this.handleTenantSwitch(activeTenant, storeUser);
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NotificationService, deps: [{ token: i1$2.Store }, { token: AppConfigSettings }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NotificationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NotificationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: AppConfigSettings }, { type: i0.NgZone }] });

class SentryService {
    constructor() {
        this.handleError = console.error;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SentryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SentryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SentryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class AuthenticationErrorStatus {
    static { this.BAD_USERNAME_OR_PASSWORD = 'BAD_USERNAME_OR_PASSWORD'; }
    static { this.PASSSWORD_RESET_REQUIRED = 'PASSSWORD_RESET_REQUIRED'; }
    static { this.INVALID_PASSWORD = 'INVALID_PASSWORD'; }
    static { this.RESET_CODE_INVALID = 'RESET_CODE_INVALID'; }
    static { this.BAD_USERNAME = 'BAD_USERNAME'; }
    static { this.CODE_DELIVERY_FAILURE = 'CODE_DELIVERY_FAILURE'; }
    static { this.USER_NOT_CONFIRMED = 'USER_NOT_CONFIRMED'; }
    static { this.CODE_MISMATCH = 'CODE_MISMATCH'; }
    static { this.EXPIRED_CODE = 'EXPIRED_CODE'; }
    static { this.NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'; }
    static { this.RESET_CODE_SENT = 'RESET_CODE_SENT'; }
    static { this.RESET_REQUEST_FAILED = 'RESET_REQUEST_FAILED'; }
    static { this.TEMPORARY_PASSWORD_EXPIRED = 'TEMPORARY_PASSWORD_EXPIRED'; }
    static { this.PASSWORD_IN_HISTORY = 'PASSWORD_IN_HISTORY'; }
}
class AuthenticationSuccessStatus {
    static { this.LOGIN_SUCCESS = 'LOGIN_SUCCESS'; }
    static { this.RESET_SUCCESS = 'RESET_SUCCESS'; }
}

/**
 * Authentication
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * User Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * User Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * User Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * User Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

class PermissionTypes {
    static { this.UserRoleManagement = 'arc-permission-section-users-permission-usersandrolesmanagement'; }
    static { this.Email = 'arc-permission-section-email-permission-sendemail'; }
    static { this.CoreAuth = 'rc-permission-section-core-permission-auth'; }
    static { this.AccountManagement = 'arc-permission-section-accounts-permission-accountsmanagement'; }
    static { this.SSOConfiguration = 'arc-permission-section-system-settings-permission-sso-configuration'; }
    static { this.ReportManagement = 'arc-permission-section-reports-permission-reportmanagement'; }
    static { this.ServiceAccountPermission = 'arc-permission-section-users-permission-serviceaccounts'; }
    constructor(store) {
        this.store = store;
        this.UserRoleManagement = 'arc-permission-section-users-permission-usersandrolesmanagement';
        this.Email = 'arc-permission-section-email-permission-sendemail';
        this.CoreAuth = 'rc-permission-section-core-permission-auth';
        this.AccountManagement = 'arc-permission-section-accounts-permission-accountsmanagement';
        this.SSOConfiguration = 'arc-permission-section-system-settings-permission-sso-configuration';
        this.ReportManagement = 'arc-permission-section-reports-permission-reportmanagement';
        this.ServiceAccountPermission = 'arc-permission-section-users-permission-serviceaccounts';
    }
    hasPermission(permissionData, permissionString) {
        const permissions = this._tryParsePermissionV3(permissionString);
        return this._evaluatePermissionStack(permissionData, permissions);
    }
    // for performance improvement
    hasPermissionKeyValue(permissionData, permissionString) {
        const permissions = this._tryParsePermission(permissionString);
        if (permissions[1]) {
            const permissionRequired = permissions[0];
            let hasPermission = false;
            const permissionForKey = permissionData[permissionRequired.permissionId];
            if (!!permissionForKey) {
                const loopPar = ['read', 'edit', 'delete', 'create'];
                for (const key of loopPar) {
                    if (permissionRequired[key]) {
                        hasPermission = hasPermission || permissionForKey[key];
                    }
                }
            }
            return hasPermission;
        }
        return false;
    }
    hasPermissionAndApp$(store, permissionString, apps) {
        apps = apps || [];
        return combineLatest(this.store.pipe(select(UserPermissionStore), filter((t) => t && t.length && t.length > 0)), getActiveTenant$(this.store)).pipe(map(([x, y]) => {
            const permissionStoreData = x || [];
            const hasPermission = permissionString
                ? this.hasPermission(permissionStoreData, permissionString)
                : true;
            let hasApp = !!(y.applications || []).find((app) => apps.includes(app.applicationId));
            if (apps.length === 0) {
                hasApp = true;
            }
            return hasPermission && hasApp;
        }));
    }
    hasPermission$(store, permissionString) {
        return store.pipe(select(UserPermissionStore), filter((t) => t && t.length && t.length > 0), take(1), map((x) => {
            const permissionStoreData = x || [];
            return this.hasPermission(permissionStoreData, permissionString);
        }));
    }
    // require user to handle unsubscribe
    isPermitted$(permissionString, store) {
        const fStore = store || this.store;
        return fStore.pipe(select(UserPermissionStore), filter((t) => t && t.length && t.length > 0), map((x) => {
            const permissionStoreData = x || [];
            return this.hasPermission(permissionStoreData, permissionString);
        }));
    }
    filterArrayWithPermission(inputArray, permissionStringKeyName, store) {
        permissionStringKeyName = permissionStringKeyName || 'permissionString';
        return new Promise((resolve) => {
            return this.store
                .pipe(select(UserPermissionStore), take(1))
                .subscribe((permissionData) => {
                resolve(inputArray.filter((x) => this.hasPermission(permissionData, x[permissionStringKeyName])));
            });
        });
    }
    filterArrayWithPermission$(inputArray, permissionStringKeyName, store) {
        const fStore = store || this.store;
        permissionStringKeyName = permissionStringKeyName || 'permissionString';
        return fStore.pipe(select(UserPermissionStore), map((permissionData) => {
            return inputArray.filter((x) => this.hasPermission(permissionData, x[permissionStringKeyName]));
        }));
    }
    filterArray$(inputArray, permissionStringKeyName) {
        permissionStringKeyName = permissionStringKeyName || 'permissionString';
        return this.store.pipe(select(UserPermissionStore), map((permissionData) => {
            return inputArray.filter((x) => (x[permissionStringKeyName] &&
                this.hasPermission(permissionData, x[permissionStringKeyName])) ||
                !x[permissionStringKeyName]);
        }));
    }
    /*
      permissionString format: [permissionId:read,create,delete,edit]
  
       and is &&
       or is  ||
       should support ()
       future *
    */
    _tryParsePermission(permissionString) {
        const result = {
            permissionId: '',
            read: false,
            create: false,
            edit: false,
            delete: false,
        };
        if (permissionString) {
            const parts = permissionString.split(':');
            if (parts && parts.length > 1) {
                result.permissionId = (parts[0] + '').trim();
                const permissions = parts[1].split(',') || [];
                permissions.forEach((item) => {
                    if (item.trim() === 'read') {
                        result.read = true;
                    }
                    if (item.trim() === 'create') {
                        result.create = true;
                    }
                    if (item.trim() === 'delete') {
                        result.delete = true;
                    }
                    if (item.trim() === 'edit') {
                        result.edit = true;
                    }
                });
                return [result, this._validatePermission(result)];
            }
            else {
                return [result, this._validatePermission(result)];
            }
        }
        return [result, false];
    }
    _tryParsePermissionV2(permissionString) {
        const result = {
            permissionId: '',
            read: false,
            create: false,
            edit: false,
            delete: false,
        };
        const permissionStack = [];
        if (permissionString) {
            const parts = permissionString.split(':');
            if (parts && parts.length > 1) {
                result.permissionId = (parts[0] + '').trim();
                const permissions = parts[1].split(',') || [];
                permissions.forEach((item) => {
                    if (item.trim() === 'read') {
                        result.read = true;
                    }
                    if (item.trim() === 'create') {
                        result.create = true;
                    }
                    if (item.trim() === 'delete') {
                        result.delete = true;
                    }
                    if (item.trim() === 'edit') {
                        result.edit = true;
                    }
                });
                return [result, this._validatePermission(result)];
            }
            else {
                return [result, this._validatePermission(result)];
            }
        }
        return [result, false];
    }
    _tryParsePermissionV3(permissionString) {
        const permissionStack = [];
        let conditionAnd = true;
        if (permissionString) {
            let permissionStringArray = [];
            if (permissionString.indexOf('||') > -1) {
                permissionStringArray = permissionString.split('||');
                conditionAnd = false;
            }
            else if (permissionString.indexOf('&&') > -1) {
                permissionStringArray = permissionString.split('&&');
            }
            else {
                permissionStringArray = [permissionString];
            }
            permissionStringArray.forEach((singlePermissionString) => {
                const result = {
                    permissionId: '',
                    read: false,
                    create: false,
                    edit: false,
                    delete: false,
                };
                const parts = singlePermissionString.split(':');
                if (parts && parts.length > 1) {
                    result.permissionId = (parts[0] + '').trim();
                    const permissions = parts[1].split(',') || [];
                    permissions.forEach((item) => {
                        if (item.trim() === 'read') {
                            result.read = true;
                        }
                        if (item.trim() === 'create') {
                            result.create = true;
                        }
                        if (item.trim() === 'delete') {
                            result.delete = true;
                        }
                        if (item.trim() === 'edit') {
                            result.edit = true;
                        }
                    });
                    permissionStack.push(result);
                }
            });
            return [
                permissionStack,
                this._validatePermissionV2(permissionStack),
                conditionAnd,
            ];
        }
        else {
            return [
                permissionStack,
                this._validatePermissionV2(permissionStack),
                conditionAnd,
            ];
        }
        // return [permissionStack, false];
    }
    _evaluatePermissionStack(_permissionData, _permissionStack) {
        if (_permissionStack[1]) {
            const permissionStack = _permissionStack[0];
            if (permissionStack && permissionStack.length === 0) {
                return false;
            }
            const permissionData = _permissionData || [];
            const conditionAnd = _permissionStack[2];
            let hasPermission = null;
            permissionStack.forEach((permissionDefinition) => {
                if (conditionAnd) {
                    if (hasPermission === null) {
                        hasPermission = true;
                    }
                    hasPermission =
                        this._evaluateSinglePermission(permissionData, permissionDefinition) && hasPermission;
                }
                else {
                    if (hasPermission === null) {
                        hasPermission = false;
                    }
                    hasPermission =
                        this._evaluateSinglePermission(permissionData, permissionDefinition) || hasPermission;
                }
            });
            return hasPermission;
        }
        return false;
    }
    _evaluateSinglePermission(_permissionData, _singlePermissionDef) {
        return _permissionData.some((permissionSection) => {
            const permissionArray = permissionSection.permissions || [];
            return permissionArray.some((permission) => {
                let resultFlag = false;
                let keyFound = false;
                const nameMatch = permission.permissionId === _singlePermissionDef.permissionId;
                if (!nameMatch) {
                    return false;
                }
                const loopPar = ['read', 'edit', 'delete', 'create'];
                for (const key of loopPar) {
                    if (_singlePermissionDef[key]) {
                        if (!keyFound) {
                            keyFound = true;
                        }
                        resultFlag = resultFlag || permission[key];
                    }
                }
                return keyFound ? resultFlag : false;
            });
        });
    }
    _validatePermission(permission) {
        if (permission.permissionId) {
            return true;
        }
        return false;
    }
    _validatePermissionV2(permissionArray) {
        return (permissionArray &&
            permissionArray.length > 0 &&
            permissionArray.every((x) => x.permissionId));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionTypes, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionTypes, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionTypes, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }] });

class ApplicationType {
    static { this.Quantum = 'arc-quantum'; }
    static { this.Cash = 'cash-app'; }
    static { this.Credit = 'credit-app'; }
    static { this.Credit2 = 'credit-app-2'; }
    static { this.Collection = 'collections-app'; }
}

class PageMeta {
}

class DataDogService {
    constructor(appConfigSetting) {
        this.appConfigSetting = appConfigSetting;
        this.sessionReplayEnabled = false;
        this.sessionReplaySampleRate = 0;
        this.initializeRum = (datadogContext) => {
            if (!datadogRum.getInternalContext()) {
                datadogRum.init({
                    applicationId: this.applicationId,
                    clientToken: this.clientToken,
                    site: this.site, // 'datadoghq.com'
                    service: this.service, // 'composite' -> 'app.billtrust.com'
                    env: this.environment, // [prod|uat|dev]
                    version: this.version,
                    sessionSampleRate: 100,
                    sessionReplaySampleRate: this.sessionReplaySampleRate, // if not included, the default is 100
                    trackUserInteractions: true,
                    trackResources: true,
                    trackLongTasks: true,
                    beforeSend: (event, context) => {
                        // skip logging for the following routes
                        const appRoute = event.view.url.split('/')[3];
                        switch (appRoute) {
                            case 'bpn':
                                return false;
                            case 'bpn-accounts':
                                return false;
                            default:
                                break;
                        }
                        if (datadogContext.activeTenant.tenantType === 'standard') {
                            event.context = {
                                ...event.context,
                                userId: datadogContext.user.userId,
                                emailAddress: datadogContext.user.email,
                                tenantId: datadogContext.activeTenant.tenantId,
                                tenantType: datadogContext.activeTenant.tenantType,
                            };
                        }
                        if (this.isRumResourceEvent(event) && event.resource.url.includes('/ccsignin.php')) {
                            event.resource.url = event.resource.url.replace(/accessToken=[^&]*/, 'accessToken=REDACTED');
                        }
                        return true;
                    },
                });
            }
        };
        this.initializeLogging = () => datadogLogs.init({
            clientToken: this.clientToken,
            site: this.site,
            service: this.service,
            env: this.environment,
            version: this.version,
            forwardErrorsToLogs: true,
            sessionSampleRate: 100,
            forwardConsoleLogs: 'all',
        });
        this.setUser = (datadogContext) => {
            datadogRum.setUser({
                id: datadogContext.user.userId,
                email: datadogContext.user.email,
                tenantId: datadogContext.activeTenant.tenantId,
                tenantName: datadogContext.activeTenant.tenantName,
            });
        };
        this.applicationId = this.appConfigSetting.getconfig('dataDogApplicationId');
        this.clientToken = this.appConfigSetting.getconfig('dataDogClientToken');
        this.site = this.appConfigSetting.getconfig('dataDogSite');
        this.service = this.appConfigSetting.getconfig('dataDogService');
        this.environment = this.appConfigSetting.getconfig('environment');
        this.version = this.appConfigSetting.getconfig('releaseTag');
        this.sessionReplayEnabled =
            this.appConfigSetting.getconfig('dataDogSessionReplayEnabled') === 'true';
        this.sessionReplaySampleRate = +this.appConfigSetting.getconfig('dataDogSessionReplaySampleRate');
    }
    handleError(error, context) {
        datadogRum.addError(error, context);
    }
    isRumResourceEvent(event) {
        return event.resource !== undefined && event.resource.url !== undefined;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DataDogService, deps: [{ token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DataDogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DataDogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: AppConfigSettings }] });

class PendoService {
    constructor(store, appConfig, zone) {
        this.store = store;
        this.appConfig = appConfig;
        this.zone = zone;
        this._isFirstLoad = true;
        this.setupPendo();
    }
    get isAnalyticEnabled() {
        return this.appConfig.getconfig('enablePendoAnalytics') === 'true';
    }
    setupPendo() {
        if (!pendo) {
            console.warn('pendo not defined');
            return;
        }
        if (this.isAnalyticEnabled) {
            if (this._isFirstLoad) {
                this.zone.runOutsideAngular(() => {
                    pendo.initialize({
                        account: {
                            resellerid: 'BILLTRUST'
                        }
                    });
                    // pendo.startSendingEvents();
                    // pendo.startGuides();
                    this._isFirstLoad = false;
                });
            }
        }
        const user$ = this.store.pipe(select(AuthUserStore), filter((x) => x && x.loggedIn && !!x.user), distinctUntilChanged((x, y) => x.user.userId === y.user.userId));
        const roleIds$ = this.store.pipe(select(UserPermissionStore), map((permissions) => Array.from(new Set(permissions.map(permission => permission.description)))));
        combineLatest([user$, getActiveTenant$(this.store), roleIds$])
            .pipe(filter(() => this.isAnalyticEnabled), tap(([x, y, roleIds]) => {
            this.zone.runOutsideAngular(() => {
                if (y.tenantType !== 'automation' ||
                    y.tenantName === 'Billtrust Test Environment') {
                    // pendo.initialize(this.setVisitorAndAccount(x.user, y));
                    pendo.updateOptions(this.setVisitorAndAccount(x.user, y, roleIds));
                }
                else if (y.tenantType === 'automation' &&
                    y.tenantName !== 'Billtrust Test Environment') {
                    // pendo.updateOptions(this.setVisitorAndAccount());
                    if (pendo) {
                        pendo.stopSendingEvents();
                        pendo.stopGuides();
                        // send nothing if tenant is automation tenant
                    }
                }
                else {
                    pendo.startSendingEvents();
                    pendo.startGuides();
                    pendo.updateOptions(this.setVisitorAndAccount(x.user, y, roleIds));
                }
            });
        }))
            .subscribe();
    }
    setVisitorAndAccount(user, tenant, roleIds) {
        const payLoad = {};
        if (user) {
            payLoad.visitor = {
                id: user.email,
                email: user.email,
                userId: user.userId,
                creationDate: user.createdDate,
                profileLanguage: normalizeLanguageLocale(user.defaultLanguage),
                roles: roleIds,
            };
        }
        else {
            payLoad.visitor = {};
        }
        if (tenant) {
            // get the salesforce id from the BURN in the array of tenantExternalIds
            let salesforceId = 'not-specified';
            if (tenant.tenantExternalIds) {
                let salesForceIds = tenant.tenantExternalIds.filter((externalId) => externalId.toLowerCase().includes('salesforceid'));
                if (salesForceIds != null) {
                    salesForceIds.some((externalId) => {
                        let burnArray = externalId.split(':');
                        if (burnArray.length > 1) {
                            salesforceId = burnArray[burnArray.length - 1];
                            return true;
                        }
                    });
                }
            }
            payLoad.account = {
                id: tenant.tenantId,
                name: tenant.tenantName,
                tenantId: tenant.tenantId,
                tenantExternalId: tenant.tenantExternalId,
                tenantUsername: tenant.tenantUsername,
                salesforceId: salesforceId,
                resellerid: tenant?.resellerId ?? 'BILLTRUST',
            };
        }
        else {
            payLoad.account = {};
        }
        this._payload = payLoad;
        return payLoad;
    }
    /**
     * Add additional context about the account and user to pendo.
     * Pendo initializes very early in the bootstrapping of the angular application.
     * Use this method to inject additional tracking attributes, that are not ascertained by default during the ng-application's startup.
     * @param accountExtras Additional data points representing the tenant.
     * @param visitorExtras Additional data points representing the user.
     */
    includeAdditionalContext(accountExtras, visitorExtras) {
        if (!this._payload) {
            console.error('Cannot include additional context. setVisitorAndAccount() must be applied first.');
            return;
        }
        let payload = { ...this._payload }; // copy existing
        // mix in the extras
        payload.account = { ...this._payload.account, ...accountExtras };
        payload.visitor = { ...this._payload.visitor, ...visitorExtras };
        // outside of anuglar, re-apply
        this.zone.runOutsideAngular(() => {
            pendo.updateOptions(payload);
        });
        this._payload = payload;
    }
    /**
     * Track Events allow you to record any actions your users perform,
     * along with any properties that describe the action. Each action is known as an event.
     * Each event has a name and properties. For example, a "Registered" event may
     * have properties like "plan" or "accountType."
     * See https://support.pendo.io/hc/en-us/articles/360032294291-Track-Events-Configuration for more info.
     * @param eventName The name of the event. This is how track events will display in Pendo
     * @param eventData [optional] Data related to the event. Note that to discretely use these, the data must be a flat structure.
     */
    trackEvent(eventName, eventData) {
        if (this.isAnalyticEnabled && eventName) {
            pendo.track(eventName, eventData);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PendoService, deps: [{ token: i1$2.Store }, { token: AppConfigSettings }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PendoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PendoService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: AppConfigSettings }, { type: i0.NgZone }] });
function normalizeLanguageLocale(defaultLanguage) {
    try {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale
        // https://datatracker.ietf.org/doc/html/rfc5646
        return new Intl.Locale(defaultLanguage).toLocaleString();
    }
    catch {
        return 'en'; // This should NOT happen, but if it does, default to 'en'.
    }
}

class RoutePermissions {
    constructor(store, permissionType, coreService) {
        this.store = store;
        this.permissionType = permissionType;
        this.coreService = coreService;
    }
    /**
     * Returns an Observable<Route[]> which is a filtered list of the input routes which represent which routes the user has access to.
     * It uses the data property on the each route and considers the following optional properties: "permissionString: string", "apps: string[]".
     * If neither of these properties are present (or no data property exists on the route), the user is allowed to access the route.
     * @param routes
     */
    getPermissibleRoutes$(routes) {
        return getActiveTenant$(this.store).pipe(switchMap((tenant) => {
            let hasClientConnectSession = (this.coreService.getClientConnectFromLocalStorage() || '') === '1';
            const obs = routes
                .filter((r) => !r.data.clientConnectOnly ||
                (r.data.clientConnectOnly && hasClientConnectSession))
                .map((route) => this.getHasPermissionForRoute$(tenant, route));
            const permissibleRoutes$ = forkJoin(obs).pipe(map((items) => items.filter((item) => item.hasPermission)), map((items) => items.map((item) => item.route)));
            return permissibleRoutes$;
        }));
    }
    getHasPermissionForRoute$(tenant, route) {
        let apps = [];
        if (route.data && route.data.apps)
            apps = route.data.apps || [];
        let permissionString = null;
        if (route.data && route.data.permissionString)
            permissionString = route.data.permissionString;
        if (!!permissionString && apps.length > 0) {
            // if there are both permission + apps defined on tab, display it based on hasPermissionAndApp
            return this.permissionType
                .hasPermissionAndApp$(this.store, permissionString, apps)
                .pipe(take(1), map((hasPermission) => ({ hasPermission, route: route })));
        }
        else if (!!permissionString && apps.length === 0) {
            // if there is only a permission string (and not any apps), display it based on that
            return this.permissionType
                .hasPermission$(this.store, permissionString)
                .pipe(take(1), map((hasPermission) => ({ hasPermission, route: route })));
        }
        else if (!permissionString && apps.length > 0) {
            // if there is only apps defined (and not permissionString), display it based on that
            const tenantApplications = tenant.applications || [];
            // has permission if they have ANY of the applications the route needs
            const hasPermission = tenantApplications.filter((application) => apps.indexOf(application.applicationId) >= 0).length > 0;
            return of({ hasPermission, route });
        }
        else {
            // Already tried to verify permissions every other way I know.  At this point, just let them see it.
            return of({ hasPermission: true, route: route });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RoutePermissions, deps: [{ token: i1$2.Store }, { token: PermissionTypes }, { token: CoreService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RoutePermissions, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RoutePermissions, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: PermissionTypes }, { type: CoreService }] });

class RedirectToLatestContextService {
    constructor(storage) {
        this.storage = storage;
    }
    GetRedirectToRoute(permissibleRoutes) {
        if (permissibleRoutes.length === 0)
            return null;
        const sortedRoutes = permissibleRoutes.sort((a, b) => {
            if (!a.data && !b.data)
                return 0;
            if (!a.data)
                return -1;
            if (!b.data)
                return 1;
            return a.data.displayOrder - b.data.displayOrder;
        });
        const lastTabId = this.storage.getItem(`latest_context`);
        if (!lastTabId)
            return sortedRoutes[0];
        const redirectTo = sortedRoutes
            .filter((r) => r.path != `cc`)
            .find((availableRoute) => availableRoute.data.tabId === lastTabId);
        if (redirectTo == null)
            return sortedRoutes[0];
        return redirectTo;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectToLatestContextService, deps: [{ token: BrowserStorageService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectToLatestContextService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectToLatestContextService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BrowserStorageService }] });

class DemoDataService {
    constructor(store, permissionType, demoDataService) {
        this.store = store;
        this.permissionType = permissionType;
        this.demoDataService = demoDataService;
        this.destroy$ = new Subject();
    }
    putDemoDataRequest$() {
        return getActiveTenant$(this.store).pipe(take(1), switchMap((tenant) => {
            if (tenant.tenantType === 'automation' ||
                tenant.tenantType === 'demo') {
                return this.demoDataService.v1DemoDataPut(tenant.tenantId).pipe(tap((x) => {
                    const action = new UserNotificationAction({
                        type: 'success',
                        message: 'Refreshing the database. Please wait',
                    });
                    this.store.dispatch(action);
                }), catchError((error) => {
                    const action = new UserNotificationAction({
                        type: 'error',
                        message: 'Error while refreshing demo data',
                    });
                    this.store.dispatch(action);
                    return of({});
                }), map((response) => { }));
            }
            else {
                return of({});
            }
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DemoDataService, deps: [{ token: i1$2.Store }, { token: PermissionTypes }, { token: DemoDataV1Service }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DemoDataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DemoDataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: PermissionTypes }, { type: DemoDataV1Service }] });

class AppNameService {
    constructor() {
        this._name = new BehaviorSubject('billtrust');
    }
    get name$() {
        return this._name.asObservable();
    }
    setName(value) {
        this._name.next(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppNameService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppNameService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppNameService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class NotificationCounterService {
    constructor() {
        this._notificationCount = new BehaviorSubject(0);
    }
    get notificationCount$() {
        return this._notificationCount.asObservable();
    }
    setNotificationCount(count) {
        this._notificationCount.next(count);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NotificationCounterService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NotificationCounterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NotificationCounterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class BtPanelComponent {
    constructor() { }
    ngOnInit() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BtPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: BtPanelComponent, selector: "arc-shared-btpanel", ngImport: i0, template: "<div class=\"login-body\">\n  <aur-card class=\"login-panel\">\n    <img class=\"logo\" alt=\"Billtrust\" width=\"260\" src=\"./assets/layout/images/logo2x.png\">\n    <ng-content></ng-content>\n  </aur-card>\n</div>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.logo{margin-bottom:24px}.login-body{background:linear-gradient(#008658 10%,#003035 90%),url(/assets/layout/images/bk.png) center no-repeat #f7f7f7;background-blend-mode:overlay,normal;background-size:cover;height:100vh;display:flex;align-items:center;justify-content:center;overflow-y:auto}.login-panel{flex:none;text-align:center;width:360px}.login-panel .ui-g .ui-g-12 .ui-button{margin-bottom:20px}.login-panel .ui-button:hover{background-color:#003035}.login-panel .ui-button:focus{outline:0 none;background-color:#00b979}.login-panel .ui-inputtext{width:100%}.login-panel .ui-inputtext:focus{border-width:0 0 2px 0;border-color:#008658;padding-bottom:0}.login-footer{position:absolute;bottom:10px;font-size:16px;width:100%;text-align:center;color:#4d6069}@media (max-width: 1024px){.login-panel{text-align:center}}@media (max-width: 640px){.login-panel{text-align:center;width:300px;padding:40px 20px}.login-panel .ui-g .ui-g-12{padding:20px}.login-panel .ui-g .ui-g-12 .ui-button{margin-top:30px}}\n"], dependencies: [{ kind: "component", type: i2$1.CardComponent, selector: "aur-card", inputs: ["title", "emphasis", "flex", "flexColumn", "noBodyPadding", "scroll", "stickyHeader", "stickyFooter"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BtPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-btpanel', template: "<div class=\"login-body\">\n  <aur-card class=\"login-panel\">\n    <img class=\"logo\" alt=\"Billtrust\" width=\"260\" src=\"./assets/layout/images/logo2x.png\">\n    <ng-content></ng-content>\n  </aur-card>\n</div>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.logo{margin-bottom:24px}.login-body{background:linear-gradient(#008658 10%,#003035 90%),url(/assets/layout/images/bk.png) center no-repeat #f7f7f7;background-blend-mode:overlay,normal;background-size:cover;height:100vh;display:flex;align-items:center;justify-content:center;overflow-y:auto}.login-panel{flex:none;text-align:center;width:360px}.login-panel .ui-g .ui-g-12 .ui-button{margin-bottom:20px}.login-panel .ui-button:hover{background-color:#003035}.login-panel .ui-button:focus{outline:0 none;background-color:#00b979}.login-panel .ui-inputtext{width:100%}.login-panel .ui-inputtext:focus{border-width:0 0 2px 0;border-color:#008658;padding-bottom:0}.login-footer{position:absolute;bottom:10px;font-size:16px;width:100%;text-align:center;color:#4d6069}@media (max-width: 1024px){.login-panel{text-align:center}}@media (max-width: 640px){.login-panel{text-align:center;width:300px;padding:40px 20px}.login-panel .ui-g .ui-g-12{padding:20px}.login-panel .ui-g .ui-g-12 .ui-button{margin-top:30px}}\n"] }]
        }], ctorParameters: () => [] });

// import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile';
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
class ArcValidators {
    static oneUpperCase(control) {
        if (isEmptyInputValue(control.value)) {
            return {
                oneUpperCase: {
                    valid: true,
                },
            };
        }
        const regexp = new RegExp('[A-Z]');
        if (!regexp.test(control.value)) {
            return {
                oneUpperCase: {
                    valid: true,
                },
            };
        }
        return null;
    }
    static minLength(minLength) {
        function fn(control) {
            if (isEmptyInputValue(control.value)) {
                return {
                    minlength: {
                        requiredLength: minLength,
                        actualLength: 0,
                    },
                };
            }
            const length = control.value.length;
            return length < minLength
                ? { minlength: { requiredLength: minLength, actualLength: length } }
                : null;
        }
        return fn;
    }
    static lowerCase(count) {
        function fn(control) {
            if (isEmptyInputValue(control.value)) {
                return {
                    lowerCase: {
                        requiredLength: count,
                        actualLength: 0,
                    },
                };
            }
            const regexp = new RegExp('[a-z]', 'g');
            const match = control.value.match(regexp);
            if (!match || match.length < count) {
                return {
                    lowerCase: {
                        requiredLength: count,
                        actualLength: match.length,
                    },
                };
            }
            return null;
        }
        return fn;
    }
    static oneLowerCase(control) {
        if (isEmptyInputValue(control.value)) {
            return {
                oneLowerCase: {
                    valid: true,
                },
            };
        }
        const regexp = new RegExp('[a-z]');
        if (!regexp.test(control.value)) {
            return {
                oneLowerCase: {
                    valid: true,
                },
            };
        }
        return null;
    }
    static upperCase(count) {
        function fn(control) {
            if (isEmptyInputValue(control.value)) {
                return {
                    upperCase: {
                        requiredLength: count,
                        actualLength: 0,
                    },
                };
            }
            const regexp = new RegExp('[A-Z]', 'g');
            const match = control.value.match(regexp);
            if (!match || match.length < count) {
                return {
                    upperCase: {
                        requiredLength: count,
                        actualLength: match.length,
                    },
                };
            }
            return null;
        }
        return fn;
    }
    static oneNumber(control) {
        if (isEmptyInputValue(control.value)) {
            return {
                oneNumber: {
                    valid: true,
                },
            };
        }
        const regexp = new RegExp('[0-9]');
        if (!regexp.test(control.value)) {
            return {
                oneNumber: {
                    valid: true,
                },
            };
        }
        return null;
    }
    static xPath(control) {
        if (isEmptyInputValue(control.value)) {
            return {
                xPath: {
                    valid: true,
                },
            };
        }
        const regexp = new RegExp('[0-9]');
        if (!regexp.test(control.value)) {
            return {
                xPath: {
                    valid: true,
                },
            };
        }
        return null;
    }
    static oneSpecialCharacter(control) {
        if (isEmptyInputValue(control.value)) {
            return {
                oneSpecialCharacter: {
                    valid: true,
                },
            };
        }
        const regexp = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/;
        if (!regexp.test(control.value)) {
            return { oneSpecialCharacter: { valid: true } };
        }
        return null;
    }
    //   static validatePattern(
    //     control: AbstractControl,
    //     pattern: string,
    //     errorKey: string
    //   ) {
    //     if (isEmptyInputValue(control.value)) {
    //       return {
    //         errorKey: {
    //           valid: true
    //         }
    //       };
    //     }
    //     // TODO: implement this for real
    //     const regexp = new RegExp('pattern');
    //     if (!regexp.test(control.value)) {
    //       return {
    //         errorKey: {
    //           valid: true
    //         }
    //       };
    //     }
    //     return null;
    //   }
    static fieldMatch(matchFieldName, sourceFieldName, form = null) {
        function fn(control) {
            let matchValue;
            let sourceValue;
            if (form) {
                matchValue = form.get(matchFieldName).value;
                sourceValue = form.get(sourceFieldName).value;
            }
            else {
                matchValue = control.get(matchFieldName).value;
                sourceValue = control.get(sourceFieldName).value;
            }
            if (matchValue !== sourceValue) {
                return {
                    fieldMatch: {
                        valid: true,
                    },
                };
            }
            return null;
        }
        return fn;
    }
    static email(c) {
        const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return EMAIL_REGEX.test(c.value)
            ? null
            : {
                email: {
                    valid: false,
                },
            };
    }
}

class CodeVerificationComponent {
    constructor() {
        this.showMessage = false;
        this.setVerificationClicked = new EventEmitter();
        this.resendCodeClicked = new EventEmitter();
        this.verificationCodeControl = new UntypedFormControl('', {
            validators: [],
        });
        this.emailFormControl = new UntypedFormControl('', {
            validators: [],
        });
    }
    ngOnInit() {
        this.verificationFormGroup = new UntypedFormGroup({
            verificationCode: this.verificationCodeControl,
            email: this.emailFormControl,
        });
        this.verificationFormGroup.patchValue({ email: this.email });
    }
    setPassword() {
        this.verificationCodeControl.clearValidators();
        this.emailFormControl.clearValidators();
        this.verificationCodeControl.markAsTouched();
        this.emailFormControl.markAsTouched();
        this.verificationCodeControl.setValidators(Validators.required);
        this.emailFormControl.setValidators([
            Validators.required,
            ArcValidators.email,
        ]);
        this.emailFormControl.updateValueAndValidity();
        this.verificationCodeControl.updateValueAndValidity();
        if (this.verificationFormGroup.valid) {
            this.setVerificationClicked.emit(this.verificationFormGroup.value);
        }
        else {
            // this.verificationFormGroup.markAsTouched();
            this.verificationCode.markAsTouched();
            this.emailControl.markAsTouched();
        }
    }
    get verificationCode() {
        return this.verificationFormGroup.get('verificationCode');
    }
    get verificationCodeIsInValid() {
        return this.verificationCode.errors && this.verificationCode.touched;
    }
    get emailControl() {
        return this.verificationFormGroup.get('email');
    }
    get emailIsInValid() {
        return this.emailControl.errors && this.emailControl.touched;
    }
    resendCode($event) {
        this.emailFormControl.clearValidators();
        this.verificationCodeControl.clearValidators();
        this.emailFormControl.markAsTouched();
        this.verificationCodeControl.markAsUntouched();
        this.emailFormControl.setValidators([
            Validators.required,
            ArcValidators.email,
        ]);
        this.emailFormControl.updateValueAndValidity();
        // this.verificationCodeControl.updateValueAndValidity();
        if (this.emailFormControl.valid) {
            this.resendCodeClicked.emit(this.emailFormControl.value);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CodeVerificationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CodeVerificationComponent, selector: "arc-shared-codeverification", inputs: { showMessage: "showMessage", email: "email" }, outputs: { setVerificationClicked: "setVerificationClicked", resendCodeClicked: "resendCodeClicked" }, ngImport: i0, template: "<h2>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_HEADER' | translate }}</h2>\n\n<form [formGroup]=\"verificationFormGroup\" (ngSubmit)=\"setPassword()\">\n  <div class=\"p-col-12\">\n    <aur-input\n      #email\n      [autofocus]=\"true\"\n      type=\"email\"\n      formControlName=\"email\"\n      [label]=\"'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate\"\n      [errorMessages]=\"{\n        'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate,\n        'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate\n      }\"\n    ></aur-input>\n  </div>\n\n  <div class=\"p-col-12\">\n    <aur-input\n      formControlName=\"verificationCode\"\n      [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_LABEL' | translate\"\n    ></aur-input>\n  </div>\n  <div class=\"p-col-12\">\n    <!-- TODO: text attr below needs to be translated -->\n    <aur-notice\n      *ngIf=\"showMessage\"\n      severity=\"info\"\n    >\n      {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_EMAIL_SENT_MESSAGE_BODY' | translate}}\n    </aur-notice>\n  </div>\n  <div class=\"p-col-12\">\n    <button type=\"submit\" id=\"btnVerificationCode\" class=\"set-password-button\"\n      aur-button>{{  'ARC_SHARED_COMPONENTS_PRESENTATION_VERIFICATION_CODE_BUTTON' | translate }}</button>\n  </div>\n\n</form>\n<div class=\"p-col-12\">\n  <button (click)=\"resendCode($event)\" aur-button importance=\"tertiary\">{{ 'ARC_SHARED_COMPONENTS_FEATURE_CODEVERIFICATION_CODE_RESEND_BUTTON'\n    | translate }}</button>\n    </div>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}aur-input{width:100%}.disabled{cursor:default;pointer-events:none;opacity:.6}.set-password-button{width:100%}\n"], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i2$1.NoticeComponent, selector: "aur-notice", inputs: ["emoji", "icon", "id", "severity", "size", "title"] }, { kind: "component", type: i2$1.InputComponent, selector: "aur-input", inputs: ["allowNegativeNumbers", "autocomplete", "autofocus", "aurMask", "autotrim", "decimalPlaces", "disabled", "dropSpecialCharacters", "errorMessages", "formControlName", "formControlPath", "form", "frameless", "hiddenInput", "id", "inlineLabel", "inputId", "inputMode", "enterKeyHint", "inputName", "indicateRequirement", "label", "locale", "noValidate", "max", "min", "placeholder", "prefix", "showClearButton", "step", "suffix", "suggestion", "thousandSeparator", "tooltip", "tooltipOptions", "type", "value"], outputs: ["clearClick", "suggestionClick", "passwordToggled", "valueChange", "blur", "focus"] }, { kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CodeVerificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-codeverification', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h2>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_HEADER' | translate }}</h2>\n\n<form [formGroup]=\"verificationFormGroup\" (ngSubmit)=\"setPassword()\">\n  <div class=\"p-col-12\">\n    <aur-input\n      #email\n      [autofocus]=\"true\"\n      type=\"email\"\n      formControlName=\"email\"\n      [label]=\"'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate\"\n      [errorMessages]=\"{\n        'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate,\n        'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate\n      }\"\n    ></aur-input>\n  </div>\n\n  <div class=\"p-col-12\">\n    <aur-input\n      formControlName=\"verificationCode\"\n      [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_LABEL' | translate\"\n    ></aur-input>\n  </div>\n  <div class=\"p-col-12\">\n    <!-- TODO: text attr below needs to be translated -->\n    <aur-notice\n      *ngIf=\"showMessage\"\n      severity=\"info\"\n    >\n      {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_CODEVERIFICATION_EMAIL_SENT_MESSAGE_BODY' | translate}}\n    </aur-notice>\n  </div>\n  <div class=\"p-col-12\">\n    <button type=\"submit\" id=\"btnVerificationCode\" class=\"set-password-button\"\n      aur-button>{{  'ARC_SHARED_COMPONENTS_PRESENTATION_VERIFICATION_CODE_BUTTON' | translate }}</button>\n  </div>\n\n</form>\n<div class=\"p-col-12\">\n  <button (click)=\"resendCode($event)\" aur-button importance=\"tertiary\">{{ 'ARC_SHARED_COMPONENTS_FEATURE_CODEVERIFICATION_CODE_RESEND_BUTTON'\n    | translate }}</button>\n    </div>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}aur-input{width:100%}.disabled{cursor:default;pointer-events:none;opacity:.6}.set-password-button{width:100%}\n"] }]
        }], ctorParameters: () => [], propDecorators: { showMessage: [{
                type: Input
            }], email: [{
                type: Input
            }], setVerificationClicked: [{
                type: Output
            }], resendCodeClicked: [{
                type: Output
            }] } });

class ActiveTenantChangingPayload {
}
class AuthActionTypes {
    static { this.Login = '[Auth] Login'; }
    static { this.LoginByToken = '[Auth] Login By Token'; }
    static { this.LoginWithToken = '[Auth] Login With Token'; }
    static { this.ExternalUserLogin = '[Auth] External User Login'; }
    static { this.ExternalUserLoginByToken = '[Auth] External User Login By Token'; }
    static { this.Logout = '[Auth] Logout'; }
    static { this.ValidateSession = '[Auth] Validate Session'; }
    static { this.LoginSuccess = '[Auth] Login Success'; }
    static { this.LoadProfile = '[Auth] Load User Profile'; }
    static { this.DefineActiveTenant = '[Auth] Define Active Tenant'; }
    static { this.UpdatedProfile = '[Auth] Updated User Profile'; }
    static { this.ChangeUserProfile = '[Auth] Change User Profile'; }
    static { this.RouteToLandingPage = '[Auth] Route to Landing Page'; }
    static { this.LoginSuccessWithResetPassword = '[Auth] Login Success With Password Reset'; }
    static { this.ActiveTenantChanging = '[Auth] Active Tenant Changing'; }
    static { this.DidTenantChange = '[Auth] Did Active Tenant Change'; }
    static { this.ActiveTenantChanged = '[Auth] Active Tenant Changed'; }
    static { this.LoginFailure = '[Auth] Login Failure'; }
    static { this.LoginRedirect = '[Auth] Login Redirect'; }
    static { this.VerificationCodeRedirect = '[Auth] Verification Code Redirect'; }
    static { this.ForgotPasswordRedirect = '[Auth] Forgot Password Redirect'; }
    static { this.NewPasswordRequiredRedirect = '[Auth] New Password Redirect'; }
    static { this.DashboardRedirect = '[Auth] Dashboard Redirect'; }
    static { this.SendResetPasswordEmail = '[Auth] Send Reset Password Email'; }
    static { this.PasswordResetStoreVerificationCode = '[Auth] Store Verification Code'; }
    static { this.UpdatePasswordResetStore = '[Auth] Update Store password'; }
    static { this.ResetPassword = '[Auth] Reset Password'; }
    static { this.ForceResetPassword = '[Auth] Account Need Reset Password'; }
    static { this.ChangePassword = '[Auth] Account Change Password'; }
    static { this.updatePermissionStore = '[Auth] Update Permission Store'; }
    static { this.UserAlive = '[Auth] User Alive'; }
    static { this.DisplaySessionTimeoutWarning = '[Auth] Display Session Timeout Warning'; }
    static { this.GetSessionTTL = '[Auth] Get Session TTL'; }
    static { this.CreateAnonymousUser = '[Auth] Create Anonymous User'; }
    static { this.AuthPhoneVerificationRequired = '[Auth] Phone Verification Required'; }
    static { this.VerifyAccountViaPhone = '[Auth] Verify Account Via Phone'; }
    static { this.VerifyAccountViaPhoneExternal = '[Auth] Verify Account Via Phone for External'; }
    static { this.SendVerificationCodeViaPhone = '[Auth] Send Verification Code Via Phone'; }
    static { this.ReSendVerificationCodeViaPhone = '[Auth] ReSend Verification Code Via Phone'; }
}
class Login {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.Login;
    }
}
class ExternalUserLogin {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ExternalUserLogin;
    }
}
class ExternalUserLoginByToken {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ExternalUserLoginByToken;
    }
}
class LoginByToken {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.LoginByToken;
    }
}
class LoginSuccessWithResetPassword {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.LoginSuccessWithResetPassword;
    }
}
class RouteToLandingPage {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.RouteToLandingPage;
    }
}
class CreateAnonymousUserAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.CreateAnonymousUser;
    }
}
class ValidateSession {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ValidateSession;
    }
}
class DisplaySessionTimeoutWarningAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.DisplaySessionTimeoutWarning;
    }
}
class GetSessionTTLAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.GetSessionTTL;
    }
}
class LoadProfile {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.LoadProfile;
    }
}
class UpdatedProfile {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.UpdatedProfile;
    }
}
class ChangeUserProfile {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ChangeUserProfile;
    }
}
class ActiveTenantChanged {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ActiveTenantChanged;
    }
}
class ActiveTenantChanging {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ActiveTenantChanging;
    }
}
class DidTenantChange {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.DidTenantChange;
    }
}
class DefineActiveTenant {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.DefineActiveTenant;
    }
}
class LoginSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.LoginSuccess;
    }
}
class LoginWithToken {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.LoginWithToken;
    }
}
class LoginFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.LoginFailure;
    }
}
class UserAliveAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.UserAlive;
    }
}
class AuthPhoneVerificationRequiredAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.AuthPhoneVerificationRequired;
    }
}
class LoginRedirect {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.LoginRedirect;
    }
}
class DashboardRedirect {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.DashboardRedirect;
    }
}
class VerificationCodeRedirect {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.VerificationCodeRedirect;
    }
}
class Logout {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.Logout;
    }
}
class SendResetPasswordEmail {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.SendResetPasswordEmail;
    }
}
class ResetPassword {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ResetPassword;
    }
}
class ForceResetPassword {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ForceResetPassword;
    }
}
class PasswordResetStoreVerificationCode {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.PasswordResetStoreVerificationCode;
    }
}
class UpdatePasswordResetStore {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.UpdatePasswordResetStore;
    }
}
class ForgotPasswordRedirect {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ForgotPasswordRedirect;
    }
}
class NewPasswordRequiredRedirect {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.NewPasswordRequiredRedirect;
    }
}
class UpdatePermissionStore {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.updatePermissionStore;
    }
}
class ChangePassword {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.ChangePassword;
    }
}
class VerifyAccountViaPhoneAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.VerifyAccountViaPhone;
    }
}
class VerifyAccountViaPhoneExternalAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.VerifyAccountViaPhoneExternal;
    }
}
class SendVerificationCodeViaPhoneAction {
    constructor(payload) {
        this.payload = payload;
        this.type = AuthActionTypes.SendVerificationCodeViaPhone;
    }
}

class CodeVerificationContainerComponent {
    constructor(store) {
        this.store = store;
        this.goBackClicked = new EventEmitter();
        this.onSetVerificationClicked = new EventEmitter();
        this.onForgotPasswordClicked = new EventEmitter();
        this.labelPrefix = 'ARC_SHARED_COMPONENTS_FEATURE_';
    }
    ngOnInit() {
        this.isPasswordSend$ = this.store.pipe(select(ResetPasswordStore), map((store) => store.resetPasswordEmailSent));
        this.email$ = this.store.pipe(select(ResetPasswordStore), map((x) => x.email));
    }
    onSetVerification($event) {
        // this.store
        this.store.dispatch(new PasswordResetStoreVerificationCode($event));
        this.onSetVerificationClicked.emit();
    }
    goBack() {
        this.goBackClicked.emit();
        this.store.dispatch(new LoginRedirect(null));
    }
    goToForgotPassword($event) {
        this.onForgotPasswordClicked.emit();
        this.store.dispatch(new ForgotPasswordRedirect(null));
    }
    resendCodeClicked(event) {
        if (event) {
            this.store.dispatch(new SendResetPasswordEmail({ email: event }));
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CodeVerificationContainerComponent, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: CodeVerificationContainerComponent, selector: "arc-shared-app-codeverification", outputs: { goBackClicked: "goBackClicked", onSetVerificationClicked: "onSetVerificationClicked", onForgotPasswordClicked: "onForgotPasswordClicked" }, ngImport: i0, template: "<arc-shared-codeverification [email]=\"email$ | async\" [showMessage]=\"this.isPasswordSend$ | async\" (setVerificationClicked)=\"onSetVerification($event)\" (resendCodeClicked)=\"resendCodeClicked($event)\">\n</arc-shared-codeverification>\n\n<div class=\"p-col-12 ui-md-12 back-button-wrapper\">\n    <button id=\"btnGoBack\" (click)=\"goBack()\" aur-button icon=\"arrow_back\" importance=\"tertiary\">\n        {{ 'ARC_SHARED_COMPONENTS_BACK' | translate }}\n    </button>\n    <!-- <button (click)=\"goToForgotPassword($event)\" aur-button importance=\"tertiary\">{{ 'ARC_SHARED_COMPONENTS_FEATURE_CODEVERIFICATION_CODE_RESEND_BUTTON'\n        | translate }}</button> -->\n</div>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.back-button-wrapper{padding-top:16px;display:flex;justify-content:space-between;align-items:center}\n"], dependencies: [{ kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: CodeVerificationComponent, selector: "arc-shared-codeverification", inputs: ["showMessage", "email"], outputs: ["setVerificationClicked", "resendCodeClicked"] }, { kind: "pipe", type: i2$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CodeVerificationContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-app-codeverification', template: "<arc-shared-codeverification [email]=\"email$ | async\" [showMessage]=\"this.isPasswordSend$ | async\" (setVerificationClicked)=\"onSetVerification($event)\" (resendCodeClicked)=\"resendCodeClicked($event)\">\n</arc-shared-codeverification>\n\n<div class=\"p-col-12 ui-md-12 back-button-wrapper\">\n    <button id=\"btnGoBack\" (click)=\"goBack()\" aur-button icon=\"arrow_back\" importance=\"tertiary\">\n        {{ 'ARC_SHARED_COMPONENTS_BACK' | translate }}\n    </button>\n    <!-- <button (click)=\"goToForgotPassword($event)\" aur-button importance=\"tertiary\">{{ 'ARC_SHARED_COMPONENTS_FEATURE_CODEVERIFICATION_CODE_RESEND_BUTTON'\n        | translate }}</button> -->\n</div>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.back-button-wrapper{padding-top:16px;display:flex;justify-content:space-between;align-items:center}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.Store }], propDecorators: { goBackClicked: [{
                type: Output
            }], onSetVerificationClicked: [{
                type: Output
            }], onForgotPasswordClicked: [{
                type: Output
            }] } });

class ForgotPasswordComponent {
    constructor(settings) {
        this.settings = settings;
        this.resetPasswordClicked = new EventEmitter();
        this.goBackClicked = new EventEmitter();
        this.goToVerificationCodeClicked = new EventEmitter();
    }
    ngOnInit() {
        this.forgotPasswordForm = new UntypedFormGroup({
            email: new UntypedFormControl('', {
                validators: [Validators.required, ArcValidators.email],
            }),
        }, { updateOn: 'submit' });
        this.forgotPasswordForm.patchValue({ email: this.email });
    }
    resetPassword() {
        if (this.forgotPasswordForm.valid) {
            this.resetPasswordClicked.emit(this.emailControl.value);
        }
        else {
            this.emailControl.markAsTouched();
        }
    }
    goBack() {
        this.goBackClicked.emit();
    }
    goToVerificationCode() {
        this.goToVerificationCodeClicked.emit();
    }
    get emailControl() {
        return this.forgotPasswordForm.get('email');
    }
    get emailIsInValid() {
        return this.emailControl.errors && this.emailControl.touched;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ForgotPasswordComponent, deps: [{ token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ForgotPasswordComponent, selector: "arc-shared-forgotpassword", inputs: { email: "email" }, outputs: { resetPasswordClicked: "resetPasswordClicked", goBackClicked: "goBackClicked", goToVerificationCodeClicked: "goToVerificationCodeClicked" }, ngImport: i0, template: "<h2>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOT_PASSWORD_LABEL' | translate }}</h2>\n\n<form [formGroup]=\"forgotPasswordForm\" (ngSubmit)=\"resetPassword()\">\n  <div class=\"p-col-12\">\n    <aur-input\n      #email\n      type=\"email\"\n      [autofocus]=\"true\"\n      formControlName=\"email\"\n      [label]=\"'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate\"\n      [errorMessages]=\"{\n        'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate,\n        'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate\n      }\"\n    ></aur-input>\n    <!-- <span class=\"md-inputfield\">\n      <input autofocus type=\"text\" formControlName=\"email\" autocomplete=\"off\" pInputText required>\n      <label>{{ 'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate }}</label>\n      <div [ngClass]=\"{'bt-hide-validation-error': !emailIsInValid, 'ui-message ui-messages-error ui-corner-all': true }\">\n        {{'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate}}\n      </div>\n    </span> -->\n  </div>\n  <div class=\"p-col-12\">\n    <button id=\"btnResetPassword\"\n      type=\"submit\"\n      class=\"reset-button\"\n      aur-button\n    >{{'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_RESET_PASSWORD' | translate}}</button>\n  </div>\n</form>\n\n<div class=\"p-col-12 ui-md-12 back-button-wrapper\">\n  <button\n    aur-button\n    id=\"btnGoBack\"\n    type=\"button\"\n    (click)=\"goBack()\"\n    importance=\"tertiary\"\n    icon=\"arrow_back\"\n  >{{'ARC_SHARED_BACK' | translate }}</button>\n\n  <button\n    id=\"btnGoToVerificationCode\"\n    aur-button\n    type=\"button\"\n    importance=\"tertiary\"\n    (click)=\"goToVerificationCode()\"\n  >{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_ALREADY_HAVE_CODE' | translate }}\n    </button>\n</div>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.ui-inputtext{width:100%}.md-inputfield{text-align:left}aur-input{display:block}.disabled{cursor:default;pointer-events:none;opacity:.6}.reset-button{width:100%}.email-sent-message{padding:16px}.back-button-wrapper{padding-top:16px;display:flex;justify-content:space-between;align-items:center}\n"], dependencies: [{ kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i2$1.InputComponent, selector: "aur-input", inputs: ["allowNegativeNumbers", "autocomplete", "autofocus", "aurMask", "autotrim", "decimalPlaces", "disabled", "dropSpecialCharacters", "errorMessages", "formControlName", "formControlPath", "form", "frameless", "hiddenInput", "id", "inlineLabel", "inputId", "inputMode", "enterKeyHint", "inputName", "indicateRequirement", "label", "locale", "noValidate", "max", "min", "placeholder", "prefix", "showClearButton", "step", "suffix", "suggestion", "thousandSeparator", "tooltip", "tooltipOptions", "type", "value"], outputs: ["clearClick", "suggestionClick", "passwordToggled", "valueChange", "blur", "focus"] }, { kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ForgotPasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-forgotpassword', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h2>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOT_PASSWORD_LABEL' | translate }}</h2>\n\n<form [formGroup]=\"forgotPasswordForm\" (ngSubmit)=\"resetPassword()\">\n  <div class=\"p-col-12\">\n    <aur-input\n      #email\n      type=\"email\"\n      [autofocus]=\"true\"\n      formControlName=\"email\"\n      [label]=\"'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate\"\n      [errorMessages]=\"{\n        'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate,\n        'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate\n      }\"\n    ></aur-input>\n    <!-- <span class=\"md-inputfield\">\n      <input autofocus type=\"text\" formControlName=\"email\" autocomplete=\"off\" pInputText required>\n      <label>{{ 'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate }}</label>\n      <div [ngClass]=\"{'bt-hide-validation-error': !emailIsInValid, 'ui-message ui-messages-error ui-corner-all': true }\">\n        {{'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_VALID_EMAIL_REQUIRED' | translate}}\n      </div>\n    </span> -->\n  </div>\n  <div class=\"p-col-12\">\n    <button id=\"btnResetPassword\"\n      type=\"submit\"\n      class=\"reset-button\"\n      aur-button\n    >{{'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_RESET_PASSWORD' | translate}}</button>\n  </div>\n</form>\n\n<div class=\"p-col-12 ui-md-12 back-button-wrapper\">\n  <button\n    aur-button\n    id=\"btnGoBack\"\n    type=\"button\"\n    (click)=\"goBack()\"\n    importance=\"tertiary\"\n    icon=\"arrow_back\"\n  >{{'ARC_SHARED_BACK' | translate }}</button>\n\n  <button\n    id=\"btnGoToVerificationCode\"\n    aur-button\n    type=\"button\"\n    importance=\"tertiary\"\n    (click)=\"goToVerificationCode()\"\n  >{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOTPASSWORD_ALREADY_HAVE_CODE' | translate }}\n    </button>\n</div>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.ui-inputtext{width:100%}.md-inputfield{text-align:left}aur-input{display:block}.disabled{cursor:default;pointer-events:none;opacity:.6}.reset-button{width:100%}.email-sent-message{padding:16px}.back-button-wrapper{padding-top:16px;display:flex;justify-content:space-between;align-items:center}\n"] }]
        }], ctorParameters: () => [{ type: AppConfigSettings }], propDecorators: { email: [{
                type: Input
            }], resetPasswordClicked: [{
                type: Output
            }], goBackClicked: [{
                type: Output
            }], goToVerificationCodeClicked: [{
                type: Output
            }] } });

class ForgotPasswordContainerComponent {
    constructor(store) {
        this.store = store;
        this.verificationEmailSent = new EventEmitter();
        this.gotoVerificationCodeClicked = new EventEmitter();
        this.goBackClicked = new EventEmitter();
        this.subs = new SubSink();
    }
    ngOnInit() {
        this.email$ = this.store.pipe(select(ResetPasswordStore), map((x) => x.email));
        this.subs.add(this.store
            .select(SuccessStore)
            .pipe(filter((x) => x && x.actionType === AuthActionTypes.SendResetPasswordEmail))
            .subscribe((x) => {
            this.verificationEmailSent.emit();
        }));
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    onResetPassword(email) {
        this.store.dispatch(new SendResetPasswordEmail({
            email: email,
            from: this.fromExternal
        }));
    }
    onGoBack() {
        this.goBackClicked.emit();
        this.store.dispatch(new LoginRedirect(null));
    }
    onGoToVerificationCode() {
        this.gotoVerificationCodeClicked.emit();
        this.store.dispatch(new VerificationCodeRedirect(false));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ForgotPasswordContainerComponent, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ForgotPasswordContainerComponent, selector: "arc-shared-app-forgotpassword", inputs: { fromExternal: "fromExternal" }, outputs: { verificationEmailSent: "verificationEmailSent", gotoVerificationCodeClicked: "gotoVerificationCodeClicked", goBackClicked: "goBackClicked" }, ngImport: i0, template: "<arc-shared-forgotpassword (resetPasswordClicked)=\"onResetPassword($event)\" (goBackClicked)=\"onGoBack()\" (goToVerificationCodeClicked)=\"onGoToVerificationCode()\"\n  [email]=\"email$ | async\">\n</arc-shared-forgotpassword>", dependencies: [{ kind: "component", type: ForgotPasswordComponent, selector: "arc-shared-forgotpassword", inputs: ["email"], outputs: ["resetPasswordClicked", "goBackClicked", "goToVerificationCodeClicked"] }, { kind: "pipe", type: i2$2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ForgotPasswordContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-app-forgotpassword', template: "<arc-shared-forgotpassword (resetPasswordClicked)=\"onResetPassword($event)\" (goBackClicked)=\"onGoBack()\" (goToVerificationCodeClicked)=\"onGoToVerificationCode()\"\n  [email]=\"email$ | async\">\n</arc-shared-forgotpassword>" }]
        }], ctorParameters: () => [{ type: i1$2.Store }], propDecorators: { fromExternal: [{
                type: Input
            }], verificationEmailSent: [{
                type: Output
            }], gotoVerificationCodeClicked: [{
                type: Output
            }], goBackClicked: [{
                type: Output
            }] } });

class BrandingActionTypes {
    static { this.LoadPrivacyPolicy = '[Branding] Load Privacy Policy'; }
    static { this.UpdatePrivacyPolicy = '[Branding] Update Privacy Policy'; }
    static { this.LoadPlatformName = '[Branding] Load Platform Name'; }
    static { this.UpdatePlatformName = '[Branding] Update Platform Name'; }
    static { this.UpdateTenantId = '[Branding] Update Tenant Id'; }
}
class LoadPrivacyPolicyAction {
    constructor(payload) {
        this.payload = payload;
        this.type = BrandingActionTypes.LoadPrivacyPolicy;
    }
}
class UpdatePrivacyPolicyAction {
    constructor(privacyPolicy) {
        this.privacyPolicy = privacyPolicy;
        this.type = BrandingActionTypes.UpdatePrivacyPolicy;
    }
}
class LoadPlatformNameAction {
    constructor(payload) {
        this.payload = payload;
        this.type = BrandingActionTypes.LoadPlatformName;
    }
}
class UpdatePlatformNameAction {
    constructor(platformName) {
        this.platformName = platformName;
        this.type = BrandingActionTypes.UpdatePlatformName;
    }
}
class UpdateTenantId {
    constructor(tenantId) {
        this.tenantId = tenantId;
        this.type = BrandingActionTypes.UpdateTenantId;
    }
}

const initialPrivacyPolicy = 'https://www.billtrust.com/privacy-policy/';
function privacyPolicyReducer(state = initialPrivacyPolicy, action) {
    switch (action.type) {
        case BrandingActionTypes.LoadPrivacyPolicy: {
            return state;
        }
        case BrandingActionTypes.UpdatePrivacyPolicy: {
            return action.privacyPolicy;
        }
        default:
            return state;
    }
}
function tenantReducer(state = '', action) {
    switch (action.type) {
        case BrandingActionTypes.UpdateTenantId: {
            return action.tenantId;
        }
        default:
            return state;
    }
}
const brandingReducers = {
    privacyPolicy: privacyPolicyReducer,
    tenant: tenantReducer,
};
const BrandingModuleStore = createFeatureSelector('branding-store');
const BrandingPrivacyPolicyStore = createSelector(BrandingModuleStore, (state) => {
    if (state) {
        return state.privacyPolicy;
    }
});
const BrandingTenantStore = createSelector(BrandingModuleStore, (state) => {
    if (state) {
        return state.tenant;
    }
});

class JPMorganTermsComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: JPMorganTermsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: JPMorganTermsComponent, selector: "app-jpmorgan-terms", ngImport: i0, template: "<div class=\"esign-consent-dialog\">\n  <div>\n    <p>\n      By accessing and using our website or application, you agree to comply\n      with the following terms of use. Please read them carefully.\n    </p>\n    <p>Acceptance of Terms</p>\n    <p>\n      By using our services, you acknowledge that you have read, understood,\n      and accepted these terms. If you do not agree with any part of these\n      terms, please refrain from using our platform.\n    </p>\n    <p>User Conduct</p>\n    <ul>\n      <li>\n        You must use our services in accordance with applicable laws and\n        regulations.\n      </li>\n      <li>\n        Do not engage in any illegal, harmful, or abusive activities on our\n        platform.\n      </li>\n      <li>Respect other users and their rights.</li>\n    </ul>\n\n    <p>Intellectual Property</p>\n    <ul>\n      <li>\n        All content on our website is protected by copyright and other\n        intellectual property laws.\n      </li>\n      <li>\n        You may not reproduce, distribute, or modify our content without\n        proper authorization.\n      </li>\n    </ul>\n\n    <p>Disclaimer</p>\n    <ul>\n      <li>\n        We strive to provide accurate information, but we do not guarantee its\n        completeness or correctness.\n      </li>\n      <li>Use our services at your own risk.</li>\n    </ul>\n  </div>\n</div>\n", styles: [":host .esign-consent-dialog{text-align:start}:host h6{margin-top:0}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: JPMorganTermsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-jpmorgan-terms', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"esign-consent-dialog\">\n  <div>\n    <p>\n      By accessing and using our website or application, you agree to comply\n      with the following terms of use. Please read them carefully.\n    </p>\n    <p>Acceptance of Terms</p>\n    <p>\n      By using our services, you acknowledge that you have read, understood,\n      and accepted these terms. If you do not agree with any part of these\n      terms, please refrain from using our platform.\n    </p>\n    <p>User Conduct</p>\n    <ul>\n      <li>\n        You must use our services in accordance with applicable laws and\n        regulations.\n      </li>\n      <li>\n        Do not engage in any illegal, harmful, or abusive activities on our\n        platform.\n      </li>\n      <li>Respect other users and their rights.</li>\n    </ul>\n\n    <p>Intellectual Property</p>\n    <ul>\n      <li>\n        All content on our website is protected by copyright and other\n        intellectual property laws.\n      </li>\n      <li>\n        You may not reproduce, distribute, or modify our content without\n        proper authorization.\n      </li>\n    </ul>\n\n    <p>Disclaimer</p>\n    <ul>\n      <li>\n        We strive to provide accurate information, but we do not guarantee its\n        completeness or correctness.\n      </li>\n      <li>Use our services at your own risk.</li>\n    </ul>\n  </div>\n</div>\n", styles: [":host .esign-consent-dialog{text-align:start}:host h6{margin-top:0}\n"] }]
        }] });

class LoginComponent {
    get emailControl() {
        return this.loginFormGroup.get('email');
    }
    get passwordControl() {
        return this.loginFormGroup.get('password');
    }
    get emailIsInValid() {
        return this.emailControl.errors && this.emailControl.touched;
    }
    get passwordIsInValid() {
        return this.passwordControl.errors && this.passwordControl.touched;
    }
    get showSignUpLink() {
        return (this.router.url.startsWith(this.settings.routes.loginRoute) &&
            this.enablePersonaRegistrationFlow);
    }
    constructor(changeDetector, store, userService, settings, router) {
        this.changeDetector = changeDetector;
        this.store = store;
        this.userService = userService;
        this.settings = settings;
        this.router = router;
        this.signinClicked = new EventEmitter();
        this.forgotPasswordClicked = new EventEmitter();
        this.showLoginButton = true;
        this.showForgetPasswordButton = true;
        this.enablePersonaRegistrationFlow = true;
        this.msgs = [];
        this.signUpLink = '/signup';
        this.jpmPrivacyPolicy = 'https://www.jpmorgan.com/privacy';
    }
    ngOnInit() {
        this.loginFormGroup = new UntypedFormGroup({
            email: new UntypedFormControl('', {
                validators: [Validators.required, ArcValidators.email],
                updateOn: 'submit',
            }),
            password: new UntypedFormControl('', {
                validators: [Validators.required],
                updateOn: 'submit',
            }),
        });
        this.privacyPolicy$ = this.store.select(BrandingPrivacyPolicyStore);
        this.resellerSubscription = this.userService.isResellerJPM.subscribe(id => {
            this.isJPMTermsVisible = id;
        });
    }
    ngOnDestroy() {
        this.resellerSubscription.unsubscribe();
    }
    showTermsDialog() {
        this.termsDialogVisible = true;
    }
    ngAfterViewInit() {
        const emailElement = this.emailInputComponentRef.nativeInput.nativeElement;
        const passwordElement = this.passwordInputComponentRef.nativeInput.nativeElement;
        // Object.defineProperty(emailElement, 'value', {
        // });
        this.defineValueProperty(emailElement);
        this.defineValueProperty(passwordElement);
        this.emailInputComponentRef.nativeInput.nativeElement.addEventListener('valuechange', (e) => {
            this.emailControl.setValue(e.detail.data);
            this.emailControl.updateValueAndValidity();
            this.changeDetector.detectChanges();
        });
        // this.emailInputComponentRef.nativeInput.nativeElement.addEventListener('input', e => {
        //   this.emailControl.setValue(e.detail.data);
        //   this.emailControl.updateValueAndValidity();
        //   this.changeDetector.detectChanges();
        // });
        this.passwordInputComponentRef.nativeInput.nativeElement.addEventListener('valuechange', (e) => {
            this.passwordControl.setValue(e.detail.data);
            this.passwordControl.updateValueAndValidity();
            this.changeDetector.detectChanges();
        });
        this.emailInputComponentRef.nativeInput.nativeElement.focus();
    }
    onSignin() {
        if (this.loginFormGroup.valid) {
            this.signinClicked.emit(this.loginFormGroup.value);
        }
        else {
            this.emailControl.markAsTouched();
            this.passwordControl.markAsTouched();
        }
    }
    onForgotPassword() {
        this.forgotPasswordClicked.emit(this.emailControl.value);
    }
    onEmailEnterKey(value) {
        this.emailControl.setValue(value);
    }
    onPasswordEnterKey(value) {
        this.passwordControl.setValue(value);
    }
    defineValueProperty(element) {
        var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
        var originalSet = descriptor.set;
        descriptor.set = function (val) {
            if (this.value !== val) {
                originalSet.apply(this, arguments);
                var a;
                var event = new CustomEvent('valuechange', {
                    detail: { data: val },
                });
                this.dispatchEvent(event);
            }
            else {
                originalSet.apply(this, arguments);
            }
        };
        Object.defineProperty(element, 'value', descriptor);
    }
    emailValueChanged($event) {
        this.emailControl.setValue($event);
        this.emailControl.updateValueAndValidity();
    }
    passwordValueChanged($event) {
        this.passwordControl.setValue($event);
        this.passwordControl.updateValueAndValidity();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1$2.Store }, { token: UserService }, { token: AppConfigSettings }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: LoginComponent, selector: "arc-shared-login", inputs: { showLoginButton: "showLoginButton", showForgetPasswordButton: "showForgetPasswordButton", enablePersonaRegistrationFlow: "enablePersonaRegistrationFlow", msgs: "msgs", submitting: "submitting", signUpLink: "signUpLink" }, outputs: { signinClicked: "signinClicked", forgotPasswordClicked: "forgotPasswordClicked" }, viewQueries: [{ propertyName: "emailInputComponentRef", first: true, predicate: ["email"], descendants: true }, { propertyName: "passwordInputComponentRef", first: true, predicate: ["password"], descendants: true }], ngImport: i0, template: "<div>\n  <h4 *ngIf=\"!showSignUpLink\">\n    {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_NEW_USER_HEADING_DESCRIPTION' | translate }}\n  </h4>\n\n  <form [formGroup]=\"loginFormGroup\" class=\"p-grid\" (ngSubmit)=\"onSignin()\">\n    <div class=\"p-col-12\" *ngIf=\"msgs && msgs.length > 0\">\n      <p-messages [(value)]=\"msgs\"></p-messages>\n    </div>\n\n    <div class=\"p-col-12 ui-md-12\">\n      <aur-input #email inputId=\"email-input\" [autofocus]=\"true\" formControlName=\"email\" [label]=\"'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate\"\n      (valueChange)=\"emailValueChanged($event)\" \n      [errorMessages]=\"{\n          'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_USER_NAME_REQUIRED_ERROR' | translate\n        }\" (keydown.enter)=\"onEmailEnterKey(email.value)\"></aur-input>\n    </div>\n    <div class=\"p-col-12 ui-md-12\">\n      <aur-input #password inputId=\"password-input\" type=\"password\" [autofocus]=\"false\" autocomplete=\"on\" formControlName=\"password\" [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_LABEL' | translate\"\n      (valueChange)=\"passwordValueChanged($event)\"  \n      [errorMessages]=\"{\n          'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQUIRED_ERROR' | translate\n        }\" (keydown.enter)=\"onPasswordEnterKey(password.value)\"></aur-input>\n    </div>\n    <div class=\"p-col-12 ui-md-12\">\n      <button type=\"submit\" id=\"btnSignIn\" class=\"sign-in-button\" aur-button [disabled]=\"submitting\">{{\n        'ARC_SHARED_COMPONENTS_PRESENTATION_SIGNIN_BUTTON' | translate }}</button>\n    </div>\n    <div class=\"p-col-12 ui-md-12\" *ngIf=\"showSignUpLink\">\n      {{ 'ARC_SHARED_DONT_HAVE_ACCOUNT' | translate }}\n      <button id=\"btnRegisterNav\" class=\"color-primary\" aur-button [routerLink]=\"signUpLink\">{{ 'ARC_SHARED_SIGN_UP_WITH_BILLTRUST_ID_NEW' | translate }}</button>\n    </div>\n    <div class=\"p-col-12 ui-md-12 forgot-wrapper\">\n      <a id=\"btnForgotPassword\" [class.disabled]=\"submitting\" (click)=\"onForgotPassword()\">{{\n        'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOT_PASSWORD_LABEL' | translate }}</a>\n    </div>\n    <div class=\"p-col-12 ui-md-12 policy-wrapper\">\n      <ng-container *ngIf=\"isJPMTermsVisible; else defaultPolicy\">\n        {{'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_PRIVACY_POLICY_TEXT' | translate}}\n        <a href=\"{{jpmPrivacyPolicy}}\" target=\"_blank\">{{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_LINK'\n          | translate}}</a>\n        {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_ECONSENT_TEXT' | translate }}\n        <button class=\"terms-link\" id=\"btnJPMorganTerms\" type=\"button\" aur-button (click)=\"showTermsDialog()\" importance=\"link\">\n          {{'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_TERMS_LINK' | translate}}\n        </button>\n        <p-dialog [(visible)]=\"termsDialogVisible\" [modal]=\"true\" [style]=\"{ width: '50vw' }\" [draggable]=\"false\" [resizable]=\"false\">\n          <ng-template pTemplate=\"header\">\n            <h4 class=\"terms-header\">{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_TERMS_LINK' | translate }}</h4>\n          </ng-template>\n          <app-jpmorgan-terms></app-jpmorgan-terms>\n          <ng-template pTemplate=\"footer\">\n            <div class=\"terms-footer\">\n              <button aur-button (click)=\"termsDialogVisible = false\">{{ 'ARC_SHARED_COMPONENTS_BUTTON_OK' | translate }}</button>\n            </div>\n          </ng-template>\n        </p-dialog>\n      </ng-container>\n      <ng-template #defaultPolicy>\n        {{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_TEXT' | translate}}\n        <a href=\"{{ privacyPolicy$ | async }}\" target=\"_blank\">{{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_LINK' | translate}}</a>\n      </ng-template>\n    </div>\n  </form>\n\n</div>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.ui-inputtext{width:100%}.md-inputfield{text-align:left}.disabled{cursor:default;pointer-events:none;opacity:.6}.sign-in-button{width:100%}aur-input{display:block}.forgot-wrapper{text-align:center}.policy-wrapper{font-size:14px}.terms-header{margin:0;text-align:start}.terms-footer{display:flex;justify-content:flex-end;padding:16px}.terms-link{padding-bottom:4px!important}\n"], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i2$1.InputComponent, selector: "aur-input", inputs: ["allowNegativeNumbers", "autocomplete", "autofocus", "aurMask", "autotrim", "decimalPlaces", "disabled", "dropSpecialCharacters", "errorMessages", "formControlName", "formControlPath", "form", "frameless", "hiddenInput", "id", "inlineLabel", "inputId", "inputMode", "enterKeyHint", "inputName", "indicateRequirement", "label", "locale", "noValidate", "max", "min", "placeholder", "prefix", "showClearButton", "step", "suffix", "suggestion", "thousandSeparator", "tooltip", "tooltipOptions", "type", "value"], outputs: ["clearClick", "suggestionClick", "passwordToggled", "valueChange", "blur", "focus"] }, { kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i8.Dialog, selector: "p-dialog", inputs: ["header", "draggable", "resizable", "positionLeft", "positionTop", "contentStyle", "contentStyleClass", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "responsive", "appendTo", "breakpoints", "styleClass", "maskStyleClass", "maskStyle", "showHeader", "breakpoint", "blockScroll", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeIcon", "closeAriaLabel", "closeTabindex", "minimizeIcon", "maximizeIcon", "visible", "style", "position"], outputs: ["onShow", "onHide", "visibleChange", "onResizeInit", "onResizeEnd", "onDragEnd", "onMaximize"] }, { kind: "directive", type: i9.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i10.Messages, selector: "p-messages", inputs: ["value", "closable", "style", "styleClass", "enableService", "key", "escape", "severity", "showTransitionOptions", "hideTransitionOptions"], outputs: ["valueChange", "onClose"] }, { kind: "directive", type: i1$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: JPMorganTermsComponent, selector: "app-jpmorgan-terms" }, { kind: "pipe", type: i2$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-login', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\n  <h4 *ngIf=\"!showSignUpLink\">\n    {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_NEW_USER_HEADING_DESCRIPTION' | translate }}\n  </h4>\n\n  <form [formGroup]=\"loginFormGroup\" class=\"p-grid\" (ngSubmit)=\"onSignin()\">\n    <div class=\"p-col-12\" *ngIf=\"msgs && msgs.length > 0\">\n      <p-messages [(value)]=\"msgs\"></p-messages>\n    </div>\n\n    <div class=\"p-col-12 ui-md-12\">\n      <aur-input #email inputId=\"email-input\" [autofocus]=\"true\" formControlName=\"email\" [label]=\"'ARC_SHARED_COMPONENTS_EMAIL_ADDRESS_LABEL' | translate\"\n      (valueChange)=\"emailValueChanged($event)\" \n      [errorMessages]=\"{\n          'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_USER_NAME_REQUIRED_ERROR' | translate\n        }\" (keydown.enter)=\"onEmailEnterKey(email.value)\"></aur-input>\n    </div>\n    <div class=\"p-col-12 ui-md-12\">\n      <aur-input #password inputId=\"password-input\" type=\"password\" [autofocus]=\"false\" autocomplete=\"on\" formControlName=\"password\" [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_LABEL' | translate\"\n      (valueChange)=\"passwordValueChanged($event)\"  \n      [errorMessages]=\"{\n          'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQUIRED_ERROR' | translate\n        }\" (keydown.enter)=\"onPasswordEnterKey(password.value)\"></aur-input>\n    </div>\n    <div class=\"p-col-12 ui-md-12\">\n      <button type=\"submit\" id=\"btnSignIn\" class=\"sign-in-button\" aur-button [disabled]=\"submitting\">{{\n        'ARC_SHARED_COMPONENTS_PRESENTATION_SIGNIN_BUTTON' | translate }}</button>\n    </div>\n    <div class=\"p-col-12 ui-md-12\" *ngIf=\"showSignUpLink\">\n      {{ 'ARC_SHARED_DONT_HAVE_ACCOUNT' | translate }}\n      <button id=\"btnRegisterNav\" class=\"color-primary\" aur-button [routerLink]=\"signUpLink\">{{ 'ARC_SHARED_SIGN_UP_WITH_BILLTRUST_ID_NEW' | translate }}</button>\n    </div>\n    <div class=\"p-col-12 ui-md-12 forgot-wrapper\">\n      <a id=\"btnForgotPassword\" [class.disabled]=\"submitting\" (click)=\"onForgotPassword()\">{{\n        'ARC_SHARED_COMPONENTS_PRESENTATION_FORGOT_PASSWORD_LABEL' | translate }}</a>\n    </div>\n    <div class=\"p-col-12 ui-md-12 policy-wrapper\">\n      <ng-container *ngIf=\"isJPMTermsVisible; else defaultPolicy\">\n        {{'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_PRIVACY_POLICY_TEXT' | translate}}\n        <a href=\"{{jpmPrivacyPolicy}}\" target=\"_blank\">{{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_LINK'\n          | translate}}</a>\n        {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_ECONSENT_TEXT' | translate }}\n        <button class=\"terms-link\" id=\"btnJPMorganTerms\" type=\"button\" aur-button (click)=\"showTermsDialog()\" importance=\"link\">\n          {{'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_TERMS_LINK' | translate}}\n        </button>\n        <p-dialog [(visible)]=\"termsDialogVisible\" [modal]=\"true\" [style]=\"{ width: '50vw' }\" [draggable]=\"false\" [resizable]=\"false\">\n          <ng-template pTemplate=\"header\">\n            <h4 class=\"terms-header\">{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_JPM_TERMS_LINK' | translate }}</h4>\n          </ng-template>\n          <app-jpmorgan-terms></app-jpmorgan-terms>\n          <ng-template pTemplate=\"footer\">\n            <div class=\"terms-footer\">\n              <button aur-button (click)=\"termsDialogVisible = false\">{{ 'ARC_SHARED_COMPONENTS_BUTTON_OK' | translate }}</button>\n            </div>\n          </ng-template>\n        </p-dialog>\n      </ng-container>\n      <ng-template #defaultPolicy>\n        {{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_TEXT' | translate}}\n        <a href=\"{{ privacyPolicy$ | async }}\" target=\"_blank\">{{'ARC_SHARED_COMPONENTS_PRESENTATION_PRIVACY_POLICY_LINK' | translate}}</a>\n      </ng-template>\n    </div>\n  </form>\n\n</div>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.ui-inputtext{width:100%}.md-inputfield{text-align:left}.disabled{cursor:default;pointer-events:none;opacity:.6}.sign-in-button{width:100%}aur-input{display:block}.forgot-wrapper{text-align:center}.policy-wrapper{font-size:14px}.terms-header{margin:0;text-align:start}.terms-footer{display:flex;justify-content:flex-end;padding:16px}.terms-link{padding-bottom:4px!important}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i1$2.Store }, { type: UserService }, { type: AppConfigSettings }, { type: i1$1.Router }], propDecorators: { signinClicked: [{
                type: Output
            }], forgotPasswordClicked: [{
                type: Output
            }], showLoginButton: [{
                type: Input
            }], showForgetPasswordButton: [{
                type: Input
            }], enablePersonaRegistrationFlow: [{
                type: Input
            }], msgs: [{
                type: Input
            }], submitting: [{
                type: Input
            }], signUpLink: [{
                type: Input
            }], emailInputComponentRef: [{
                type: ViewChild,
                args: ['email']
            }], passwordInputComponentRef: [{
                type: ViewChild,
                args: ['password']
            }] } });

class LoginContainerComponent {
    constructor(store, coreService, route, actions$, authService) {
        this.store = store;
        this.coreService = coreService;
        this.route = route;
        this.actions$ = actions$;
        this.authService = authService;
        this.widgetMode = 'regular';
        this.applicationId = '';
        this.featureId = '';
        this.personaId = '';
        this.redirectUrl = '';
        this.tenantId = '';
        this.newUserWelcomeTemplateTypeId = '';
        this.existingUserWelcomeTemplateTypeId = '';
        this.preventTitleChange = false;
        this.enablePersonaRegistrationFlow = false;
        this.signUpLink = '/signup';
        this.loginSucceeded = new EventEmitter();
        this.loginError = new EventEmitter();
        this.loginButtonClicked = new EventEmitter();
        this.forgetPasswordButtonClicked = new EventEmitter();
        this.msgs = [];
        this.errmsg = '';
        this.showresetpassword = false;
        this.subs = new SubSink();
        this._returnUrl = '';
        this._logoutUrl = '';
        this._tenantId = '';
        this._oidc = false;
        this.isBypass = true;
    }
    ngOnInit() {
        if (!this.preventTitleChange)
            document.title = 'billtrust';
        const isClientSession = (this.route.snapshot.queryParams['dualsession'] || '') === '1';
        if (isClientSession) {
            this.coreService.setClientConnectLocalStorage('1');
        }
        else {
            this.coreService.clearClientConnectLocalStorage();
        }
        // this.widgetMode = this.route.snapshot.data['widgetMode'] || 'regular';
        // this.applciationId = this.route.snapshot.data['applciationId'];
        // this.featureId = this.route.snapshot.data['featureId'];
        // this.redirectUrl = this.route.snapshot.data['redirectUrl'];
        // this.tenantId = this.route.snapshot.data['tenantId'];
        // this.newUserWelcomeTemplateTypeId = this.route.snapshot.data['newUserWelcomeTemplateTypeId'];
        // this.existingUserWelcomeTemplateTypeId = this.route.snapshot.data['existingUserWelcomeTemplateTypeId'];
        this.route.queryParams.subscribe((params) => {
            let token = params['token'];
            this._tenantId = params['tenantId'];
            this._returnUrl = params['returnUrl'];
            this._logoutUrl = params['logoutUrl'] || params['logoutRedirectUrl'];
            this._oidc = params['oidc'] === 'oidc';
            this.submitting$ = this.store
                .select(AuthStore)
                .pipe(select((x) => x.user.submitting));
            if (token) {
                const accessToken = params['token'];
                if (accessToken && this.widgetMode !== 'external') {
                    this.store.dispatch(new LoginByToken({
                        accessToken: accessToken,
                        tenantId: this._tenantId,
                        returnUrl: this._returnUrl,
                        logoutUrl: this._logoutUrl,
                        isIdentityProvider: this._oidc,
                    }));
                }
                else if (accessToken && this.widgetMode === 'external') {
                    const loginRequest = {
                        accessToken: accessToken,
                        tenantId: this._tenantId,
                        returnUrl: this._returnUrl,
                        logoutUrl: this._logoutUrl,
                        isIdentityProvider: this._oidc,
                    };
                    this.store.dispatch(new ExternalUserLoginByToken(loginRequest));
                }
                else {
                    this.isBypass = false;
                }
            }
            else {
                token = this.coreService.getAuthTokenFromLocalStorage();
                const activeTenantString = this.coreService.getActiveTenantFromLocalStorage();
                const activeTenant = activeTenantString
                    ? JSON.parse(activeTenantString)
                    : {};
                const tenantId = activeTenant ? activeTenant.tenantId : null;
                this.verifyTokenIsValid$(token).subscribe((verified) => {
                    if (token && this.widgetMode !== 'external') {
                        this.store.dispatch(new LoginByToken({
                            accessToken: token,
                            tenantId: tenantId,
                            silentError: true,
                            isIdentityProvider: this._oidc,
                        }));
                    }
                    else if (token && this.widgetMode === 'external' && verified) {
                        const loginRequest = {
                            accessToken: token,
                            tenantId: this._tenantId,
                            returnUrl: this._returnUrl,
                            logoutUrl: this._logoutUrl,
                            isIdentityProvider: this._oidc,
                        };
                        this.store.dispatch(new ExternalUserLoginByToken(loginRequest));
                    }
                    else {
                        this.isBypass = false;
                    }
                });
            }
        });
        this.subs.add(this.actions$
            .pipe(ofType(GeneralActionTypes.UserNotification), map((action) => action.payload), filter((x) => x.type === 'danger'))
            .subscribe((x) => {
            this.isBypass = false;
        }));
        this.subs.add(this.actions$
            .pipe(ofType(GeneralActionTypes.DoNothing))
            .subscribe((x) => {
            this.isBypass = false;
        }));
        this.subs.add(this.actions$
            .pipe(ofType(AuthActionTypes.LoginSuccess))
            .subscribe((x) => {
            this.loginSucceeded.emit();
        }));
        this.subs.add(this.actions$
            .pipe(ofType(AuthActionTypes.LoginFailure))
            .subscribe((x) => {
            this.loginError.emit();
        }));
    }
    verifyTokenIsValid$(token) {
        if (!token) {
            return of(false);
        }
        return this.authService.V1VerifysessionPost({ accessToken: token }).pipe(map((x) => x.body), map((x) => x.verified), catchError((error) => {
            return of(false);
        }));
    }
    onSignin(user) {
        this.loginButtonClicked.emit();
        this.msgs = [];
        if (this.widgetMode === 'external') {
            this.store.dispatch(new ExternalUserLogin({
                ...user,
                returnUrl: this._returnUrl,
                tenantId: this.tenantId,
                applicationId: this.applicationId,
                featureId: this.featureId,
                personaId: this.personaId,
                redirectUrl: this.redirectUrl,
                newUserWelcomeTemplateTypeId: this.newUserWelcomeTemplateTypeId,
                existingUserWelcomeTemplateTypeId: this.existingUserWelcomeTemplateTypeId,
            }));
        }
        else {
            this.store.dispatch(new Login({
                ...user,
                returnUrl: this._returnUrl,
                tenantId: this._tenantId,
                isIdentityProvider: this._oidc,
            }));
        }
    }
    onForgetPassword(email) {
        this.forgetPasswordButtonClicked.emit();
        this.store.dispatch(new ForgotPasswordRedirect(email));
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginContainerComponent, deps: [{ token: i1$2.Store }, { token: CoreService }, { token: i1$1.ActivatedRoute }, { token: i2.Actions }, { token: AuthService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: LoginContainerComponent, selector: "arc-shared-app-login", inputs: { widgetMode: "widgetMode", applicationId: "applicationId", featureId: "featureId", personaId: "personaId", redirectUrl: "redirectUrl", tenantId: "tenantId", newUserWelcomeTemplateTypeId: "newUserWelcomeTemplateTypeId", existingUserWelcomeTemplateTypeId: "existingUserWelcomeTemplateTypeId", preventTitleChange: "preventTitleChange", enablePersonaRegistrationFlow: "enablePersonaRegistrationFlow", signUpLink: "signUpLink", fromExternal: "fromExternal" }, outputs: { loginSucceeded: "loginSucceeded", loginError: "loginError", loginButtonClicked: "loginButtonClicked", forgetPasswordButtonClicked: "forgetPasswordButtonClicked" }, ngImport: i0, template: "<arc-shared-login *ngIf=\"!isBypass\" [msgs]=\"msgs\" [submitting]=\"submitting$ | async\" [enablePersonaRegistrationFlow]=\"enablePersonaRegistrationFlow\" (forgotPasswordClicked)=\"onForgetPassword($event)\"\n        (signinClicked)='onSignin($event)' [signUpLink]=\"signUpLink\">\n</arc-shared-login>\n", dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: LoginComponent, selector: "arc-shared-login", inputs: ["showLoginButton", "showForgetPasswordButton", "enablePersonaRegistrationFlow", "msgs", "submitting", "signUpLink"], outputs: ["signinClicked", "forgotPasswordClicked"] }, { kind: "pipe", type: i2$2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-app-login', template: "<arc-shared-login *ngIf=\"!isBypass\" [msgs]=\"msgs\" [submitting]=\"submitting$ | async\" [enablePersonaRegistrationFlow]=\"enablePersonaRegistrationFlow\" (forgotPasswordClicked)=\"onForgetPassword($event)\"\n        (signinClicked)='onSignin($event)' [signUpLink]=\"signUpLink\">\n</arc-shared-login>\n" }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: CoreService }, { type: i1$1.ActivatedRoute }, { type: i2.Actions }, { type: AuthService }], propDecorators: { widgetMode: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], featureId: [{
                type: Input
            }], personaId: [{
                type: Input
            }], redirectUrl: [{
                type: Input
            }], tenantId: [{
                type: Input
            }], newUserWelcomeTemplateTypeId: [{
                type: Input
            }], existingUserWelcomeTemplateTypeId: [{
                type: Input
            }], preventTitleChange: [{
                type: Input
            }], enablePersonaRegistrationFlow: [{
                type: Input
            }], signUpLink: [{
                type: Input
            }], fromExternal: [{
                type: Input
            }], loginSucceeded: [{
                type: Output
            }], loginError: [{
                type: Output
            }], loginButtonClicked: [{
                type: Output
            }], forgetPasswordButtonClicked: [{
                type: Output
            }] } });

class LoginSilentComponent {
    constructor(router, store, coreService, route, actions$, document) {
        this.router = router;
        this.store = store;
        this.coreService = coreService;
        this.route = route;
        this.actions$ = actions$;
        this.widgetMode = 'regular';
        this.applicationId = '';
        this.featureId = '';
        this.personaId = '';
        this.redirectUrl = '';
        this.tenantId = '';
        this.newUserWelcomeTemplateTypeId = '';
        this.existingUserWelcomeTemplateTypeId = '';
        this.preventTitleChange = false;
        this.loginSucceeded = new EventEmitter();
        this.loginError = new EventEmitter();
        this.loginButtonClicked = new EventEmitter();
        this.forgetPasswordButtonClicked = new EventEmitter();
        this.msgs = [];
        this.errmsg = '';
        this.showresetpassword = false;
        this.subs = new SubSink();
        this._returnUrl = '';
        this._logoutUrl = '';
        this._tenantId = '';
        this._oidc = false;
        this.isBypass = true;
    }
    ngOnInit() {
        if (!this.preventTitleChange)
            document.title = 'billtrust';
        const isClientSession = (this.route.snapshot.queryParams['dualsession'] || '') === '1';
        if (isClientSession) {
            this.coreService.setClientConnectLocalStorage('1');
        }
        else {
            this.coreService.clearClientConnectLocalStorage();
        }
        // this.widgetMode = this.route.snapshot.data['widgetMode'] || 'regular';
        // this.applciationId = this.route.snapshot.data['applciationId'];
        // this.featureId = this.route.snapshot.data['featureId'];
        // this.redirectUrl = this.route.snapshot.data['redirectUrl'];
        // this.tenantId = this.route.snapshot.data['tenantId'];
        // this.newUserWelcomeTemplateTypeId = this.route.snapshot.data['newUserWelcomeTemplateTypeId'];
        // this.existingUserWelcomeTemplateTypeId = this.route.snapshot.data['existingUserWelcomeTemplateTypeId'];
        this.route.queryParams.subscribe((params) => {
            let token = params['token'];
            this._tenantId = params['tenantId'];
            this._returnUrl = params['returnUrl'];
            this._logoutUrl = params['logoutUrl'] || params['logoutRedirectUrl'];
            this._oidc = params['oidc'] === 'oidc';
            this.submitting$ = this.store
                .select(AuthStore)
                .pipe(select((x) => x.user.submitting));
            if (token) {
                const accessToken = params['token'];
                if (accessToken) {
                    this.store.dispatch(new LoginByToken({
                        accessToken: accessToken,
                        tenantId: this._tenantId,
                        returnUrl: this._returnUrl,
                        logoutUrl: this._logoutUrl,
                        isIdentityProvider: this._oidc,
                    }));
                }
                else {
                    this.isBypass = false;
                }
            }
            else {
                token = this.coreService.getAuthTokenFromLocalStorage();
                const activeTenantString = this.coreService.getActiveTenantFromLocalStorage();
                const activeTenant = activeTenantString
                    ? JSON.parse(activeTenantString)
                    : {};
                const tenantId = activeTenant ? activeTenant.tenantId : null;
                if (token) {
                    this.store.dispatch(new LoginByToken({
                        accessToken: token,
                        tenantId: tenantId,
                        silentError: true,
                        isIdentityProvider: this._oidc,
                    }));
                }
                else {
                    this.isBypass = false;
                }
            }
        });
        this.subs.add(this.actions$
            .pipe(ofType(GeneralActionTypes.UserNotification), map((action) => action.payload), filter((x) => x.type === 'danger'))
            .subscribe((x) => {
            this.isBypass = false;
        }));
        this.subs.add(this.actions$
            .pipe(ofType(GeneralActionTypes.DoNothing))
            .subscribe((x) => {
            this.isBypass = false;
        }));
        this.subs.add(this.actions$
            .pipe(ofType(AuthActionTypes.LoginSuccess))
            .subscribe((x) => {
            this.loginSucceeded.emit();
        }));
        this.subs.add(this.actions$
            .pipe(ofType(AuthActionTypes.LoginFailure))
            .subscribe((x) => {
            this.loginError.emit();
        }));
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginSilentComponent, deps: [{ token: i1$1.Router }, { token: i1$2.Store }, { token: CoreService }, { token: i1$1.ActivatedRoute }, { token: i2.Actions }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: LoginSilentComponent, selector: "arc-shared-app-login-silent", inputs: { widgetMode: "widgetMode", applicationId: "applicationId", featureId: "featureId", personaId: "personaId", redirectUrl: "redirectUrl", tenantId: "tenantId", newUserWelcomeTemplateTypeId: "newUserWelcomeTemplateTypeId", existingUserWelcomeTemplateTypeId: "existingUserWelcomeTemplateTypeId", preventTitleChange: "preventTitleChange" }, outputs: { loginSucceeded: "loginSucceeded", loginError: "loginError", loginButtonClicked: "loginButtonClicked", forgetPasswordButtonClicked: "forgetPasswordButtonClicked" }, ngImport: i0, template: "<div class=\"splash-screen\">\n   <img src=\"./assets/layout/images/white-loading-on-blue.gif\" alt=\"Loading\">\n</div>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginSilentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-app-login-silent', template: "<div class=\"splash-screen\">\n   <img src=\"./assets/layout/images/white-loading-on-blue.gif\" alt=\"Loading\">\n</div>" }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: i1$2.Store }, { type: CoreService }, { type: i1$1.ActivatedRoute }, { type: i2.Actions }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { widgetMode: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], featureId: [{
                type: Input
            }], personaId: [{
                type: Input
            }], redirectUrl: [{
                type: Input
            }], tenantId: [{
                type: Input
            }], newUserWelcomeTemplateTypeId: [{
                type: Input
            }], existingUserWelcomeTemplateTypeId: [{
                type: Input
            }], preventTitleChange: [{
                type: Input
            }], loginSucceeded: [{
                type: Output
            }], loginError: [{
                type: Output
            }], loginButtonClicked: [{
                type: Output
            }], forgetPasswordButtonClicked: [{
                type: Output
            }] } });

class PasswordresetComponent {
    constructor(settings) {
        this.settings = settings;
        this.resetPasswordClicked = new EventEmitter();
        this.goBackClicked = new EventEmitter();
        this.backButtonVisible = true;
        this.labelPrefix = '';
    }
    ngOnInit() {
        this.passwordFormGroup = new UntypedFormGroup({
            passwordConfirm1: new UntypedFormControl('', {
                validators: [
                    Validators.required,
                    ArcValidators.minLength(8),
                    ArcValidators.oneLowerCase,
                    ArcValidators.oneUpperCase,
                    ArcValidators.oneSpecialCharacter,
                    ArcValidators.oneNumber,
                ],
                updateOn: 'change',
            }),
            passwordConfirm2: new UntypedFormControl('', {
                updateOn: 'change',
            }),
        }, {
            validators: [
                ArcValidators.fieldMatch('passwordConfirm1', 'passwordConfirm2'),
            ],
            updateOn: 'blur',
        });
        this.passwordFormGroup
            .get('passwordConfirm2')
            .setValidators([
            Validators.required,
            ArcValidators.fieldMatch('passwordConfirm1', 'passwordConfirm2', this.passwordFormGroup),
        ]);
    }
    setPassword() {
        this.passwordFormGroup.updateValueAndValidity();
        if (this.passwordFormGroup.valid) {
            this.resetPasswordClicked.emit(this.passwordFormGroup.controls.passwordConfirm1.value);
        }
        else {
            this.passwordConfirm1.markAsTouched();
            this.passwordConfirm2.markAsTouched();
        }
    }
    get passwordConfirm1() {
        return this.passwordFormGroup.get('passwordConfirm1');
    }
    get passwordConfirm2() {
        return this.passwordFormGroup.get('passwordConfirm2');
    }
    get passwordConfirm1Changed() {
        return this.passwordConfirm1.touched;
    }
    get passwordConfirm1IsInValid() {
        return this.passwordConfirm1.errors && this.passwordConfirm1.touched;
    }
    get passwordConfirm2IsInValid() {
        return ((this.passwordConfirm2.errors ||
            (this.passwordFormGroup.errors &&
                this.passwordFormGroup.errors.fieldMatch)) &&
            this.passwordConfirm2.touched);
    }
    showError(control, error) {
        return control.touched && control.errors && control.errors[error];
    }
    showSuccess(control, error) {
        return ((control.dirty && !control.errors) ||
            (control.errors && !control.errors[error]));
    }
    goBack($event) {
        this.goBackClicked.emit();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PasswordresetComponent, deps: [{ token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: PasswordresetComponent, selector: "arc-shared-passwordreset", inputs: { backButtonVisible: "backButtonVisible" }, outputs: { resetPasswordClicked: "resetPasswordClicked", goBackClicked: "goBackClicked" }, ngImport: i0, template: "<form id=\"passwordResetForm\" (ngSubmit)=\"setPassword()\" [formGroup]=\"passwordFormGroup\">\n    <div class=\"list-wrapper\">\n        <div class=\"security-measures\">\n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red': showError(passwordConfirm1, 'minlength'),\n                'green': showSuccess(passwordConfirm1, 'minlength')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'minlength')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'minlength')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_MINIMUM_LENGTH8' | translate}} </span>\n            </div>\n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red': showError(passwordConfirm1, 'oneLowerCase'),\n                'green': showSuccess(passwordConfirm1, 'oneLowerCase')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'oneLowerCase')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'oneLowerCase')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONELOWERCASE' | translate }}</span>\n            </div>\n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red':showError(passwordConfirm1, 'oneUpperCase'),\n                'green':showSuccess(passwordConfirm1, 'oneUpperCase')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'oneUpperCase')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'oneUpperCase')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONEUPPERCASE' | translate }}</span>\n            </div>\n    \n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red':showError(passwordConfirm1, 'oneNumber'),\n                'green':showSuccess(passwordConfirm1, 'oneNumber')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'oneNumber')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'oneNumber')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONENUMBER' | translate }}</span>\n            </div>\n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red':showError(passwordConfirm1, 'oneSpecialCharacter'),\n                'green':showSuccess(passwordConfirm1, 'oneSpecialCharacter')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'oneSpecialCharacter')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'oneSpecialCharacter')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONSPECIALCHAR' | translate }}</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"p-col-12\">\n        <aur-input\n            type=\"password\"\n            formControlName=\"passwordConfirm1\"\n            [showClearButton]=\"true\"\n            [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_1_LABEL' | translate\"\n            [errorMessages]=\"{\n                'minlength': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'oneLowerCase': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'oneNumber': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'oneSpecialCharacter': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'oneUpperCase': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate\n            }\"\n        ></aur-input>\n    </div>\n    <div class=\"p-col-12\">\n        <aur-input\n            type=\"password\"\n            formControlName=\"passwordConfirm2\"\n            [showClearButton]=\"true\"\n            [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_CONFIRM_LABEL' | translate\"\n            [errorMessages]=\"{\n                'fieldMatch': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate,\n                'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate\n            }\"\n        ></aur-input>\n    </div>\n\n    \n    <div class=\"p-col-12\">\n        <!-- <aur-validation-error\n            [form]=\"passwordFormGroup\"\n            for=\"form\"\n            [errorMessages]=\"{\n                'fieldMatch': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate\n            }\"\n        ></aur-validation-error> -->\n        <!-- <aur-notice severity=\"error\" *ngIf=\"passwordFormGroup?.errors?.fieldMatch\">\n            {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate }}\n        </aur-notice> -->\n        <button type=\"submit\" id=\"btSetNewPassword\" class=\"reset-button\" aur-button>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_SAVE_PASSWORD_BUTTON'\n            | translate}}</button>\n    </div>\n    <div *ngIf=\"backButtonVisible\" class=\"p-col-12 ui-md-12\">\n        <button type=\"button\" aur-button (click)=\"goBack($event)\" icon=\"arrow_back\" importance=\"tertiary\">{{ 'ARC_SHARED_COMPONENTS_BACK'\n            | translate }}</button>\n    </div>\n</form>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}form{text-align:left;display:block}.list-wrapper{display:flex;justify-content:center;width:100%}.security-measure{display:flex;margin-bottom:8px;padding:0 12px}.security-measure.total{padding-top:4px;border-top:2px solid rgba(77,96,105,.15)}.icon-wrapper{align-items:center;display:flex;margin-right:4px;width:24px}aur-icon{display:block;font-size:20px!important}.red{color:#8f1100}.green{color:#005c00}aur-input{width:100%}.disabled{cursor:default;pointer-events:none;opacity:.6}.reset-button{width:100%}\n"], dependencies: [{ kind: "directive", type: i2$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i2$1.IconComponent, selector: "aur-icon", inputs: ["color", "fontset", "rotate", "size", "emphasis", "iconStyle"] }, { kind: "component", type: i2$1.InputComponent, selector: "aur-input", inputs: ["allowNegativeNumbers", "autocomplete", "autofocus", "aurMask", "autotrim", "decimalPlaces", "disabled", "dropSpecialCharacters", "errorMessages", "formControlName", "formControlPath", "form", "frameless", "hiddenInput", "id", "inlineLabel", "inputId", "inputMode", "enterKeyHint", "inputName", "indicateRequirement", "label", "locale", "noValidate", "max", "min", "placeholder", "prefix", "showClearButton", "step", "suffix", "suggestion", "thousandSeparator", "tooltip", "tooltipOptions", "type", "value"], outputs: ["clearClick", "suggestionClick", "passwordToggled", "valueChange", "blur", "focus"] }, { kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PasswordresetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-passwordreset', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form id=\"passwordResetForm\" (ngSubmit)=\"setPassword()\" [formGroup]=\"passwordFormGroup\">\n    <div class=\"list-wrapper\">\n        <div class=\"security-measures\">\n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red': showError(passwordConfirm1, 'minlength'),\n                'green': showSuccess(passwordConfirm1, 'minlength')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'minlength')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'minlength')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_MINIMUM_LENGTH8' | translate}} </span>\n            </div>\n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red': showError(passwordConfirm1, 'oneLowerCase'),\n                'green': showSuccess(passwordConfirm1, 'oneLowerCase')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'oneLowerCase')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'oneLowerCase')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONELOWERCASE' | translate }}</span>\n            </div>\n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red':showError(passwordConfirm1, 'oneUpperCase'),\n                'green':showSuccess(passwordConfirm1, 'oneUpperCase')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'oneUpperCase')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'oneUpperCase')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONEUPPERCASE' | translate }}</span>\n            </div>\n    \n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red':showError(passwordConfirm1, 'oneNumber'),\n                'green':showSuccess(passwordConfirm1, 'oneNumber')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'oneNumber')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'oneNumber')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONENUMBER' | translate }}</span>\n            </div>\n            <div [ngClass]=\"{\n                'security-measure': true,\n                'red':showError(passwordConfirm1, 'oneSpecialCharacter'),\n                'green':showSuccess(passwordConfirm1, 'oneSpecialCharacter')\n            }\">\n                <span class=\"icon-wrapper\">\n                    <aur-icon *ngIf=\"showError(passwordConfirm1, 'oneSpecialCharacter')\" color=\"danger\">highlight_off</aur-icon>\n                    <aur-icon *ngIf=\"showSuccess(passwordConfirm1, 'oneSpecialCharacter')\" color=\"success\">check_circle_outline</aur-icon>\n                </span>\n                <span>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ONSPECIALCHAR' | translate }}</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"p-col-12\">\n        <aur-input\n            type=\"password\"\n            formControlName=\"passwordConfirm1\"\n            [showClearButton]=\"true\"\n            [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_1_LABEL' | translate\"\n            [errorMessages]=\"{\n                'minlength': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'oneLowerCase': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'oneNumber': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'oneSpecialCharacter': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'oneUpperCase': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate,\n                'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_VALIDATION' | translate\n            }\"\n        ></aur-input>\n    </div>\n    <div class=\"p-col-12\">\n        <aur-input\n            type=\"password\"\n            formControlName=\"passwordConfirm2\"\n            [showClearButton]=\"true\"\n            [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_CONFIRM_LABEL' | translate\"\n            [errorMessages]=\"{\n                'fieldMatch': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate,\n                'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate\n            }\"\n        ></aur-input>\n    </div>\n\n    \n    <div class=\"p-col-12\">\n        <!-- <aur-validation-error\n            [form]=\"passwordFormGroup\"\n            for=\"form\"\n            [errorMessages]=\"{\n                'fieldMatch': 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate\n            }\"\n        ></aur-validation-error> -->\n        <!-- <aur-notice severity=\"error\" *ngIf=\"passwordFormGroup?.errors?.fieldMatch\">\n            {{ 'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_REQ_ERROR_MATCH' | translate }}\n        </aur-notice> -->\n        <button type=\"submit\" id=\"btSetNewPassword\" class=\"reset-button\" aur-button>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_SAVE_PASSWORD_BUTTON'\n            | translate}}</button>\n    </div>\n    <div *ngIf=\"backButtonVisible\" class=\"p-col-12 ui-md-12\">\n        <button type=\"button\" aur-button (click)=\"goBack($event)\" icon=\"arrow_back\" importance=\"tertiary\">{{ 'ARC_SHARED_COMPONENTS_BACK'\n            | translate }}</button>\n    </div>\n</form>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}form{text-align:left;display:block}.list-wrapper{display:flex;justify-content:center;width:100%}.security-measure{display:flex;margin-bottom:8px;padding:0 12px}.security-measure.total{padding-top:4px;border-top:2px solid rgba(77,96,105,.15)}.icon-wrapper{align-items:center;display:flex;margin-right:4px;width:24px}aur-icon{display:block;font-size:20px!important}.red{color:#8f1100}.green{color:#005c00}aur-input{width:100%}.disabled{cursor:default;pointer-events:none;opacity:.6}.reset-button{width:100%}\n"] }]
        }], ctorParameters: () => [{ type: AppConfigSettings }], propDecorators: { resetPasswordClicked: [{
                type: Output
            }], goBackClicked: [{
                type: Output
            }], backButtonVisible: [{
                type: Input
            }] } });

class PasswordresetContainerComponent {
    constructor(store, settings) {
        this.store = store;
        this.settings = settings;
        this.emailsent = false;
        this.msgs = [];
        this.subs = new SubSink();
        this.goBackClicked = new EventEmitter();
        this.onResetPasswordSucceeded = new EventEmitter();
        this.onResetPasswordError = new EventEmitter();
    }
    ngOnInit() {
        this.subs.add(this.store
            .select(SuccessStore)
            .pipe(filter((x) => x && x.actionType === AuthActionTypes.ResetPassword))
            .subscribe((x) => {
            this.onResetPasswordSucceeded.emit();
        }));
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    onResetPasswordClick($event) {
        this.store.dispatch(new ResetPassword($event));
    }
    goBack($event) {
        this.goBackClicked.emit();
        this.store.dispatch(new LoginRedirect(null));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PasswordresetContainerComponent, deps: [{ token: i1$2.Store }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: PasswordresetContainerComponent, selector: "arc-shared-app-passwordreset", outputs: { goBackClicked: "goBackClicked", onResetPasswordSucceeded: "onResetPasswordSucceeded", onResetPasswordError: "onResetPasswordError" }, ngImport: i0, template: "<div class=\"p-col-12 ui-md-12\">\n    <h2>{{'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_MSG' | translate}}</h2>\n    <p> {{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_REQ_DESCRIPTION' | translate}}</p>\n</div>\n<arc-shared-passwordreset [backButtonVisible]=\"false\" (resetPasswordClicked)=\"onResetPasswordClick($event)\"></arc-shared-passwordreset>\n\n<div class=\"p-col-12 ui-md-12 tertiary-wrapper\">\n    <button aur-button type=\"button\" (click)=\"goBack($event)\" icon=\"arrow_back\" importance=\"tertiary\">{{ 'ARC_SHARED_COMPONENTS_BACK'\n        | translate }}</button>\n</div>\n", styles: [".tertiary-wrapper{display:flex}\n"], dependencies: [{ kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: PasswordresetComponent, selector: "arc-shared-passwordreset", inputs: ["backButtonVisible"], outputs: ["resetPasswordClicked", "goBackClicked"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PasswordresetContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-app-passwordreset', template: "<div class=\"p-col-12 ui-md-12\">\n    <h2>{{'ARC_SHARED_COMPONENTS_PRESENTATION_PASSWORD_MSG' | translate}}</h2>\n    <p> {{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_REQ_DESCRIPTION' | translate}}</p>\n</div>\n<arc-shared-passwordreset [backButtonVisible]=\"false\" (resetPasswordClicked)=\"onResetPasswordClick($event)\"></arc-shared-passwordreset>\n\n<div class=\"p-col-12 ui-md-12 tertiary-wrapper\">\n    <button aur-button type=\"button\" (click)=\"goBack($event)\" icon=\"arrow_back\" importance=\"tertiary\">{{ 'ARC_SHARED_COMPONENTS_BACK'\n        | translate }}</button>\n</div>\n", styles: [".tertiary-wrapper{display:flex}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: AppConfigSettings }], propDecorators: { goBackClicked: [{
                type: Output
            }], onResetPasswordSucceeded: [{
                type: Output
            }], onResetPasswordError: [{
                type: Output
            }] } });

class ForceResetPasswordContainerComponent {
    constructor(store, route) {
        this.store = store;
        this.route = route;
        this.msgs = [];
        this.onResetPasswordClicked = new EventEmitter();
    }
    ngOnInit() { }
    onResetPasswordClick($event) {
        this.onResetPasswordClicked.emit($event);
        let isExternal = this.route.snapshot.paramMap.get('isExternal');
        let tenantId = this.route.snapshot.paramMap.get('tenantId');
        let payload;
        if (isExternal) {
            payload = { newPassword: $event, tenantId: tenantId, isExternal: true };
        }
        else {
            payload = { newPassword: $event };
        }
        this.store.dispatch(new ForceResetPassword(payload));
        // this.store.dispatch(new ResetPassword($event));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ForceResetPasswordContainerComponent, deps: [{ token: i1$2.Store }, { token: i1$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ForceResetPasswordContainerComponent, selector: "arc-shared-app-newpassword", outputs: { onResetPasswordClicked: "onResetPasswordClicked" }, ngImport: i0, template: "<div class=\"p-col-12 ui-md-12\">\n    <h2>{{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_MSG_NEW' | translate}}</h2>\n    <p> {{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_REQ_DESCRIPTION' | translate}}</p>\n</div>\n<arc-shared-passwordreset [backButtonVisible]=\"false\" (resetPasswordClicked)=\"onResetPasswordClick($event)\"></arc-shared-passwordreset>\n", styles: ["p{margin-bottom:0}\n"], dependencies: [{ kind: "component", type: PasswordresetComponent, selector: "arc-shared-passwordreset", inputs: ["backButtonVisible"], outputs: ["resetPasswordClicked", "goBackClicked"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ForceResetPasswordContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-app-newpassword', template: "<div class=\"p-col-12 ui-md-12\">\n    <h2>{{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_MSG_NEW' | translate}}</h2>\n    <p> {{'ARC_SHARED_COMPONENTS_PRESENTATION_FORCE_PASSWORD_REQ_DESCRIPTION' | translate}}</p>\n</div>\n<arc-shared-passwordreset [backButtonVisible]=\"false\" (resetPasswordClicked)=\"onResetPasswordClick($event)\"></arc-shared-passwordreset>\n", styles: ["p{margin-bottom:0}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i1$1.ActivatedRoute }], propDecorators: { onResetPasswordClicked: [{
                type: Output
            }] } });

class TenantswitcherComponent {
    set tenantList(value) {
        this._tenantList = value;
    }
    get visible() {
        return this._visible;
    }
    set visible(value) {
        if (this._visible !== value) {
            this._visible = value;
            if (value === false) {
                this.resetTenant();
            }
            else if (value === true) {
                this.scrollToSelectedTenant();
            }
        }
    }
    get tenantList() {
        return this._tenantList;
    }
    constructor(element) {
        this.element = element;
        this._visible = false;
        this.onCancelClicked = new EventEmitter();
        this.onOkClicked = new EventEmitter();
        this._tenantList = [];
    }
    ngOnInit() {
        this.activeTenantFormGroup = new UntypedFormGroup({
            selectedTenant: new UntypedFormControl(this.currentTenant, [
                Validators.required,
            ]),
        });
    }
    ngOnChanges(changes) {
        if (this.activeTenantFormGroup && this.currentTenant) {
            const tenantInList = (this._tenantList || []).find((x) => x.tenantId === this.currentTenant.tenantId);
            this.activeTenantFormGroup.patchValue({
                selectedTenant: tenantInList,
            });
        }
    }
    changeTenantClicked($event) {
        if (this.activeTenantFormGroup.valid) {
            this.onOkClicked.emit(this.activeTenantFormGroup.controls.selectedTenant.value);
        }
    }
    resetTenant() {
        if (this.activeTenantFormGroup) {
            this.activeTenantFormGroup.patchValue({
                selectedTenant: this.currentTenant,
            });
        }
    }
    cancelClicked($event) {
        this.resetTenant();
        this.onCancelClicked.emit();
    }
    scrollToSelectedTenant() {
        const ele = this.element.nativeElement.querySelector('.active-link');
        if (ele) {
            ele.scrollIntoView();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantswitcherComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: TenantswitcherComponent, selector: "arc-shared-tenantswitcher", inputs: { tenantList: "tenantList", currentTenant: "currentTenant", visible: "visible" }, outputs: { onCancelClicked: "onCancelClicked", onOkClicked: "onOkClicked" }, usesOnChanges: true, ngImport: i0, template: "<form class=\"p-grid form-group tenant-form\" [formGroup]=\"activeTenantFormGroup\">\n  <div class=\"tenant-list-wrapper\">\n    <span class=\"md-inputfield\">\n      <!-- <p-dropdown\n        id=\"selected-tenant-dropdown\"\n        [class.ui-inputwrapper-filled]=\"!!activeTenantFormGroup?.value?.selectedTenant\"\n        formControlName=\"selectedTenant\"\n        [options]=\"tenantList\"\n        dataKey=\"tenantId\"\n        optionLabel=\"tenantName\"\n        appendTo=\"body\"\n        [autoWidth]=\"false\"\n        [style]=\"{ 'width': '100%' }\"\n      ></p-dropdown> -->\n\n      <aur-menu id=\"selected-tenant-list\" class=\"tenant-list\" [class.ui-inputwrapper-filled]=\"true\" dataKey=\"tenantId\" [closable]=\"false\"\n        optionLabel=\"tenantName\" formControlName=\"selectedTenant\" [items]=\"tenantList\"></aur-menu>\n      <label>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_TENANT_SWITCHER_LABEL' | translate }}</label>\n    </span>\n  </div>\n\n  <div>\n    <button aur-button type=\"button\" importance=\"secondary\" id=\"tenant-switch-cancel-button\" (click)=\"cancelClicked($event)\">{{\n      'ARC_SHARED_COMPONENTS_BUTTON_CANCEL' | translate }}</button>\n\n    <button aur-button (click)=\"changeTenantClicked($event)\" id=\"tenant-switch-button\">{{ 'ARC_SHARED_COMPONENTS_BUTTON_OK'\n      | translate }}</button>\n  </div>\n</form>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}:host{display:flex;flex:1 1 auto}form{display:flex;flex:1 1 auto;flex-direction:column}footer{display:flex;justify-content:flex-end;padding:16px 0}\n"], dependencies: [{ kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i2$1.MenuComponent, selector: "aur-menu", inputs: ["dataKey", "optionLabel", "closable", "disabled", "exact", "items", "scrollToSelected", "value", "formControlName", "id", "open", "size"], outputs: ["openChange", "selected"] }, { kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantswitcherComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-tenantswitcher', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form class=\"p-grid form-group tenant-form\" [formGroup]=\"activeTenantFormGroup\">\n  <div class=\"tenant-list-wrapper\">\n    <span class=\"md-inputfield\">\n      <!-- <p-dropdown\n        id=\"selected-tenant-dropdown\"\n        [class.ui-inputwrapper-filled]=\"!!activeTenantFormGroup?.value?.selectedTenant\"\n        formControlName=\"selectedTenant\"\n        [options]=\"tenantList\"\n        dataKey=\"tenantId\"\n        optionLabel=\"tenantName\"\n        appendTo=\"body\"\n        [autoWidth]=\"false\"\n        [style]=\"{ 'width': '100%' }\"\n      ></p-dropdown> -->\n\n      <aur-menu id=\"selected-tenant-list\" class=\"tenant-list\" [class.ui-inputwrapper-filled]=\"true\" dataKey=\"tenantId\" [closable]=\"false\"\n        optionLabel=\"tenantName\" formControlName=\"selectedTenant\" [items]=\"tenantList\"></aur-menu>\n      <label>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_TENANT_SWITCHER_LABEL' | translate }}</label>\n    </span>\n  </div>\n\n  <div>\n    <button aur-button type=\"button\" importance=\"secondary\" id=\"tenant-switch-cancel-button\" (click)=\"cancelClicked($event)\">{{\n      'ARC_SHARED_COMPONENTS_BUTTON_CANCEL' | translate }}</button>\n\n    <button aur-button (click)=\"changeTenantClicked($event)\" id=\"tenant-switch-button\">{{ 'ARC_SHARED_COMPONENTS_BUTTON_OK'\n      | translate }}</button>\n  </div>\n</form>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}:host{display:flex;flex:1 1 auto}form{display:flex;flex:1 1 auto;flex-direction:column}footer{display:flex;justify-content:flex-end;padding:16px 0}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { tenantList: [{
                type: Input
            }], currentTenant: [{
                type: Input
            }], visible: [{
                type: Input
            }], onCancelClicked: [{
                type: Output
            }], onOkClicked: [{
                type: Output
            }] } });

class TenantswitcherContainerComponent {
    constructor(store, titleService, appConfigSettings, pendoService, document) {
        this.store = store;
        this.titleService = titleService;
        this.appConfigSettings = appConfigSettings;
        this.pendoService = pendoService;
        this.document = document;
        this.visible = false;
        this.cancel = new EventEmitter();
        this.ok = new EventEmitter();
    }
    ngOnInit() {
        this.tenantList$ = this.store.pipe(select(AuthUserStore), filter((user) => user && user.user && user.user.tenants && user.user.tenants.length > 0), map((user) => user.user.tenants));
        this.currentTenant$ = this.store.pipe(select(ActiveTenantStore) //,
        );
        this.resellerSubscription = this.store.pipe(select(selectTenantResellerId)).subscribe(resellerId => {
            this.changeTabHeader(resellerId); // TODO: this may be superseded by moving tab header logic to the unified header
            this.pendoService.includeAdditionalContext({ 'resellerid': resellerId?.toUpperCase() ?? 'BILLTRUST' }, {});
        });
    }
    ngOnDestroy() {
        this.resellerSubscription.unsubscribe();
    }
    onCancelClicked($event) {
        this.cancel.emit();
    }
    onOkClicked($event) {
        this.store.dispatch(new ActiveTenantChanging({ tenantId: $event.tenantId, resetRoute: true }));
        this.ok.emit();
    }
    changeTabHeader(resellerId) {
        const link = this.document?.querySelector("link[rel='icon']");
        if (link) {
            switch (resellerId?.toLowerCase()) {
                case 'jpmorgan':
                    link.href = 'assets/layout/images/jpm-favicon.ico?v1';
                    this.titleService.setTitle(this.appConfigSettings.getconfig('jpmorganTabTitle'));
                    break;
                default:
                    link.href = 'assets/layout/images/favicon.ico?v1';
                    this.titleService.setTitle(this.appConfigSettings.getconfig('billtrustTabTitle'));
                    break;
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantswitcherContainerComponent, deps: [{ token: i1$2.Store }, { token: i2$3.Title }, { token: AppConfigSettings }, { token: PendoService }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: TenantswitcherContainerComponent, selector: "arc-shared-tenantswitchercontainer", inputs: { visible: "visible" }, outputs: { cancel: "cancel", ok: "ok" }, ngImport: i0, template: "<arc-shared-tenantswitcher\n  [currentTenant]=\"currentTenant$ | async\"\n  [tenantList]=\"tenantList$ | async\"\n  [visible]=\"visible\"\n  (onCancelClicked)=\"onCancelClicked($event)\"\n  (onOkClicked)=\"onOkClicked($event)\"\n></arc-shared-tenantswitcher>\n\n\n", styles: [":host{display:flex;flex:1 1 auto}\n"], dependencies: [{ kind: "component", type: TenantswitcherComponent, selector: "arc-shared-tenantswitcher", inputs: ["tenantList", "currentTenant", "visible"], outputs: ["onCancelClicked", "onOkClicked"] }, { kind: "pipe", type: i2$2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TenantswitcherContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-tenantswitchercontainer', template: "<arc-shared-tenantswitcher\n  [currentTenant]=\"currentTenant$ | async\"\n  [tenantList]=\"tenantList$ | async\"\n  [visible]=\"visible\"\n  (onCancelClicked)=\"onCancelClicked($event)\"\n  (onOkClicked)=\"onOkClicked($event)\"\n></arc-shared-tenantswitcher>\n\n\n", styles: [":host{display:flex;flex:1 1 auto}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i2$3.Title }, { type: AppConfigSettings }, { type: PendoService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { visible: [{
                type: Input
            }], cancel: [{
                type: Output
            }], ok: [{
                type: Output
            }] } });

class ProfileContainerComponent {
    constructor() { }
    ngOnInit() { }
    displaySwitchTenant() {
        // this.app.toggleSwitchTenant();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ProfileContainerComponent, selector: "arc-shared-profilecontainer", ngImport: i0, template: "<!-- <li role=\"menuitem\">\n  <a href=\"javascript:void(0)\" (click)=\"displaySwitchTenant()\">\n  <i class=\"material-icons\">swap_calls</i>\n  <span>Change Company</span>\n  </a>\n  </li> -->\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ProfileContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-profilecontainer', template: "<!-- <li role=\"menuitem\">\n  <a href=\"javascript:void(0)\" (click)=\"displaySwitchTenant()\">\n  <i class=\"material-icons\">swap_calls</i>\n  <span>Change Company</span>\n  </a>\n  </li> -->\n" }]
        }], ctorParameters: () => [] });

class TopbarprofileComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.onDestroy$ = new Subject();
        this.open = false;
        this.tabindex = 0;
    }
    ngOnInit() {
        this.subscribeToClickAway();
    }
    ngOnDestroy() {
        this.onDestroy$.next();
    }
    // @HostListener('click', ['$event'])
    toggleMenu(event) {
        if (this.menu) {
            this.menu.toggle(event);
        }
        else {
            this.open = !this.open;
        }
    }
    subscribeToClickAway() {
        fromEvent(document, 'click')
            .pipe(filter((event) => {
            return this.open && this.isOutsideComponent(event.target);
        }), merge(fromEvent(document, 'keyup').pipe(filter((event) => event.key === 'Escape'))), takeUntil(this.onDestroy$))
            .subscribe(() => {
            this.open = false;
        });
    }
    isOutsideComponent(target) {
        return !this.elementRef.nativeElement.contains(target);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TopbarprofileComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: TopbarprofileComponent, selector: "arc-shared-topbarprofile", inputs: { user: "user", tenant: "tenant", items: "items", open: "open" }, host: { listeners: { "keyup.enter": "toggleMenu($event)" }, properties: { "tabindex": "this.tabindex" } }, viewQueries: [{ propertyName: "menu", first: true, predicate: ["menu"], descendants: true }], ngImport: i0, template: "<aur-popup-menu [items]=\"items\" originY=\"bottom\" originX=\"end\" overlayX=\"end\">\n    <ng-template aurTemplate=\"trigger\">\n        <div id=\"profile-dropdown\" class=\"profile-dropdown\">\n            <div class=\"content-wrapper\">\n                <aur-icon color=\"inherit\" class=\"account-icon\">account_circle</aur-icon>\n        \n                <div id=\"aur-topbar-user-profile-desc\" class=\"description\">\n                    <div\n                        class=\"name\"\n                        id=\"profile-user-name\"\n                        *ngIf=\"user\"\n                        [title]=\"(user.user?.firstName || '' ) +' ' + (user.user?.lastName\n                        || '')\"\n                    >{{ (user.user?.firstName || '' ) +' ' + (user.user?.lastName\n                        || '') }} </div>\n                    <div\n                        class=\"tenant\"\n                        id=\"profile-tenant-name\"\n                        [title]=\"tenant?.tenantName\"\n                    >{{ (tenant?.tenantName) }}</div>\n                </div>\n            </div>\n        </div>\n    </ng-template>\n</aur-popup-menu>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}:host{color:#fff;cursor:pointer;display:flex;flex:0 1 auto;overflow:hidden;position:relative}:host:hover,:host:focus{outline:0}:host:hover .profile-dropdown,:host:focus .profile-dropdown{background:#ffffff1a}aur-popup-menu{overflow:hidden}.profile-dropdown{display:flex;height:100%;align-items:center;padding:0 12px}.content-wrapper{display:flex;width:100%}a{color:#fff}aur-icon{flex:0 0 auto}.description{flex:1 1 auto;margin:0 8px;overflow:hidden}.name,.tenant{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.name{font-size:16px;line-height:1.3em}.tenant{font-size:14px;margin-top:8px;font-weight:500}.topbar-items{margin:0;padding:0;list-style-type:none}aur-menu{min-width:100%;right:0}@media screen and (max-width: 1024px){.profile-dropdown{align-items:center}.description{display:none}.account-icon.size-md{font-size:32px}}\n"], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.TemplateDirective, selector: "ng-template[aurTemplate]", inputs: ["aurTemplate"] }, { kind: "component", type: i2$1.IconComponent, selector: "aur-icon", inputs: ["color", "fontset", "rotate", "size", "emphasis", "iconStyle"] }, { kind: "component", type: i2$1.PopupMenuComponent, selector: "aur-popup-menu", inputs: ["dataKey", "optionLabel", "disabled", "icon", "iconPosition", "id", "importance", "items", "label", "menuId", "open", "size", "itemIconSize", "triggerId", "value"], outputs: ["selected", "openChange", "toggleClick"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TopbarprofileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-topbarprofile', template: "<aur-popup-menu [items]=\"items\" originY=\"bottom\" originX=\"end\" overlayX=\"end\">\n    <ng-template aurTemplate=\"trigger\">\n        <div id=\"profile-dropdown\" class=\"profile-dropdown\">\n            <div class=\"content-wrapper\">\n                <aur-icon color=\"inherit\" class=\"account-icon\">account_circle</aur-icon>\n        \n                <div id=\"aur-topbar-user-profile-desc\" class=\"description\">\n                    <div\n                        class=\"name\"\n                        id=\"profile-user-name\"\n                        *ngIf=\"user\"\n                        [title]=\"(user.user?.firstName || '' ) +' ' + (user.user?.lastName\n                        || '')\"\n                    >{{ (user.user?.firstName || '' ) +' ' + (user.user?.lastName\n                        || '') }} </div>\n                    <div\n                        class=\"tenant\"\n                        id=\"profile-tenant-name\"\n                        [title]=\"tenant?.tenantName\"\n                    >{{ (tenant?.tenantName) }}</div>\n                </div>\n            </div>\n        </div>\n    </ng-template>\n</aur-popup-menu>\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}:host{color:#fff;cursor:pointer;display:flex;flex:0 1 auto;overflow:hidden;position:relative}:host:hover,:host:focus{outline:0}:host:hover .profile-dropdown,:host:focus .profile-dropdown{background:#ffffff1a}aur-popup-menu{overflow:hidden}.profile-dropdown{display:flex;height:100%;align-items:center;padding:0 12px}.content-wrapper{display:flex;width:100%}a{color:#fff}aur-icon{flex:0 0 auto}.description{flex:1 1 auto;margin:0 8px;overflow:hidden}.name,.tenant{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.name{font-size:16px;line-height:1.3em}.tenant{font-size:14px;margin-top:8px;font-weight:500}.topbar-items{margin:0;padding:0;list-style-type:none}aur-menu{min-width:100%;right:0}@media screen and (max-width: 1024px){.profile-dropdown{align-items:center}.description{display:none}.account-icon.size-md{font-size:32px}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { user: [{
                type: Input
            }], tenant: [{
                type: Input
            }], items: [{
                type: Input
            }], open: [{
                type: Input
            }], tabindex: [{
                type: HostBinding,
                args: ['tabindex']
            }], menu: [{
                type: ViewChild,
                args: ['menu']
            }], toggleMenu: [{
                type: HostListener,
                args: ['keyup.enter', ['$event']]
            }] } });

class TopbarcontainerComponent {
    /**
     * array of menu items for secondary navigation (right side)
     */
    set secondaryNav(value) {
        this._secondaryNav = value;
        this.createHamburgerMenu();
    }
    get secondaryNav() {
        return this._secondaryNav;
    }
    /**
     * array of menu items for topbarprofile popup
     */
    set profileItems(value) {
        this._profileItems = value;
        this.createHamburgerMenu();
    }
    get profileItems() {
        return this._profileItems;
    }
    get testTenant() {
        return this._testTenant;
    }
    set testTenant(value) {
        if (value !== this._testTenant) {
            this._testTenant = value;
            this.testTenantChange.emit(value);
        }
    }
    constructor(store) {
        this.store = store;
        this._testTenant = false;
        this.color = 'light';
        /**
         * whether you should define a max-width or not
         */
        this.hasMaxWidth = false;
        this.user$ = this.store.select(AuthUserStore);
        this.tenant$ = getActiveTenant$(this.store);
        this.testTenantChange = new EventEmitter();
        /**
         * config for the hamburger menu icon
         */
        this.hamburger = {
            icon: 'menu',
            id: 'topbar-menu-button',
        };
        /**
         * is the hamburger menu open?
         */
        this.hamburgerOpen = false;
    }
    ngOnInit() { }
    createHamburgerMenu() {
        const secondarySubMenus = this.secondaryNav.reduce((previous, current) => {
            if (current.items && current.items.length > 0) {
                return previous.concat(current.items);
            }
            return previous;
        }, []);
        this.hamburger.items = secondarySubMenus.concat(this.profileItems);
    }
    toggleTest(isOn) {
        this.testTenant = isOn;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TopbarcontainerComponent, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: TopbarcontainerComponent, selector: "arc-shared-topbarcontainer", inputs: { color: "color", logo: "logo", hasMaxWidth: "hasMaxWidth", primaryNav: "primaryNav", user$: "user$", tenant$: "tenant$", secondaryNav: "secondaryNav", profileItems: "profileItems", testTenant: "testTenant" }, outputs: { testTenantChange: "testTenantChange" }, host: { properties: { "class.test-tenant": "this.testTenant" } }, ngImport: i0, template: "<div class=\"topbar\" [class.has-max-width]=\"hasMaxWidth\">\n    <aur-main-nav id=\"primary-nav\" class=\"primary-nav\" [class.test-tenant]=\"testTenant\" [color]=\"color\" [navItems]=\"primaryNav\"></aur-main-nav>\n    <div *ngIf=\"!logo\" class=\"logo\">\n\n        <!-- TODO: translate -->\n        <div class=\"test-message\" *ngIf=\"testTenant\">\n            {{ 'ARC_SHARED_TEST_MODE' | translate }}\n            <aur-icon color=\"inherit\" emphasis=\"subdued\" size=\"sm\" [pTooltip]=\"'Any changes you make here will not affect your production environment'\">info</aur-icon>\n        </div>\n    </div>\n    <div *ngIf=\"logo\" class=\"reseller-logo\" [style.backgroundImage] = \"'url(' + logo + ')'\">\n    </div>\n\n    <div class=\"topbar-right\">\n        <aur-main-nav [color]=\"color\" id=\"secondary-nav\" class=\"secondary-nav\" [navItems]=\"secondaryNav\"></aur-main-nav>\n\n        <arc-shared-topbarprofile [items]=\"profileItems\" class=\"profile\" [user]=\"user$ | async\" [tenant]=\"tenant$ | async\"></arc-shared-topbarprofile>\n\n    </div>\n</div>\n<!-- <div *ngIf=\"testTenant\" class=\"test-tenant\">\n    <span class=\"message\">\n        Test mode\n        <aur-icon\n            emphasis=\"subdued\"\n            size=\"sm\"\n            [pTooltip]=\"'Any changes you make here will not affect your production environment'\"\n        >info</aur-icon>\n    </span>\n    \n    <div class=\"switch\">\n        <span>Turn off</span>\n        <p-inputSwitch [(ngModel)]=\"testTenant\"></p-inputSwitch>\n    </div>\n</div> -->\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}:host{-webkit-user-select:none;user-select:none;z-index:100;position:relative;width:100%;flex:0 0 auto;height:64px;align-items:stretch;background:#003035;box-shadow:0 2px 5px #00000042;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.26);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}:host.test-tenant{background-image:linear-gradient(135deg,#0000004d 33%,#0000 34% 66%,#0000004d 67%);background-size:128px}:host.test-tenant .logo{display:flex;align-items:flex-end;justify-content:center;background-position:top;background-size:auto 50%}:host.test-tenant .logo .test-message{color:#fff;font-weight:700;display:flex;align-items:center}:host.test-tenant .logo .test-message aur-icon{margin-left:8px}.reseller-logo{width:150px;flex:0 0 auto;margin:8px 12px;height:auto;background-position:center;background-repeat:no-repeat;background-size:contain}.logo{width:150px;flex:0 0 auto;margin:8px 12px;height:auto;background-position:center;background-repeat:no-repeat;background-image:url(/assets/layout/images/logo-light2x.png);background-size:contain}.topbar{position:relative;background:none;box-shadow:none;z-index:1;width:100%;height:64px;display:flex;justify-content:space-between;align-items:stretch;margin:auto}.topbar.has-max-width{max-width:1280px}.topbar .topbar-right{display:flex;overflow:hidden;position:relative}.primary-nav,.topbar-right{flex:1 1 50%}.topbar-right{justify-content:flex-end}@media screen and (max-width: 1024px){.logo{order:-1}.primary-nav{flex:1 1 auto}}@media screen and (min-width: 769px){.primary-nav{background:none}}@media screen and (max-width: 768px){.primary-nav{position:fixed;bottom:0;height:64px;left:0;right:0;justify-content:center;background-color:#003035;box-shadow:0 -2px 5px #00000042;-webkit-box-shadow:0 -2px 5px 0 rgba(0,0,0,.26);-moz-box-shadow:0 -2px 5px 0 rgba(0,0,0,.26)}}.hamburger{display:none}@media screen and (max-width: 768px){.hamburger{display:block}}\n"], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.IconComponent, selector: "aur-icon", inputs: ["color", "fontset", "rotate", "size", "emphasis", "iconStyle"] }, { kind: "component", type: i2$1.MainNavComponent, selector: "aur-main-nav", inputs: ["color", "navItems"] }, { kind: "directive", type: i4.Tooltip, selector: "[pTooltip]", inputs: ["tooltipPosition", "tooltipEvent", "appendTo", "positionStyle", "tooltipStyleClass", "tooltipZIndex", "escape", "showDelay", "hideDelay", "life", "positionTop", "positionLeft", "autoHide", "fitContent", "hideOnEscape", "pTooltip", "tooltipDisabled", "tooltipOptions"] }, { kind: "component", type: TopbarprofileComponent, selector: "arc-shared-topbarprofile", inputs: ["user", "tenant", "items", "open"] }, { kind: "pipe", type: i2$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TopbarcontainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-topbarcontainer', template: "<div class=\"topbar\" [class.has-max-width]=\"hasMaxWidth\">\n    <aur-main-nav id=\"primary-nav\" class=\"primary-nav\" [class.test-tenant]=\"testTenant\" [color]=\"color\" [navItems]=\"primaryNav\"></aur-main-nav>\n    <div *ngIf=\"!logo\" class=\"logo\">\n\n        <!-- TODO: translate -->\n        <div class=\"test-message\" *ngIf=\"testTenant\">\n            {{ 'ARC_SHARED_TEST_MODE' | translate }}\n            <aur-icon color=\"inherit\" emphasis=\"subdued\" size=\"sm\" [pTooltip]=\"'Any changes you make here will not affect your production environment'\">info</aur-icon>\n        </div>\n    </div>\n    <div *ngIf=\"logo\" class=\"reseller-logo\" [style.backgroundImage] = \"'url(' + logo + ')'\">\n    </div>\n\n    <div class=\"topbar-right\">\n        <aur-main-nav [color]=\"color\" id=\"secondary-nav\" class=\"secondary-nav\" [navItems]=\"secondaryNav\"></aur-main-nav>\n\n        <arc-shared-topbarprofile [items]=\"profileItems\" class=\"profile\" [user]=\"user$ | async\" [tenant]=\"tenant$ | async\"></arc-shared-topbarprofile>\n\n    </div>\n</div>\n<!-- <div *ngIf=\"testTenant\" class=\"test-tenant\">\n    <span class=\"message\">\n        Test mode\n        <aur-icon\n            emphasis=\"subdued\"\n            size=\"sm\"\n            [pTooltip]=\"'Any changes you make here will not affect your production environment'\"\n        >info</aur-icon>\n    </span>\n    \n    <div class=\"switch\">\n        <span>Turn off</span>\n        <p-inputSwitch [(ngModel)]=\"testTenant\"></p-inputSwitch>\n    </div>\n</div> -->\n", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}:host{-webkit-user-select:none;user-select:none;z-index:100;position:relative;width:100%;flex:0 0 auto;height:64px;align-items:stretch;background:#003035;box-shadow:0 2px 5px #00000042;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.26);-moz-box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}:host.test-tenant{background-image:linear-gradient(135deg,#0000004d 33%,#0000 34% 66%,#0000004d 67%);background-size:128px}:host.test-tenant .logo{display:flex;align-items:flex-end;justify-content:center;background-position:top;background-size:auto 50%}:host.test-tenant .logo .test-message{color:#fff;font-weight:700;display:flex;align-items:center}:host.test-tenant .logo .test-message aur-icon{margin-left:8px}.reseller-logo{width:150px;flex:0 0 auto;margin:8px 12px;height:auto;background-position:center;background-repeat:no-repeat;background-size:contain}.logo{width:150px;flex:0 0 auto;margin:8px 12px;height:auto;background-position:center;background-repeat:no-repeat;background-image:url(/assets/layout/images/logo-light2x.png);background-size:contain}.topbar{position:relative;background:none;box-shadow:none;z-index:1;width:100%;height:64px;display:flex;justify-content:space-between;align-items:stretch;margin:auto}.topbar.has-max-width{max-width:1280px}.topbar .topbar-right{display:flex;overflow:hidden;position:relative}.primary-nav,.topbar-right{flex:1 1 50%}.topbar-right{justify-content:flex-end}@media screen and (max-width: 1024px){.logo{order:-1}.primary-nav{flex:1 1 auto}}@media screen and (min-width: 769px){.primary-nav{background:none}}@media screen and (max-width: 768px){.primary-nav{position:fixed;bottom:0;height:64px;left:0;right:0;justify-content:center;background-color:#003035;box-shadow:0 -2px 5px #00000042;-webkit-box-shadow:0 -2px 5px 0 rgba(0,0,0,.26);-moz-box-shadow:0 -2px 5px 0 rgba(0,0,0,.26)}}.hamburger{display:none}@media screen and (max-width: 768px){.hamburger{display:block}}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.Store }], propDecorators: { color: [{
                type: Input
            }], logo: [{
                type: Input
            }], hasMaxWidth: [{
                type: Input
            }], primaryNav: [{
                type: Input
            }], user$: [{
                type: Input
            }], tenant$: [{
                type: Input
            }], secondaryNav: [{
                type: Input
            }], profileItems: [{
                type: Input
            }], testTenant: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.test-tenant']
            }], testTenantChange: [{
                type: Output
            }] } });

class DatetimeService {
    constructor() {
        this.defaultInputFormat = 'YYYY-MM-DD hh:mm:ss';
        this.defaultTimezone = 'America/New_York';
    }
    convertToUserTime(datetime, user, displayDate = true, displayTime = false, agnostic = false, inputFormat, outputFormat) {
        inputFormat = inputFormat || this.defaultInputFormat;
        if (!datetime || datetime.trim() === '') {
            return '';
        }
        if (datetime === 'today') {
            inputFormat = `${inputFormat}a`;
            datetime = moment__default.utc().format(inputFormat);
        }
        const momentInTime = moment__default.utc(datetime, inputFormat);
        const format = this.dateFormat(user, displayDate, displayTime, outputFormat);
        const timezone = user.timeZone || this.defaultTimezone;
        if (agnostic) {
            return momentInTime.format(format.replace(/ ?z/i, ''));
        }
        return momentInTime.tz(timezone).format(format);
    }
    dateFormat(user, displayDate = true, displayTime = false, outputFormat = null) {
        if (outputFormat) {
            return outputFormat;
        }
        let format = '';
        if (displayDate) {
            format += user.timeZoneDateFormat;
            if (displayTime) {
                format += user.timeZoneDateTimeDelimiter;
            }
        }
        if (displayTime) {
            format += user.timeZoneTimeFormat;
        }
        return format;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DatetimeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DatetimeService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DatetimeService, decorators: [{
            type: Injectable
        }] });

const initialResetPasswordState = {
    email: '',
    verificationCode: '',
    password: '',
    isPasswordMatch: false,
    isPasswordStrong: false,
    resetPasswordEmailSent: false,
};
function resetPasswordReducer(state = initialResetPasswordState, action) {
    switch (action.type) {
        case AuthActionTypes.PasswordResetStoreVerificationCode: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case AuthActionTypes.ResetPassword: {
            return {
                ...state,
                password: action.payload,
            };
        }
        case AuthActionTypes.SendResetPasswordEmail: {
            return {
                ...state,
                email: action.payload.email,
            };
        }
        case AuthActionTypes.ForgotPasswordRedirect: {
            return {
                ...state,
                email: action.payload,
            };
        }
        case AuthActionTypes.VerificationCodeRedirect: {
            return {
                ...state,
                resetPasswordEmailSent: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}

const loadPermissions = createAction('[Auth] Load Permissions', props());
const loadPermissionsSuccess = createAction('[Auth] Load Permissions Success', props());
const loadPermissionsFailure = createAction('[Auth] Load Permissions Failure', props());

const permissionsFeatureKey = 'permissions';
const initialState$1 = [];
const permissionsReducer = createReducer(initialState$1, on(loadPermissions, (state) => ({
    ...state,
})), on(loadPermissionsSuccess, (state, { data }) => data), on(loadPermissionsFailure, (state) => ({
    ...state,
})));

const initialState = {
    submitting: false,
    validatingSession: false,
    activeTenantSet: false,
    loggedIn: false,
    sessionTimeOutPopUp: false,
    user: {
        timeZone: 'America/New_York',
        timeZoneDateFormat: 'DD MMM YYYY',
        timeZoneDateTimeDelimiter: ' ',
        timeZoneTimeFormat: 'hh:mma z',
    },
};
function loginReducer(state = initialState, action) {
    switch (action.type) {
        case AuthActionTypes.Login: {
            return {
                ...state,
                submitting: true,
            };
        }
        case AuthActionTypes.AuthPhoneVerificationRequired: {
            return {
                ...state,
                submitting: false,
            };
        }
        // case AuthActionTypes.Logout: {
        //   return {
        //     ...initialState
        //   };
        // }
        case AuthActionTypes.ValidateSession: {
            return {
                ...state,
                validatingSession: true,
            };
        }
        case AuthActionTypes.LoginSuccess: {
            return {
                ...state,
                submitting: false,
                loggedIn: true,
                activeTenant: action.payload.activeTenant,
                logoutUrl: action.payload.logoutUrl,
                user: action.payload.user,
                activeRole: action.payload.activeRole,
                permissions: [],
            };
        }
        case AuthActionTypes.DisplaySessionTimeoutWarning: {
            return {
                ...state,
                sessionTimeOutTime: action.payload.countDown,
                sessionTimeOutPopUp: action.payload.display,
            };
        }
        case AuthActionTypes.UpdatedProfile: {
            return {
                ...state,
                user: { ...state.user, ...action.payload },
            };
        }
        case AuthActionTypes.LoginFailure: {
            return {
                ...state,
                submitting: false,
                loggedIn: false,
            };
        }
        case AuthActionTypes.LoginRedirect: {
            return {
                ...state,
            };
        }
        case AuthActionTypes.ActiveTenantChanged: {
            return {
                ...state,
                validatingSession: false,
                activeTenantSet: true,
                activeTenant: action.payload,
                activeRole: action.payload.role,
            };
        }
        case AuthActionTypes.LoginSuccessWithResetPassword: {
            return {
                ...state,
                loggedIn: false,
                submitting: false,
                user: { ...state.user, ...action.payload },
            };
        }
        case AuthActionTypes.ForceResetPassword: {
            return {
                ...state,
                loggedIn: false,
                user: { ...state.user, password: action.payload },
            };
        }
        case AuthActionTypes.updatePermissionStore: {
            return {
                ...state,
                permissions: action.payload,
            };
        }
        case GeneralActionTypes.UserNotification: {
            return {
                ...state,
                submitting: false,
            };
        }
        default: {
            return state;
        }
    }
}
const authreducers = {
    user: loginReducer,
    resetPassword: resetPasswordReducer,
    permissions: permissionsReducer,
};

class BrandingEffects {
    constructor(actions$, titleService) {
        this.actions$ = actions$;
        this.titleService = titleService;
        this.updateTitle$ = createEffect(() => this.actions$.pipe(ofType(BrandingActionTypes.UpdatePlatformName), map((x) => x.platformName), tap((title) => {
            this.titleService.setTitle(title);
        })), { dispatch: false });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrandingEffects, deps: [{ token: i2.Actions }, { token: i2$3.Title }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrandingEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrandingEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.Actions }, { type: i2$3.Title }] });

class BrandingModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrandingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: BrandingModule, imports: [CommonModule, i1$2.StoreFeatureModule, i2.EffectsFeatureModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrandingModule, imports: [CommonModule,
            StoreModule.forFeature('branding-store', brandingReducers),
            EffectsModule.forFeature([BrandingEffects])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: BrandingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        StoreModule.forFeature('branding-store', brandingReducers),
                        EffectsModule.forFeature([BrandingEffects]),
                    ],
                    exports: [],
                }]
        }] });

/**
 * Multi Factor Authentication Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/member-ordering */
class MfaV1Service {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
        if (appConfigSetting.getconfig('mfaServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('mfaServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    v1StartPost(request, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/start`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1VerifyPost(request, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/verify`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1VerifySessionCompletePost(request, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        let httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        let consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        let httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.post(`${this.basePath}/v1/verify-session-complete`, request, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v1VerifyrecaptchaPost(body, observe = 'body', reportProgress = false) {
        let headers = this.defaultHeaders;
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/v1/verifyrecaptcha`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: MfaV1Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: MfaV1Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: MfaV1Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

/*
 ultimate goal, only stores
   1. access token,
   2. current tenant ID for user
   3. test tenant mode,

  currently stores:
   1. token
   2. active tenant
   3. entire user profile
   4. permissions


   to do: complete  ultimate goal


    LoginSuccess  is the action for user name password login, sso login,
*/
class AuthEffects {
    constructor(authService, mfaService, userService, permissionService, tenantMgmtService, tenantStandAloneService, translateService, cookieService, appNameService, actions$, store$, tenantStore, router, coreService, settings, storageService) {
        this.authService = authService;
        this.mfaService = mfaService;
        this.userService = userService;
        this.permissionService = permissionService;
        this.tenantMgmtService = tenantMgmtService;
        this.tenantStandAloneService = tenantStandAloneService;
        this.translateService = translateService;
        this.cookieService = cookieService;
        this.appNameService = appNameService;
        this.actions$ = actions$;
        this.store$ = store$;
        this.tenantStore = tenantStore;
        this.router = router;
        this.coreService = coreService;
        this.settings = settings;
        this.storageService = storageService;
        // tenantId, test mode, token or username, role,
        /* login pipeline
        //  login to obtain token -> get user profile -> test mode
        //    ->  define which tenantId to use  ->  get role -> get permissions  ->  define landing route -> set data in  localstorage  -> set data in store ->  do route
        */
        /* login via token and tenant Id pipeline
        //   get user profile
        //    ->  get tenant info ->  get role -> get permissions  ->  define landing route -> set data in  localstorage  -> set data in store ->  do route
        */
        // login success vs login force reset password
        // login success means got user profile have at least 0 tenants, 0 active tenant  roles,
        this.loginViaToken1$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.LoginByToken), map((action) => action.payload), exhaustMap((tokenWithTenantId) => {
                this.coreService.setTokenLocalStorage(tokenWithTenantId.accessToken);
                return this.coreService
                    .loadUserInfo(tokenWithTenantId.accessToken, tokenWithTenantId, true)
                    .pipe(map((result) => ({
                    ...result,
                    logoutUrl: tokenWithTenantId.logoutUrl,
                    isIdentityProvider: tokenWithTenantId.isIdentityProvider,
                })), catchError((error) => of({ error: error, silentError: tokenWithTenantId.silentError })));
            }), tap((x) => {
                if (!x.error) {
                    this.coreService.setLocalStorageForLogin(x.accessToken, x.activeTenant, { logoutUrl: x.logoutUrl });
                }
            }), mergeMap((resultObj) => {
                if (resultObj.error) {
                    return [
                        new LoginFailure({
                            ...resultObj.error,
                            silentError: resultObj.silentError,
                        }),
                    ];
                }
                else {
                    if (resultObj.isIdentityProvider) {
                        return [
                            new ExternalRedirectAction(this.settings.getconfig('oidcServiceUrl') +
                                '/interaction/' +
                                resultObj.user.userId +
                                '/login'),
                        ];
                    }
                    else {
                        return [
                            new LoginSuccess({
                                user: resultObj.user, // set user
                                activeTenant: {
                                    ...resultObj.activeTenant,
                                }, // set active tenant
                                activeRole: resultObj.activeTenant
                                    ? resultObj.activeTenant.role
                                    : null,
                                logoutUrl: resultObj.logoutUrl,
                            }),
                            new RouteToLandingPage(resultObj.loginRedirectUrl),
                            new UserAliveAction({}),
                        ];
                    }
                }
            }));
        });
        this.externalUserLogin$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ExternalUserLogin), map((action) => action.payload), exhaustMap((auth) => this.authService.V1LoginPost(auth).pipe(map((response) => response.body), mergeMap((loginResponse) => {
                return this.coreService.CheckAndSetExternalUserProfileForTenant$(auth, loginResponse.accessToken);
            }), catchError((error) => of({ error: error, authPayload: auth })))), tap((x) => {
                if (!x.error ||
                    (x.error &&
                        x.error.error &&
                        x.error.error.status + '' === 'NEW_PASSWORD_REQUIRED')) {
                    this.coreService.setLocalStorageForExternalLogin(x.accessToken, x.activeTenant, x.authPayload?.applicationId, x.authPayload?.featureId, x.authPayload?.personaId);
                }
            }), mergeMap((resultObj) => {
                if (resultObj.error) {
                    if (resultObj.error.error &&
                        resultObj.error.error.status + '' === 'NEW_PASSWORD_REQUIRED') {
                        return of(new LoginSuccessWithResetPassword({
                            ...resultObj.error.error,
                            tenantId: resultObj.authPayload.tenantId,
                            isExternal: true,
                        }));
                    }
                    else if (resultObj.error.error &&
                        resultObj.error.error.status + '' === 'MFA_CODE_REQUIRED') {
                        return of(new AuthPhoneVerificationRequiredAction({
                            mfaToken: resultObj.error.error.mfaToken,
                        }));
                    }
                    return of(new LoginFailure(resultObj.error));
                }
                else {
                    return [
                        new LoginSuccess({
                            user: resultObj.user, // set user
                            activeTenant: {
                                ...resultObj.activeTenant,
                            }, // set active tenant
                            activeRole: resultObj.activeTenant
                                ? resultObj.activeTenant.role
                                : null,
                            logoutUrl: resultObj.logoutUrl || this.settings.routes.logoutRoute,
                        }),
                        new RouteToLandingPage(resultObj.loginRedirectUrl || this.settings.routes.dashboardRoute),
                        new UserAliveAction({ accessToken: resultObj.accessToken }),
                    ];
                }
            }));
        });
        this.externalUserLoginViaToken$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ExternalUserLoginByToken), map((action) => action.payload), exhaustMap((auth) => {
                const tenantString = this.coreService.getActiveTenantFromLocalStorage();
                let tenant;
                if (tenantString) {
                    tenant = JSON.parse(tenantString);
                }
                const exLoginRequest = {
                    applicationId: this.coreService.getAppIdFromLocalStorage(),
                    featureId: this.coreService.getFeatureIdFromLocalStorage(),
                    personaId: this.coreService.getPersonaIdFromLocalStorage(),
                    tenantId: auth.tenantId || (tenant || {}).tenantId,
                    email: '',
                    password: '',
                    loginRedirectUrl: auth.returnUrl,
                };
                return this.coreService.ReloadExternalUserProfileForTenant$(exLoginRequest, auth.accessToken);
            }), tap((x) => {
                if (!x.error ||
                    (x.error &&
                        x.error.error &&
                        x.error.error.status + '' === 'NEW_PASSWORD_REQUIRED')) {
                    this.coreService.setLocalStorageForExternalLogin(x.accessToken, x.activeTenant, x.authPayload.applicationId, x.authPayload.featureId, x.authPayload.personaId);
                }
            }), mergeMap((resultObj) => {
                if (resultObj.error) {
                    return of(new LoginFailure(resultObj.error));
                }
                else {
                    return [
                        new LoginSuccess({
                            user: resultObj.user, // set user
                            activeTenant: {
                                ...resultObj.activeTenant,
                            }, // set active tenant
                            activeRole: resultObj.activeTenant
                                ? resultObj.activeTenant.role
                                : null,
                            logoutUrl: resultObj.logoutUrl || this.settings.routes.logoutRoute,
                        }),
                        new RouteToLandingPage(resultObj.loginRedirectUrl || this.settings.routes.dashboardRoute),
                        new UserAliveAction({ accessToken: resultObj.accessToken }),
                    ];
                }
            }));
        });
        this.login1$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.Login), map((action) => action.payload), exhaustMap((auth) => this.authService.V1LoginPost(auth).pipe(map((response) => response.body), mergeMap((loginResponse) => {
                this.coreService.setTokenLocalStorage(loginResponse.accessToken);
                return this.coreService
                    .loadUserInfo(loginResponse.accessToken, {
                    ...auth,
                    tenants: loginResponse.tenants,
                })
                    .pipe(map((x) => {
                    return { ...x, isIdentityProvider: auth.isIdentityProvider };
                }));
            }), catchError((error) => of({ error: error })))), tap((x) => {
                if (!x.error ||
                    (x.error &&
                        x.error.error &&
                        x.error.error.status + '' === 'NEW_PASSWORD_REQUIRED')) {
                    this.coreService.setLocalStorageForLogin(x.accessToken, x.activeTenant, {});
                }
            }), mergeMap((resultObj) => {
                if (resultObj.error) {
                    if (resultObj.error.error &&
                        resultObj.error.error.status + '' === 'NEW_PASSWORD_REQUIRED') {
                        return of(new LoginSuccessWithResetPassword(resultObj.error.error));
                    }
                    else if (resultObj.error.error &&
                        resultObj.error.error.status + '' === 'MFA_CODE_REQUIRED') {
                        return of(new AuthPhoneVerificationRequiredAction({
                            mfaToken: resultObj.error.error.mfaToken,
                        }));
                    }
                    return of(new LoginFailure(resultObj.error));
                }
                else {
                    if (resultObj.isIdentityProvider) {
                        return [
                            new ExternalRedirectAction(this.settings.getconfig('oidcServiceUrl') +
                                '/interaction/' +
                                resultObj.user.userId +
                                '/login'),
                        ];
                        // return [new ExternalRedirectAction("https://727aec3571e4.ngrok.io/interaction/" + resultObj.user.userId + "/login")];
                    }
                    return [
                        new LoginSuccess({
                            user: resultObj.user, // set user
                            activeTenant: {
                                ...resultObj.activeTenant,
                            }, // set active tenant
                            activeRole: resultObj.activeTenant
                                ? resultObj.activeTenant.role
                                : null,
                            logoutUrl: resultObj.logoutUrl,
                        }),
                        new RouteToLandingPage(resultObj.loginRedirectUrl),
                        new UserAliveAction({ accessToken: resultObj.accessToken }),
                    ];
                }
            }));
        });
        this.verifyAccountViaPhone$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.VerifyAccountViaPhone), map((action) => action.payload), exhaustMap((auth) => this.mfaService
                .v1VerifyPost({
                mfaToken: this.coreService.getLocalStorage('mfaToken'),
                verificationCode: auth.verificationCode,
            })
                .pipe(mergeMap((result) => {
                const loginResponse = result.loginResponse;
                return this.coreService.loadUserInfo(loginResponse.accessToken, {
                    ...auth,
                    tenants: loginResponse.tenants,
                });
            }), catchError((error) => of({ error: error })))), tap((x) => {
                if (!x.error) {
                    this.coreService.setLocalStorageForLogin(x.accessToken, x.activeTenant, {});
                }
            }), mergeMap((resultObj) => {
                if (resultObj.error) {
                    return of(new LoginFailure(resultObj.error));
                }
                else {
                    return [
                        new LoginSuccess({
                            user: resultObj.user, // set user
                            activeTenant: resultObj.activeTenant, // set active tenant
                            activeRole: resultObj.activeTenant
                                ? resultObj.activeTenant.role
                                : null,
                            logoutUrl: resultObj.logoutUrl,
                        }),
                        new RouteToLandingPage(resultObj.loginRedirectUrl),
                        new UserAliveAction({}),
                    ];
                }
            }));
        });
        this.verifyAccountViaPhoneExternal$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.VerifyAccountViaPhoneExternal), map((action) => action.payload), exhaustMap((auth) => this.mfaService
                .v1VerifyPost({
                mfaToken: this.coreService.getLocalStorage('mfaToken'),
                verificationCode: auth.verificationCode,
            })
                .pipe(
            // mergeMap(result => {
            //   const loginResponse = result.loginResponse;
            // }),
            mergeMap((result) => {
                const loginResponse = result.loginResponse;
                return this.coreService.CheckAndSetExternalUserProfileForTenant$(auth, loginResponse.accessToken);
            }), catchError((error) => of({ error: error })))), tap((x) => {
                if (!x.error) {
                    this.coreService.setLocalStorageForExternalLogin(x.accessToken, x.activeTenant, x.authPayload.applicationId, x.authPayload.featureId, x.authPayload.personaId);
                }
            }), mergeMap((resultObj) => {
                if (resultObj.error) {
                    return of(new LoginFailure(resultObj.error));
                }
                else {
                    return [
                        new LoginSuccess({
                            user: resultObj.user, // set user
                            activeTenant: resultObj.activeTenant, // set active tenant
                            activeRole: resultObj.activeTenant
                                ? resultObj.activeTenant.role
                                : null,
                            logoutUrl: resultObj.logoutUrl,
                        }),
                        new RouteToLandingPage(resultObj.loginRedirectUrl),
                        new UserAliveAction({}),
                    ];
                }
            }));
        });
        this.sendVerificationCodeViaPhone$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.SendVerificationCodeViaPhone), map((action) => action.payload), exhaustMap((phoneObj) => this.mfaService
                .v1StartPost({
                mfaToken: this.coreService.getLocalStorage('mfaToken'),
                phoneNumber: phoneObj.phoneNumber,
            })
                .pipe(map(() => {
                if (!phoneObj.resend) {
                    return new GeneralSuccessAction(AuthActionTypes.SendVerificationCodeViaPhone);
                }
                return new GeneralSuccessAction({
                    actionType: AuthActionTypes.ReSendVerificationCodeViaPhone,
                    actionData: 'CODE_RESENT',
                });
            }), catchError((error) => {
                if (error &&
                    error.error &&
                    error.error.status === 'START_MFA_RATE_LIMIT_EXCEEDED') {
                    return of(new GeneralErrorAction({
                        actionType: AuthActionTypes.SendVerificationCodeViaPhone,
                        message: 'START_MFA_RATE_LIMIT_EXCEEDED',
                    }));
                }
                return of(new GeneralErrorAction({
                    actionType: AuthActionTypes.SendVerificationCodeViaPhone,
                }));
            }))));
        });
        this.loadProfile$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.LoadProfile), map((action) => action.payload), exhaustMap(() => this.userService.v1UsersProfileGet().pipe(map((x) => {
                const profile = x;
                return new UpdatedProfile(profile);
            }))));
        });
        this.changeUserProfile$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ChangeUserProfile), map((action) => action.payload), exhaustMap((payload) => this.userService
                .v1UsersProfilePut({
                firstName: payload.firstName,
                lastName: payload.lastName,
                timeZone: payload.timeZone,
                defaultTenantId: payload.defaultTenantId,
                defaultLanguage: payload.defaultLanguage,
            })
                .pipe(mergeMap((x) => {
                const profile = x;
                return [
                    new UpdatedProfile(profile),
                    new GeneralSuccessAction('changeprofilesucceed'),
                ];
            }), catchError(() => {
                this.coreService.isLoading = false;
                return of(new UserNotificationAction({
                    type: 'error',
                    message: this.translateService.instant('ARC_SHARED_ACTION_CHANGE_PROFILE_FAILED_ERROR'),
                }));
            }))));
        });
        this.userAlive$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.UserAlive), map((action) => action.payload), withLatestFrom(this.store$.select(AuthUserStore)), map(([payload, user]) => {
                let accessToken = '';
                if (user?.user?.accessToken && user.loggedIn) {
                    accessToken = user.user.accessToken;
                }
                else if (payload && payload.accessToken) {
                    accessToken = payload.accessToken;
                }
                else {
                    accessToken = this.coreService.getAuthTokenFromLocalStorage();
                }
                return accessToken;
            }), filter((accessToken) => !!accessToken), exhaustMap((accessToken) => {
                return this.authService
                    .V1VerifysessionPost({ accessToken: accessToken })
                    .pipe(map(() => new GeneralSuccessAction(AuthActionTypes.UserAlive)), catchError(() => {
                    return of(new Logout('sessiontimeout'));
                }));
            }));
        });
        this.sendResetPasswordEmail$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.SendResetPasswordEmail), map((action) => action.payload), withLatestFrom(this.tenantStore.select(BrandingTenantStore)), exhaustMap(([resetPasswordRequest, tenant]) => this.authService.V1ResetpasswordPost(resetPasswordRequest, tenant).pipe(mergeMap(() => [
                new VerificationCodeRedirect(true),
                new GeneralSuccessAction(AuthActionTypes.SendResetPasswordEmail),
            ]), catchError((error) => {
                const messageKey = this.handelAuthError(error, 'ARC_SHARED_RESET_PASSWORD_EMAIL_ERROR_MESSAGE');
                const isSticky = messageKey ===
                    'ARC_SHARED_PASSWORD_TEMPORARY_PASSWORD_EXPIRED_MESSAGE';
                // Don't show a hint to attackers that the email does not exists in the system
                if (messageKey === 'ARC_SHARED_RESET_PASSWORD_EMAIL_ERROR_MESSAGE') {
                    return of(new VerificationCodeRedirect(true));
                }
                else {
                    return of(new UserNotificationAction({
                        type: 'error',
                        message: this.translateService.instant(messageKey),
                        sticky: isSticky,
                    }));
                }
            }))));
        });
        this.resetPassword$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ResetPassword), withLatestFrom(this.store$.select(ResetPasswordStore), (action, state) => state), map((data) => ({
                email: data.email,
                password: data.password,
                code: data.verificationCode,
            })), exhaustMap((data) => this.authService
                .V1ResetpasswordVerifyPost({ ...data, fromCaptcha: true })
                .pipe(mergeMap(() => {
                const messagetype = 'success';
                const messagekey = 'ARC_SHARED_PASSWORD_RESET_SUCCESS_MESSAGE';
                return [
                    new LoginRedirect(''),
                    new UserNotificationAction({
                        type: messagetype,
                        message: this.translateService.instant(messagekey),
                    }),
                    new GeneralSuccessAction(AuthActionTypes.ResetPassword),
                ];
            }), catchError((error) => {
                const messagekey = this.handelAuthError(error, 'ARC_SHARED_PASSWORD_RESET_ERROR_MESSAGE');
                return of(new UserNotificationAction({
                    type: 'error',
                    message: this.translateService.instant(messagekey),
                }));
            }))));
        });
        this.forceResetPassword$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ForceResetPassword), map((x) => x.payload), withLatestFrom(this.store$.pipe(select(AuthUserStore))), map(([actionPayload, data]) => ({
                email: data.user.email,
                newPassword: actionPayload.newPassword,
                userId: data.user.userId,
                session: data.user.session,
                tenantId: actionPayload.tenantId,
                isExternal: actionPayload.isExternal,
            })), exhaustMap((data) => {
                const isExternal = data.isExternal;
                delete data.isExternal;
                return this.authService
                    .V1ForceresetPost({ ...data, fromCaptcha: true })
                    .pipe(map((response) => response.body), mergeMap((result) => {
                    // const activeTenantString = this.coreService.getActiveTenantFromLocalStorage();
                    // let activeTenant;
                    // if (activeTenantString) {
                    //   activeTenant = JSON.parse(activeTenantString);
                    // }
                    const tokenRequest = {
                        accessToken: result.accessToken,
                        tenantId: data.tenantId,
                    };
                    if (isExternal) {
                        return [
                            new ExternalUserLoginByToken(tokenRequest),
                            new UserNotificationAction({
                                type: 'success',
                                message: this.translateService.instant('ARC_SHARED_FORCE_PASSWORD_RESET_SUCCESS_MESSAGE'),
                            }),
                        ];
                    }
                    else {
                        return [
                            new LoginByToken(tokenRequest),
                            new UserNotificationAction({
                                type: 'success',
                                message: this.translateService.instant('ARC_SHARED_FORCE_PASSWORD_RESET_SUCCESS_MESSAGE'),
                            }),
                        ];
                    }
                }), catchError((error) => {
                    const messagekey = this.handelAuthError(error, 'ARC_SHARED_FORCE_PASSWORD_RESET_ERROR_MESSAGE');
                    return of(new UserNotificationAction({
                        type: 'error',
                        message: this.translateService.instant(messagekey),
                    }));
                }));
            }));
        });
        this.loginFailure$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.LoginFailure), map((action) => action.payload), map((error) => {
                if (error.silentError) {
                    return new DoNothingAction();
                }
                const messageKey = this.handelAuthError(error, 'ARC_SHARED_SIGN_IN_ERROR_MESSAGE');
                if (messageKey) {
                    const isSticky = messageKey ===
                        ('ARC_SHARED_PASSWORD_TEMPORARY_PASSWORD_EXPIRED_MESSAGE' ||
                            'ARC_SHARED_SIGN_IN_ERROR_MESSAGE');
                    return new UserNotificationAction({
                        type: 'error',
                        message: this.translateService.instant(messageKey),
                        sticky: isSticky,
                    });
                }
                // return new UserNotificationAction({ type: 'error', message: this.translateService.instant('ARC_SHARED_SIGN_IN_ERROR_MESSAGE') });
            }), catchError(() => of(new UserNotificationAction({
                type: 'error',
                message: this.translateService.instant('ARC_SHARED_SIGN_IN_ERROR_MESSAGE'),
            }))));
        });
        this.loginSuccess1$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.LoginSuccess), map((action) => action.payload), switchMap((x) => {
                let logoutUrl = x.logoutUrl || this.settings.getconfig('frontendHostUrl');
                if (x?.activeTenant?.resellerId && x?.activeTenant?.resellerId.toLowerCase() === 'jpmorgan') {
                    logoutUrl = x.logoutUrl || (this.settings.getconfig('frontendHostUrl') + '/jpmorgan');
                }
                this.cookieService.setSessionCookiePerEnvEncoded('__bt_logoutUrl', logoutUrl);
                return [
                    loadPermissions({
                        tenantId: x.activeTenant.tenantId,
                    }),
                ];
            }));
        });
        this.loginRedirect$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.LoginRedirect), tap(() => {
                this.router.navigate([this.settings.routes.loginRoute]);
            }));
        }, { dispatch: false });
        this.logOut$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.Logout), map((action) => action.payload), switchMap((type) => {
                const token = this.coreService.getAuthTokenFromLocalStorage();
                return this.authService.V1LogoutPost({ accessToken: token }).pipe(map(() => ({ type: type })), catchError(() => {
                    return of({ type: type });
                }));
            }), withLatestFrom(this.store$.select(AuthUserStore)), map(([result, userState]) => {
                this.coreService.cancelSessionTimeoutTimer();
                this.coreService.clearLocalStorageForLogin();
                this.coreService.clearClientConnectLocalStorage();
                if (userState) {
                    let logoutUrl = userState.logoutUrl;
                    // Double check if the user is a jpmorgan reseller
                    if (userState.activeTenant?.resellerId && userState.activeTenant?.resellerId.toLowerCase() === 'jpmorgan') {
                        logoutUrl = userState.logoutUrl || this.settings?.getconfig('frontendHostUrl') + '/jpmorgan';
                    }
                    return { logoutUrl: logoutUrl, type: result.type };
                }
                return { type: result.type };
            }), mergeMap((result) => {
                if (result.logoutUrl) {
                    return [
                        new ClearAllStoreAction(null),
                        new ExternalRedirectAction(result.logoutUrl),
                    ];
                }
                else if (result.type === 'sessiontimeout') {
                    // on sso app selection page, if timeout, go to access denied route, else go to login route
                    // if (this.router.url === 'sso') {
                    //   return [new ClearAllStoreAction(null), new GeneralRedirectAction('/accessdenied')];
                    // }
                    return [
                        new ClearAllStoreAction(null),
                        new GeneralRedirectAction(this.settings.routes.loginRoute),
                        new UserNotificationAction({
                            type: 'error',
                            message: this.translateService.instant('ARC_SHARED_SESSION_ERROR_ACCESSTOKEN_EXPIRED'),
                            sticky: false,
                        }),
                    ];
                }
                else {
                    return [
                        new ClearAllStoreAction(null),
                        new GeneralRedirectAction(this.settings.routes.loginRoute),
                    ];
                }
            }));
        });
        this.verificationCodeRedirect$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.VerificationCodeRedirect), tap(() => {
                if (this.settings.loginWidgetMode === 'route') {
                    this.router.navigate([this.settings.routes.verificationCodeRoute]);
                }
            }));
        }, { dispatch: false });
        this.getSessionTTLAction$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.GetSessionTTL), exhaustMap(() => this.authService.V1SessionTtlGet().pipe(catchError(() => of({})))));
        }, { dispatch: false });
        this.resetPasswordRedirect$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.PasswordResetStoreVerificationCode), tap(() => {
                if (this.settings.loginWidgetMode === 'route') {
                    this.router.navigate([this.settings.routes.resetPasswordRoute]);
                }
            }));
        }, { dispatch: false });
        this.forgotPasswordRedirect$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ForgotPasswordRedirect), tap(() => {
                if (this.settings.loginWidgetMode === 'route') {
                    this.router.navigate([this.settings.routes.forgotPasswordRoute]);
                }
            }));
        }, { dispatch: false });
        this.newPasswordRequiredRedirect$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.LoginSuccessWithResetPassword), map((action) => action.payload), tap((authed) => {
                if (authed.isExternal) {
                    this.router.navigate([
                        this.settings.routes.newPasswordRequiredRoute,
                        { tenantId: authed.tenantId, isExternal: true },
                    ]);
                }
                else {
                    this.router.navigate([
                        this.settings.routes.newPasswordRequiredRoute,
                    ]);
                }
            }));
        }, { dispatch: false });
        this.verificationRequiredRedirect$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.AuthPhoneVerificationRequired), map((action) => action.payload), tap((tokenObj) => {
                // const token = ;
                this.coreService.writeLocalStorage('mfaToken', tokenObj.mfaToken);
                if (this.settings.loginWidgetMode === 'route') {
                    this.router.navigate([this.settings.routes.verifyPhoneNUmberRoute]);
                }
            }));
        }, { dispatch: false });
        this.routeToLandingPage$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.RouteToLandingPage), map((action) => action.payload), tap((authed) => {
                this.router.navigateByUrl(authed);
            }));
        }, { dispatch: false });
        this.activeTenantChanging$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ActiveTenantChanging), map((action) => action.payload), withLatestFrom(this.store$.pipe(select(AuthUserStore))), exhaustMap(([tenantContext, user]) => {
                const newTenantId = tenantContext.tenantId;
                const previousTenant = user.activeTenant;
                if (newTenantId) {
                    this.coreService.isLoading = true;
                    return this.getTenantChanging$(newTenantId).pipe(map((obj) => {
                        // newTenant.permissionSections = obj.permissionSections;
                        // newTenant.applications = obj.applications;
                        // newTenant.role = obj.role;
                        if (obj.isTestTenant) {
                            if (previousTenant && previousTenant.regularTenantId) {
                                obj.regularTenantId = previousTenant.regularTenantId;
                            }
                        }
                        else {
                            obj.regularTenantId = obj.tenantId;
                        }
                        this.coreService.isLoading = false;
                        // return new ActiveTenantChanged(obj);
                        return new DidTenantChange({
                            tenant: obj,
                            resetRoute: tenantContext.resetRoute,
                        });
                    }), catchError(() => {
                        this.coreService.isLoading = false;
                        return of(new DidTenantChange({ tenant: previousTenant }));
                    }));
                }
            }));
        });
        this.didTenantChange$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.DidTenantChange), map((action) => action.payload), withLatestFrom(this.store$.pipe(select(ActiveTenantStore))), mergeMap(([tenantContext]) => {
                const resetRoute = tenantContext.resetRoute;
                if (resetRoute &&
                    this.settings.getconfig('enableSwitchTenantDefaultRoute') === 'true') {
                    return [
                        new ActiveTenantChanged(tenantContext.tenant),
                        new GeneralRedirectAction(this.storageService.getItem('latest_context') ||
                            this.settings.routes.dashboardRoute),
                    ];
                }
                else {
                    return [new ActiveTenantChanged(tenantContext.tenant)];
                }
            }));
        });
        this.activeTenantChanged$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ActiveTenantChanged), map((action) => action.payload), switchMap((activeTenant) => {
                if (activeTenant) {
                    const liveTenantId = activeTenant.isTestTenant
                        ? activeTenant.liveTenantId
                        : activeTenant.tenantId;
                    this.cookieService.setSessionCookiePerEnvEncoded('__bt_q_activetenant', JSON.stringify({
                        tenantName: activeTenant.tenantName,
                        tenantId: activeTenant.tenantId,
                        tenantType: activeTenant.tenantType,
                        isTestTenant: !!activeTenant.isTestTenant,
                        resellerId: activeTenant.resellerId,
                        liveTenantId: liveTenantId,
                    }));
                    return [
                        loadPermissions({
                            tenantId: activeTenant.tenantId,
                        }),
                    ];
                }
            }), catchError(() => {
                return [
                    new Logout(''),
                    new GeneralRedirectAction(this.settings.routes.loginRoute),
                ];
            }));
        });
        this.createAnonymousUser$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.CreateAnonymousUser), map((action) => action.payload), exhaustMap((params) => {
                if (!params.featureId) {
                    return this.authService
                        .V1TenantsByTenantIdUserExternalAnonymousApplicationByApplicationIdPersonaByPersonaIdPost({
                        email: params.email,
                        firstName: params.firstName,
                        lastName: params.lastName,
                        templateId: params.templateId,
                        redirectUrl: params.redirectUrl,
                        newUserWelcomeTemplateTypeId: params.newUserWelcomeTemplateTypeId ||
                            this.settings.getconfig('newUserWelcomeTemplateTypeId') ||
                            '',
                        existingUserWelcomeTemplateTypeId: params.existingUserWelcomeTemplateTypeId ||
                            this.settings.getconfig('existingUserWelcomeTemplateTypeId') ||
                            '',
                        newUserWelcomeTemplateId: params.newUserWelcomeTemplateId || '',
                        existingUserWelcomeTemplateId: params.existingUserWelcomeTemplateId || '',
                        from: params.from,
                    }, params.tenantId, params.applicationId, params.personaId)
                        .pipe(catchError((err) => of({ error: err })));
                }
                else {
                    return this.authService
                        .V1TenantsByTenantIdUserExternalAnonymousApplicationByApplicationIdPersonaByPersonaIdFeatureByFeatureIdPost({
                        email: params.email,
                        firstName: params.firstName,
                        lastName: params.lastName,
                        templateId: params.templateId,
                        redirectUrl: params.redirectUrl,
                        newUserWelcomeTemplateTypeId: params.newUserWelcomeTemplateTypeId ||
                            this.settings.getconfig('newUserWelcomeTemplateTypeId') ||
                            '',
                        existingUserWelcomeTemplateTypeId: params.existingUserWelcomeTemplateTypeId ||
                            this.settings.getconfig('existingUserWelcomeTemplateTypeId') ||
                            '',
                        newUserWelcomeTemplateId: params.newUserWelcomeTemplateId || '',
                        existingUserWelcomeTemplateId: params.existingUserWelcomeTemplateId || '',
                    }, params.tenantId, params.applicationId, params.featureId, params.personaId)
                        .pipe(catchError((err) => of({ error: err })));
                }
                // of(new GeneralSuccessAction(AuthActionTypes.CreateAnonymousUser))
            }), map((t) => {
                if (t.error) {
                    return new GeneralErrorAction({
                        actionType: AuthActionTypes.CreateAnonymousUser,
                    });
                }
                else {
                    return new GeneralSuccessAction(AuthActionTypes.CreateAnonymousUser);
                }
            }));
        });
        this.changePassword$ = createEffect(() => {
            return this.actions$.pipe(ofType(AuthActionTypes.ChangePassword), map((act) => act.payload), exhaustMap((auth) => this.authService
                .V1ChangePasswordPost({
                ...auth,
                accessToken: this.coreService.getAuthTokenFromLocalStorage(),
            })
                .pipe(map((response) => response.body), map((user) => {
                // const loginresposne = <User>user.body;
                if (user.status && user.status === 'CHANGE_SUCCESS') {
                    return new GeneralSuccessAction('changepasswordsucceed');
                }
                else {
                    return new UserNotificationAction({
                        type: 'error',
                        message: this.translateService.instant('ARC_SHARED_ACTION_CHANGE_PASSWORD_FAILED_ERROR'),
                    });
                }
            }), catchError((err) => {
                let message = 'ARC_SHARED_ACTION_CHANGE_PASSWORD_FAILED_ERROR';
                if (err && err.error && err.error.status) {
                    message = 'ARC_SHARED_AUTH_ERROR_' + err.error.status;
                }
                return of(new UserNotificationAction({
                    type: 'error',
                    message: this.translateService.instant(message),
                }));
            }))));
        });
    }
    handelAuthError(error, defaultMessageKey = '') {
        let messagekey = defaultMessageKey;
        const errorKeyTagMapping = {
            [AuthenticationErrorStatus.CODE_MISMATCH]: 'ARC_SHARED_PASSWORD_CODE_MISMATCH_MESSAGE',
            [AuthenticationErrorStatus.EXPIRED_CODE]: 'ARC_SHARED_PASSWORD_CODE_EXPIRE_MESSAGE',
            [AuthenticationErrorStatus.TEMPORARY_PASSWORD_EXPIRED]: 'ARC_SHARED_PASSWORD_TEMPORARY_PASSWORD_EXPIRED_MESSAGE',
            [AuthenticationErrorStatus.PASSWORD_IN_HISTORY]: 'ARC_SHARED_PASSWORD_IN_HISTORY_MESSAGE',
            [AuthenticationErrorStatus.PASSSWORD_RESET_REQUIRED]: 'ARC_SHARED_PASSSWORD_RESET_REQUIRED',
        };
        if (error && error.error && error.error.status) {
            const errorTag = errorKeyTagMapping[error.error.status];
            messagekey = errorTag || messagekey;
        }
        return messagekey;
    }
    handleLoginFlow(auth) {
        this.authService.V1LoginPost(auth).pipe();
    }
    getTenantChanging$(tenantId, token) {
        let getTenantByTenantId$ = this.tenantStandAloneService.v1TenantsByIdGet(tenantId);
        const getTenantMetaById$ = this.tenantMgmtService.v1TenantsTenantIdMetaGet(tenantId)
            .pipe(catchError((err) => {
            console.error(err);
            return of({ 'externalClientConnectUrl': '' });
        })); // Don't stop tenant change even if this fails
        let getTenantRole$ = this.permissionService
            .v1TenantsByTenantIdRoleProfileGet(tenantId)
            .pipe(catchError(() => {
            return of({});
        }));
        let loginForTenant$ = this.userService.v1TenantsByTenantIdUsersLoginPost(tenantId, { loginMethod: 'CHANGE_TENANT' });
        let tenantApplications$ = this.tenantStandAloneService.v1TenantsByIdApplicationsGet(tenantId, 'true');
        if (token) {
            getTenantRole$ = this.permissionService.v1TenantsByTenantIdRoleProfileGet(tenantId, token);
            loginForTenant$ = this.userService.v1TenantsByTenantIdUsersLoginPost(tenantId, { loginMethod: 'CHANGE_TENANT' }, token);
            tenantApplications$ =
                this.tenantStandAloneService.v1TenantsByIdApplicationsGet(tenantId, 'true', token);
            getTenantByTenantId$ = this.tenantStandAloneService.v1TenantsByIdGet(tenantId, token);
        }
        const tenantChanging$ = forkJoin([
            getTenantRole$,
            loginForTenant$,
            tenantApplications$,
            getTenantByTenantId$,
            getTenantMetaById$,
        ]).pipe(map(([roleByUserIdResponse, y, tenantApplicationsResponse, tenantProfile, tenantMeta,]) => {
            tenantMeta.externalClientConnectUrl = removeTrailingSlashes(tenantMeta.externalClientConnectUrl);
            return ({
                ...tenantProfile,
                permissionSections: roleByUserIdResponse.permissions,
                applications: tenantApplicationsResponse,
                role: roleByUserIdResponse,
                clientConnectUrl: tenantMeta.externalClientConnectUrl, // tenant-mgmt service changed this key name, so we duplicate to the old name in case it's consumed somewhere
                ...tenantMeta,
            });
        }));
        return tenantChanging$;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthEffects, deps: [{ token: AuthService }, { token: MfaV1Service }, { token: UserService }, { token: PermissionV1Service }, { token: TenantMgmtV1Service }, { token: TenantStandAloneV1Service }, { token: i3.TranslateService }, { token: BrowserCookieService }, { token: AppNameService }, { token: i2.Actions }, { token: i1$2.Store }, { token: i1$2.Store }, { token: i1$1.Router }, { token: CoreService }, { token: AppConfigSettings }, { token: BrowserStorageService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthService }, { type: MfaV1Service }, { type: UserService }, { type: PermissionV1Service }, { type: TenantMgmtV1Service }, { type: TenantStandAloneV1Service }, { type: i3.TranslateService }, { type: BrowserCookieService }, { type: AppNameService }, { type: i2.Actions }, { type: i1$2.Store }, { type: i1$2.Store }, { type: i1$1.Router }, { type: CoreService }, { type: AppConfigSettings }, { type: BrowserStorageService }] });

/**
 * Permission Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */
class PermissionV2Service {
    constructor(httpClient, basePath, configuration, appConfigSetting) {
        this.httpClient = httpClient;
        this.appConfigSetting = appConfigSetting;
        this.basePath = 'https://localhost';
        this.defaultHeaders = new HttpHeaders();
        this.configuration = new Configuration();
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
        if (appConfigSetting.getconfig('permissionServiceUrl')) {
            this.basePath = appConfigSetting.getconfig('permissionServiceUrl');
        }
    }
    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    canConsumeForm(consumes) {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }
    v2TenantsTenantIdRoleProfileGet(tenantId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v2TenantsTenantIdRoleProfileGet.');
        }
        // if (xBilltrustAuth === null || xBilltrustAuth === undefined) {
        //   throw new Error(
        //     'Required parameter xBilltrustAuth was null or undefined when calling v2TenantsTenantIdRoleProfileGet.'
        //   );
        // }
        let headers = this.defaultHeaders;
        // if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
        //   headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        // }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v2/tenants/${encodeURIComponent(String(tenantId))}/role/profile`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v2TenantsTenantIdRolesGetByUseridUserIdGet(tenantId, userId, xBilltrustAuth, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v2TenantsTenantIdRolesGetByUseridUserIdGet.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling v2TenantsTenantIdRolesGetByUseridUserIdGet.');
        }
        if (xBilltrustAuth === null || xBilltrustAuth === undefined) {
            throw new Error('Required parameter xBilltrustAuth was null or undefined when calling v2TenantsTenantIdRolesGetByUseridUserIdGet.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v2/tenants/${encodeURIComponent(String(tenantId))}/roles/get-by-userid/${encodeURIComponent(String(userId))}`, {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v2TenantsTenantIdUserRoleGet(tenantId, xBilltrustAuth, ids, hidrate, observe = 'body', reportProgress = false) {
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v2TenantsTenantIdUserRoleGet.');
        }
        if (xBilltrustAuth === null || xBilltrustAuth === undefined) {
            throw new Error('Required parameter xBilltrustAuth was null or undefined when calling v2TenantsTenantIdUserRoleGet.');
        }
        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (ids !== undefined && ids !== null) {
            queryParameters = queryParameters.set('Ids', ids);
        }
        if (hidrate !== undefined && hidrate !== null) {
            queryParameters = queryParameters.set('Hidrate', hidrate);
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [];
        return this.httpClient.request('get', `${this.basePath}/v2/tenants/${encodeURIComponent(String(tenantId))}/user-role`, {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    v2TenantsTenantIdUsersUserIdRolesPost(xBilltrustAuth, tenantId, userId, body, observe = 'body', reportProgress = false) {
        if (xBilltrustAuth === null || xBilltrustAuth === undefined) {
            throw new Error('Required parameter xBilltrustAuth was null or undefined when calling v2TenantsTenantIdUsersUserIdRolesPost.');
        }
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v2TenantsTenantIdUsersUserIdRolesPost.');
        }
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling v2TenantsTenantIdUsersUserIdRolesPost.');
        }
        let headers = this.defaultHeaders;
        if (xBilltrustAuth !== undefined && xBilltrustAuth !== null) {
            headers = headers.set('X-Billtrust-Auth', String(xBilltrustAuth));
        }
        // to determine the Accept header
        let httpHeaderAccepts = ['application/json'];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        // to determine the Content-Type header
        const consumes = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }
        return this.httpClient.request('post', `${this.basePath}/v2/tenants/${encodeURIComponent(String(tenantId))}/users/${encodeURIComponent(String(userId))}/roles`, {
            body: body,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionV2Service, deps: [{ token: i1.HttpClient }, { token: BASE_PATH, optional: true }, { token: Configuration, optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionV2Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionV2Service, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [BASE_PATH]
                }] }, { type: Configuration, decorators: [{
                    type: Optional
                }] }, { type: AppConfigSettings }] });

class PermissionsEffects {
    constructor(actions$, permissionV2Service) {
        this.actions$ = actions$;
        this.permissionV2Service = permissionV2Service;
        this.loadPermissions$ = createEffect(() => {
            return this.actions$.pipe(ofType(loadPermissions), switchMap((payload) => {
                return this.permissionV2Service
                    .v2TenantsTenantIdRoleProfileGet(payload.tenantId)
                    .pipe(map((res) => {
                    return loadPermissionsSuccess({
                        data: this.toRoles(res),
                    });
                }), catchError((error) => of(loadPermissionsFailure({ error }))));
            }));
        });
    }
    toRoles(res) {
        return res.map((item) => ({
            roleId: item.roleId,
            roleName: item.roleName,
            permissions: item.permissions.map((p) => this.toPermission(p)),
        }));
    }
    toPermission(permissionDTO) {
        const { _delete, ...otherProps } = permissionDTO;
        return {
            ...(permissionDTO._delete !== undefined && {
                delete: permissionDTO._delete,
            }),
            permissionId: permissionDTO.permissionId,
            ...otherProps,
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionsEffects, deps: [{ token: i2.Actions }, { token: PermissionV2Service }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionsEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.Actions }, { type: PermissionV2Service }] });

class AuthModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: AuthModule, imports: [CommonModule, i1$2.StoreFeatureModule, i2.EffectsFeatureModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthModule, imports: [CommonModule,
            StoreModule.forFeature('auth', authreducers),
            EffectsModule.forFeature([AuthEffects, PermissionsEffects])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AuthModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        StoreModule.forFeature('auth', authreducers),
                        EffectsModule.forFeature([AuthEffects, PermissionsEffects]),
                    ],
                    exports: [],
                }]
        }] });

class TokenInterceptor {
    constructor(store, settings, coreService) {
        this.store = store;
        this.settings = settings;
        this.coreService = coreService;
        this.token = '';
        this.store.select(AuthUserStore).subscribe((x) => {
            if (x && x.user && x.user.accessToken) {
                this.token = x.user.accessToken;
            }
            else {
                this.token = '';
            }
        });
        this.getToken();
    }
    getToken() {
        const token = this.coreService.getAuthTokenFromLocalStorage();
        if (token) {
            this.token = token;
        }
    }
    intercept(request, next) {
        let authToken = '';
        if (this.token) {
            authToken = this.token;
        }
        else {
            this.getToken();
            authToken = this.token;
        }
        try {
            let hasBilltrustDomain = false;
            hasBilltrustDomain =
                (this.settings.getconfig('AttachedTokenDomain') &&
                    request.url.includes(this.settings.getconfig('AttachedTokenDomain'))) ||
                    request.url.includes('billtrust.com/');
            if (hasBilltrustDomain) {
                if (request.headers.has('X-Billtrust-Auth') &&
                    !!request.headers.get('X-Billtrust-Auth')) {
                }
                else {
                    request = request.clone({
                        setHeaders: {
                            'X-Billtrust-Auth': authToken,
                        },
                    });
                }
            }
        }
        catch (ce) { }
        return next.handle(request);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TokenInterceptor, deps: [{ token: i1$2.Store }, { token: AppConfigSettings }, { token: CoreService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TokenInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TokenInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: AppConfigSettings }, { type: CoreService }] });
class TestModeInterceptor {
    constructor() { }
    intercept(request, next) {
        request = request.clone({
            setHeaders: {
                'X-BT-Test-Mode': '',
            },
        });
        return next.handle(request);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TestModeInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TestModeInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TestModeInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });
// logout when any 401 happens after user logged, this is problematic since it  appliys to any api, platform is not using this interceport, credit team is.
class ErrorInterceptor {
    constructor(store, translateService) {
        this.store = store;
        this.translateService = translateService;
    }
    intercept(request, next) {
        return next.handle(request).pipe(tap((event) => { }, (err) => {
            console.log(err);
            if (err instanceof HttpErrorResponse) {
                // console.log(err.error);
                this.store
                    .select(AuthUserStore)
                    .pipe(take(1), filter((x) => x.loggedIn))
                    .subscribe((x) => {
                    if (err.status === 401) {
                        // console.log(err.error);
                        if (err.error &&
                            err.error &&
                            !err.error.verified &&
                            err.error.status + '' === 'ACCESSTOKEN_EXPIRED') {
                            this.store.dispatch(new Logout('sessiontimeout'));
                            // this.store.dispatch(new UserNotificationAction({ type: 'error', message: this.translateService.instant('ARC_SHARED_SESSION_ERROR_' + err.error.status), sticky: false }));
                        }
                        else {
                            this.store.dispatch(new Logout(''));
                        }
                        // redirect to the login route
                        // or show a modal
                    }
                });
            }
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ErrorInterceptor, deps: [{ token: i1$2.Store }, { token: i3.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ErrorInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ErrorInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i3.TranslateService }] });
class ApiRequestRetryInterceptor {
    constructor() { }
    intercept(request, next) {
        return next.handle(request).pipe(catchError((error) => {
            if (request.method.toLowerCase() === 'post' &&
                (error.status === 502 || error.status === 504)) {
                return throwError(error);
            }
            if (error.status === 429 ||
                error.status === 502 ||
                error.status === 503 ||
                error.status === 504) {
                return next.handle(request);
            }
            return throwError(error);
        }));
    }
}
class SessionTimeOutInterceptor {
    constructor(store, coreService, ngZone) {
        this.store = store;
        this.coreService = coreService;
        this.ngZone = ngZone;
    }
    intercept(request, next) {
        if (request.url.toLowerCase().endsWith('/verify-session') &&
            request.method === 'POST') {
            return next.handle(request).pipe(tap((event) => {
                // timer(15000).subscribe(x => { });
                if (event instanceof HttpResponse) {
                    if (event.status > 199 && event.status < 301) {
                        const timeForReminder = 15 * 60 * 1000 - 90000 - 5000;
                        this.ngZone.runOutsideAngular(() => {
                            this.coreService.setSessionTimeoutTimer(timeForReminder, () => {
                                this.ngZone.run(() => {
                                    this.store.dispatch(new GetSessionTTLAction());
                                    // this.store.dispatch(new DisplaySessionTimeoutWarningAction({ display: true, countDown: 90000 }));
                                });
                            });
                        });
                    }
                }
            }));
        }
        else {
            return next.handle(request);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SessionTimeOutInterceptor, deps: [{ token: i1$2.Store }, { token: CoreService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SessionTimeOutInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SessionTimeOutInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: CoreService }, { type: i0.NgZone }] });
class SessionTTLInterceptor {
    constructor(store, coreService, ngZone) {
        this.store = store;
        this.coreService = coreService;
        this.ngZone = ngZone;
    }
    intercept(request, next) {
        if (request.url.toLowerCase().endsWith('/session/ttl') &&
            request.method === 'GET') {
            return next.handle(request).pipe(catchError((error) => {
                this.coreService.cancelSessionTimeoutTimer();
                this.ngZone.run(() => {
                    this.store.dispatch(new Logout('sessiontimeout'));
                });
                return throwError(error);
            }), tap((event) => {
                // timer(15000).subscribe(x => { });
                if (event instanceof HttpResponse) {
                    if (event.status > 199 && event.status < 301) {
                        const ttlInSeconds = parseInt(event.body.ttlInSeconds, 10);
                        const timeForReminder = Math.max(ttlInSeconds * 1000 - 90000, 0);
                        this.ngZone.runOutsideAngular(() => {
                            if (timeForReminder > 10000) {
                                this.store.dispatch(new DisplaySessionTimeoutWarningAction({
                                    display: false,
                                    countDown: 0,
                                }));
                                this.coreService.setSessionTimeoutTimer(timeForReminder - 5000, () => {
                                    this.ngZone.run(() => {
                                        this.store.dispatch(new GetSessionTTLAction());
                                        // this.store.dispatch(new DisplaySessionTimeoutWarningAction({ display: true, countDown: 90000 }));
                                    });
                                });
                                // _this.store.dispatch(new GetSessionTTLAction());
                            }
                            else {
                                // this.coreService.setSessionTimeoutTimer(timeForReminder, () => {
                                this.ngZone.run(() => {
                                    this.store.dispatch(new DisplaySessionTimeoutWarningAction({
                                        display: true,
                                        countDown: 90000,
                                    }));
                                });
                                // });
                            }
                        });
                    }
                    else {
                        this.coreService.cancelSessionTimeoutTimer();
                        this.ngZone.run(() => {
                            this.store.dispatch(new Logout('sessiontimeout'));
                        });
                    }
                }
            }));
        }
        else {
            return next.handle(request);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SessionTTLInterceptor, deps: [{ token: i1$2.Store }, { token: CoreService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SessionTTLInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SessionTTLInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: CoreService }, { type: i0.NgZone }] });

class PermissionActionTypes {
    static { this.LoadRoleList = '[Permission] Load Role List'; }
    static { this.UpdateRoleList = '[Permission] Update Role List'; }
    static { this.LoadPermissionSectionList = '[Permission] Load Permission Section List'; }
    static { this.UpdatePermission = '[Permission] Update permission'; }
    static { this.UpdateSingleRole = '[Permission] Update Single Role'; }
    static { this.DeleteSingleRole = '[Permission] Delete Single Role'; }
    static { this.CreateRole = '[Permission] Create Role'; }
    static { this.SaveRole = '[Permission] Save Role'; }
    static { this.SaveRoleV2 = '[Permission] Save Role V2'; }
    static { this.GetUserCountPerRole = '[Permission] Get User Count Per Role'; }
    static { this.UpdateUserCountRole = '[Permission] Update User Count For Role in store'; }
    static { this.AssignUserToRole = '[Permission] Assign User To Role'; }
    static { this.AssignUserToRoleSuccess = '[Permission] Assign User To Role Success'; }
    static { this.GetUserListRole = '[User] Get User List Role'; }
    static { this.UpdateUserListWithRole = '[User] Update User List With Role'; }
    static { this.GetUserListRoleSuccess = '[User] Get User List Role Success'; }
    static { this.GetUserRoleId = '[User] Get User Role Id'; }
    static { this.GetUserRoleIdSuccess = '[User] Get User Role Id Success'; }
    static { this.GetRoleListWithDefaultCountAndPermission = '[User] Get Role List With Default Count and Permission'; }
    static { this.ClearRoleList = '[Permission] Clear Role List'; }
    static { this.BulkChangeUserRole = '[Permission] Bulk Change User Role'; }
    static { this.GetUsersByRole = '[Permission] Get User By Role'; }
}
class UpdateRoleListAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.UpdateRoleList;
    }
}
class LoadRoleListAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.LoadRoleList;
    }
}
class UpdateUserListWithRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.UpdateUserListWithRole;
    }
}
class UpdateSingleRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.UpdateSingleRole;
    }
}
class GetUserRoleIdAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.GetUserRoleId;
    }
}
class CreateRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.CreateRole;
    }
}
class SaveRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.SaveRole;
    }
}
class SaveRoleV2Action {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.SaveRoleV2;
    }
}
class GetUserCountPerRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.GetUserCountPerRole;
    }
}
class UpdateUserCountRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.UpdateUserCountRole;
    }
}
class AssignUserToRoleSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.AssignUserToRoleSuccess;
    }
}
class GetUserListRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.GetUserListRole;
    }
}
class GetUserListRoleSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.GetUserListRoleSuccess;
    }
}
class GetUsersByRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.GetUsersByRole;
    }
}
class GetUserRoleIdSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.GetUserRoleIdSuccess;
    }
}
class AssignUserToRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.AssignUserToRole;
    }
}
class ClearRoleListAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.ClearRoleList;
    }
}
class GetRoleListWithDefaultCountAndPermissionAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.GetRoleListWithDefaultCountAndPermission;
    }
}
class LoadPermissionSectionListAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.LoadPermissionSectionList;
    }
}
class BulkChangeUserRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.BulkChangeUserRole;
    }
}
class UpdatePermissionAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.UpdatePermission;
    }
}
class DeleteSingleRoleAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PermissionActionTypes.DeleteSingleRole;
    }
}

class PermissionEffects {
    constructor(permissionV1Service, translateService, actions$, store$, router, coreService) {
        this.permissionV1Service = permissionV1Service;
        this.translateService = translateService;
        this.actions$ = actions$;
        this.store$ = store$;
        this.router = router;
        this.coreService = coreService;
        this.allRoles$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.LoadRoleList), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([params, currentTenant]) => {
            return this.permissionV1Service
                .v1TenantsByTenantIdRolesGet(currentTenant.tenantId)
                .pipe(map((x) => {
                return new UpdateRoleListAction(x);
            }), catchError((err) => {
                this.coreService.isLoading = false;
                return of(new GeneralErrorAction({
                    actionType: PermissionActionTypes.LoadRoleList,
                }));
            }));
        })));
        this.permissionSectionByRole$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.LoadPermissionSectionList), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([params, currentTenant]) => this.permissionV1Service
            .v1TenantsByTenantIdRolesByRoleIdGet(currentTenant.tenantId, params.roleId)
            .pipe(map((x) => {
            const displayOnUISections = this.normalizePermission(x); //(x || []).filter(x => x.displayOnUI);
            return new UpdateSingleRoleAction({
                roleId: params.roleId,
                permissionSections: displayOnUISections,
            });
        }), catchError((error) => {
            return of(new DoNothingAction());
        })))));
        this.DeleteSingleRole$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.DeleteSingleRole), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([roleId, currentTenant]) => this.permissionV1Service
            .v1TenantsByTenantIdRolesByRoleIdDelete(currentTenant.tenantId, roleId)
            .pipe(map((x) => {
            return new GeneralSuccessAction(PermissionActionTypes.DeleteSingleRole);
        }), catchError((error) => of(new UserNotificationAction({
            type: 'error',
            message: 'ARC_SHARED_FAILED_TO_DELETE_ROLE',
        })))))));
        this.createNewRole$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.CreateRole), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), map(([role, currentTenant]) => {
            role = role || {};
            const propArrays = ['read', 'create', 'edit', 'delete'];
            const createRoleRequest = {
                tenantId: currentTenant.tenantId,
                name: role.name,
                description: role.description,
                permissionInformation: [],
            };
            role.permissionSections = role.permissionSections || [];
            role.permissionSections.forEach((permissionSection) => {
                permissionSection.permissions = permissionSection.permissions || [];
                permissionSection.permissions.forEach((permission) => {
                    propArrays.forEach((prop) => {
                        if (permission[prop]) {
                            createRoleRequest.permissionInformation.push({
                                permissionId: permission.permissionId,
                                actionId: prop.toUpperCase(),
                            });
                        }
                    });
                });
            });
            return createRoleRequest;
        }), exhaustMap((roleRequest) => this.permissionV1Service
            .v1TenantsByTenantIdRolesPost(roleRequest.tenantId, roleRequest)
            .pipe(mergeMap(() => {
            return [new GeneralSuccessAction(PermissionActionTypes.CreateRole)];
        }), catchError(() => {
            return of(new UserNotificationAction({
                type: 'error',
                message: 'ARC_SHARED_FAILED_TO_SAVE_NEW_ROLE',
            }));
        })))));
        this.saveRole$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.SaveRole), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), map(([role, currentTenant]) => {
            role = role || {};
            const propArrays = ['read', 'create', 'edit', 'delete'];
            const createRoleRequest = {
                tenantId: currentTenant.tenantId,
                name: role.name,
                roleId: role.roleId,
                description: role.description,
                permissionInformation: [],
            };
            role.permissionSections = role.permissionSections || [];
            role.permissionSections.forEach((permissionSection) => {
                permissionSection.permissions = permissionSection.permissions || [];
                permissionSection.permissions.forEach((permission) => {
                    propArrays.forEach((prop) => {
                        if (permission[prop]) {
                            createRoleRequest.permissionInformation.push({
                                permissionId: permission.permissionId,
                                actionId: prop.toUpperCase(),
                            });
                        }
                    });
                });
            });
            return createRoleRequest;
        }), exhaustMap((roleRequest) => {
            if (roleRequest.roleId) {
                const roleId = roleRequest.roleId;
                delete roleRequest.roleId;
                return this.permissionV1Service
                    .v1TenantsByTenantIdRolesByRoleIdPut(roleRequest.tenantId, roleId, roleRequest)
                    .pipe(mergeMap(() => {
                    return [new GeneralSuccessAction(PermissionActionTypes.SaveRole)];
                }), catchError(this.handleSaveRoleError()));
                // handle update role in the future
                // return of(new GeneralSuccessAction(PermissionActionTypes.SaveRole));
            }
            else {
                return this.permissionV1Service
                    .v1TenantsByTenantIdRolesPost(roleRequest.tenantId, roleRequest)
                    .pipe(mergeMap(() => {
                    return [new GeneralSuccessAction(PermissionActionTypes.SaveRole)];
                }), catchError(this.handleSaveRoleError()));
            }
        })));
        this.saveRoleV2$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.SaveRoleV2), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([roleRequest, currentTenant]) => {
            roleRequest.tenantId = currentTenant.tenantId;
            if (roleRequest.roleId) {
                const roleId = roleRequest.roleId;
                delete roleRequest.roleId;
                return this.permissionV1Service
                    .v1TenantsByTenantIdRolesByRoleIdPut(currentTenant.tenantId, roleId, roleRequest)
                    .pipe(mergeMap(() => {
                    return [
                        new GeneralSuccessAction(PermissionActionTypes.SaveRoleV2),
                    ];
                }), catchError(this.handleSaveRoleError()));
            }
            else {
                return this.permissionV1Service
                    .v1TenantsByTenantIdRolesPost(roleRequest.tenantId, roleRequest)
                    .pipe(mergeMap(() => {
                    return [
                        new GeneralSuccessAction(PermissionActionTypes.SaveRoleV2),
                    ];
                }), catchError(this.handleSaveRoleError()));
            }
        })));
        this.getUserCountByRole$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.GetUserCountPerRole), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([params, currentTenant]) => this.permissionV1Service
            .v1TenantsByTenantIdRolesByRoleIdGetUserCountGet(currentTenant.tenantId, params.roleId)
            .pipe(map((yy) => {
            return new UpdateUserCountRoleAction({
                userCount: yy.userCount,
                roleId: params.roleId,
            });
        })))));
        this.getUserRoleId$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.GetUserRoleId), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([params, currentTenant]) => this.permissionV1Service
            .v1TenantsByTenantIdRolesGetByUseridByUserIdGet(params.tenantId || currentTenant.tenantId, params.userId)
            .pipe(map((roleObj) => {
            // if (!params.updateUserStore) {
            //     return new GeneralSuccessAction(PermissionActionTypes.GetUserRoleId);
            // }
            return new GetUserRoleIdSuccessAction(roleObj);
        })))));
        this.assignUserRole$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.AssignUserToRole), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([params, currentTenant]) => this.permissionV1Service
            .v1TenantsByTenantIdRolesByRoleIdUsersPut(currentTenant.tenantId, params.roleId, { userId: params.userId })
            .pipe(mergeMap((x) => {
            return [
                new AssignUserToRoleSuccessAction({ roleId: params.roleId }),
                new UserNotificationAction({
                    type: 'success',
                    message: 'ARC_SHARED_USER_ROLE_CHANGED_SUCCESS_MESSAGE',
                }),
            ];
        }), catchError((error) => {
            return of(new UserNotificationAction({
                type: 'error',
                message: 'ARC_SHARED_USER_ROLE_CHANGED_FAILED_MESSAGE',
            }));
        })))));
        this.bulkChangeUerRole$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.BulkChangeUserRole), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([params, currentTenant]) => this.permissionV1Service
            .v1TenantsByTenantIdRolesByRoleIdUsersBulkPut(params.tenantId || currentTenant.tenantId, params.roleId, { userIds: params.userIds })
            .pipe(mergeMap((x) => {
            return [
                new GeneralSuccessAction(PermissionActionTypes.BulkChangeUserRole),
            ];
        }), catchError((error) => {
            return of(new UserNotificationAction({
                type: 'error',
                message: 'ARC_SHARED_FAILED_TO_CHANGE_ROLE',
            }));
        })))));
        this.getUserListRole$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.GetUserListRole), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([params, currentTenant]) => this.permissionV1Service
            .v1TenantsByTenantIdUserRoleGet(params.tenantId || currentTenant.tenantId, '', true)
            .pipe(map((x) => {
            if (params.updateUserStore) {
                return new UpdateUserListWithRoleAction(x);
            }
            return new GetUserListRoleSuccessAction(x);
        }), catchError((error) => {
            return of(new UserNotificationAction({
                type: 'error',
                message: 'ARC_SHARED_SOMETHING_IS_WRONG',
            }));
        })))));
        // @Effect()
        // getRoleListWithDefaultCountAndPermission$: Observable<
        //   Action
        // > = this.actions$.pipe(
        //   ofType(PermissionActionTypes.GetRoleListWithDefaultCountAndPermission),
        //   map(
        //     (action: GetRoleListWithDefaultCountAndPermissionAction) => action.payload
        //   ),
        //   withLatestFrom(this.store$.select(ActiveTenantStore)),
        //   concatMap(([params, currentTenant]) =>
        //     this.permissionV1Service
        //       .v1TenantsByTenantIdRolesGet(params.tenantId || currentTenant.tenantId)
        //       .pipe(
        //         map(x => {
        //           const roleList = <Role[]>x;
        //           let defaultRoleID = params.defaultRoleId;
        //           const tenantId = params.tenantId || currentTenant.tenantId;
        //           if (roleList && roleList.length && roleList.length > 0) {
        //             if (!params.defaultRoleId) {
        //               defaultRoleID = roleList[0].roleId;
        //             }
        //           }
        //           return {
        //             roleList: roleList,
        //             defaultRoleId: defaultRoleID,
        //             tenantId: tenantId
        //           };
        //         })
        //       )
        //   ),
        //   concatMap(x =>
        //     this.permissionV1Service
        //       .v1TenantsByTenantIdRolesByRoleIdGet(x.tenantId, x.defaultRoleId)
        //       .pipe(
        //         map(permissionSections => {
        //           const roleList = x.roleList || [];
        //           const roleDefault = roleList.find(
        //             role => role.roleId === x.defaultRoleId
        //           );
        //           roleDefault.permissionSections =
        //             <PermissionSection[]>permissionSections || [];
        //           return { ...x };
        //         })
        //       )
        //   ),
        //   concatMap(x => {
        //     const allAccessRole = x.roleList.find(r =>
        //       r.roleId.startsWith('arc-all-access-role')
        //     );
        //     if (allAccessRole && x.defaultRoleId === allAccessRole.roleId) {
        //       return of({ ...x });
        //     }
        //     return this.permissionV1Service
        //       .v1TenantsByTenantIdRolesByRoleIdGet(x.tenantId, allAccessRole.roleId)
        //       .pipe(
        //         map(permissionSections => {
        //           const roleList = x.roleList || [];
        //           const roleDefault = roleList.find(
        //             role => role.roleId === allAccessRole.roleId
        //           );
        //           roleDefault.permissionSections =
        //             <PermissionSection[]>permissionSections || [];
        //           return { ...x };
        //         })
        //       );
        //   }),
        //   concatMap(x =>
        //     this.permissionV1Service
        //       .v1TenantsByTenantIdRolesByRoleIdGetUserCountGet(
        //         x.tenantId,
        //         x.defaultRoleId
        //       )
        //       .pipe(
        //         map(roleUserObj => {
        //           const roleList = x.roleList || [];
        //           const roleDefault = roleList.find(
        //             role => role.roleId === x.defaultRoleId
        //           );
        //           roleDefault.userCount = roleUserObj.userCount || 0;
        //           return new UpdateRoleListAction(x.roleList);
        //           // return { ...x }
        //         })
        //       )
        //   )
        // );
        this.getRoleListWithDefaultCountAndPermission$ = createEffect(() => this.actions$.pipe(ofType(PermissionActionTypes.GetRoleListWithDefaultCountAndPermission), map((action) => action.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), concatMap(([params, currentTenant]) => this.getRoleListWithPermission$(params.tenantId || currentTenant.tenantId, params.defaultRoleId).pipe(map((roleList) => {
            return new UpdateRoleListAction(roleList);
        })))));
    }
    handleSaveRoleError() {
        return (error) => {
            if (error.status === 409 &&
                error.error.status === 'DUPLICATE_ROLE_EXISTS') {
                return of(new UserNotificationAction({
                    type: 'error',
                    message: 'ARC_SHARED_USER_SAVE_ROLE_FAILED_DUPLICATE_MESSAGE',
                }));
            }
            else if (error.error.status === 'BAD_REQUEST_NO_PERMISSIONS') {
                return of(new UserNotificationAction({
                    type: 'error',
                    message: 'ARC_SHARED_USER_SAVE_ROLE_FAILED_BAD_REQUEST_NO_PERMISSIONS',
                }));
            }
            else {
                return of(new UserNotificationAction({
                    type: 'error',
                    message: 'ARC_SHARED_FAILED_TO_SAVE_ROLE',
                }));
            }
        };
    }
    getRoleListWithPermission$(tenantId, inputRoleId) {
        const tenantRoleList$ = this.permissionV1Service.v1TenantsByTenantIdRolesGet(tenantId);
        return tenantRoleList$.pipe(mergeMap((x) => {
            let roleId = inputRoleId;
            const roleList = (x || []).filter((t) => t.displayOnUI);
            if (!roleId && roleList && roleList.length > 0) {
                roleId = roleList[0].roleId;
            }
            const allAccessRoleId = roleList.find((role) => role.roleId.startsWith('arc-all-access-role')).roleId;
            const getPermissionByRoleIdAndCount$ = forkJoin([
                this.getPermissionByRoleId$(tenantId, roleId, allAccessRoleId),
                this.permissionV1Service.v1TenantsByTenantIdRolesByRoleIdGetUserCountGet(tenantId, roleId),
            ]).pipe(map(([permissionMap, roleUserObj]) => {
                permissionMap.forEach((value, key, map) => {
                    const role = roleList.find((role) => role.roleId === key);
                    if (role) {
                        role.permissionSections = value;
                    }
                    if (role.roleId === roleId) {
                        role.userCount = roleUserObj.userCount;
                    }
                });
                return roleList;
            }));
            return getPermissionByRoleIdAndCount$;
        }));
    }
    getPermissionByRoleId$(tenantId, inputRoleId, allAccessRoleId) {
        let tenantPermissionForAllAccessRoleAndDefault$;
        if ((inputRoleId || '').startsWith('arc-all-access-role')) {
            tenantPermissionForAllAccessRoleAndDefault$ = this.permissionV1Service
                .v1TenantsByTenantIdRolesByRoleIdGet(tenantId, inputRoleId)
                .pipe(map((x) => {
                const resultMap = new Map();
                resultMap.set(inputRoleId, this.normalizePermission(x));
                return resultMap;
            }), catchError((error) => {
                return of(new Map());
            }));
        }
        else {
            tenantPermissionForAllAccessRoleAndDefault$ = forkJoin([
                this.permissionV1Service.v1TenantsByTenantIdRolesByRoleIdGet(tenantId, inputRoleId),
                this.permissionV1Service.v1TenantsByTenantIdRolesByRoleIdGet(tenantId, allAccessRoleId),
            ]).pipe(map(([x, y]) => {
                const resultMap = new Map();
                resultMap.set(inputRoleId, this.normalizePermission(x));
                resultMap.set(allAccessRoleId, this.normalizePermission(y));
                return resultMap;
            }), catchError((error) => {
                return of(new Map());
            }));
        }
        return tenantPermissionForAllAccessRoleAndDefault$;
    }
    normalizePermission(permissionSections) {
        permissionSections = permissionSections || [];
        permissionSections.forEach((x) => {
            // x.canAssignRead = x.permissions.some(p => p.canAssignRead);
            // x.canAssignCreate = x.permissions.some(p => p.canAssignCreate);
            // x.canAssignDelete = x.permissions.some(p => p.canAssignDelete);
            // x.canAssignEdit = x.permissions.some(p => p.canAssignEdit);
            // x.permissions = x.permissions.filter(p => p.displayOnUI && !p.assignedToAllRoles);
            x.permissions = x.permissions || [];
            x.permissions = x.permissions.filter((p) => p.displayOnUI && !p.assignedToAllRoles);
            // x.read = x.permissions
            //   .filter(y => y.read !== undefined)
            //   .every(y => y.read);
            // x.create = x.permissions
            //   .filter(y => y.create !== undefined)
            //   .every(y => y.create);
            // x.edit = x.permissions
            //   .filter(y => y.edit !== undefined)
            //   .every(y => y.edit);
            // x.delete = x.permissions
            //   .filter(y => y.delete !== undefined)
            //   .every(y => y.delete);
        });
        permissionSections =
            permissionSections.filter((x) => x.displayOnUI && x.permissions && x.permissions.length > 0) || [];
        return permissionSections;
        // sections = sections.filter(x => );
        // return sections;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionEffects, deps: [{ token: PermissionV1Service }, { token: i3.TranslateService }, { token: i2.Actions }, { token: i1$2.Store }, { token: i1$1.Router }, { token: CoreService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: PermissionV1Service }, { type: i3.TranslateService }, { type: i2.Actions }, { type: i1$2.Store }, { type: i1$1.Router }, { type: CoreService }] });

const initialRoleListState = [];
const initialPermissionListState = [];
function roleReducer(state = initialRoleListState, action) {
    switch (action.type) {
        case PermissionActionTypes.UpdateRoleList: {
            return Array.from(action.payload).sort((a, b) => {
                return (a.name || '').localeCompare(b.name || '');
            });
        }
        case PermissionActionTypes.ClearRoleList: {
            return initialRoleListState;
        }
        case PermissionActionTypes.UpdateSingleRole: {
            const roleIndex = state.findIndex((x) => x.roleId === action.payload.roleId);
            const newState = [...state];
            if (roleIndex >= 0) {
                newState[roleIndex] = {
                    ...newState[roleIndex],
                    permissionSections: action.payload.permissionSections || [],
                };
            }
            return newState;
            // return action.payload;
        }
        case PermissionActionTypes.UpdateUserCountRole: {
            const newState = [...state];
            const roleIndex = state.findIndex((x) => x.roleId === action.payload.roleId);
            if (roleIndex >= 0) {
                newState[roleIndex] = {
                    ...newState[roleIndex],
                    userCount: action.payload.userCount,
                };
            }
            return newState;
            // return action.payload;
        }
        default: {
            return state;
        }
    }
}
function permissionReducer(state = initialPermissionListState, action) {
    switch (action.type) {
        default: {
            return state;
        }
    }
}
const permissionReducers = {
    roleList: roleReducer,
    permissionList: permissionReducer,
};
const PermissionModuleStore = createFeatureSelector('permission');
const RoleListStore = createSelector(PermissionModuleStore, (state) => {
    if (state) {
        return state.roleList;
    }
});
const NormalizedVisibleRoleListStore = createSelector(PermissionModuleStore, (state) => {
    if (state && state.roleList && state.roleList.length) {
        const roleList = state.roleList.filter((x) => x.displayOnUI);
        const normRoleList = [];
        roleList.forEach((role) => {
            const normRole = { ...role, permissionSections: [] };
            // normRole.permissionSections = [];
            let sectionList = [];
            sectionList = (role.permissionSections || []).filter((x) => x.displayOnUI);
            sectionList.forEach((x) => {
                const normSection = { ...x };
                normSection.permissions = (x.permissions || []).filter((p) => p.displayOnUI);
                normSection.read = x.permissions
                    .filter((t) => !t.canAssignRead)
                    .every((t) => t.read);
                normSection.create = x.permissions
                    .filter((t) => !t.canAssignCreate)
                    .every((t) => t.create);
                normSection.edit = x.permissions
                    .filter((t) => !t.canAssignEdit)
                    .every((t) => t.edit);
                normSection.delete = x.permissions
                    .filter((t) => !t.canAssignDelete)
                    .every((t) => t.delete);
                normRole.permissionSections.push(normSection);
            });
            normRoleList.push(normRole);
        });
        return normRoleList;
    }
});
const PermissionSectionMasterListStore = createSelector(NormalizedVisibleRoleListStore, (state) => {
    var roleList = state || [];
    const displayRoles = roleList.filter((item) => item.displayOnUI);
    const _allAccessRole = displayRoles.find((x) => x.roleId.indexOf('arc-all-access-role') === 0);
    if (_allAccessRole && _allAccessRole.roleId) {
        const permissionSections = _allAccessRole.permissionSections || [];
        let sections = permissionSections.filter((x) => x.displayOnUI);
        sections.forEach((x) => {
            x.canAssignRead = x.permissions.some((p) => p.canAssignRead);
            x.canAssignCreate = x.permissions.some((p) => p.canAssignCreate);
            x.canAssignDelete = x.permissions.some((p) => p.canAssignDelete);
            x.canAssignEdit = x.permissions.some((p) => p.canAssignEdit);
            x.permissions = x.permissions.filter((p) => p.displayOnUI && !p.assignedToAllRoles);
        });
        sections = sections.filter((x) => x.permissions && x.permissions.length > 0);
        return sections;
    }
    return [];
});
const NewRoleFromRoleStore = createSelector(NormalizedVisibleRoleListStore, (state) => {
    const allAccessRole = state.find((y) => y.roleId.indexOf('arc-all-access-role') === 0) || {};
    const newRole = {
        roleId: '',
        name: '',
        description: '',
        tenantId: '',
        permissionSections: [],
    };
    allAccessRole.permissionSections = allAccessRole.permissionSections || [];
    for (let i = 0; i < allAccessRole.permissionSections.length; i++) {
        let permissionSection = null;
        if (allAccessRole.permissionSections[i].displayOnUI) {
            permissionSection = {
                ...allAccessRole.permissionSections[i],
                read: false,
                edit: false,
                create: false,
                delete: false,
                permissions: [],
            };
        }
        else {
            continue;
        }
        allAccessRole.permissionSections[i].permissions =
            allAccessRole.permissionSections[i].permissions || [];
        for (let j = 0; j < allAccessRole.permissionSections[i].permissions.length; j++) {
            if (allAccessRole.permissionSections[i].permissions[j].displayOnUI) {
                permissionSection.permissions.push({
                    ...allAccessRole.permissionSections[i].permissions[j],
                    read: false,
                    edit: false,
                    create: false,
                    delete: false,
                });
            }
        }
        newRole.permissionSections.push(permissionSection);
        return newRole;
    }
});

class PermissionStoreModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionStoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: PermissionStoreModule, imports: [CommonModule, i1$2.StoreFeatureModule, i2.EffectsFeatureModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionStoreModule, imports: [CommonModule,
            StoreModule.forFeature('permission', permissionReducers),
            EffectsModule.forFeature([PermissionEffects])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionStoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        StoreModule.forFeature('permission', permissionReducers),
                        EffectsModule.forFeature([PermissionEffects]),
                    ],
                    exports: [],
                }]
        }] });

class SearchActionTypes {
    static { this.TypeAheadSearch = '[Search] Type Ahead Search'; }
    static { this.TypeAheadSearchResult = '[Search] Type Ahead Search Result'; }
    static { this.TypeAheadSearchResultWithMetadata = '[Search] Type Ahead Search Result With Metadata'; }
    static { this.TypeAheadSearchPaged = '[Search] Type Ahead Search Paged'; }
    static { this.TypeAheadSearchPagedResult = '[Search] Type Ahead Search Paged Result'; }
}
class TypeAheadSearchAction {
    constructor(payload) {
        this.payload = payload;
        this.type = SearchActionTypes.TypeAheadSearch;
    }
}
class TypeAheadSearchResultAction {
    constructor(payload) {
        this.payload = payload;
        this.type = SearchActionTypes.TypeAheadSearchResult;
    }
}
class TypeAheadSearchResultWithMetadataAction {
    constructor(payload) {
        this.payload = payload;
        this.type = SearchActionTypes.TypeAheadSearchResultWithMetadata;
    }
}
class TypeAheadSearchPagedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = SearchActionTypes.TypeAheadSearchPaged;
    }
}
class TypeAheadSearchPagedResultAction {
    constructor(payload) {
        this.payload = payload;
        this.type = SearchActionTypes.TypeAheadSearchPagedResult;
    }
}

const initialSearchState = {};
function searchReducer(state = initialSearchState, action) {
    switch (action.type) {
        case SearchActionTypes.TypeAheadSearchResult: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}
const SearchReducers = {
    search: searchReducer,
};

class SearchEffects {
    constructor(actions$, store$, searchService, translateService, sanitizer, coreService) {
        this.actions$ = actions$;
        this.store$ = store$;
        this.searchService = searchService;
        this.translateService = translateService;
        this.sanitizer = sanitizer;
        this.coreService = coreService;
        this.typeAheadSearch$ = createEffect(() => this.actions$.pipe(ofType(SearchActionTypes.TypeAheadSearch), map((x) => x.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), switchMap(([params, currentTenant]) => this.searchService
            .searchV1Typeahead(currentTenant.tenantId, params.term, params.type)
            .pipe(switchMap((x) => {
            x = x || [];
            let suggestions = [];
            suggestions = x.map((suggestType) => {
                const searchType = suggestType.type;
                const result = {};
                result.type = suggestType.type;
                result.title = this.translateService.instant('ARC_TYPEAHEAD_TITLE_' + suggestType.type.toUpperCase());
                suggestType.results = suggestType.results || [];
                result.results = suggestType.results.map((t) => {
                    if (searchType === 'accounts') {
                        const highlightArray = t.highlight;
                        const [accountName, accountNumber] = [
                            t.meta.accountName,
                            t.meta.accountNumber,
                        ].map((u) => {
                            return (highlightArray.find((item) => this.removeHighlights(item).toLowerCase() ===
                                u.toLowerCase()) || u);
                        });
                        return {
                            type: searchType,
                            referenceId: t.referenceId,
                            title: this.transformHighlights(accountName),
                            subtitle: this.transformHighlights(accountNumber),
                        };
                    }
                    if (searchType === 'invoices') {
                        const highlightArray = t.highlight;
                        const [billDate, invoiceNumber, billName] = [
                            t.meta.billDate,
                            t.meta.invoiceNumber,
                            t.meta.billName,
                        ].map((u) => {
                            if (!u)
                                return '';
                            return (highlightArray.find((item) => this.removeHighlights(item).toLowerCase() ===
                                u.toLowerCase()) || u);
                        });
                        return {
                            type: searchType,
                            referenceId: t.referenceId,
                            accountId: t.meta.accountId,
                            invoiceNumber: this.removeHighlights(invoiceNumber),
                            title: this.transformHighlights(billName),
                            subtitle: this.transformHighlights(invoiceNumber),
                            amount: billDate,
                        };
                    }
                });
                return result;
            });
            return [
                new TypeAheadSearchResultAction(suggestions),
                new TypeAheadSearchResultWithMetadataAction({
                    term: params.term,
                    types: params.type,
                    searchAttemptCount: params.searchAttemptCount,
                    results: suggestions,
                }),
            ];
        }), catchError((error) => {
            return from([
                new TypeAheadSearchResultAction([]),
                new TypeAheadSearchResultWithMetadataAction({
                    term: params.term,
                    types: params.type,
                    searchAttemptCount: params.searchAttemptCount,
                    results: [],
                }),
            ]);
        })))));
        this.typeAheadSearchPaged$ = createEffect(() => this.actions$.pipe(ofType(SearchActionTypes.TypeAheadSearchPaged), map((x) => x.payload), withLatestFrom(this.store$.select(ActiveTenantStore)), exhaustMap(([params, currentTenant]) => {
            let pageNumber = params.pageIndex || 1;
            let pageSize = params.pageSize || 10;
            let types = params.type || ['accounts', 'invoices'];
            return this.coreService.quickSearchAll(params.term, params.tenantId || currentTenant.tenantId, types, pageNumber, pageSize);
        }), map((result) => new TypeAheadSearchPagedResultAction(result))));
    }
    transformHighlights(text) {
        // return (text || '').replace('<em>', '<m>').replace('</em>', '</m>');
        return text;
    }
    removeHighlights(text) {
        return (text || '').replace('<em>', '').replace('</em>', '');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchEffects, deps: [{ token: i2.Actions }, { token: i1$2.Store }, { token: SearchV1Service }, { token: i3.TranslateService }, { token: i2$3.DomSanitizer }, { token: CoreService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchEffects, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i2.Actions }, { type: i1$2.Store }, { type: SearchV1Service }, { type: i3.TranslateService }, { type: i2$3.DomSanitizer }, { type: CoreService }] });

class SearchStoreModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchStoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: SearchStoreModule, imports: [CommonModule, i1$2.StoreFeatureModule, i2.EffectsFeatureModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchStoreModule, imports: [CommonModule,
            StoreModule.forFeature('search', SearchReducers),
            EffectsModule.forFeature([SearchEffects])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchStoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        StoreModule.forFeature('search', SearchReducers),
                        EffectsModule.forFeature([SearchEffects]),
                    ],
                    exports: [],
                }]
        }] });

class CoreStoreModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CoreStoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: CoreStoreModule, imports: [CommonModule,
            AuthModule,
            PermissionStoreModule,
            SearchStoreModule,
            BrandingModule], exports: [AuthModule,
            GeneralStoreModule,
            PermissionStoreModule,
            SearchStoreModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CoreStoreModule, imports: [CommonModule,
            AuthModule,
            PermissionStoreModule,
            SearchStoreModule,
            BrandingModule, AuthModule,
            GeneralStoreModule,
            PermissionStoreModule,
            SearchStoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CoreStoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        AuthModule,
                        PermissionStoreModule,
                        SearchStoreModule,
                        BrandingModule,
                    ],
                    exports: [
                        AuthModule,
                        GeneralStoreModule,
                        PermissionStoreModule,
                        SearchStoreModule,
                    ],
                    providers: [],
                }]
        }] });

// export * from './auth.module';
// export * from './effects/auth.effects';

class ArcDatePipe {
    ngOnDestroy() {
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }
    constructor(store, translationService) {
        this.store = store;
        this.translationService = translationService;
        this.translatePlaceHolder = [
            'ARC_COMMON_DATE_MONTH_SHORT_JANUARY',
            'ARC_COMMON_DATE_MONTH_SHORT_FEBRUARY',
            'ARC_COMMON_DATE_MONTH_SHORT_MARCH',
            'ARC_COMMON_DATE_MONTH_SHORT_APRIL',
            'ARC_COMMON_DATE_MONTH_SHORT_MAY',
            'ARC_COMMON_DATE_MONTH_SHORT_JUNE',
            'ARC_COMMON_DATE_MONTH_SHORT_JULY',
            'ARC_COMMON_DATE_MONTH_SHORT_AUGUST',
            'ARC_COMMON_DATE_MONTH_SHORT_SEPTEMBER',
            'ARC_COMMON_DATE_MONTH_SHORT_OCTOBER',
            'ARC_COMMON_DATE_MONTH_SHORT_NOVEMBER',
            'ARC_COMMON_DATE_MONTH_SHORT_DECEMBER',
        ];
    }
    transform(value, showTimeOrDateFormat, convertToLocalTime) {
        if (!value) {
            return '';
        }
        const result = this.store.select(AuthUserStore).pipe(take(1), map((userState) => userState?.user));
        let latestValue;
        this._sub = result.subscribe((data) => {
            latestValue = data;
        });
        this.currentLanguage = latestValue.defaultLanguage;
        this.userTimezone = latestValue.timeZone;
        const datePipe = new DatePipe(this.currentLanguage);
        let customFormat = '';
        if (typeof showTimeOrDateFormat === 'string') {
            customFormat = showTimeOrDateFormat;
        }
        else {
            customFormat = `${this.currentLanguage === 'en' ? 'MMM dd, yyyy' : 'dd MMM yyyy'}${showTimeOrDateFormat ? ' h:mm a' : ''}`;
        }
        let customTimeZone;
        if (typeof value === "string") {
            if (value.endsWith("Z")) {
                customTimeZone = 'UTC';
            }
        }
        else {
            customTimeZone = 'UTC';
        }
        if (convertToLocalTime && this.userTimezone) {
            customTimeZone = moment__default(value).tz(this.userTimezone).format('Z');
        }
        const monthStr = datePipe.transform(value, 'MMM', customTimeZone);
        const month = datePipe.transform(value, 'M', customTimeZone);
        const monthInt = parseInt(month) - 1;
        const formattedDate = datePipe.transform(value, customFormat, customTimeZone);
        const translatedMonths = this.translationService.instant(this.translatePlaceHolder[monthInt]);
        let translatedDate = formattedDate;
        if (translatedMonths) {
            translatedDate = formattedDate.replace(monthStr, translatedMonths);
        }
        return translatedDate;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcDatePipe, deps: [{ token: i1$2.Store }, { token: i3.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ArcDatePipe, name: "sharedDate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sharedDate',
                }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i3.TranslateService }] });

const moment = moment$1;
class DateTimeContainerComponent {
    constructor(datetimeService, store) {
        this.datetimeService = datetimeService;
        this.store = store;
        /**
         * whether the output date value should be agnostic of timezone or not.
         * if true, the output will not convert from utc to the user's timezone.
         */
        this.agnostic = false;
        this.displayDate = true;
        this.displayTime = false;
    }
    ngOnInit() {
        if (!this.displayDate) {
            this.outputFormat = "h:mm a";
        }
        if (this.outputFormat && this.outputFormat.indexOf("D") != -1) {
            this.outputFormat = this.outputFormat.replaceAll("D", "d");
        }
        if (this.datetime === "today") {
            this.datetime = new Date();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DateTimeContainerComponent, deps: [{ token: DatetimeService }, { token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: DateTimeContainerComponent, selector: "arc-shared-datetime", inputs: { agnostic: "agnostic", datetime: "datetime", displayDate: "displayDate", displayTime: "displayTime", outputFormat: "outputFormat" }, ngImport: i0, template: "<span>{{datetime | sharedDate: outputFormat? outputFormat:displayTime:!agnostic}}</span>", dependencies: [{ kind: "pipe", type: ArcDatePipe, name: "sharedDate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DateTimeContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-datetime', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span>{{datetime | sharedDate: outputFormat? outputFormat:displayTime:!agnostic}}</span>" }]
        }], ctorParameters: () => [{ type: DatetimeService }, { type: i1$2.Store }], propDecorators: { agnostic: [{
                type: Input
            }], datetime: [{
                type: Input
            }], displayDate: [{
                type: Input
            }], displayTime: [{
                type: Input
            }], outputFormat: [{
                type: Input
            }] } });

class ArcCurrencyPipe {
    constructor(store, currencyPipe) {
        this.store = store;
        this.currencyPipe = currencyPipe;
    }
    ngOnDestroy() {
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }
    /**
     * Transforms a string into a number (if needed).
     */
    strToNumber(value) {
        // Convert strings to numbers
        if (typeof value === 'string' &&
            !isNaN(Number(value) - parseFloat(value))) {
            return Number(value);
        }
        if (typeof value !== 'number') {
            throw new Error(`${value} is not a number`);
        }
        return value;
    }
    transform(value, currencyCode, display, digitsInfo) {
        if (value == null || value == undefined) {
            return '';
        }
        const result = this.store.select(AuthUserStore).pipe(take$1(1), map$1((userState) => userState?.user));
        let latestValue;
        this._sub = result.subscribe((data) => {
            latestValue = data;
        });
        if (display == null || display == "code") {
            display = "";
        }
        ;
        const absValue = Math.abs(this.strToNumber(value));
        const upperCaseCurrencyCode = currencyCode == null ? null : currencyCode.toUpperCase();
        let displayValue = '';
        if (latestValue) {
            try {
                displayValue = this.currencyPipe.transform(absValue, '', display, digitsInfo, latestValue.defaultLanguage);
            }
            catch (e) {
                displayValue = this.currencyPipe.transform(absValue, '', display, digitsInfo);
            }
        }
        else {
            displayValue = this.currencyPipe.transform(absValue, '', display, digitsInfo);
        }
        displayValue = `${displayValue}${upperCaseCurrencyCode ? ' ' + upperCaseCurrencyCode : ''}`;
        // If the value is negative, wrap it in parentheses
        // +value is used to convert the string to a number
        return +value < 0 ? `(${displayValue})` : displayValue;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcCurrencyPipe, deps: [{ token: i1$2.Store }, { token: i2$2.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ArcCurrencyPipe, name: "sharedCurrency" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sharedCurrency',
                }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i2$2.CurrencyPipe }] });

class DatetimeModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DatetimeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: DatetimeModule, declarations: [DateTimeContainerComponent, ArcDatePipe], imports: [CommonModule], exports: [DateTimeContainerComponent, ArcDatePipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DatetimeModule, providers: [DatetimeService], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: DatetimeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [DateTimeContainerComponent, ArcDatePipe],
                    exports: [DateTimeContainerComponent, ArcDatePipe],
                    providers: [DatetimeService],
                }]
        }] });

class AppSwitcherComponent {
    constructor() {
        this.appList = [];
        this.appClick = new EventEmitter();
        this.columnWidth = 3;
    }
    ngOnInit() {
        // this.appList = [
        //   { id: 'test', url: 'test', icon: 'monetization_on' },
        //   { id: 'test123', url: 'test', icon: 'monetization_on' }
        // ];
    }
    appClicked($event) {
        this.appClick.emit($event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppSwitcherComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: AppSwitcherComponent, selector: "arc-shared-appswitcher", inputs: { appList: "appList" }, outputs: { appClick: "appClick" }, ngImport: i0, template: "<div style=\"text-align: center; margin: 0px 0px 20px 0px;\"> <label style=\"font-size:20pt; margin: 0px 0px 30px 0px;\">{{ 'ARC_SHARED_CHOOSE_AN_APPLICATION' | translate }}</label></div>\n<div style=\"padding:0px 40px; text-align: center \">\n\n  <div class=\"p-grid p-align-stretch vertical-container\" style=\"justify-content:center;\">\n    <div *ngFor=\"let app of appList\" class=\"p-col\">\n      <div class=\"box box box-stretched app-content\">\n        <p-card>\n          <div style=\"text-align: center\">\n            <div style=\"font-size: 4rem; \">\n\n              <a href=\"javascript:void(); \" (click)=\"appClicked(app) \"><i class=\"material-icons lg-48\n    icon-blue \">{{app.icon}}</i></a>\n\n            </div>\n            <label style=\"color:#154b94; font-size:16pt; margin: 20px 0px 0px 0px; display:inline-block\"> {{app.name}}</label>\n          </div>\n        </p-card>\n      </div>\n    </div>\n  </div>\n</div>", styles: ["i.icon-blue{color:#154b94}.app-content{border:2px solid #154b94}.app-content :hover{border-width:4px}\n"], dependencies: [{ kind: "directive", type: i2$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2$4.Card, selector: "p-card", inputs: ["header", "subheader", "style", "styleClass"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AppSwitcherComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-appswitcher', template: "<div style=\"text-align: center; margin: 0px 0px 20px 0px;\"> <label style=\"font-size:20pt; margin: 0px 0px 30px 0px;\">{{ 'ARC_SHARED_CHOOSE_AN_APPLICATION' | translate }}</label></div>\n<div style=\"padding:0px 40px; text-align: center \">\n\n  <div class=\"p-grid p-align-stretch vertical-container\" style=\"justify-content:center;\">\n    <div *ngFor=\"let app of appList\" class=\"p-col\">\n      <div class=\"box box box-stretched app-content\">\n        <p-card>\n          <div style=\"text-align: center\">\n            <div style=\"font-size: 4rem; \">\n\n              <a href=\"javascript:void(); \" (click)=\"appClicked(app) \"><i class=\"material-icons lg-48\n    icon-blue \">{{app.icon}}</i></a>\n\n            </div>\n            <label style=\"color:#154b94; font-size:16pt; margin: 20px 0px 0px 0px; display:inline-block\"> {{app.name}}</label>\n          </div>\n        </p-card>\n      </div>\n    </div>\n  </div>\n</div>", styles: ["i.icon-blue{color:#154b94}.app-content{border:2px solid #154b94}.app-content :hover{border-width:4px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { appList: [{
                type: Input
            }], appClick: [{
                type: Output
            }] } });

class TimeoutWarningContainerComponent {
    get countDownInSeconds() {
        return Math.max(0, parseInt(this.countDown / 1000 + '', 10));
    }
    constructor(store, titleService, translateService) {
        this.store = store;
        this.titleService = titleService;
        this.translateService = translateService;
        this._isLive = true;
        this.blockUI = true;
        this.countDown = 0;
        this._subsink = new SubSink();
        this.oldTitle = null;
    }
    ngOnInit() {
        this.oldTitle = this.titleService.getTitle();
        this._subsink.add(this.store
            .pipe(select(AuthUserStore), filter((x) => x.sessionTimeOutPopUp), map((x) => ({
            sessionTimeOutPopUp: x.sessionTimeOutPopUp,
            sessionTimeOutTime: x.sessionTimeOutTime
        })), distinctUntilChanged((prev, curr) => prev.sessionTimeOutPopUp === curr.sessionTimeOutPopUp &&
            prev.sessionTimeOutTime === curr.sessionTimeOutTime), switchMap((x) => {
            this.countDown = x.sessionTimeOutTime;
            return interval(1000).pipe(tap((t) => {
                // console.log('interval ' + t);
            }));
        }))
            .subscribe((t) => {
            // console.log('counting down');
            this.countDown = this.countDown - 1000;
            const countDownTitle = this.translateService.instant('ARC_SHARED_SESSION_TIMEOUT_WARNING_PAGE_TITLE_TIME_LEFT', { count: this.countDownInSeconds });
            this.titleService.setTitle(countDownTitle);
            this.store.dispatch(new GetSessionTTLAction());
            if (this.countDown <= 0) {
                this.resetTitle();
                this.store.dispatch(new Logout('sessiontimeout'));
            }
        }));
    }
    ngOnDestroy() {
        this.resetTitle();
        this._isLive = false;
        this._subsink.unsubscribe();
    }
    onExtendSessionClick($event) {
        this.resetTitle();
        // console.log('extend session');
        this.blockUI = false;
        this.store.dispatch(new DisplaySessionTimeoutWarningAction({ display: false, countDown: 0 }));
        this.store.dispatch(new UserAliveAction({}));
    }
    onLogOutClick($event) {
        this.resetTitle();
        this.store.dispatch(new Logout(''));
    }
    resetTitle() {
        this.titleService.setTitle(this.oldTitle);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TimeoutWarningContainerComponent, deps: [{ token: i1$2.Store }, { token: i2$3.Title }, { token: i3.TranslateService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: TimeoutWarningContainerComponent, selector: "arc-shared-sessionwarning", ngImport: i0, template: "<!-- <p-blockUI [blocked]=\"blockUI\"> -->\n<p-dialog [modal]=\"true\" [closeOnEscape]=\"false\" width=\"400\" [visible]=\"true\" (visible)=\"onExtendSessionClick($event)\" [responsive]=\"true\"\n  [header]=\"'ARC_SHARED_SESSION_TIMEOUT_WARNING_HEADER' | translate\" [closable]=\"false\">\n  <p>\n    {{'ARC_SHARED_SESSION_TIMEOUT_WARNING_MESSAGE_TIME_LEFT' | translate:{count : countDownInSeconds} }}\n  </p>\n  <footer>\n    <button type=\"button\" aur-button (click)=\"onExtendSessionClick($event)\">{{'ARC_SHARED_SESSION_TIMEOUT_WARNING_STAY_LOGGED_IN_BUTTON_TEXT'\n      | translate}}\n    </button>\n    <button type=\"button\" importance=\"secondary\" aur-button (click)=\"onLogOutClick($event)\" translate>{{'ARC_SHARED_SESSION_TIMEOUT_WARNING_LOG_OUT_BUTTON_TEXT'\n      | translate}}\n    </button>\n  </footer>\n</p-dialog>\n\n<!-- </p-blockUI> -->", styles: [""], dependencies: [{ kind: "directive", type: i3.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i8.Dialog, selector: "p-dialog", inputs: ["header", "draggable", "resizable", "positionLeft", "positionTop", "contentStyle", "contentStyleClass", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "responsive", "appendTo", "breakpoints", "styleClass", "maskStyleClass", "maskStyle", "showHeader", "breakpoint", "blockScroll", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeIcon", "closeAriaLabel", "closeTabindex", "minimizeIcon", "maximizeIcon", "visible", "style", "position"], outputs: ["onShow", "onHide", "visibleChange", "onResizeInit", "onResizeEnd", "onDragEnd", "onMaximize"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TimeoutWarningContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-sessionwarning', template: "<!-- <p-blockUI [blocked]=\"blockUI\"> -->\n<p-dialog [modal]=\"true\" [closeOnEscape]=\"false\" width=\"400\" [visible]=\"true\" (visible)=\"onExtendSessionClick($event)\" [responsive]=\"true\"\n  [header]=\"'ARC_SHARED_SESSION_TIMEOUT_WARNING_HEADER' | translate\" [closable]=\"false\">\n  <p>\n    {{'ARC_SHARED_SESSION_TIMEOUT_WARNING_MESSAGE_TIME_LEFT' | translate:{count : countDownInSeconds} }}\n  </p>\n  <footer>\n    <button type=\"button\" aur-button (click)=\"onExtendSessionClick($event)\">{{'ARC_SHARED_SESSION_TIMEOUT_WARNING_STAY_LOGGED_IN_BUTTON_TEXT'\n      | translate}}\n    </button>\n    <button type=\"button\" importance=\"secondary\" aur-button (click)=\"onLogOutClick($event)\" translate>{{'ARC_SHARED_SESSION_TIMEOUT_WARNING_LOG_OUT_BUTTON_TEXT'\n      | translate}}\n    </button>\n  </footer>\n</p-dialog>\n\n<!-- </p-blockUI> -->" }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i2$3.Title }, { type: i3.TranslateService }] });

class LoginWidgetContainerComponent {
    constructor(coreService, route, settings, userService) {
        this.coreService = coreService;
        this.route = route;
        this.settings = settings;
        this.userService = userService;
        this.timeBasedMessagePrefix = 'ARC_SHARED_COMPONENTS_PRESENTATION_LOGIN_WIDGET_TIME_BASED_MESSAGE_';
        this.timeBasedMessageHours = [0, 4, 8, 12, 16, 20];
        this.nearestHour = this.getNearestHour();
        this.message = this.getTimeBasedMessage();
        this.signUpLink = '/signup';
        this.enablePersonaRegistrationFlow = false;
        this.widgetMode = 'regular';
        this.applicationId = '';
        this.featureId = '';
        this.personaId = '';
        this.redirectUrl = '';
        this.tenantId = '';
        this.newUserWelcomeTemplateTypeId = '';
        this.existingUserWelcomeTemplateTypeId = '';
        this.preventTitleChange = false;
        this.showMessage = true;
        this.verificationCodeSent = new EventEmitter();
        this.passwordResetSucceeded = new EventEmitter();
        this.msgs = [];
        this._returnUrl = '';
        this._logoutUrl = '';
        this._tenantId = '';
        this.steps = '1';
    }
    set navigationStrategy(value) {
        this.settings.loginWidgetMode = value;
    }
    get navigationStrategy() {
        return this.settings.loginWidgetMode;
    }
    ngOnInit() {
        const step = this.route.snapshot.queryParams['step'];
        if (step) {
            this.steps = step;
        }
        if (this.isTenantJPMReseller) {
            this.userService.isResellerJPM.next(true);
        }
        else {
            this.userService.isResellerJPM.next(false);
        }
    }
    getNearestHour(forHour = getHours(new Date())) {
        let nearestHour = 0;
        this.timeBasedMessageHours.forEach((hour) => {
            if (forHour >= hour) {
                nearestHour = hour;
            }
        });
        return nearestHour;
    }
    getTimeBasedMessage() {
        return `${this.timeBasedMessagePrefix}${this.nearestHour}`;
    }
    forgetPasswordButtonClicked($event) {
        this.steps = '2';
    }
    forgotPasswordGoBack($event) {
        this.steps = '1';
    }
    verificationEmailSent($event) {
        this.steps = '3';
        this.verificationCodeSent.emit();
    }
    gotoVerificationCodeClicked($event) {
        this.steps = '3';
    }
    onSetVerificationClicked($event) {
        this.steps = '4';
    }
    codeVerificationGoBack($event) {
        this.steps = '1';
    }
    passwordResetGoBack($event) {
        this.steps = '1';
    }
    onResetPasswordSucceeded($event) {
        this.steps = '1';
        this.passwordResetSucceeded.emit();
    }
    goToForgotPassword($event) {
        this.steps = '2';
    }
    onForceRestPasswordClicked($event) {
        this.steps = '1';
    }
    onActivate($event) {
        if ($event) {
            if ($event instanceof LoginContainerComponent) {
                const comp = $event;
                comp.personaId = this.personaId;
                comp.applicationId = this.applicationId;
                comp.enablePersonaRegistrationFlow = this.enablePersonaRegistrationFlow;
                comp.featureId = this.featureId;
                comp.widgetMode = this.widgetMode;
                comp.redirectUrl = this.redirectUrl;
                comp.tenantId = this.tenantId;
                comp.newUserWelcomeTemplateTypeId = this.newUserWelcomeTemplateTypeId;
                comp.signUpLink = this.signUpLink;
                comp.existingUserWelcomeTemplateTypeId =
                    this.existingUserWelcomeTemplateTypeId;
                comp.preventTitleChange = this.preventTitleChange;
            }
            if ($event instanceof ForgotPasswordContainerComponent) {
                const comp = $event;
                comp.fromExternal = this.fromExternal;
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginWidgetContainerComponent, deps: [{ token: CoreService }, { token: i1$1.ActivatedRoute }, { token: AppConfigSettings }, { token: UserService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: LoginWidgetContainerComponent, selector: "arc-shared-login-widget-ultimate", inputs: { message: "message", signUpLink: "signUpLink", enablePersonaRegistrationFlow: "enablePersonaRegistrationFlow", widgetMode: "widgetMode", applicationId: "applicationId", featureId: "featureId", personaId: "personaId", redirectUrl: "redirectUrl", tenantId: "tenantId", newUserWelcomeTemplateTypeId: "newUserWelcomeTemplateTypeId", existingUserWelcomeTemplateTypeId: "existingUserWelcomeTemplateTypeId", preventTitleChange: "preventTitleChange", showMessage: "showMessage", fromExternal: "fromExternal", isTenantJPMReseller: "isTenantJPMReseller", navigationStrategy: "navigationStrategy" }, outputs: { verificationCodeSent: "verificationCodeSent", passwordResetSucceeded: "passwordResetSucceeded" }, ngImport: i0, template: "<fieldset [class.fieldset]=\"showMessage\">\n  <legend *ngIf=\"showMessage\">{{ (message | translate) || 'Billtrust ID' }}</legend>\n\n  <div *ngIf=\"navigationStrategy === 'showhide'\">\n    <arc-shared-app-login [widgetMode]=\"widgetMode\" [applicationId]=\"applicationId\" [featureId]=\"featureId\" [preventTitleChange]=\"preventTitleChange\" [personaId]=\"personaId\" [redirectUrl]=\"redirectUrl\"  [tenantId]=\"tenantId\" *ngIf=\"steps === '1'\" (forgetPasswordButtonClicked)=\"forgetPasswordButtonClicked($event)\"></arc-shared-app-login>\n    <arc-shared-app-forgotpassword *ngIf=\"steps === '2'\" [fromExternal]=\"fromExternal\" (goBackClicked)=\"forgotPasswordGoBack($event)\" (verificationEmailSent)=\"verificationEmailSent($event)\"\n      (gotoVerificationCodeClicked)=\"gotoVerificationCodeClicked($event)\"></arc-shared-app-forgotpassword>\n    <arc-shared-app-codeverification *ngIf=\"steps === '3'\" (goBackClicked)=\"codeVerificationGoBack($event)\" (onSetVerificationClicked)=\"onSetVerificationClicked($event)\"\n      (onForgotPasswordClicked)=\"goToForgotPassword($event)\"></arc-shared-app-codeverification>\n    <arc-shared-app-passwordreset *ngIf=\"steps === '4'\" (goBackClicked)=\"passwordResetGoBack($event)\" (onResetPasswordSucceeded)=\"onResetPasswordSucceeded($event)\"></arc-shared-app-passwordreset>\n    <arc-shared-app-newpassword *ngIf=\"steps === '5'\" (onResetPasswordClicked)=\"onForceRestPasswordClicked($event)\"></arc-shared-app-newpassword>\n  </div>\n\n  <div *ngIf=\"navigationStrategy === 'route'\">\n    <router-outlet (activate)='onActivate($event)'></router-outlet>\n  </div>\n</fieldset>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}:host{display:block;min-width:280px;text-align:center}.fieldset{background:linear-gradient(160deg,#f4f4f4,#f4f4f4b3);border:none;border-radius:6px;box-shadow:0 0 5px #0003 inset;margin:0;padding-top:16px;position:relative}legend{background:#fff;border-radius:0 0 6px 6px;box-shadow:0 2px 3px #0003;color:#4d6069;left:50%;line-height:1;padding:0 8px 4px;position:absolute;top:-1px;transform:translate(-50%);font-weight:600}.message{font-family:Inter,Arial,sans-serif;font-size:24px}\n"], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.RouterOutlet, selector: "router-outlet", inputs: ["name"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }, { kind: "component", type: LoginContainerComponent, selector: "arc-shared-app-login", inputs: ["widgetMode", "applicationId", "featureId", "personaId", "redirectUrl", "tenantId", "newUserWelcomeTemplateTypeId", "existingUserWelcomeTemplateTypeId", "preventTitleChange", "enablePersonaRegistrationFlow", "signUpLink", "fromExternal"], outputs: ["loginSucceeded", "loginError", "loginButtonClicked", "forgetPasswordButtonClicked"] }, { kind: "component", type: PasswordresetContainerComponent, selector: "arc-shared-app-passwordreset", outputs: ["goBackClicked", "onResetPasswordSucceeded", "onResetPasswordError"] }, { kind: "component", type: ForgotPasswordContainerComponent, selector: "arc-shared-app-forgotpassword", inputs: ["fromExternal"], outputs: ["verificationEmailSent", "gotoVerificationCodeClicked", "goBackClicked"] }, { kind: "component", type: CodeVerificationContainerComponent, selector: "arc-shared-app-codeverification", outputs: ["goBackClicked", "onSetVerificationClicked", "onForgotPasswordClicked"] }, { kind: "component", type: ForceResetPasswordContainerComponent, selector: "arc-shared-app-newpassword", outputs: ["onResetPasswordClicked"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginWidgetContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-login-widget-ultimate', template: "<fieldset [class.fieldset]=\"showMessage\">\n  <legend *ngIf=\"showMessage\">{{ (message | translate) || 'Billtrust ID' }}</legend>\n\n  <div *ngIf=\"navigationStrategy === 'showhide'\">\n    <arc-shared-app-login [widgetMode]=\"widgetMode\" [applicationId]=\"applicationId\" [featureId]=\"featureId\" [preventTitleChange]=\"preventTitleChange\" [personaId]=\"personaId\" [redirectUrl]=\"redirectUrl\"  [tenantId]=\"tenantId\" *ngIf=\"steps === '1'\" (forgetPasswordButtonClicked)=\"forgetPasswordButtonClicked($event)\"></arc-shared-app-login>\n    <arc-shared-app-forgotpassword *ngIf=\"steps === '2'\" [fromExternal]=\"fromExternal\" (goBackClicked)=\"forgotPasswordGoBack($event)\" (verificationEmailSent)=\"verificationEmailSent($event)\"\n      (gotoVerificationCodeClicked)=\"gotoVerificationCodeClicked($event)\"></arc-shared-app-forgotpassword>\n    <arc-shared-app-codeverification *ngIf=\"steps === '3'\" (goBackClicked)=\"codeVerificationGoBack($event)\" (onSetVerificationClicked)=\"onSetVerificationClicked($event)\"\n      (onForgotPasswordClicked)=\"goToForgotPassword($event)\"></arc-shared-app-codeverification>\n    <arc-shared-app-passwordreset *ngIf=\"steps === '4'\" (goBackClicked)=\"passwordResetGoBack($event)\" (onResetPasswordSucceeded)=\"onResetPasswordSucceeded($event)\"></arc-shared-app-passwordreset>\n    <arc-shared-app-newpassword *ngIf=\"steps === '5'\" (onResetPasswordClicked)=\"onForceRestPasswordClicked($event)\"></arc-shared-app-newpassword>\n  </div>\n\n  <div *ngIf=\"navigationStrategy === 'route'\">\n    <router-outlet (activate)='onActivate($event)'></router-outlet>\n  </div>\n</fieldset>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}:host{display:block;min-width:280px;text-align:center}.fieldset{background:linear-gradient(160deg,#f4f4f4,#f4f4f4b3);border:none;border-radius:6px;box-shadow:0 0 5px #0003 inset;margin:0;padding-top:16px;position:relative}legend{background:#fff;border-radius:0 0 6px 6px;box-shadow:0 2px 3px #0003;color:#4d6069;left:50%;line-height:1;padding:0 8px 4px;position:absolute;top:-1px;transform:translate(-50%);font-weight:600}.message{font-family:Inter,Arial,sans-serif;font-size:24px}\n"] }]
        }], ctorParameters: () => [{ type: CoreService }, { type: i1$1.ActivatedRoute }, { type: AppConfigSettings }, { type: UserService }], propDecorators: { message: [{
                type: Input
            }], signUpLink: [{
                type: Input
            }], enablePersonaRegistrationFlow: [{
                type: Input
            }], widgetMode: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], featureId: [{
                type: Input
            }], personaId: [{
                type: Input
            }], redirectUrl: [{
                type: Input
            }], tenantId: [{
                type: Input
            }], newUserWelcomeTemplateTypeId: [{
                type: Input
            }], existingUserWelcomeTemplateTypeId: [{
                type: Input
            }], preventTitleChange: [{
                type: Input
            }], showMessage: [{
                type: Input
            }], fromExternal: [{
                type: Input
            }], isTenantJPMReseller: [{
                type: Input
            }], navigationStrategy: [{
                type: Input
            }], verificationCodeSent: [{
                type: Output
            }], passwordResetSucceeded: [{
                type: Output
            }] } });

class QuantumLoginComponent {
    constructor() {
        this.useBTPanel = true;
    }
    ngOnInit() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: QuantumLoginComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: QuantumLoginComponent, selector: "arc-shared-quantum-login", inputs: { useBTPanel: "useBTPanel" }, ngImport: i0, template: "<arc-shared-btpanel *ngIf=\"useBTPanel; else noPanel\">\n  <arc-shared-login-widget-ultimate></arc-shared-login-widget-ultimate>\n</arc-shared-btpanel>\n\n<ng-template #noPanel>\n<arc-shared-login-widget-ultimate [showMessage]=\"false\"></arc-shared-login-widget-ultimate>\n</ng-template>", styles: [""], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: BtPanelComponent, selector: "arc-shared-btpanel" }, { kind: "component", type: LoginWidgetContainerComponent, selector: "arc-shared-login-widget-ultimate", inputs: ["message", "signUpLink", "enablePersonaRegistrationFlow", "widgetMode", "applicationId", "featureId", "personaId", "redirectUrl", "tenantId", "newUserWelcomeTemplateTypeId", "existingUserWelcomeTemplateTypeId", "preventTitleChange", "showMessage", "fromExternal", "isTenantJPMReseller", "navigationStrategy"], outputs: ["verificationCodeSent", "passwordResetSucceeded"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: QuantumLoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-quantum-login', template: "<arc-shared-btpanel *ngIf=\"useBTPanel; else noPanel\">\n  <arc-shared-login-widget-ultimate></arc-shared-login-widget-ultimate>\n</arc-shared-btpanel>\n\n<ng-template #noPanel>\n<arc-shared-login-widget-ultimate [showMessage]=\"false\"></arc-shared-login-widget-ultimate>\n</ng-template>" }]
        }], ctorParameters: () => [], propDecorators: { useBTPanel: [{
                type: Input
            }] } });

class SignupformComponent {
    constructor(appconfigsetting, mfaService) {
        this.appconfigsetting = appconfigsetting;
        this.mfaService = mfaService;
        this.signUpClicked = new EventEmitter();
        this.msgs = [];
        this.siteKey = '';
        this.siteKey = appconfigsetting.getconfig('googleSiteKey');
        this.signUpFormGroup = new UntypedFormGroup({
            email: new UntypedFormControl('', {
                validators: [Validators.required, ArcValidators.email],
            }),
            firstName: new UntypedFormControl(''),
            lastName: new UntypedFormControl(''),
            recaptcha: new UntypedFormControl('', [, Validators.required]),
        });
    }
    ngOnInit() { }
    onSignup() {
        if (this.signUpFormGroup.valid) {
            this.signUpClicked.emit(this.signUpFormGroup.value);
        }
    }
    onEmailEnterKey(value) {
        this.signUpFormGroup.get('email').setValue(value);
    }
    onFirstNameEnterKey(value) {
        this.signUpFormGroup.get('firstName').setValue(value);
    }
    onLastNameEnterKey(value) {
        this.signUpFormGroup.get('lastName').setValue(value);
    }
    async handleSuccess(e) {
        let body = {
            response: e,
        };
        try {
            await this.mfaService
                .v1VerifyrecaptchaPost(body)
                .pipe(tap((x) => {
                if (!x.success) {
                    throw new Error();
                }
            }))
                .toPromise();
        }
        catch (error) {
            console.log(error);
        }
    }
    handleError() { }
    handleExpire() { }
    handleReset() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SignupformComponent, deps: [{ token: AppConfigSettings }, { token: MfaV1Service }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: SignupformComponent, selector: "arc-shared-signupform", outputs: { signUpClicked: "signUpClicked" }, ngImport: i0, template: "<div>\n  <h2>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_SINGUP_DESCRIPTION_NEW' | translate }}</h2>\n  <form [formGroup]=\"signUpFormGroup\" (ngSubmit)=\"onSignup()\">\n    <div *ngIf=\"msgs && msgs.length > 0\">\n      <p-messages [(value)]=\"msgs\"></p-messages>\n    </div>\n\n    <div>\n      <aur-input #firstname id=\"firstName\" [autofocus]=\"true\" formControlName=\"firstName\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_FIRSTNAME_LABEL' | translate\"></aur-input>\n    </div>\n    <div>\n      <aur-input #lastname id=\"lastName\" formControlName=\"lastName\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_LASTNAME_LABEL' | translate\"></aur-input>\n    </div>\n    <div>\n      <aur-input #email id=\"email\" formControlName=\"email\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_EMAIL_LABEL' | translate\" [errorMessages]=\"{\n          'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_EMAIL_REQUIRED_ERROR' | translate,\n          'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_EMAIL_FORMAT_ERROR' | translate\n        }\"></aur-input>\n    </div>\n    <div>\n        <ngx-recaptcha2 #captchaElem\n          [siteKey]=\"siteKey\"\n          (reset)=\"handleReset()\"\n          (expire)=\"handleExpire()\"\n          (error)=\"handleError()\"\n          (success)=\"handleSuccess($event)\"\n          [useGlobalDomain]=\"false\"\n          formControlName=\"recaptcha\">\n        </ngx-recaptcha2>\n    </div>\n    <div style=\"margin: 10px 3px;\">\n      <button type=\"submit\" id=\"btnSignUp\" aur-button [disabled]=\"!signUpFormGroup.valid\">{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_SINGUP_BUTTON'\n        | translate }}</button>\n    </div>\n  </form>\n\n</div>", styles: ["aur-input{width:100%}#btnSignUp{width:100%}\n"], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i2$1.InputComponent, selector: "aur-input", inputs: ["allowNegativeNumbers", "autocomplete", "autofocus", "aurMask", "autotrim", "decimalPlaces", "disabled", "dropSpecialCharacters", "errorMessages", "formControlName", "formControlPath", "form", "frameless", "hiddenInput", "id", "inlineLabel", "inputId", "inputMode", "enterKeyHint", "inputName", "indicateRequirement", "label", "locale", "noValidate", "max", "min", "placeholder", "prefix", "showClearButton", "step", "suffix", "suggestion", "thousandSeparator", "tooltip", "tooltipOptions", "type", "value"], outputs: ["clearClick", "suggestionClick", "passwordToggled", "valueChange", "blur", "focus"] }, { kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i10.Messages, selector: "p-messages", inputs: ["value", "closable", "style", "styleClass", "enableService", "key", "escape", "severity", "showTransitionOptions", "hideTransitionOptions"], outputs: ["valueChange", "onClose"] }, { kind: "component", type: i7.ReCaptcha2Component, selector: "ngx-recaptcha2", inputs: ["theme", "size"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SignupformComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-signupform', template: "<div>\n  <h2>{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_SINGUP_DESCRIPTION_NEW' | translate }}</h2>\n  <form [formGroup]=\"signUpFormGroup\" (ngSubmit)=\"onSignup()\">\n    <div *ngIf=\"msgs && msgs.length > 0\">\n      <p-messages [(value)]=\"msgs\"></p-messages>\n    </div>\n\n    <div>\n      <aur-input #firstname id=\"firstName\" [autofocus]=\"true\" formControlName=\"firstName\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_FIRSTNAME_LABEL' | translate\"></aur-input>\n    </div>\n    <div>\n      <aur-input #lastname id=\"lastName\" formControlName=\"lastName\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_LASTNAME_LABEL' | translate\"></aur-input>\n    </div>\n    <div>\n      <aur-input #email id=\"email\" formControlName=\"email\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_EMAIL_LABEL' | translate\" [errorMessages]=\"{\n          'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_EMAIL_REQUIRED_ERROR' | translate,\n          'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_EMAIL_FORMAT_ERROR' | translate\n        }\"></aur-input>\n    </div>\n    <div>\n        <ngx-recaptcha2 #captchaElem\n          [siteKey]=\"siteKey\"\n          (reset)=\"handleReset()\"\n          (expire)=\"handleExpire()\"\n          (error)=\"handleError()\"\n          (success)=\"handleSuccess($event)\"\n          [useGlobalDomain]=\"false\"\n          formControlName=\"recaptcha\">\n        </ngx-recaptcha2>\n    </div>\n    <div style=\"margin: 10px 3px;\">\n      <button type=\"submit\" id=\"btnSignUp\" aur-button [disabled]=\"!signUpFormGroup.valid\">{{ 'ARC_SHARED_COMPONENTS_PRESENTATION_SINGUP_BUTTON'\n        | translate }}</button>\n    </div>\n  </form>\n\n</div>", styles: ["aur-input{width:100%}#btnSignUp{width:100%}\n"] }]
        }], ctorParameters: () => [{ type: AppConfigSettings }, { type: MfaV1Service }], propDecorators: { signUpClicked: [{
                type: Output
            }] } });

class SignupContainerComponent {
    constructor(store, actions$, route) {
        this.store = store;
        this.actions$ = actions$;
        this.route = route;
        this.succeeded = new EventEmitter();
        this.failed = new EventEmitter();
        this.backButtonClicked = new EventEmitter();
        this.showBackButton = true;
        this._subsink = new SubSink();
        this.applicationId =
            this.route.snapshot.params['applicationId'] || this.applicationId;
        this.personaId = this.route.snapshot.params['personaId'] || this.personaId;
        this.tenantId = this.route.snapshot.params['tenantId'] || this.tenantId;
    }
    ngOnInit() {
        this._subsink.add(this.actions$
            .pipe(ofType(GeneralActionTypes.GeneralError), map((x) => x.payload), filter((x) => x.actionType === AuthActionTypes.CreateAnonymousUser))
            .subscribe((x) => {
            this.showBlockUILoading = false;
            this.store.dispatch(new UserNotificationAction({
                type: 'error',
                message: 'ARC_SHARED_ERROR_MESSAGE_ANONYMOUS_USER_CREATED',
            }));
            this.failed.emit();
        }));
        this._subsink.add(this.actions$
            .pipe(ofType(GeneralActionTypes.GeneralSuccess), filter((x) => x.payload === AuthActionTypes.CreateAnonymousUser))
            .subscribe((x) => {
            this.showBlockUILoading = false;
            this.store.dispatch(new UserNotificationAction({
                type: 'success',
                sticky: true,
                message: 'ARC_SHARED_SUCCESS_MESSAGE_ANONYMOUS_USER_CREATED',
            }));
            this.succeeded.emit();
        }));
    }
    onSignUpClick($event) {
        if (this.tenantId && this.applicationId && this.personaId) {
            this.showBlockUILoading = true;
            this.store.dispatch(new CreateAnonymousUserAction({
                ...$event,
                ...{
                    tenantId: this.tenantId,
                    featureId: this.featureId,
                    templateId: this.emailTemplateId,
                    applicationId: this.applicationId,
                    personaId: this.personaId,
                    redirectUrl: this.redirectUrlEmail,
                    newUserWelcomeTemplateId: this.newUserWelcomeTemplateId,
                    existingUserWelcomeTemplateId: this.existingUserWelcomeTemplateId,
                    newUserWelcomeTemplateTypeId: this.newUserWelcomeTemplateTypeId,
                    existingUserWelcomeTemplateTypeId: this.existingUserWelcomeTemplateTypeId,
                    from: this.from
                }
            }));
        }
        else {
            //  throw new Error('misisng input value');
        }
    }
    onBackClick($event) {
        this.backButtonClicked.emit();
        this.store.dispatch(new LoginRedirect(null));
    }
    ngOnDestroy() {
        this._subsink.unsubscribe();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SignupContainerComponent, deps: [{ token: i1$2.Store }, { token: i2.Actions }, { token: i1$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: SignupContainerComponent, selector: "arc-shared-signup-container", inputs: { applicationId: "applicationId", personaId: "personaId", emailTemplateId: "emailTemplateId", featureId: "featureId", redirectUrlEmail: "redirectUrlEmail", tenantId: "tenantId", showBackButton: "showBackButton", newUserWelcomeTemplateId: "newUserWelcomeTemplateId", existingUserWelcomeTemplateId: "existingUserWelcomeTemplateId", newUserWelcomeTemplateTypeId: "newUserWelcomeTemplateTypeId", existingUserWelcomeTemplateTypeId: "existingUserWelcomeTemplateTypeId", from: "from" }, outputs: { succeeded: "succeeded", failed: "failed", backButtonClicked: "backButtonClicked" }, ngImport: i0, template: "<arc-shared-signupform (signUpClicked)=\"onSignUpClick($event)\"></arc-shared-signupform>\n\n<div class=\"back-button-wrapper\">\n    <button *ngIf=\"showBackButton\" id=\"btnBackToLogIn\" aur-button importance=\"tertiary\" (click)=\"onBackClick($event)\">\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_BACK_BUTTON' | translate}}\n    </button>\n</div>\n\n<aur-loading-spinner\nclass=\"spinner\"\n*ngIf=\"showBlockUILoading\"\n></aur-loading-spinner>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.back-button-wrapper{padding-top:16px;display:flex;justify-content:space-between;align-items:center}.spinner{position:absolute;z-index:999999}\n"], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i2$1.LoadingSpinnerComponent, selector: "aur-loading-spinner", inputs: ["color", "loading", "context"] }, { kind: "component", type: SignupformComponent, selector: "arc-shared-signupform", outputs: ["signUpClicked"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SignupContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-signup-container', template: "<arc-shared-signupform (signUpClicked)=\"onSignUpClick($event)\"></arc-shared-signupform>\n\n<div class=\"back-button-wrapper\">\n    <button *ngIf=\"showBackButton\" id=\"btnBackToLogIn\" aur-button importance=\"tertiary\" (click)=\"onBackClick($event)\">\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_BACK_BUTTON' | translate}}\n    </button>\n</div>\n\n<aur-loading-spinner\nclass=\"spinner\"\n*ngIf=\"showBlockUILoading\"\n></aur-loading-spinner>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.back-button-wrapper{padding-top:16px;display:flex;justify-content:space-between;align-items:center}.spinner{position:absolute;z-index:999999}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i2.Actions }, { type: i1$1.ActivatedRoute }], propDecorators: { applicationId: [{
                type: Input
            }], personaId: [{
                type: Input
            }], emailTemplateId: [{
                type: Input
            }], featureId: [{
                type: Input
            }], redirectUrlEmail: [{
                type: Input
            }], tenantId: [{
                type: Input
            }], succeeded: [{
                type: Output
            }], failed: [{
                type: Output
            }], backButtonClicked: [{
                type: Output
            }], showBackButton: [{
                type: Input
            }], newUserWelcomeTemplateId: [{
                type: Input
            }], existingUserWelcomeTemplateId: [{
                type: Input
            }], newUserWelcomeTemplateTypeId: [{
                type: Input
            }], existingUserWelcomeTemplateTypeId: [{
                type: Input
            }], from: [{
                type: Input
            }] } });

class VerifyAccountFormComponent {
    constructor() {
        this.hasVerificationCode = false;
        this.sendCodeClicked = new EventEmitter();
        this.verifyAccountClicked = new EventEmitter();
        this.onBackButtonClicked = new EventEmitter();
        this.verificationCodeFormControl = new UntypedFormControl('');
        this.phoneNumberFormControl = new UntypedFormControl('');
        this.msgs = [];
        this.verifyAccountFormGroup = new UntypedFormGroup({
            phoneNumber: this.phoneNumberFormControl,
            verificationCode: this.verificationCodeFormControl,
        });
    }
    ngOnInit() { }
    ngAfterViewInit() {
        // this.phoneNumber.phoneNumberForm.get('phoneNumber').blur();
    }
    get isPhoneNumberValid() {
        return this.verifyAccountFormGroup.get('phoneNumber').valid;
    }
    btnSendCodeClick($event) {
        this.verificationCodeFormControl.clearValidators();
        this.phoneNumber.required = true;
        this.phoneNumber.phoneNumberForm.get('phoneNumber').markAsDirty();
        this.phoneNumber.phoneNumberForm.get('phoneNumber').markAsTouched();
        this.phoneNumber.onTouched();
        this.phoneNumber.onBlur();
        this.phoneNumber.phoneNumberForm
            .get('phoneNumber')
            .updateValueAndValidity();
        this.phoneNumber.phoneNumberForm.updateValueAndValidity();
        // const phoneNumber = this.phoneNumber.phoneNumberForm.get('')
        if (this.phoneNumber.phoneNumberForm.valid) {
            this.sendCodeClicked.emit(this.verifyAccountFormGroup.value);
            this.hasVerificationCode = true;
        }
        else {
        }
    }
    btnHasCodeClick($event) {
        this.hasVerificationCode = true;
    }
    btnResendCodeClick($event) {
        this.verificationCodeFormControl.clearValidators();
        this.verificationCodeFormControl.updateValueAndValidity();
        this.phoneNumber.required = true;
        this.phoneNumber.phoneNumberForm.get('phoneNumber').markAsDirty();
        this.phoneNumber.phoneNumberForm.get('phoneNumber').markAsTouched();
        this.phoneNumber.onTouched();
        this.phoneNumber.onBlur();
        this.phoneNumber.phoneNumberForm
            .get('phoneNumber')
            .updateValueAndValidity();
        this.phoneNumber.phoneNumberForm.updateValueAndValidity();
        // const phoneNumber = this.phoneNumber.phoneNumberForm.get('')
        if (this.phoneNumber.phoneNumberForm.valid) {
            this.sendCodeClicked.emit({
                ...this.verifyAccountFormGroup.value,
                resend: true,
            });
            this.hasVerificationCode = true;
        }
    }
    onVerifyAccount($event) {
        this.phoneNumber.required = true;
        this.phoneNumber.phoneNumberForm.get('phoneNumber').markAsDirty();
        this.phoneNumber.phoneNumberForm.get('phoneNumber').markAsTouched();
        this.phoneNumber.onTouched();
        this.phoneNumber.onBlur();
        this.phoneNumber.phoneNumberForm
            .get('phoneNumber')
            .updateValueAndValidity();
        this.phoneNumber.phoneNumberForm.updateValueAndValidity();
        this.verificationCodeFormControl.setValidators(Validators.required);
        this.verificationCodeFormControl.markAsTouched();
        this.verificationCodeFormControl.updateValueAndValidity();
        // this.verifyAccountFormGroup.updateValueAndValidity();
        if (this.verifyAccountFormGroup.valid) {
            this.verifyAccountClicked.emit(this.verifyAccountFormGroup.value);
        }
    }
    onBackClick($event) {
        this.onBackButtonClicked.emit();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VerifyAccountFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: VerifyAccountFormComponent, selector: "arc-shared-verifyaccount-form", inputs: { hasVerificationCode: "hasVerificationCode" }, outputs: { sendCodeClicked: "sendCodeClicked", verifyAccountClicked: "verifyAccountClicked", onBackButtonClicked: "onBackButtonClicked" }, viewQueries: [{ propertyName: "phoneNumber", first: true, predicate: PhoneNumberComponent, descendants: true }], ngImport: i0, template: "<div>\n  <h2>{{ 'ARC_SHARED_COMPONENTS_SIGNUP_MFA_DESCRIPTION' | translate }} </h2>\n\n  <form [formGroup]=\"verifyAccountFormGroup\" (ngSubmit)=\"onVerifyAccount($event)\">\n    <div *ngIf=\"msgs && msgs.length > 0\">\n      <p-messages [(value)]=\"msgs\"></p-messages>\n    </div>\n\n    <div>\n      <!-- <aur-input #phoneNumber id=\"txtPhoneNumber\" [autofocus]=\"true\" formControlName=\"phoneNumber\"\n        [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_MFA_PHONE_NUMBER_LABEL' | translate\" ></aur-input> -->\n      <aur-phone-number id=\"txtPhoneNumber\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_MFA_PHONE_NUMBER_LABEL' | translate\"\n        formControlName=\"phoneNumber\" [placeholder]=\"'609-235-1010'\"></aur-phone-number>\n    </div>\n    <div>\n      <aur-input *ngIf=\"hasVerificationCode\" #verificationCode id=\"txtVerificationCode\"\n        formControlName=\"verificationCode\"\n        [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_MFA_VERIFICATION_CODE_NUMBER_LABEL' | translate\"></aur-input>\n    </div>\n    <!-- <div>\n      <aur-input #email id=\"email\" formControlName=\"email\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_EMAIL_LABEL' | translate\" [errorMessages]=\"{\n          'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_EMAIL_REQUIRED_ERROR' | translate,\n          'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_EMAIL_FORMAT_ERROR' | translate\n        }\"></aur-input>\n    </div> -->\n    <div style=\"margin: 10px 3px;\" *ngIf=\"!hasVerificationCode\">\n      <button type=\"button\" id=\"btnSendCode\" aur-button (click)=\"btnSendCodeClick($event)\"\n        >\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_MFA_BUTTON_SEND_VERIFICATION_CODE'| translate}}\n      </button>\n    </div>\n    <div style=\"margin: 10px 3px;\" *ngIf=\"!hasVerificationCode\">\n      <button importance=\"tertiary\" type=\"button\" id=\"btnHasCode\" aur-button (click)=\"btnHasCodeClick($event)\">\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_MFA_BUTTON_HAS_VERIFICATION_CODE'| translate}}\n      </button>\n    </div>\n\n    <div style=\"margin: 10px 3px;\" *ngIf=\"hasVerificationCode\">\n      <button type=\"submit\" id=\"btnVerifyAccount\" aur-button >\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_MFA_BUTTON_VERIFY_ACCOUNT'| translate}}\n      </button>\n    </div>\n    <div style=\"margin: 10px 3px;\" *ngIf=\"hasVerificationCode\">\n      <button importance=\"tertiary\" type=\"button\" id=\"btnReSendCode\" aur-button (click)=\"btnResendCodeClick($event)\">\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_MFA_BUTTON_RESEND_VERIFICATION_CODE'| translate}}\n      </button>\n    </div>\n    <div style=\"margin: 10px 3px;\">\n      <button importance=\"tertiary\" type=\"button\" id=\"btnBackToLogin\" aur-button (click)=\"onBackClick($event)\">\n        {{ 'ARC_SHARED_COMPONENTS_BACK' | translate }}\n      </button>\n    </div>\n\n  </form>\n\n</div>", styles: [":host ::ng-deep .phone-input>div>input{width:auto!important}.phone-input{width:auto}#txtVerificationCode{width:100%}aur-phone-number{display:block}button{width:100%}\n"], dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.ButtonComponent, selector: "[aur-button], [aurButton]", inputs: ["active", "isLoading", "disabled", "icon", "iconStyle", "iconRotated", "iconPosition", "importance", "size", "loading"] }, { kind: "component", type: i2$1.InputComponent, selector: "aur-input", inputs: ["allowNegativeNumbers", "autocomplete", "autofocus", "aurMask", "autotrim", "decimalPlaces", "disabled", "dropSpecialCharacters", "errorMessages", "formControlName", "formControlPath", "form", "frameless", "hiddenInput", "id", "inlineLabel", "inputId", "inputMode", "enterKeyHint", "inputName", "indicateRequirement", "label", "locale", "noValidate", "max", "min", "placeholder", "prefix", "showClearButton", "step", "suffix", "suggestion", "thousandSeparator", "tooltip", "tooltipOptions", "type", "value"], outputs: ["clearClick", "suggestionClick", "passwordToggled", "valueChange", "blur", "focus"] }, { kind: "component", type: i2$1.PhoneNumberComponent, selector: "aur-phone-number", inputs: ["errorMessages", "form", "formControlName", "placeholder", "required", "id", "formatMask", "showCopyButtonIfDisabled", "showExtension", "autoFocus", "label", "indicateRequirement", "formControlPath", "defaultRegion", "defaultCountry", "value", "disabled", "countries"], outputs: ["valueChange", "change", "blur", "focus"] }, { kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i10.Messages, selector: "p-messages", inputs: ["value", "closable", "style", "styleClass", "enableService", "key", "escape", "severity", "showTransitionOptions", "hideTransitionOptions"], outputs: ["valueChange", "onClose"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VerifyAccountFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-verifyaccount-form', template: "<div>\n  <h2>{{ 'ARC_SHARED_COMPONENTS_SIGNUP_MFA_DESCRIPTION' | translate }} </h2>\n\n  <form [formGroup]=\"verifyAccountFormGroup\" (ngSubmit)=\"onVerifyAccount($event)\">\n    <div *ngIf=\"msgs && msgs.length > 0\">\n      <p-messages [(value)]=\"msgs\"></p-messages>\n    </div>\n\n    <div>\n      <!-- <aur-input #phoneNumber id=\"txtPhoneNumber\" [autofocus]=\"true\" formControlName=\"phoneNumber\"\n        [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_MFA_PHONE_NUMBER_LABEL' | translate\" ></aur-input> -->\n      <aur-phone-number id=\"txtPhoneNumber\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_MFA_PHONE_NUMBER_LABEL' | translate\"\n        formControlName=\"phoneNumber\" [placeholder]=\"'609-235-1010'\"></aur-phone-number>\n    </div>\n    <div>\n      <aur-input *ngIf=\"hasVerificationCode\" #verificationCode id=\"txtVerificationCode\"\n        formControlName=\"verificationCode\"\n        [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_MFA_VERIFICATION_CODE_NUMBER_LABEL' | translate\"></aur-input>\n    </div>\n    <!-- <div>\n      <aur-input #email id=\"email\" formControlName=\"email\" [label]=\"'ARC_SHARED_COMPONENTS_SIGNUP_EMAIL_LABEL' | translate\" [errorMessages]=\"{\n          'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_EMAIL_REQUIRED_ERROR' | translate,\n          'email': 'ARC_SHARED_COMPONENTS_PRESENTATION_EMAIL_FORMAT_ERROR' | translate\n        }\"></aur-input>\n    </div> -->\n    <div style=\"margin: 10px 3px;\" *ngIf=\"!hasVerificationCode\">\n      <button type=\"button\" id=\"btnSendCode\" aur-button (click)=\"btnSendCodeClick($event)\"\n        >\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_MFA_BUTTON_SEND_VERIFICATION_CODE'| translate}}\n      </button>\n    </div>\n    <div style=\"margin: 10px 3px;\" *ngIf=\"!hasVerificationCode\">\n      <button importance=\"tertiary\" type=\"button\" id=\"btnHasCode\" aur-button (click)=\"btnHasCodeClick($event)\">\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_MFA_BUTTON_HAS_VERIFICATION_CODE'| translate}}\n      </button>\n    </div>\n\n    <div style=\"margin: 10px 3px;\" *ngIf=\"hasVerificationCode\">\n      <button type=\"submit\" id=\"btnVerifyAccount\" aur-button >\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_MFA_BUTTON_VERIFY_ACCOUNT'| translate}}\n      </button>\n    </div>\n    <div style=\"margin: 10px 3px;\" *ngIf=\"hasVerificationCode\">\n      <button importance=\"tertiary\" type=\"button\" id=\"btnReSendCode\" aur-button (click)=\"btnResendCodeClick($event)\">\n        {{'ARC_SHARED_COMPONENTS_SIGNUP_MFA_BUTTON_RESEND_VERIFICATION_CODE'| translate}}\n      </button>\n    </div>\n    <div style=\"margin: 10px 3px;\">\n      <button importance=\"tertiary\" type=\"button\" id=\"btnBackToLogin\" aur-button (click)=\"onBackClick($event)\">\n        {{ 'ARC_SHARED_COMPONENTS_BACK' | translate }}\n      </button>\n    </div>\n\n  </form>\n\n</div>", styles: [":host ::ng-deep .phone-input>div>input{width:auto!important}.phone-input{width:auto}#txtVerificationCode{width:100%}aur-phone-number{display:block}button{width:100%}\n"] }]
        }], ctorParameters: () => [], propDecorators: { hasVerificationCode: [{
                type: Input
            }], sendCodeClicked: [{
                type: Output
            }], verifyAccountClicked: [{
                type: Output
            }], onBackButtonClicked: [{
                type: Output
            }], phoneNumber: [{
                type: ViewChild,
                args: [PhoneNumberComponent]
            }] } });

class VerifyAccountContainerComponent {
    constructor(store, actions$, settings) {
        this.store = store;
        this.actions$ = actions$;
        this.settings = settings;
        this._subSink = new SubSink();
        this.widgetMode = 'regular';
        this.applicationId = '';
        this.featureId = '';
        this.personaId = '';
        this.redirectUrl = '';
        this.tenantId = '';
        this.newUserWelcomeTemplateTypeId = '';
        this.existingUserWelcomeTemplateTypeId = '';
    }
    ngOnInit() {
        this._subSink.add(this.actions$
            .pipe(ofType(GeneralActionTypes.GeneralSuccess), map((x) => x.payload), filter((x) => x === AuthActionTypes.SendVerificationCodeViaPhone))
            .subscribe((x) => {
            this.store.dispatch(new UserNotificationAction({
                type: 'success',
                message: 'ARC_SHARED_EXTERNAL_USER_VERIFICATION_CODE_SENT',
            }));
        }));
        this._subSink.add(this.actions$
            .pipe(ofType(GeneralActionTypes.GeneralSuccess), map((x) => x.payload), filter((x) => x.actionType === AuthActionTypes.ReSendVerificationCodeViaPhone))
            .subscribe((x) => {
            this.store.dispatch(new UserNotificationAction({
                type: 'success',
                message: 'ARC_SHARED_EXTERNAL_USER_VERIFICATION_CODE_SENT_' +
                    x.actionData,
            }));
        }));
        this._subSink.add(this.actions$
            .pipe(ofType(GeneralActionTypes.GeneralError), map((x) => x.payload), filter((x) => x.actionType === AuthActionTypes.SendVerificationCodeViaPhone))
            .subscribe((x) => {
            if (x.message) {
                this.store.dispatch(new UserNotificationAction({
                    type: 'error',
                    message: 'ARC_SHARED_EXTERNAL_USER_VERIFICATION_CODE_SENT_ERROR_' +
                        x.message,
                }));
            }
            else {
                this.store.dispatch(new UserNotificationAction({
                    type: 'error',
                    message: 'ARC_SHARED_EXTERNAL_USER_VERIFICATION_CODE_SENT_GENERAL_ERROR',
                }));
            }
        }));
        this._subSink.add(this.actions$
            .pipe(ofType(GeneralActionTypes.GeneralError), map((x) => x.payload), filter((x) => x.actionType === AuthActionTypes.VerifyAccountViaPhone))
            .subscribe((x) => {
            this.store.dispatch(new UserNotificationAction({
                type: 'error',
                message: 'ARC_SHARED_EXTERNAL_USER_VERIFY_ACCOUNT_ERROR_FAILED',
            }));
        }));
    }
    ngOnDestroy() {
        this._subSink.unsubscribe();
    }
    sendCodeClicked($event) {
        const phoneNumber = $event.phoneNumber.countryCode + $event.phoneNumber.phoneNumber;
        this.store.dispatch(new SendVerificationCodeViaPhoneAction({
            phoneNumber: phoneNumber,
            resend: $event.resend,
        }));
    }
    verifyAccountClicked($event) {
        if (this.widgetMode === 'external') {
            $event.applicationId = this.applicationId;
            $event.featureId = this.featureId;
            $event.personaId = this.personaId;
            $event.loginRedirectUrl = this.redirectUrl;
            $event.tenantId = this.tenantId;
            $event.newUserWelcomeTemplateTypeId = this.newUserWelcomeTemplateTypeId;
            $event.existingUserWelcomeTemplateTypeId =
                this.existingUserWelcomeTemplateTypeId;
            this.store.dispatch(new VerifyAccountViaPhoneExternalAction($event));
        }
        else {
            this.store.dispatch(new VerifyAccountViaPhoneAction($event));
        }
    }
    backButtonClicked($event) {
        this.store.dispatch(new GeneralRedirectAction(this.settings.routes.loginRoute));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VerifyAccountContainerComponent, deps: [{ token: i1$2.Store }, { token: i2.Actions }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: VerifyAccountContainerComponent, selector: "arc-shared-verifyaccount-container", inputs: { widgetMode: "widgetMode", applicationId: "applicationId", featureId: "featureId", personaId: "personaId", redirectUrl: "redirectUrl", tenantId: "tenantId", newUserWelcomeTemplateTypeId: "newUserWelcomeTemplateTypeId", existingUserWelcomeTemplateTypeId: "existingUserWelcomeTemplateTypeId" }, ngImport: i0, template: "<arc-shared-verifyaccount-form (sendCodeClicked)=\"sendCodeClicked($event)\" (verifyAccountClicked)=\"verifyAccountClicked($event)\" (onBackButtonClicked)=\"backButtonClicked($event)\"></arc-shared-verifyaccount-form>", styles: [""], dependencies: [{ kind: "component", type: VerifyAccountFormComponent, selector: "arc-shared-verifyaccount-form", inputs: ["hasVerificationCode"], outputs: ["sendCodeClicked", "verifyAccountClicked", "onBackButtonClicked"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VerifyAccountContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-verifyaccount-container', template: "<arc-shared-verifyaccount-form (sendCodeClicked)=\"sendCodeClicked($event)\" (verifyAccountClicked)=\"verifyAccountClicked($event)\" (onBackButtonClicked)=\"backButtonClicked($event)\"></arc-shared-verifyaccount-form>" }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i2.Actions }, { type: AppConfigSettings }], propDecorators: { widgetMode: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], featureId: [{
                type: Input
            }], personaId: [{
                type: Input
            }], redirectUrl: [{
                type: Input
            }], tenantId: [{
                type: Input
            }], newUserWelcomeTemplateTypeId: [{
                type: Input
            }], existingUserWelcomeTemplateTypeId: [{
                type: Input
            }] } });

class FileUploadService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    generatePreSignedUrlToUpload(presignedUrlRequestObj, requestBody) {
        return this.httpClient.post(presignedUrlRequestObj.requestUrl, requestBody, {
            headers: presignedUrlRequestObj.headers,
            params: presignedUrlRequestObj.params,
        });
    }
    uploadFileToVault(response, fileData) {
        const httpHeaders = new HttpHeaders()
            .set('x-amz-server-side-encryption', 'AES256')
            .set('content-type', ' ');
        return this.httpClient.put(response.uploadUrl, fileData, {
            headers: httpHeaders,
        });
    }
    pollingRequest(pollingRequestObj, response) {
        const uploadId = response.uploadId;
        pollingRequestObj.requestUrl = _.replace(pollingRequestObj.requestUrl, 'uploadId', uploadId);
        return this.httpClient.get(pollingRequestObj.requestUrl, {
            headers: pollingRequestObj.headers,
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileUploadService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileUploadService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileUploadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class FileUploadWithUrlComponent {
    constructor(fileUploadService, ngZone, store, fileService) {
        this.fileUploadService = fileUploadService;
        this.ngZone = ngZone;
        this.store = store;
        this.fileService = fileService;
        this.pollingDelay = 1;
        this.thresholdLimit = 300;
        this.attachmentsChange = new EventEmitter();
        this.fileUploadStatusChange = new EventEmitter();
        this.fileScanStatusChange = new EventEmitter();
        this.attachments = [];
    }
    set isDisabledFileUpload(value) {
        this.isDisabled = value;
    }
    ngOnInit() {
        this.isLoggedInSubscription = this.store
            .pipe(select(AuthStore), pluck('user', 'loggedIn'))
            .subscribe((isLoggedIn) => {
            if (!isLoggedIn) {
                this.fileService.closeTray();
                this.fileService.trayRef = null;
            }
        });
    }
    onAttachmentChange(event) {
        this.attachmentsChange.emit(event);
    }
    onChange(event) {
        this.isDisabled = true;
        const requestBody = {
            filename: event.items[0].file.name,
        };
        this.fileUploadService
            .generatePreSignedUrlToUpload(this.presignedUrlRequestObj, requestBody)
            .subscribe((data) => {
            this.fileUploadService
                .uploadFileToVault(data, event.items[0].file)
                .subscribe((response) => {
                if (this.enablePolling) {
                    this.getStatus(event, data);
                }
                else {
                    event.items[0].status = 'SUCCESS';
                    this.fileService.trayAttachments.update(event.items);
                    this.isDisabled = false;
                    this.fileInputComponent.clear();
                    this.fileUploadStatusChange.emit(response);
                }
            }, (err) => {
                event.items[0].status = 'FAILED';
                this.fileService.trayAttachments.update(event.items);
                this.isDisabled = false;
                this.fileInputComponent.clear();
            });
        }, (error) => {
            event.items[0].status = 'FAILED';
            this.fileService.trayAttachments.update(event.items);
            this.isDisabled = false;
            this.fileInputComponent.clear();
        });
    }
    getStatus(event, data) {
        const latestAttachment = event.items[0];
        this.attachments.push(event.items[0]);
        this.ngZone.runOutsideAngular(() => {
            this.pollingSubscription = interval$1(this.pollingDelay * 1000)
                .pipe(takeUntil(timer(this.thresholdLimit * 1000)), startWith(0), switchMap(() => this.fileUploadService.pollingRequest(this.pollingRequestObj, data)))
                .subscribe((res) => {
                this.ngZone.run(() => {
                    event.items[0].status = res['uploadStatus'];
                    this.fileService.trayAttachments.update(event.items);
                    if (res['uploadStatus'] === 'SUCCESS' ||
                        res['uploadStatus'] === 'REJECTED') {
                        this.isDisabled = false;
                        this.fileInputComponent.clear();
                        if (this.pollingSubscription) {
                            this.pollingSubscription.unsubscribe();
                        }
                    }
                    this.fileScanStatusChange.emit(res);
                });
            }, (error) => {
                this.ngZone.run(() => {
                    event.items[0].status = 'FAILED';
                    this.fileService.trayAttachments.update(event.items);
                    this.isDisabled = false;
                    this.fileInputComponent.clear();
                });
            });
        });
    }
    ngOnDestroy() {
        if (this.pollingSubscription) {
            this.pollingSubscription.unsubscribe();
        }
        if (this.isLoggedInSubscription) {
            this.isLoggedInSubscription.unsubscribe();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileUploadWithUrlComponent, deps: [{ token: FileUploadService }, { token: i0.NgZone }, { token: i1$2.Store }, { token: i2$1.FileService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: FileUploadWithUrlComponent, selector: "arc-file-upload-with-url", inputs: { id: "id", acceptableFileType: "acceptableFileType", pollingRequestObj: "pollingRequestObj", enablePolling: "enablePolling", pollingDelay: "pollingDelay", presignedUrlRequestObj: "presignedUrlRequestObj", thresholdLimit: "thresholdLimit", isDisabledFileUpload: "isDisabledFileUpload" }, outputs: { attachmentsChange: "attachmentsChange", fileUploadStatusChange: "fileUploadStatusChange", fileScanStatusChange: "fileScanStatusChange" }, viewQueries: [{ propertyName: "fileInputComponent", first: true, predicate: FileInputComponent, descendants: true }], ngImport: i0, template: "\n<aur-file-input\n    [accept]=\"acceptableFileType\"        \n    label=\"\"  \n    [id]=\"id\"\n    [disabled] = \"isDisabled\"\n    (uploadStart)=\"onChange($event)\"\n    (attachmentsChange) =\"onAttachmentChange($event)\"\n    [autoTray]= \"true\"\n></aur-file-input>    \n\n", styles: [""], dependencies: [{ kind: "component", type: i2$1.FileInputComponent, selector: "aur-file-input", inputs: ["accept", "attachments", "allowDrop", "autoTray", "buttonLabel", "closeDelay", "disabled", "form", "formControlName", "id", "label", "manualTrayUpdate", "maxFiles", "maxFileSize", "maxTotalSize", "trayAttachments"], outputs: ["attachmentsChange", "remove", "uploadStart", "trayOpen"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileUploadWithUrlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-file-upload-with-url', template: "\n<aur-file-input\n    [accept]=\"acceptableFileType\"        \n    label=\"\"  \n    [id]=\"id\"\n    [disabled] = \"isDisabled\"\n    (uploadStart)=\"onChange($event)\"\n    (attachmentsChange) =\"onAttachmentChange($event)\"\n    [autoTray]= \"true\"\n></aur-file-input>    \n\n" }]
        }], ctorParameters: () => [{ type: FileUploadService }, { type: i0.NgZone }, { type: i1$2.Store }, { type: i2$1.FileService }], propDecorators: { id: [{
                type: Input
            }], acceptableFileType: [{
                type: Input
            }], pollingRequestObj: [{
                type: Input
            }], enablePolling: [{
                type: Input
            }], pollingDelay: [{
                type: Input
            }], presignedUrlRequestObj: [{
                type: Input
            }], thresholdLimit: [{
                type: Input
            }], isDisabledFileUpload: [{
                type: Input
            }], attachmentsChange: [{
                type: Output
            }], fileUploadStatusChange: [{
                type: Output
            }], fileScanStatusChange: [{
                type: Output
            }], fileInputComponent: [{
                type: ViewChild,
                args: [FileInputComponent]
            }] } });

class FileUploadWithUrlModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileUploadWithUrlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: FileUploadWithUrlModule, declarations: [FileUploadWithUrlComponent], imports: [CommonModule, FileUploadModule, AureusModule], exports: [FileUploadWithUrlComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileUploadWithUrlModule, providers: [FileUploadService], imports: [CommonModule, FileUploadModule, AureusModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: FileUploadWithUrlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FileUploadWithUrlComponent],
                    imports: [CommonModule, FileUploadModule, AureusModule],
                    exports: [FileUploadWithUrlComponent],
                    providers: [FileUploadService],
                }]
        }] });

class SearchComponent {
    set permissionString(value) {
        this._permissionString = value;
        this._searchPermissionString$.next(this._permissionString);
    }
    get permissionString() {
        return this._permissionString;
    }
    set allowedApps(value) {
        this._allowedApps = value || [];
        this._allowedApps$.next(this._allowedApps);
    }
    get allowedApps() {
        return this._allowedApps;
    }
    constructor(store, permissionDefinition, actions$) {
        this.store = store;
        this.permissionDefinition = permissionDefinition;
        this.actions$ = actions$;
        this._isLive = true;
        this._searchPermissionString$ = new BehaviorSubject('');
        this._allowedApps$ = new BehaviorSubject([]);
        this._query$ = new Subject();
        this.minQueryLength = 2;
        this.size = 'lg';
        this.debounceMs = 300;
        this.searchType = ['accounts', 'invoices'];
        this.selectSuggestion = new EventEmitter();
        this.showSearch$ = combineLatest([
            this._searchPermissionString$,
            this._allowedApps$,
        ]).pipe(switchMap(([permissionString, allowedApps]) => {
            if (!permissionString)
                return of(true);
            return this.permissionDefinition.hasPermissionAndApp$(this.store, permissionString, allowedApps);
        }));
        this.suggestions$ = this.actions$.pipe(ofType(SearchActionTypes.TypeAheadSearchResult), map((x) => x.payload));
    }
    onValueChange(term) {
        this._query$.next(term);
    }
    onSelectSuggestion($event) {
        this.selectSuggestion.emit($event);
    }
    ngOnInit() {
        this._query$
            .pipe(takeWhile(() => this._isLive), filter((term) => term.length > this.minQueryLength), debounceTime(this.debounceMs), distinctUntilChanged())
            .subscribe((term) => this.store.dispatch(new TypeAheadSearchAction({ term: term, type: this.searchType })));
    }
    ngOnDestroy() {
        this._isLive = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchComponent, deps: [{ token: i1$2.Store }, { token: PermissionTypes }, { token: i2.Actions }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: SearchComponent, selector: "arc-shared-search", inputs: { permissionString: "permissionString", allowedApps: "allowedApps", descriptionText: "descriptionText", inputId: "inputId", minQueryLength: "minQueryLength", noResultsFoundText: "noResultsFoundText", placeholder: "placeholder", size: "size", value: "value", debounceMs: "debounceMs", searchType: "searchType" }, outputs: { selectSuggestion: "selectSuggestion" }, ngImport: i0, template: `
    <aur-searchbar
      *ngIf="showSearch$ | async"
      [descriptionText]="descriptionText"
      [inputId]="inputId"
      [minQueryLength]="minQueryLength"
      [noResultsFoundText]="noResultsFoundText"
      [placeholder]="placeholder"
      [size]="size"
      [suggestions]="suggestions$ | async"
      [value]="value"
      (valueChange)="onValueChange($event)"
      (selectSuggestion)="onSelectSuggestion($event)"
      ngDefaultControl
    ></aur-searchbar>
  `, isInline: true, dependencies: [{ kind: "directive", type: i2$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.SearchbarComponent, selector: "aur-searchbar", inputs: ["activeSuggestionGroupIndex", "activeSuggestionItemIndex", "collapsed", "scope", "scopeOptions", "inputId", "placeholder", "open", "minQueryLength", "size", "noResultsFoundText", "descriptionText", "suggestions", "value"], outputs: ["collapsedChange", "openChange", "scopeChange", "valueChange", "search", "selectSuggestion"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "pipe", type: i2$2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SearchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'arc-shared-search',
                    template: `
    <aur-searchbar
      *ngIf="showSearch$ | async"
      [descriptionText]="descriptionText"
      [inputId]="inputId"
      [minQueryLength]="minQueryLength"
      [noResultsFoundText]="noResultsFoundText"
      [placeholder]="placeholder"
      [size]="size"
      [suggestions]="suggestions$ | async"
      [value]="value"
      (valueChange)="onValueChange($event)"
      (selectSuggestion)="onSelectSuggestion($event)"
      ngDefaultControl
    ></aur-searchbar>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: PermissionTypes }, { type: i2.Actions }], propDecorators: { permissionString: [{
                type: Input
            }], allowedApps: [{
                type: Input
            }], descriptionText: [{
                type: Input
            }], inputId: [{
                type: Input
            }], minQueryLength: [{
                type: Input
            }], noResultsFoundText: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], size: [{
                type: Input
            }], value: [{
                type: Input
            }], debounceMs: [{
                type: Input
            }], searchType: [{
                type: Input
            }], selectSuggestion: [{
                type: Output
            }] } });

class ChangepasswordContainerComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.formGroup = new UntypedFormGroup({
            currentPassword: new UntypedFormControl('', {
                validators: [Validators.required],
            }),
        });
    }
    onResetPasswordClick($event) {
        if (this.formGroup.valid) {
            this.store.dispatch(new ChangePassword({
                previousPassword: this.formGroup.get('currentPassword').value,
                newPassword: $event,
            }));
        }
    }
    get currentPassword() {
        return this.formGroup.get('currentPassword');
    }
    get ncurrentPasswordValid() {
        return this.isControlValid(this.currentPassword);
    }
    isControlValid(control) {
        return control.errors && control.touched;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ChangepasswordContainerComponent, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ChangepasswordContainerComponent, selector: "arc-shared-changepassword-container", ngImport: i0, template: "<form [formGroup]=\"formGroup\">\n  <div class=\"p-col-12\" style=\"margin-top:10px;\">\n    <aur-input\n      type=\"password\"\n      formControlName=\"currentPassword\"\n      [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_CURRENT_PASSWORD_LABEL' | translate\"\n      [errorMessages]=\"{\n        'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_CURRENT_PASSWORD_REQ_ERROR' | translate\n      }\"\n    ></aur-input>\n  </div>\n</form>\n\n<arc-shared-passwordreset [backButtonVisible]=\"false\" (resetPasswordClicked)=\"onResetPasswordClick($event)\"></arc-shared-passwordreset>\n", styles: ["aur-input{width:100%}\n"], dependencies: [{ kind: "component", type: i2$1.InputComponent, selector: "aur-input", inputs: ["allowNegativeNumbers", "autocomplete", "autofocus", "aurMask", "autotrim", "decimalPlaces", "disabled", "dropSpecialCharacters", "errorMessages", "formControlName", "formControlPath", "form", "frameless", "hiddenInput", "id", "inlineLabel", "inputId", "inputMode", "enterKeyHint", "inputName", "indicateRequirement", "label", "locale", "noValidate", "max", "min", "placeholder", "prefix", "showClearButton", "step", "suffix", "suggestion", "thousandSeparator", "tooltip", "tooltipOptions", "type", "value"], outputs: ["clearClick", "suggestionClick", "passwordToggled", "valueChange", "blur", "focus"] }, { kind: "directive", type: i3$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i3$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: PasswordresetComponent, selector: "arc-shared-passwordreset", inputs: ["backButtonVisible"], outputs: ["resetPasswordClicked", "goBackClicked"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ChangepasswordContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-changepassword-container', template: "<form [formGroup]=\"formGroup\">\n  <div class=\"p-col-12\" style=\"margin-top:10px;\">\n    <aur-input\n      type=\"password\"\n      formControlName=\"currentPassword\"\n      [label]=\"'ARC_SHARED_COMPONENTS_PRESENTATION_CURRENT_PASSWORD_LABEL' | translate\"\n      [errorMessages]=\"{\n        'required': 'ARC_SHARED_COMPONENTS_PRESENTATION_CURRENT_PASSWORD_REQ_ERROR' | translate\n      }\"\n    ></aur-input>\n  </div>\n</form>\n\n<arc-shared-passwordreset [backButtonVisible]=\"false\" (resetPasswordClicked)=\"onResetPasswordClick($event)\"></arc-shared-passwordreset>\n", styles: ["aur-input{width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.Store }] });

class NoAccessComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NoAccessComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: NoAccessComponent, selector: "arc-shared-no-access", ngImport: i0, template: "<div class=\"container\">\n    <h1 id=\"arc-shared-no-access-title\">{{'ARC_SHARED_NO_ACCESS_TITLE' | translate}}</h1>\n    <p id=\"arc-shared-no-access-subtitle\">{{'ARC_SHARED_NO_ACCESS_SUBTITLE' | translate}}</p>\n    <img id=\"arc-shared-no-access-image\" src=\"assets/images/no-access/no-access.svg\" />\n</div>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.container{text-align:center;margin:80px auto}img{max-width:320px;width:100%}h1{margin:0 auto;color:#003035;line-height:40px;max-width:420px;font-weight:700}p{color:#4d6069;margin:32px;font-size:.875rem}\n"], dependencies: [{ kind: "pipe", type: i3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: NoAccessComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-no-access', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\n    <h1 id=\"arc-shared-no-access-title\">{{'ARC_SHARED_NO_ACCESS_TITLE' | translate}}</h1>\n    <p id=\"arc-shared-no-access-subtitle\">{{'ARC_SHARED_NO_ACCESS_SUBTITLE' | translate}}</p>\n    <img id=\"arc-shared-no-access-image\" src=\"assets/images/no-access/no-access.svg\" />\n</div>", styles: ["@charset \"UTF-8\";input,textarea{font-family:Inter,Arial,sans-serif}.display{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.display{font-size:2.5rem;line-height:1.2}}@media screen and (max-width: 992px){.display{font-size:2.25rem;line-height:1.222}}.body-lg{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}@media screen and (max-width: 992px){.body-lg{font-size:1.125rem;line-height:1.555}}.body-md{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body-md{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.body-md{font-size:1rem;line-height:1.5}}.body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){.body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.body{font-size:.875rem;line-height:1.71429}}.aur-form-label{font-size:.75rem;font-weight:500;line-height:1}.tagline{text-transform:uppercase;color:#66737a;letter-spacing:normal;font-weight:600}@media screen and (min-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){.tagline{font-size:.75rem;line-height:1.71429}}body{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){body{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){body{font-size:.875rem;line-height:1.71429}}label{letter-spacing:normal;font-weight:400}@media screen and (min-width: 992px){label{font-size:.75rem;line-height:1.71429}}@media screen and (max-width: 992px){label{font-size:.75rem;line-height:1.71429}}.h1,h1{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h1,h1{font-size:2rem;line-height:1.125}}@media screen and (max-width: 992px){.h1,h1{font-size:1.75rem;line-height:1.143}}.h2,h2{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h2,h2{font-size:1.75rem;line-height:1.143}}@media screen and (max-width: 992px){.h2,h2{font-size:1.5rem;line-height:1.1667}}.h3,h3{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h3,h3{font-size:1.5rem;line-height:1.1667}}@media screen and (max-width: 992px){.h3,h3{font-size:1.25rem;line-height:1.2}}.h4,h4{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h4,h4{font-size:1.25rem;line-height:1.2}}@media screen and (max-width: 992px){.h4,h4{font-size:1.125rem;line-height:1.555}}.h5,h5{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h5,h5{font-size:1rem;line-height:1.5}}@media screen and (max-width: 992px){.h5,h5{font-size:.875rem;line-height:1.5}}.h6,h6{letter-spacing:normal;font-weight:500}@media screen and (min-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}@media screen and (max-width: 992px){.h6,h6{font-size:.875rem;line-height:1.71429}}aur-page header h1,aur-page header .h1{font-size:1.75rem;line-height:1.143}aur-card header h1,aur-card header .h1,aur-selectable-card header h1,aur-selectable-card header .h1{font-size:1.25rem;line-height:1.2}aur-drawer header h1,aur-drawer header .h1,.aur-drawer-sidebar header h1,.aur-drawer-sidebar header .h1,.aur-cdk-drawer header h1,.aur-cdk-drawer header .h1{font-size:1.5rem;line-height:1.1667}aur-page header h2,aur-page header .h2{font-size:1.75rem;line-height:1.143}aur-card header h2,aur-card header .h2,aur-selectable-card header h2,aur-selectable-card header .h2{font-size:1.25rem;line-height:1.2}aur-drawer header h2,aur-drawer header .h2,.aur-drawer-sidebar header h2,.aur-drawer-sidebar header .h2,.aur-cdk-drawer header h2,.aur-cdk-drawer header .h2{font-size:1.5rem;line-height:1.1667}aur-page header h3,aur-page header .h3{font-size:1.75rem;line-height:1.143}aur-card header h3,aur-card header .h3,aur-selectable-card header h3,aur-selectable-card header .h3{font-size:1.25rem;line-height:1.2}aur-drawer header h3,aur-drawer header .h3,.aur-drawer-sidebar header h3,.aur-drawer-sidebar header .h3,.aur-cdk-drawer header h3,.aur-cdk-drawer header .h3{font-size:1.5rem;line-height:1.1667}aur-page header h4,aur-page header .h4{font-size:1.75rem;line-height:1.143}aur-card header h4,aur-card header .h4,aur-selectable-card header h4,aur-selectable-card header .h4{font-size:1.25rem;line-height:1.2}aur-drawer header h4,aur-drawer header .h4,.aur-drawer-sidebar header h4,.aur-drawer-sidebar header .h4,.aur-cdk-drawer header h4,.aur-cdk-drawer header .h4{font-size:1.5rem;line-height:1.1667}aur-page header h5,aur-page header .h5{font-size:1.75rem;line-height:1.143}aur-card header h5,aur-card header .h5,aur-selectable-card header h5,aur-selectable-card header .h5{font-size:1.25rem;line-height:1.2}aur-drawer header h5,aur-drawer header .h5,.aur-drawer-sidebar header h5,.aur-drawer-sidebar header .h5,.aur-cdk-drawer header h5,.aur-cdk-drawer header .h5{font-size:1.5rem;line-height:1.1667}aur-page header h6,aur-page header .h6{font-size:1.75rem;line-height:1.143}aur-card header h6,aur-card header .h6,aur-selectable-card header h6,aur-selectable-card header .h6{font-size:1.25rem;line-height:1.2}aur-drawer header h6,aur-drawer header .h6,.aur-drawer-sidebar header h6,.aur-drawer-sidebar header .h6,.aur-cdk-drawer header h6,.aur-cdk-drawer header .h6{font-size:1.5rem;line-height:1.1667}.container{text-align:center;margin:80px auto}img{max-width:320px;width:100%}h1{margin:0 auto;color:#003035;line-height:40px;max-width:420px;font-weight:700}p{color:#4d6069;margin:32px;font-size:.875rem}\n"] }]
        }] });

class ClickStopPropagationDirective {
    onClick(event) {
        event.stopPropagation();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ClickStopPropagationDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: ClickStopPropagationDirective, selector: "[arcSharedStopPropagation]", host: { listeners: { "click": "onClick($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ClickStopPropagationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[arcSharedStopPropagation]',
                }]
        }], propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class ApplyPermissionDirective {
    set arcSharedPermission(value) {
        this._permissionString = value;
        this._inputBehavior.next(value);
    }
    get arcSharedPermission() {
        return this._permissionString;
    }
    constructor(store, _viewContainer, templateRef, permissionDefinition) {
        this.store = store;
        this._viewContainer = _viewContainer;
        this.templateRef = templateRef;
        this.permissionDefinition = permissionDefinition;
        this._permissionString = '';
        this._isLive = true;
        this._inputBehavior = new BehaviorSubject('');
        this._context = new NgIfContext();
    }
    ngOnInit() {
        combineLatest(this._inputBehavior.pipe(filter((x) => !!x)), getActiveTenant$(this.store), this.store.pipe(select(UserPermissionStore), filter((t) => t && t.length && t.length > 0)))
            // .takeWhile(() => this._isLive)
            .subscribe(([permissionString, activeTenant, x]) => {
            const permissionStoreData = x || [];
            const hasPermission = this.permissionDefinition.hasPermission(permissionStoreData, permissionString);
            this._updateView(hasPermission);
        });
    }
    ngOnDestroy() {
        this._isLive = false;
    }
    _updateView(show) {
        if (show) {
            this._viewContainer.clear();
            const view = this._viewContainer.createEmbeddedView(this.templateRef, this._context);
            view.markForCheck();
        }
        else {
            this._viewContainer.clear();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ApplyPermissionDirective, deps: [{ token: i1$2.Store }, { token: i0.ViewContainerRef }, { token: i0.TemplateRef }, { token: PermissionTypes }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: ApplyPermissionDirective, selector: "[arcSharedPermission]", inputs: { arcSharedPermission: "arcSharedPermission" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ApplyPermissionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[arcSharedPermission]',
                }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i0.ViewContainerRef }, { type: i0.TemplateRef }, { type: PermissionTypes }], propDecorators: { arcSharedPermission: [{
                type: Input
            }] } });

class UserActiveDirective {
    constructor(store, appConfigSettings, ngZone) {
        this.store = store;
        this.appConfigSettings = appConfigSettings;
        this.ngZone = ngZone;
        this._isLive = true;
    }
    ngOnInit() {
        const userActiveCheckTime = parseInt((this.appConfigSettings.getconfig('userActiveCheckTime') || '60000') + '', 10);
        const clientConnectKeepAlive$ = fromEvent(window, 'message').pipe(filter((message) => /\.billtrust\.(local|com)$/.test(message.origin)
            && (message.data === 'cc-iframe-user-isactive-click'
                || message.data === 'cc-iframe-user-isactive-mousemove'
                || message.data === 'cc-iframe-user-isactive-keypress')));
        this.ngZone.runOutsideAngular(() => {
            const total$ = merge$1(fromEvent(document, 'mouseup'), fromEvent(document, 'keyup'), fromEvent(document, 'wheel'), fromEvent(document, 'mousemove'), clientConnectKeepAlive$)
                .pipe(takeWhile(() => this._isLive), withLatestFrom(this.store.select(AuthStore)), map(([x, y]) => y), filter((x) => x && x.user && x.user.loggedIn), throttleTime(userActiveCheckTime))
                .subscribe((x) => {
                this.store.dispatch(new UserAliveAction({}));
            });
        });
        this.ngZone.runOutsideAngular(() => {
            const total$ = merge$1(fromEvent(document, 'visibilitychange'))
                .pipe(takeWhile(() => this._isLive), withLatestFrom(this.store.select(AuthStore)), map(([x, y]) => y), filter((x) => x &&
                x.user &&
                x.user.loggedIn &&
                document.visibilityState === 'visible'))
                .subscribe((x) => {
                this.store.dispatch(new UserAliveAction({}));
            });
        });
    }
    ngOnDestroy() {
        this._isLive = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserActiveDirective, deps: [{ token: i1$2.Store }, { token: AppConfigSettings }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: UserActiveDirective, selector: "[arcSharedUserActive]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserActiveDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[arcSharedUserActive]',
                }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: AppConfigSettings }, { type: i0.NgZone }] });

class PageSearchDirective {
    constructor(store, router, page, actionsSubject, permissionDefinition) {
        this.store = store;
        this.router = router;
        this.page = page;
        this.actionsSubject = actionsSubject;
        this.permissionDefinition = permissionDefinition;
        this._isLive = true;
        this.searchType = ['accounts', 'invoices'];
        this.searchPermissionString = '';
        this.allowedApps = [];
    }
    ngOnInit() {
        if (this.searchPermissionString) {
            this.permissionDefinition
                .hasPermissionAndApp$(this.store, this.searchPermissionString, this.allowedApps)
                .pipe(takeWhile(() => this._isLive))
                .subscribe((hasPermission) => {
                this.page.showSearch = hasPermission;
            });
        }
        else {
            this.page.showSearch = true;
        }
        this.page.selectSuggestion.subscribe((suggestion) => {
            this.handleSuggestionClick(suggestion);
        });
        this.actionsSubject
            .pipe(takeWhile(() => this._isLive), ofType(SearchActionTypes.TypeAheadSearchResult), map((x) => x.payload))
            .subscribe((x) => {
            // console.log(x);
            this.page.searchSuggestions = x;
        });
    }
    ngAfterViewInit() {
        this.page.queryChange
            .pipe(takeWhile(() => this._isLive), debounceTime(300), filter((x) => (x || '').length > 2), distinctUntilChanged())
            .subscribe((x) => {
            this.store.dispatch(new TypeAheadSearchAction({ term: x, type: this.searchType }));
        });
    }
    handleSuggestionClick($event) {
        if ($event) {
            if ($event.type === 'accounts') {
                this.router.navigateByUrl('/accounts/' + $event.referenceId);
            }
            else if ($event.type === 'invoices') {
                this.router.navigateByUrl('/accounts/' +
                    $event.accountId +
                    '/invoicing?documentNumber=' +
                    encodeURIComponent($event.invoiceNumber));
            }
        }
        // console.log($event);
    }
    ngOnDestroy() {
        this._isLive = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PageSearchDirective, deps: [{ token: i1$2.Store }, { token: i1$1.Router }, { token: i2$1.PageComponent }, { token: i2.Actions }, { token: PermissionTypes }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: PageSearchDirective, selector: "aur-page[arcSharedTypeAheadSearch]", inputs: { searchType: "searchType", searchPermissionString: "searchPermissionString", allowedApps: "allowedApps" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PageSearchDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'aur-page[arcSharedTypeAheadSearch]',
                }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i1$1.Router }, { type: i2$1.PageComponent }, { type: i2.Actions }, { type: PermissionTypes }], propDecorators: { searchType: [{
                type: Input
            }], searchPermissionString: [{
                type: Input
            }], allowedApps: [{
                type: Input
            }] } });

class LoginAuthGuard {
    constructor(store, authService, coreService, router, settings) {
        this.store = store;
        this.authService = authService;
        this.coreService = coreService;
        this.router = router;
        this.settings = settings;
    }
    canActivate(next, state) {
        return this.guard(state.url);
    }
    canActivateChild(childRoute, state) {
        return this.guard(state.url);
    }
    guard(url) {
        let isRefresh = false;
        if (url && typeof url !== 'string' && url.get('refresh')) {
            isRefresh = url.get('refresh');
            url = url.get('redirectUrl');
        }
        if (this.coreService.isPageRefresh() || isRefresh) {
            const token = this.coreService.getAuthTokenFromLocalStorage();
            const activeTenantString = this.coreService.getActiveTenantFromLocalStorage();
            const appStateString = this.coreService.getAppStateFromLocalStorage();
            const appState = appStateString ? JSON.parse(appStateString) : {};
            const activeTenant = activeTenantString
                ? JSON.parse(activeTenantString)
                : {};
            return this.authService.V1VerifysessionPost({ accessToken: token }).pipe(map((x) => x.body), map((x) => x.verified), mergeMap((x) => {
                return this.coreService.loadUserInfo(token, { tenantId: activeTenant.tenantId }, true);
            }), tap((t) => {
                this.store.dispatch(new LoginSuccess({
                    user: t.user, // set user
                    activeTenant: {
                        ...t.activeTenant,
                    }, // set active tenant
                    activeRole: t.activeTenant ? t.activeTenant.role : null,
                    logoutUrl: appState.logoutUrl,
                }));
                this.store.dispatch(new ActiveTenantChanging({ tenantId: t.activeTenant.tenantId }));
            }), map((x) => true), catchError((error) => {
                if (url === '/jpmorgan') {
                    this.router.navigate([url]);
                }
                else {
                    this.router.navigate([this.settings.routes.loginRoute], {
                        queryParams: { returnUrl: url },
                    });
                }
                return of(false);
            }));
        }
        else {
            return this.store.pipe(select(AuthStore), map((x) => x.user.loggedIn), tap((x) => {
                if (!x) {
                    this.router.navigate([this.settings.routes.loginRoute], {
                        queryParams: { returnUrl: url },
                    });
                }
            }));
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginAuthGuard, deps: [{ token: i1$2.Store }, { token: AuthService }, { token: CoreService }, { token: i1$1.Router }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginAuthGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LoginAuthGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: AuthService }, { type: CoreService }, { type: i1$1.Router }, { type: AppConfigSettings }] });

class IsPartnerGuard {
    constructor(store, router, appConfigSettings) {
        this.store = store;
        this.router = router;
        this.appConfigSettings = appConfigSettings;
    }
    canActivate(next, state) {
        return this.guard();
    }
    canActivateChild(childRoute, state) {
        return this.guard();
    }
    guard() {
        return this.store.pipe(select(ActiveTenantStore), filter((x) => !!x), map((x) => x.isPartner), tap((x) => {
            if (!x) {
                this.router.navigate([this.appConfigSettings.routes.dashboardRoute]);
            }
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: IsPartnerGuard, deps: [{ token: i1$2.Store }, { token: i1$1.Router }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: IsPartnerGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: IsPartnerGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: i1$1.Router }, { type: AppConfigSettings }] });

class PermissionGuard {
    constructor(store, permissionDefinition) {
        this.store = store;
        this.permissionDefinition = permissionDefinition;
    }
    canActivate(next, state) {
        const permissionString = next.data['permissionString'];
        return this.guard(permissionString);
    }
    canActivateChild(childRoute, state) {
        const permissionString = childRoute.data['permissionString'];
        return this.guard(permissionString);
    }
    guard(permissionString) {
        return this.store.pipe(select(UserPermissionStore), filter((t) => t && t.length && t.length > 0), take(1), map((x) => {
            const permissionStoreData = x || [];
            let hasPermission = false;
            hasPermission = this.permissionDefinition.hasPermission(permissionStoreData, permissionString);
            return hasPermission;
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionGuard, deps: [{ token: i1$2.Store }, { token: PermissionTypes }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: PermissionTypes }] });

class RedirectGuard {
    constructor(router, settings) {
        this.router = router;
        this.settings = settings;
    }
    canActivate(next, state) {
        return this.guard(state.url);
    }
    canActivateChild(childRoute, state) {
        return this.guard(state.url);
    }
    guard(url) {
        this.router.navigate([this.settings.routes.loginRoute], {
            queryParams: {
                returnUrl: url,
                tag: Math.random()
                    .toString(36)
                    .replace(/[^a-z]+/g, '')
                    .substr(0, 10),
            },
            replaceUrl: false,
            skipLocationChange: false,
        });
        return true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectGuard, deps: [{ token: i1$1.Router }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.Router }, { type: AppConfigSettings }] });

class PermissionAppGuard {
    constructor(store, permissionDefinition) {
        this.store = store;
        this.permissionDefinition = permissionDefinition;
    }
    canActivate(next, state) {
        const permissionString = next.data['permissionString'];
        const allowedApps = next.data['apps'];
        return this.guard(permissionString, allowedApps);
    }
    canActivateChild(childRoute, state) {
        const permissionString = childRoute.data['permissionString'];
        const allowedApps = childRoute.data['apps'];
        return this.guard(permissionString, allowedApps);
    }
    guard(permissionString, allowedApps) {
        return this.permissionDefinition.hasPermissionAndApp$(this.store, permissionString, allowedApps);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionAppGuard, deps: [{ token: i1$2.Store }, { token: PermissionTypes }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionAppGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PermissionAppGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: PermissionTypes }] });

class ExternalUserLoginAuthGuard {
    constructor(store, authService, coreService, actions$, router, settings) {
        this.store = store;
        this.authService = authService;
        this.coreService = coreService;
        this.actions$ = actions$;
        this.router = router;
        this.settings = settings;
    }
    canActivate(next, state) {
        return this.guard(state.url);
    }
    canActivateChild(childRoute, state) {
        return this.guard(state.url);
    }
    guard(url) {
        if (this.coreService.isPageRefresh()) {
            const token = this.coreService.getAuthTokenFromLocalStorage();
            const activeTenantString = this.coreService.getActiveTenantFromLocalStorage();
            const appStateString = this.coreService.getAppStateFromLocalStorage();
            const appId = this.coreService.getAppIdFromLocalStorage();
            const featureId = this.coreService.getFeatureIdFromLocalStorage();
            const personaId = this.coreService.getPersonaIdFromLocalStorage();
            const appState = appStateString ? JSON.parse(appStateString) : {};
            const activeTenant = activeTenantString
                ? JSON.parse(activeTenantString)
                : {};
            return this.authService.V1VerifysessionPost({ accessToken: token }).pipe(map((x) => x.body), map((x) => x.verified), mergeMap((x) => {
                return this.coreService.ReloadExternalUserProfileForTenant$({
                    tenantId: activeTenant.tenantId,
                    applicationId: appId,
                    featureId: featureId,
                    personaId: personaId,
                    email: '',
                    password: '',
                }, token);
            }), tap((t) => {
                this.store.dispatch(new LoginSuccess({
                    user: { ...t.user, accessToken: t.accessToken }, // set user
                    activeTenant: {
                        ...t.activeTenant,
                    }, // set active tenant
                    activeRole: t.activeTenant ? t.activeTenant.role : null,
                    logoutUrl: appState.logoutUrl,
                }));
            }), map((x) => true), catchError((error) => {
                this.router.navigate([this.settings.routes.loginRoute], {
                    queryParams: { returnUrl: url },
                });
                return of(false);
            }));
        }
        else {
            return this.store.pipe(select(AuthStore), map((x) => x.user.loggedIn), tap((x) => {
                if (!x) {
                    this.router.navigate([this.settings.routes.loginRoute], {
                        queryParams: { returnUrl: url },
                    });
                }
            }));
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalUserLoginAuthGuard, deps: [{ token: i1$2.Store }, { token: AuthService }, { token: CoreService }, { token: i2.Actions }, { token: i1$1.Router }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalUserLoginAuthGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalUserLoginAuthGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Store }, { type: AuthService }, { type: CoreService }, { type: i2.Actions }, { type: i1$1.Router }, { type: AppConfigSettings }] });

class RedirectToLatestContextGuard {
    constructor(redirectToService, routePermissions, router) {
        this.redirectToService = redirectToService;
        this.routePermissions = routePermissions;
        this.router = router;
    }
    canActivate(route, state) {
        // this guard is always on the default (path: '') route.  The possible routes to redirect to should always be the siblings
        const possibleRoutes = route.parent.routeConfig.children.filter((c) => c.data && !!c.data.tabId);
        return this.routePermissions.getPermissibleRoutes$(possibleRoutes).pipe(take(1), map((permissibleRoutes) => {
            const redirectTo = this.redirectToService.GetRedirectToRoute(permissibleRoutes);
            if (redirectTo == null)
                return true;
            return this.router.parseUrl(`${state.url}/${redirectTo.path}`);
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectToLatestContextGuard, deps: [{ token: RedirectToLatestContextService }, { token: RoutePermissions }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectToLatestContextGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: RedirectToLatestContextGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RedirectToLatestContextService }, { type: RoutePermissions }, { type: i1$1.Router }] });

class SetLatestContextGuard {
    constructor(storage) {
        this.storage = storage;
    }
    canActivate(route, state) {
        const lastTabId = route.data.tabId;
        this.storage.setItem(`latest_context`, lastTabId);
        return true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SetLatestContextGuard, deps: [{ token: BrowserStorageService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SetLatestContextGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SetLatestContextGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: BrowserStorageService }] });

const accessGuard = (route, state) => {
    const router = inject(Router);
    return inject(PermissionAppGuard).canActivate(route, state).pipe(map$1(hasPermission => {
        if (hasPermission) {
            return true;
        }
        const urlTree = createUrlTreeFromSnapshot(route, [computePath(route)]);
        router.navigateByUrl(urlTree);
        return urlTree;
    }));
};
function computePath(route) {
    const path = route.routeConfig.path.length > 0 ?
        `${'../'.repeat(route.routeConfig.path.split('/').length)}${route.data.noAccessPath}`
        : route.data.noAccessPath;
    return path;
}

class SignupRouteComponent {
    constructor(route) {
        this.route = route;
        this.tenantId = '6edd0f32-5f33-496e-905e-09023df9b9b0';
    }
    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.tenantId = params['tenantId'] || this.tenantId;
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SignupRouteComponent, deps: [{ token: i1$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: SignupRouteComponent, selector: "arc-shared-signup-route", ngImport: i0, template: `<arc-shared-signup-container
    applicationId="automation-app"
    featureId="arc-feature-automation-verification"
    personaId="automation-user-persona-feature"
    [tenantId]="tenantId"
  ></arc-shared-signup-container>`, isInline: true, dependencies: [{ kind: "component", type: SignupContainerComponent, selector: "arc-shared-signup-container", inputs: ["applicationId", "personaId", "emailTemplateId", "featureId", "redirectUrlEmail", "tenantId", "showBackButton", "newUserWelcomeTemplateId", "existingUserWelcomeTemplateId", "newUserWelcomeTemplateTypeId", "existingUserWelcomeTemplateTypeId", "from"], outputs: ["succeeded", "failed", "backButtonClicked"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: SignupRouteComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'arc-shared-signup-route',
                    template: `<arc-shared-signup-container
    applicationId="automation-app"
    featureId="arc-feature-automation-verification"
    personaId="automation-user-persona-feature"
    [tenantId]="tenantId"
  ></arc-shared-signup-container>`,
                }]
        }], ctorParameters: () => [{ type: i1$1.ActivatedRoute }] });

class VerifyAccountRouteComponent {
    constructor() {
        this.widgetMode = 'regular';
        this.applicationId = '';
        this.featureId = '';
        this.personaId = '';
        this.redirectUrl = '';
        this.tenantId = '';
        this.newUserWelcomeTemplateTypeId = '';
        this.existingUserWelcomeTemplateTypeId = '';
    }
    ngOnInit() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VerifyAccountRouteComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: VerifyAccountRouteComponent, selector: "arc-shared-verifyaccount.route", inputs: { widgetMode: "widgetMode", applicationId: "applicationId", featureId: "featureId", personaId: "personaId", redirectUrl: "redirectUrl", tenantId: "tenantId", newUserWelcomeTemplateTypeId: "newUserWelcomeTemplateTypeId", existingUserWelcomeTemplateTypeId: "existingUserWelcomeTemplateTypeId" }, ngImport: i0, template: "<arc-shared-verifyaccount-container  [widgetMode]=\"widgetMode\" [applicationId]=\"applicationId\" [featureId]=\"featureId\" [personaId]=\"personaId\" [redirectUrl]=\"redirectUrl\"  [tenantId]=\"tenantId\" ></arc-shared-verifyaccount-container>", styles: [""], dependencies: [{ kind: "component", type: VerifyAccountContainerComponent, selector: "arc-shared-verifyaccount-container", inputs: ["widgetMode", "applicationId", "featureId", "personaId", "redirectUrl", "tenantId", "newUserWelcomeTemplateTypeId", "existingUserWelcomeTemplateTypeId"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: VerifyAccountRouteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'arc-shared-verifyaccount.route', template: "<arc-shared-verifyaccount-container  [widgetMode]=\"widgetMode\" [applicationId]=\"applicationId\" [featureId]=\"featureId\" [personaId]=\"personaId\" [redirectUrl]=\"redirectUrl\"  [tenantId]=\"tenantId\" ></arc-shared-verifyaccount-container>" }]
        }], ctorParameters: () => [], propDecorators: { widgetMode: [{
                type: Input
            }], applicationId: [{
                type: Input
            }], featureId: [{
                type: Input
            }], personaId: [{
                type: Input
            }], redirectUrl: [{
                type: Input
            }], tenantId: [{
                type: Input
            }], newUserWelcomeTemplateTypeId: [{
                type: Input
            }], existingUserWelcomeTemplateTypeId: [{
                type: Input
            }] } });

class ExternalUserLoginRouteComponent {
    constructor(route) {
        this.route = route;
        this.tenantId = '';
    }
    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.tenantId = params['tenantId'];
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalUserLoginRouteComponent, deps: [{ token: i1$1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ExternalUserLoginRouteComponent, selector: "arc-shared-signup-route", ngImport: i0, template: `<arc-shared-login-widget-ultimate
    widgetMode="external"
    redirectUrl="http://google.com"
    applicationId="automation-app"
    featureId="arc-feature-automation-verification"
    personaId="automation-user-persona-feature"
    [tenantId]="tenantId"
  ></arc-shared-login-widget-ultimate>`, isInline: true, dependencies: [{ kind: "component", type: LoginWidgetContainerComponent, selector: "arc-shared-login-widget-ultimate", inputs: ["message", "signUpLink", "enablePersonaRegistrationFlow", "widgetMode", "applicationId", "featureId", "personaId", "redirectUrl", "tenantId", "newUserWelcomeTemplateTypeId", "existingUserWelcomeTemplateTypeId", "preventTitleChange", "showMessage", "fromExternal", "isTenantJPMReseller", "navigationStrategy"], outputs: ["verificationCodeSent", "passwordResetSucceeded"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ExternalUserLoginRouteComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'arc-shared-signup-route',
                    template: `<arc-shared-login-widget-ultimate
    widgetMode="external"
    redirectUrl="http://google.com"
    applicationId="automation-app"
    featureId="arc-feature-automation-verification"
    personaId="automation-user-persona-feature"
    [tenantId]="tenantId"
  ></arc-shared-login-widget-ultimate>`,
                }]
        }], ctorParameters: () => [{ type: i1$1.ActivatedRoute }] });

// Add the locale data for all the supported languages
registerLocaleData(localeDa);
registerLocaleData(localeDe);
registerLocaleData(localeEs);
registerLocaleData(localeFi);
registerLocaleData(localeFr);
registerLocaleData(localeIt);
registerLocaleData(localeNl);
registerLocaleData(localeNo);
registerLocaleData(localeSv);
registerLocaleData(localePl);
class ArcWidgetsModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcWidgetsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ArcWidgetsModule, declarations: [ArcCurrencyPipe,
            LoginComponent,
            JPMorganTermsComponent,
            LoginContainerComponent,
            PasswordresetContainerComponent,
            PasswordresetComponent,
            ForgotPasswordContainerComponent,
            ForgotPasswordComponent,
            CodeVerificationContainerComponent,
            CodeVerificationComponent,
            BtPanelComponent,
            ForceResetPasswordContainerComponent,
            TenantswitcherComponent,
            TenantswitcherContainerComponent,
            ProfileContainerComponent,
            TopbarcontainerComponent,
            TopbarprofileComponent,
            ChangepasswordContainerComponent,
            TimeoutWarningContainerComponent,
            LoginWidgetContainerComponent,
            QuantumLoginComponent,
            AppSwitcherComponent,
            SignupContainerComponent,
            SignupformComponent,
            SignupRouteComponent,
            VerifyAccountFormComponent,
            VerifyAccountContainerComponent,
            VerifyAccountRouteComponent,
            ClickStopPropagationDirective,
            PageSearchDirective,
            ApplyPermissionDirective,
            UserActiveDirective,
            ExternalUserLoginRouteComponent,
            SearchComponent,
            NoAccessComponent], imports: [CommonModule,
            AureusModule,
            DatetimeModule,
            ReactiveFormsModule,
            TranslateModule,
            DialogModule,
            CardModule,
            MessagesModule,
            TooltipModule,
            FileUploadWithUrlModule,
            RouterModule,
            NgxCaptchaModule], exports: [ReactiveFormsModule,
            DialogModule,
            AureusModule,
            ArcCurrencyPipe,
            LoginComponent,
            PasswordresetComponent,
            LoginContainerComponent,
            PasswordresetContainerComponent,
            ForgotPasswordContainerComponent,
            ForgotPasswordComponent,
            CodeVerificationContainerComponent,
            CodeVerificationComponent,
            BtPanelComponent,
            ForceResetPasswordContainerComponent,
            TenantswitcherComponent,
            TenantswitcherContainerComponent,
            ProfileContainerComponent,
            TopbarcontainerComponent,
            TopbarprofileComponent,
            ChangepasswordContainerComponent,
            TimeoutWarningContainerComponent,
            LoginWidgetContainerComponent,
            QuantumLoginComponent,
            AppSwitcherComponent,
            SignupContainerComponent,
            SignupformComponent,
            SignupRouteComponent,
            VerifyAccountFormComponent,
            VerifyAccountContainerComponent,
            VerifyAccountRouteComponent,
            ClickStopPropagationDirective,
            PageSearchDirective,
            ApplyPermissionDirective,
            UserActiveDirective,
            DatetimeModule,
            ExternalUserLoginRouteComponent,
            FileUploadWithUrlModule,
            SearchComponent,
            NoAccessComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcWidgetsModule, providers: [MessageService], imports: [CommonModule,
            AureusModule,
            DatetimeModule,
            ReactiveFormsModule,
            TranslateModule,
            DialogModule,
            CardModule,
            MessagesModule,
            TooltipModule,
            FileUploadWithUrlModule,
            RouterModule,
            NgxCaptchaModule, ReactiveFormsModule,
            DialogModule,
            AureusModule,
            DatetimeModule,
            FileUploadWithUrlModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcWidgetsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        AureusModule,
                        DatetimeModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        DialogModule,
                        CardModule,
                        MessagesModule,
                        TooltipModule,
                        FileUploadWithUrlModule,
                        RouterModule,
                        NgxCaptchaModule,
                    ],
                    declarations: [
                        ArcCurrencyPipe,
                        LoginComponent,
                        JPMorganTermsComponent,
                        LoginContainerComponent,
                        PasswordresetContainerComponent,
                        PasswordresetComponent,
                        ForgotPasswordContainerComponent,
                        ForgotPasswordComponent,
                        CodeVerificationContainerComponent,
                        CodeVerificationComponent,
                        BtPanelComponent,
                        ForceResetPasswordContainerComponent,
                        TenantswitcherComponent,
                        TenantswitcherContainerComponent,
                        ProfileContainerComponent,
                        TopbarcontainerComponent,
                        TopbarprofileComponent,
                        ChangepasswordContainerComponent,
                        TimeoutWarningContainerComponent,
                        LoginWidgetContainerComponent,
                        QuantumLoginComponent,
                        AppSwitcherComponent,
                        SignupContainerComponent,
                        SignupformComponent,
                        SignupRouteComponent,
                        VerifyAccountFormComponent,
                        VerifyAccountContainerComponent,
                        VerifyAccountRouteComponent,
                        ClickStopPropagationDirective,
                        PageSearchDirective,
                        ApplyPermissionDirective,
                        UserActiveDirective,
                        ExternalUserLoginRouteComponent,
                        SearchComponent,
                        NoAccessComponent,
                    ],
                    exports: [
                        ReactiveFormsModule,
                        DialogModule,
                        AureusModule,
                        ArcCurrencyPipe,
                        LoginComponent,
                        PasswordresetComponent,
                        LoginContainerComponent,
                        PasswordresetContainerComponent,
                        ForgotPasswordContainerComponent,
                        ForgotPasswordComponent,
                        CodeVerificationContainerComponent,
                        CodeVerificationComponent,
                        BtPanelComponent,
                        ForceResetPasswordContainerComponent,
                        TenantswitcherComponent,
                        TenantswitcherContainerComponent,
                        ProfileContainerComponent,
                        TopbarcontainerComponent,
                        TopbarprofileComponent,
                        ChangepasswordContainerComponent,
                        TimeoutWarningContainerComponent,
                        LoginWidgetContainerComponent,
                        QuantumLoginComponent,
                        AppSwitcherComponent,
                        SignupContainerComponent,
                        SignupformComponent,
                        SignupRouteComponent,
                        VerifyAccountFormComponent,
                        VerifyAccountContainerComponent,
                        VerifyAccountRouteComponent,
                        ClickStopPropagationDirective,
                        PageSearchDirective,
                        ApplyPermissionDirective,
                        UserActiveDirective,
                        DatetimeModule,
                        ExternalUserLoginRouteComponent,
                        FileUploadWithUrlModule,
                        SearchComponent,
                        NoAccessComponent,
                    ],
                    providers: [MessageService],
                }]
        }] });

// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, '/assets/languages/', '.json');
// }
class ArcSharedModule {
    static forRoot() {
        return {
            ngModule: ArcSharedModule,
            providers: [BrowserCookieService, PendoService],
        };
    }
    static forChild() {
        return {
            ngModule: ArcSharedModule,
            providers: [],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcSharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ArcSharedModule, imports: [AureusModule, CommonModule, ArcWidgetsModule, TranslateModule], exports: [AureusModule, ArcWidgetsModule, CoreStoreModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcSharedModule, providers: [BrowserCookieService], imports: [AureusModule, CommonModule, ArcWidgetsModule, TranslateModule, AureusModule, ArcWidgetsModule, CoreStoreModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcSharedModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [AureusModule, CommonModule, ArcWidgetsModule, TranslateModule],
                    declarations: [],
                    exports: [AureusModule, ArcWidgetsModule, CoreStoreModule],
                    providers: [BrowserCookieService],
                }]
        }] });

class FakeLoader {
    getTranslation(lang) {
        return of({});
    }
}
const reducers = {};
// export function TestHttpLoaderFactory(http: HttpClient) {
//     return new TranslateHttpLoader(http, './assets/languages/', '.json');
// }
class ArcSharedTestingModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcSharedTestingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ArcSharedTestingModule, imports: [ReactiveFormsModule,
            BrowserAnimationsModule,
            FormsModule,
            AureusModule, i3.TranslateModule, i1$2.StoreRootModule, i2.EffectsRootModule], exports: [ReactiveFormsModule,
            BrowserAnimationsModule,
            FormsModule,
            AureusModule,
            TranslateModule,
            StoreModule,
            RouterTestingModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcSharedTestingModule, providers: [
            { provide: AppConfigSettings, useClass: AppConfigSettings },
            provideHttpClient(withInterceptorsFromDi()),
        ], imports: [ReactiveFormsModule,
            BrowserAnimationsModule,
            FormsModule,
            AureusModule,
            TranslateModule.forRoot({
                loader: { provide: TranslateLoader, useClass: FakeLoader },
            }),
            StoreModule.forRoot(reducers, {
                initialState: {},
            }),
            EffectsModule.forRoot([]), ReactiveFormsModule,
            BrowserAnimationsModule,
            FormsModule,
            AureusModule,
            TranslateModule,
            StoreModule,
            RouterTestingModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcSharedTestingModule, decorators: [{
            type: NgModule,
            args: [{ declarations: [],
                    exports: [
                        ReactiveFormsModule,
                        BrowserAnimationsModule,
                        FormsModule,
                        AureusModule,
                        TranslateModule,
                        StoreModule,
                        RouterTestingModule,
                    ], imports: [ReactiveFormsModule,
                        BrowserAnimationsModule,
                        FormsModule,
                        AureusModule,
                        TranslateModule.forRoot({
                            loader: { provide: TranslateLoader, useClass: FakeLoader },
                        }),
                        StoreModule.forRoot(reducers, {
                            initialState: {},
                        }),
                        EffectsModule.forRoot([])], providers: [
                        { provide: AppConfigSettings, useClass: AppConfigSettings },
                        provideHttpClient(withInterceptorsFromDi()),
                    ] }]
        }] });

const GoogleTagManagerConfigService = new InjectionToken('google-tag-manager-config');
// adapted from https://github.com/auth0/auth0-angular#dynamic-configuration
class GoogleTagManagerConfiguration {
    constructor(googleTagManagerConfig) {
        this._googleTagManagerConfig = {
            id: null,
            gtm_auth: '',
            gtm_preview: '',
        };
        if (googleTagManagerConfig) {
            this.set(googleTagManagerConfig);
        }
    }
    set(googleTagManagerConfig) {
        this._googleTagManagerConfig = googleTagManagerConfig;
    }
    get() {
        return this._googleTagManagerConfig;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerConfiguration, deps: [{ token: GoogleTagManagerConfigService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerConfiguration, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerConfiguration, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [GoogleTagManagerConfigService]
                }] }] });

class GoogleTagManagerService {
    constructor(googleTagManagerConfiguration, googleTagManagerId, googleTagManagerAuth, googleTagManagerPreview, googleTagManagerResourcePath, googleTagManagerCSPNonce, settings) {
        this.googleTagManagerConfiguration = googleTagManagerConfiguration;
        this.googleTagManagerId = googleTagManagerId;
        this.googleTagManagerAuth = googleTagManagerAuth;
        this.googleTagManagerPreview = googleTagManagerPreview;
        this.googleTagManagerResourcePath = googleTagManagerResourcePath;
        this.googleTagManagerCSPNonce = googleTagManagerCSPNonce;
        this.settings = settings;
        this.isLoaded = false;
        this.browserGlobals = {
            windowRef() {
                return window;
            },
            documentRef() {
                return document;
            },
        };
        this.config = this.googleTagManagerConfiguration?.get();
        if (this.config == null) {
            this.config = { id: null };
        }
        this.config = {
            ...this.config,
            id: googleTagManagerId || this.config.id,
            gtm_auth: googleTagManagerAuth || this.config.gtm_auth,
            gtm_preview: googleTagManagerPreview || this.config.gtm_preview,
            gtm_resource_path: googleTagManagerResourcePath || this.config.gtm_resource_path,
        };
        if (this.config.id == null) {
            throw new Error('Google tag manager ID not provided.');
        }
    }
    getDataLayer() {
        const window = this.browserGlobals.windowRef();
        window.dataLayer = window.dataLayer || [];
        return window.dataLayer;
    }
    pushOnDataLayer(obj) {
        const dataLayer = this.getDataLayer();
        dataLayer.push(obj);
    }
    shouldLoadGtmToDom(useEnv, env) {
        if (!((env === 'prod' && useEnv) || !useEnv)) {
            return false;
        }
        return true;
    }
    addGtmToDom(useEnv = true) {
        const env = this.settings.environment;
        if (!this.shouldLoadGtmToDom(useEnv, env)) {
            return new Promise((resolve, reject) => {
                return resolve(false);
            });
        }
        return new Promise((resolve, reject) => {
            if (this.isLoaded) {
                return resolve(this.isLoaded);
            }
            const doc = this.browserGlobals.documentRef();
            this.pushOnDataLayer({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
            });
            const gtmScript = doc.createElement('script');
            gtmScript.id = 'GTMscript';
            gtmScript.async = true;
            gtmScript.src = this.applyGtmQueryParams(this.config.gtm_resource_path
                ? this.config.gtm_resource_path
                : 'https://www.googletagmanager.com/gtm.js');
            gtmScript.addEventListener('load', () => {
                return resolve((this.isLoaded = true));
            });
            gtmScript.addEventListener('error', () => {
                return reject(false);
            });
            if (this.googleTagManagerCSPNonce) {
                gtmScript.setAttribute('nonce', this.googleTagManagerCSPNonce);
            }
            doc.head.insertBefore(gtmScript, doc.head.firstChild);
        });
    }
    pushTag(item) {
        return new Promise((resolve, reject) => {
            if (!this.isLoaded) {
                this.addGtmToDom()
                    .then(() => {
                    this.pushOnDataLayer(item);
                    return resolve();
                })
                    .catch(() => reject());
            }
            else {
                this.pushOnDataLayer(item);
                return resolve();
            }
        });
    }
    applyGtmQueryParams(url) {
        if (url.indexOf('?') === -1) {
            url += '?';
        }
        return (url +
            Object.keys(this.config)
                .filter((k) => this.config[k])
                .map((k) => `${k}=${this.config[k]}`)
                .join('&'));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerService, deps: [{ token: GoogleTagManagerConfiguration, optional: true }, { token: 'googleTagManagerId', optional: true }, { token: 'googleTagManagerAuth', optional: true }, { token: 'googleTagManagerPreview', optional: true }, { token: 'googleTagManagerResourcePath', optional: true }, { token: 'googleTagManagerCSPNonce', optional: true }, { token: AppConfigSettings }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: GoogleTagManagerConfiguration, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [GoogleTagManagerConfiguration]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['googleTagManagerId']
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['googleTagManagerAuth']
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['googleTagManagerPreview']
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['googleTagManagerResourcePath']
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['googleTagManagerCSPNonce']
                }] }, { type: AppConfigSettings }] });

class GoogleTagManagerModule {
    static forRoot(config) {
        return {
            ngModule: GoogleTagManagerModule,
            providers: [{ provide: GoogleTagManagerConfigService, useValue: config }],
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerModule }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: GoogleTagManagerModule, decorators: [{
            type: NgModule
        }] });

class CustomMfeTranslateLoader {
    constructor(http) {
        this.http = http;
    }
    getTranslation(langCountry) {
        let translateMfeAssetsByToken = [];
        translateMfeAssetsByToken.push(this.http
            .get(`/assets/languages/${langCountry}.json`)
            .pipe(catchError(() => of({}))));
        const manifests = getManifest();
        if (manifests && Object.keys(manifests).length > 0) {
            Object.keys(manifests).forEach((mf) => {
                if (manifests[mf].translateAssetPath) {
                    const manifest = manifests[mf];
                    translateMfeAssetsByToken.push(this.http
                        .get(`${manifest.cdn}/${manifest.translateAssetPath}/${langCountry}.json`)
                        /**
                         * TODO: Should send a sentry capture message on CDN API failure
                         */
                        .pipe(catchError(() => of({}))));
                }
            });
        }
        return forkJoin([...translateMfeAssetsByToken]).pipe(map((data) => {
            const res = {};
            data.forEach((obj) => {
                Object.assign(res, obj);
            });
            return res;
        }));
    }
}

// This service is a work-around for translate service in lazy-loaded modules
class ArcTranslateConfigService extends TranslateService {
    constructor(translateService) {
        super(translateService.store, translateService.currentLoader, translateService.compiler, translateService.parser, translateService.missingTranslationHandler, true, false, true, translateService.defaultLang);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcTranslateConfigService, deps: [{ token: i3.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcTranslateConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ArcTranslateConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i3.TranslateService }] });

const buildRemoteModule = (route) => {
    const routeMfe = getManifest()[route.mfeName];
    if (!routeMfe) {
        throw Error("No manifest found in name " + route.mfeName);
    }
    const options = {
        type: "manifest",
        remoteName: route.mfeName,
        exposedModule: route.exposedModule,
    };
    return loadRemoteModule({
        ...options,
    }).then((m) => m[route.ngModuleName]);
};

/**
 * Generated bundle index. Do not edit.
 */

export { ActionContext, ActiveTenantChanged, ActiveTenantChanging, ActiveTenantChangingPayload, ActiveTenantStore, ApiRequestRetryInterceptor, AppConfigSettings, AppNameService, AppStateStore, AppSwitcherComponent, ApplicationType, ApplyPermissionDirective, ArcCurrencyPipe, ArcDatePipe, ArcSharedModule, ArcSharedTestingModule, ArcTranslateConfigService, ArcValidators, ArcWidgetsModule, AssignUserToRoleAction, AssignUserToRoleSuccessAction, AuthActionTypes, AuthEffects, AuthModule, AuthPhoneVerificationRequiredAction, AuthService, AuthStore, AuthUserProfileStore, AuthUserStore, AuthenticationErrorStatus, AuthenticationSuccessStatus, BackendMessageType, BackendNotificationAction, BrandingActionTypes, BrandingModule, BrandingModuleStore, BrandingPrivacyPolicyStore, BrandingTenantStore, BrowserCookieService, BrowserStorageService, BtPanelComponent, BulkChangeUserRoleAction, ChangePassword, ChangeUserProfile, ChangepasswordContainerComponent, ClearAllStoreAction, ClearRoleListAction, ClickStopPropagationDirective, CodeVerificationComponent, CodeVerificationContainerComponent, Cookie, CoreService, CoreStoreModule, CreateAnonymousUserAction, CreateRoleAction, CustomMfeTranslateLoader, DashboardRedirect, DataDogService, DateTimeContainerComponent, DatetimeModule, DatetimeService, DefineActiveTenant, DeleteSingleRoleAction, DemoDataService, DemoDataV1Service, DidTenantChange, DisplaySessionTimeoutWarningAction, DoNothingAction, ErrorInterceptor, ErrorStore, ExternalRedirectAction, ExternalUserLogin, ExternalUserLoginAuthGuard, ExternalUserLoginByToken, ExternalUserLoginRouteComponent, FakeLoader, FileUploadService, FileUploadWithUrlComponent, FileUploadWithUrlModule, ForceResetPassword, ForceResetPasswordContainerComponent, ForgotPasswordComponent, ForgotPasswordContainerComponent, ForgotPasswordRedirect, GeneralActionTypes, GeneralErrorAction, GeneralErrorHandledAction, GeneralRedirectAction, GeneralReducers, GeneralStoreModule, GeneralSuccessAction, GeneralSuccessHandledAction, GetRoleListWithDefaultCountAndPermissionAction, GetSessionTTLAction, GetUserCountPerRoleAction, GetUserListRoleAction, GetUserListRoleSuccessAction, GetUserRoleIdAction, GetUserRoleIdSuccessAction, GetUsersByRoleAction, GoogleTagManagerModule, GoogleTagManagerService, IsPartnerGuard, LoadPermissionSectionListAction, LoadPlatformNameAction, LoadPrivacyPolicyAction, LoadProfile, LoadRoleListAction, Login, LoginAuthGuard, LoginByToken, LoginComponent, LoginContainerComponent, LoginFailure, LoginRedirect, LoginSilentComponent, LoginSuccess, LoginSuccessWithResetPassword, LoginWidgetContainerComponent, LoginWithToken, Logout, NewPasswordRequiredRedirect, NewRoleFromRoleStore, NoAccessComponent, NormalizedVisibleRoleListStore, NotificationCounterService, NotificationService, PageMeta, PageSearchDirective, PasswordResetStoreVerificationCode, PasswordresetComponent, PasswordresetContainerComponent, PendoService, PermissionActionTypes, PermissionAppGuard, PermissionEffects, PermissionGuard, PermissionModuleStore, PermissionSectionMasterListStore, PermissionStoreModule, PermissionTypes, PermissionV1Service, ProfileContainerComponent, QuantumLoginComponent, RedirectGuard, RedirectToLatestContextGuard, RedirectToLatestContextService, ResetPassword, ResetPasswordStore, RoleListStore, RoutePermissions, RouteToLandingPage, SaveRoleAction, SaveRoleV2Action, SearchActionTypes, SearchComponent, SearchReducers, SearchStoreModule, SearchV1Service, SearchV2Service, SendResetPasswordEmail, SendVerificationCodeViaPhoneAction, SentryService, SessionTTLInterceptor, SessionTimeOutInterceptor, SetLatestContextGuard, SetTestTenantModeAction, SignupContainerComponent, SignupRouteComponent, SignupformComponent, StorageItem, SuccessStore, SysNotificationStore, SystemNotificationAction, TenantMgmtV1Service, TenantStandAloneV1Service, TenantsV1Service, TenantswitcherComponent, TenantswitcherContainerComponent, TestModeInterceptor, TimeZoneV1Service, TimeoutWarningContainerComponent, TokenInterceptor, TopbarcontainerComponent, TopbarprofileComponent, TranslationServiceFactory, TypeAheadSearchAction, TypeAheadSearchPagedAction, TypeAheadSearchPagedResultAction, TypeAheadSearchResultAction, TypeAheadSearchResultWithMetadataAction, UpdatePasswordResetStore, UpdatePermissionAction, UpdatePermissionStore, UpdatePlatformNameAction, UpdatePrivacyPolicyAction, UpdateRoleListAction, UpdateSingleRoleAction, UpdateTenantId, UpdateUserCountRoleAction, UpdateUserListWithRoleAction, UpdatedProfile, UserActiveDirective, UserAliveAction, UserNotificationAction, UserNotificationDisplayed, UserNotificationStore, UserPermissionSelector, UserPermissionStore, UserService, ValidateSession, VerificationCodeRedirect, VerifyAccountContainerComponent, VerifyAccountFormComponent, VerifyAccountRouteComponent, VerifyAccountViaPhoneAction, VerifyAccountViaPhoneExternalAction, accessGuard, activeTenantSelector, appStateReducer, authreducers, brandingReducers, buildRemoteModule, clearStateMetaReducer, computePath, convertTsickleDecoratorIntoMetadata, errorReducer, getActiveTenant$, getAnnotations, initialAppState, initialErrorState, initialPermissionListState, initialPrivacyPolicy, initialResetPasswordState, initialRoleListState, initialSearchState, initialState, initialSuccessState, initialSystemNotificationState, initialUserNotificationState, loginReducer, permissionReducer, permissionReducers, privacyPolicyReducer, reducers, resetPasswordReducer, roleReducer, searchReducer, selectIsLoggedIn, selectTenantApplications, selectTenantResellerId, successReducer, systemNotificationReducer, tenantReducer, userChanged$, userHasMultipleTenants, userNotificationReducer };
